/* tslint:disable */
/* eslint-disable */
/**
 * AI.OpenDoor2 - API文档
 * <b>注意：仅开启swagger选项有效，建议上线前关闭该选项</b>  
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @enum {string}
 */

export const AIBEANCHANGESOURCEE = {
    Recharge: 'RECHARGE',
    System: 'SYSTEM',
    Ticket: 'TICKET',
    Incentive: 'INCENTIVE',
    Query: 'QUERY',
    StoreCustomerQuery: 'STORE_CUSTOMER_QUERY'
} as const;

export type AIBEANCHANGESOURCEE = typeof AIBEANCHANGESOURCEE[keyof typeof AIBEANCHANGESOURCEE];


/**
 * 
 * @export
 * @interface AdminVo
 */
export interface AdminVo {
    /**
     * 
     * @type {number}
     * @memberof AdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminVo
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof AdminVo
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminVo
     */
    'password': string;
    /**
     * 
     * @type {Array<any>}
     * @memberof AdminVo
     */
    'menus'?: Array<any>;
    /**
     * 
     * @type {string}
     * @memberof AdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface AdvertisingAdminVo
 */
export interface AdvertisingAdminVo {
    /**
     * 
     * @type {number}
     * @memberof AdvertisingAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingAdminVo
     */
    'sequence': number;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingAdminVo
     */
    'rowId': number;
    /**
     * 
     * @type {string}
     * @memberof AdvertisingAdminVo
     */
    'image': string;
    /**
     * 
     * @type {string}
     * @memberof AdvertisingAdminVo
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof AdvertisingAdminVo
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof AdvertisingAdminVo
     */
    'appid'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdvertisingAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface AdvertisingRowAdminVo
 */
export interface AdvertisingRowAdminVo {
    /**
     * 
     * @type {number}
     * @memberof AdvertisingRowAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdvertisingRowAdminVo
     */
    'position': string;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingRowAdminVo
     */
    'sequence': number;
    /**
     * 
     * @type {string}
     * @memberof AdvertisingRowAdminVo
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof AdvertisingRowAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface AiBeanAdminVo
 */
export interface AiBeanAdminVo {
    /**
     * 
     * @type {number}
     * @memberof AiBeanAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AiBeanAdminVo
     */
    'phone'?: string;
    /**
     * 
     * @type {number}
     * @memberof AiBeanAdminVo
     */
    'beanCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof AiBeanAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof AiBeanAdminVo
     */
    'updateTime'?: string;
}
/**
 * 
 * @export
 * @interface AiBeanRecordAdminVo
 */
export interface AiBeanRecordAdminVo {
    /**
     * 
     * @type {number}
     * @memberof AiBeanRecordAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AiBeanRecordAdminVo
     */
    'phone'?: string;
    /**
     * 
     * @type {number}
     * @memberof AiBeanRecordAdminVo
     */
    'changeCount'?: number;
    /**
     * 
     * @type {AIBEANCHANGESOURCEE}
     * @memberof AiBeanRecordAdminVo
     */
    'changeSource'?: AIBEANCHANGESOURCEE;
    /**
     * 
     * @type {any}
     * @memberof AiBeanRecordAdminVo
     */
    'meta'?: any;
    /**
     * 
     * @type {number}
     * @memberof AiBeanRecordAdminVo
     */
    'recordId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AiBeanRecordAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof AiBeanRecordAdminVo
     */
    'phoneOrNameOrTrack'?: string;
    /**
     * 
     * @type {string}
     * @memberof AiBeanRecordAdminVo
     */
    'userName'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const BASEMENUTYPEE = {
    Link: 'link',
    Dir: 'dir'
} as const;

export type BASEMENUTYPEE = typeof BASEMENUTYPEE[keyof typeof BASEMENUTYPEE];


/**
 * 
 * @export
 * @enum {string}
 */

export const BASEROUTETYPEE = {
    AdminPage: 'admin_page',
    CommonPage: 'common_page'
} as const;

export type BASEROUTETYPEE = typeof BASEROUTETYPEE[keyof typeof BASEROUTETYPEE];


/**
 * 
 * @export
 * @interface BaseApiAdminVo
 */
export interface BaseApiAdminVo {
    /**
     * 
     * @type {number}
     * @memberof BaseApiAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseApiAdminVo
     */
    'path'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseApiAdminVo
     */
    'swaggerPath'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseApiAdminVo
     */
    'method'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseApiAdminVo
     */
    'tagName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseApiAdminVo
     */
    'summary'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BaseApiAdminVo
     */
    'allowAll': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BaseApiAdminVo
     */
    'enable': boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof BaseApiAdminVo
     */
    'roleIds'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof BaseApiAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface BaseDictionaryAdminVo
 */
export interface BaseDictionaryAdminVo {
    /**
     * 
     * @type {number}
     * @memberof BaseDictionaryAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseDictionaryAdminVo
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof BaseDictionaryAdminVo
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof BaseDictionaryAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface BaseMenuAdminVo
 */
export interface BaseMenuAdminVo {
    /**
     * 
     * @type {number}
     * @memberof BaseMenuAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseMenuAdminVo
     */
    'url'?: string;
    /**
     * 
     * @type {BASEMENUTYPEE}
     * @memberof BaseMenuAdminVo
     */
    'type': BASEMENUTYPEE;
    /**
     * 
     * @type {string}
     * @memberof BaseMenuAdminVo
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof BaseMenuAdminVo
     */
    'icon'?: string;
    /**
     * 
     * @type {number}
     * @memberof BaseMenuAdminVo
     */
    'sequence': number;
    /**
     * 
     * @type {boolean}
     * @memberof BaseMenuAdminVo
     */
    'enable': boolean;
    /**
     * 
     * @type {number}
     * @memberof BaseMenuAdminVo
     */
    'parentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseMenuAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof BaseMenuAdminVo
     */
    'roleIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof BaseMenuAdminVo
     */
    'routeIds'?: Array<number>;
}


/**
 * 
 * @export
 * @interface BaseMessageAdminVo
 */
export interface BaseMessageAdminVo {
    /**
     * 
     * @type {number}
     * @memberof BaseMessageAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof BaseMessageAdminVo
     */
    'tenantId'?: number;
    /**
     * 
     * @type {number}
     * @memberof BaseMessageAdminVo
     */
    'sendUserId'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseMessageAdminVo
     */
    'msgType': string;
    /**
     * 
     * @type {string}
     * @memberof BaseMessageAdminVo
     */
    'msgSummary'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseMessageAdminVo
     */
    'msgContent': string;
    /**
     * 
     * @type {string}
     * @memberof BaseMessageAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof BaseMessageAdminVo
     */
    'targetUserIds'?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseMessageAdminVo
     */
    'targetOrgCodes'?: Array<string>;
}
/**
 * 
 * @export
 * @interface BaseMessagePrivateSendVo
 */
export interface BaseMessagePrivateSendVo {
    /**
     * 
     * @type {number}
     * @memberof BaseMessagePrivateSendVo
     */
    'targetUserId': number;
    /**
     * 
     * @type {string}
     * @memberof BaseMessagePrivateSendVo
     */
    'msgSummary'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseMessagePrivateSendVo
     */
    'msgContent': string;
}
/**
 * 
 * @export
 * @interface BaseMessagePrivateUserSearchVo
 */
export interface BaseMessagePrivateUserSearchVo {
    /**
     * 
     * @type {string}
     * @memberof BaseMessagePrivateUserSearchVo
     */
    'keyword'?: string;
}
/**
 * 
 * @export
 * @interface BaseOperateAdminVo
 */
export interface BaseOperateAdminVo {
    /**
     * 
     * @type {number}
     * @memberof BaseOperateAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseOperateAdminVo
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof BaseOperateAdminVo
     */
    'name': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof BaseOperateAdminVo
     */
    'roleIds': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof BaseOperateAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface BaseOrderByVo
 */
export interface BaseOrderByVo {
    /**
     * 
     * @type {string}
     * @memberof BaseOrderByVo
     */
    'field': string;
    /**
     * 
     * @type {any}
     * @memberof BaseOrderByVo
     */
    'direction': any;
}
/**
 * 
 * @export
 * @interface BaseOrganizationAdminVo
 */
export interface BaseOrganizationAdminVo {
    /**
     * 
     * @type {number}
     * @memberof BaseOrganizationAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof BaseOrganizationAdminVo
     */
    'tenantId'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseOrganizationAdminVo
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseOrganizationAdminVo
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof BaseOrganizationAdminVo
     */
    'parentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseOrganizationAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface BasePageQueryVo
 */
export interface BasePageQueryVo {
    /**
     * 
     * @type {number}
     * @memberof BasePageQueryVo
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof BasePageQueryVo
     */
    'pageSize': number;
}
/**
 * 
 * @export
 * @interface BaseResultVo
 */
export interface BaseResultVo {
    /**
     * 
     * @type {boolean}
     * @memberof BaseResultVo
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof BaseResultVo
     */
    'msg'?: string;
    /**
     * 
     * @type {any}
     * @memberof BaseResultVo
     */
    'data'?: any;
}
/**
 * 
 * @export
 * @interface BaseRoleAdminVo
 */
export interface BaseRoleAdminVo {
    /**
     * 
     * @type {number}
     * @memberof BaseRoleAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseRoleAdminVo
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof BaseRoleAdminVo
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BaseRoleAdminVo
     */
    'orgCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof BaseRoleAdminVo
     */
    'level'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseRoleAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface BaseRouteAdminVo
 */
export interface BaseRouteAdminVo {
    /**
     * 
     * @type {number}
     * @memberof BaseRouteAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {BASEROUTETYPEE}
     * @memberof BaseRouteAdminVo
     */
    'type': BASEROUTETYPEE;
    /**
     * 
     * @type {boolean}
     * @memberof BaseRouteAdminVo
     */
    'allowAll': boolean;
    /**
     * 
     * @type {string}
     * @memberof BaseRouteAdminVo
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof BaseRouteAdminVo
     */
    'path': string;
    /**
     * 
     * @type {string}
     * @memberof BaseRouteAdminVo
     */
    'componentName': string;
    /**
     * 
     * @type {boolean}
     * @memberof BaseRouteAdminVo
     */
    'isNest': boolean;
    /**
     * 
     * @type {string}
     * @memberof BaseRouteAdminVo
     */
    'redirect'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BaseRouteAdminVo
     */
    'enable': boolean;
    /**
     * 
     * @type {number}
     * @memberof BaseRouteAdminVo
     */
    'parentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseRouteAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof BaseRouteAdminVo
     */
    'roleIds'?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof BaseRouteAdminVo
     */
    'isIndex'?: boolean;
}


/**
 * 
 * @export
 * @interface BaseTenantAdminVo
 */
export interface BaseTenantAdminVo {
    /**
     * 
     * @type {number}
     * @memberof BaseTenantAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseTenantAdminVo
     */
    'name': string;
    /**
     * 
     * @type {any}
     * @memberof BaseTenantAdminVo
     */
    'meta'?: any;
    /**
     * 
     * @type {string}
     * @memberof BaseTenantAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface BaseUserAdminVo
 */
export interface BaseUserAdminVo {
    /**
     * 
     * @type {number}
     * @memberof BaseUserAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof BaseUserAdminVo
     */
    'tenantId'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseUserAdminVo
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseUserAdminVo
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof BaseUserAdminVo
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseUserAdminVo
     */
    'nickname'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseUserAdminVo
     */
    'avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseUserAdminVo
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseUserAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {Array<BaseUserMetaItem>}
     * @memberof BaseUserAdminVo
     */
    'meta'?: Array<BaseUserMetaItem>;
    /**
     * 
     * @type {Array<number>}
     * @memberof BaseUserAdminVo
     */
    'roleIds': Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseUserAdminVo
     */
    'orgCodes'?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof BaseUserAdminVo
     */
    'routeIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof BaseUserAdminVo
     */
    'menuIds'?: Array<number>;
}
/**
 * 
 * @export
 * @interface BaseUserMetaItem
 */
export interface BaseUserMetaItem {
    /**
     * 
     * @type {string}
     * @memberof BaseUserMetaItem
     */
    '_key': string;
    /**
     * 
     * @type {any}
     * @memberof BaseUserMetaItem
     */
    '_value': any;
    /**
     * 
     * @type {string}
     * @memberof BaseUserMetaItem
     */
    '_label': string;
    /**
     * 
     * @type {string}
     * @memberof BaseUserMetaItem
     */
    '_type': string;
    /**
     * 
     * @type {string}
     * @memberof BaseUserMetaItem
     */
    '_icon'?: string;
}
/**
 * 
 * @export
 * @interface BaseUserRoleAdminVo
 */
export interface BaseUserRoleAdminVo {
    /**
     * 
     * @type {number}
     * @memberof BaseUserRoleAdminVo
     */
    'userId': number;
    /**
     * 
     * @type {string}
     * @memberof BaseUserRoleAdminVo
     */
    'orgCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof BaseUserRoleAdminVo
     */
    'roleId': number;
}
/**
 * 
 * @export
 * @interface BlackAccountAdminVo
 */
export interface BlackAccountAdminVo {
    /**
     * 
     * @type {number}
     * @memberof BlackAccountAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BlackAccountAdminVo
     */
    'phone': string;
    /**
     * 
     * @type {number}
     * @memberof BlackAccountAdminVo
     */
    'storeId': number;
    /**
     * 
     * @type {string}
     * @memberof BlackAccountAdminVo
     */
    'remark'?: string;
    /**
     * 
     * @type {string}
     * @memberof BlackAccountAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DEVICEMODE = {
    Open: 'open',
    Control: 'control',
    Close: 'close'
} as const;

export type DEVICEMODE = typeof DEVICEMODE[keyof typeof DEVICEMODE];


/**
 * 
 * @export
 * @interface DeviceAdminVo
 */
export interface DeviceAdminVo {
    /**
     * 
     * @type {number}
     * @memberof DeviceAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeviceAdminVo
     */
    'idHex'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceAdminVo
     */
    'serialNumber': string;
    /**
     * 
     * @type {number}
     * @memberof DeviceAdminVo
     */
    'deviceTypeId': number;
    /**
     * 
     * @type {string}
     * @memberof DeviceAdminVo
     */
    'remark'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface DistanceAdminVo
 */
export interface DistanceAdminVo {
    /**
     * 
     * @type {number}
     * @memberof DistanceAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DistanceAdminVo
     */
    'phone': string;
    /**
     * 
     * @type {number}
     * @memberof DistanceAdminVo
     */
    'storeId': number;
    /**
     * 
     * @type {number}
     * @memberof DistanceAdminVo
     */
    'distance': number;
    /**
     * 
     * @type {string}
     * @memberof DistanceAdminVo
     */
    'remark'?: string;
    /**
     * 
     * @type {string}
     * @memberof DistanceAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const EXPRESSSTATUSE = {
    InTransit: 'IN_TRANSIT',
    Delivering: 'DELIVERING',
    Signed: 'SIGNED'
} as const;

export type EXPRESSSTATUSE = typeof EXPRESSSTATUSE[keyof typeof EXPRESSSTATUSE];


/**
 * 
 * @export
 * @interface ExpressAdminVo
 */
export interface ExpressAdminVo {
    /**
     * 
     * @type {number}
     * @memberof ExpressAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ExpressAdminVo
     */
    'trackingNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ExpressAdminVo
     */
    'companyName': string;
    /**
     * 
     * @type {string}
     * @memberof ExpressAdminVo
     */
    'companyCode'?: string;
    /**
     * 
     * @type {EXPRESSSTATUSE}
     * @memberof ExpressAdminVo
     */
    'status': EXPRESSSTATUSE;
    /**
     * 
     * @type {Array<IExpressTrackItem>}
     * @memberof ExpressAdminVo
     */
    'trackInfo': Array<IExpressTrackItem>;
    /**
     * 
     * @type {string}
     * @memberof ExpressAdminVo
     */
    'updateTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExpressAdminVo
     */
    'createTime'?: string;
}


/**
 * 
 * @export
 * @interface ExpressCompanyAdminVo
 */
export interface ExpressCompanyAdminVo {
    /**
     * 
     * @type {number}
     * @memberof ExpressCompanyAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ExpressCompanyAdminVo
     */
    'companyName': string;
    /**
     * 
     * @type {string}
     * @memberof ExpressCompanyAdminVo
     */
    'companyImage': string;
    /**
     * 
     * @type {string}
     * @memberof ExpressCompanyAdminVo
     */
    'companyCode': string;
    /**
     * 
     * @type {string}
     * @memberof ExpressCompanyAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface FacilitatorAdminVo
 */
export interface FacilitatorAdminVo {
    /**
     * 
     * @type {number}
     * @memberof FacilitatorAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorAdminVo
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorAdminVo
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorAdminVo
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorAdminVo
     */
    'province': string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorAdminVo
     */
    'city': string;
    /**
     * 
     * @type {number}
     * @memberof FacilitatorAdminVo
     */
    'deviceCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorAdminVo
     */
    'relativePhone'?: string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorAdminVo
     */
    'relativeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof FacilitatorAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface IExpressTrackItem
 */
export interface IExpressTrackItem {
    /**
     * 
     * @type {string}
     * @memberof IExpressTrackItem
     */
    'time': string;
    /**
     * 
     * @type {string}
     * @memberof IExpressTrackItem
     */
    'description': string;
}
/**
 * 
 * @export
 * @interface IncentivePlanAdminVo
 */
export interface IncentivePlanAdminVo {
    /**
     * 
     * @type {number}
     * @memberof IncentivePlanAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof IncentivePlanAdminVo
     */
    'dailyLimit': number;
    /**
     * 
     * @type {number}
     * @memberof IncentivePlanAdminVo
     */
    'sequenceNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof IncentivePlanAdminVo
     */
    'adCode': string;
    /**
     * 
     * @type {number}
     * @memberof IncentivePlanAdminVo
     */
    'beanCount': number;
    /**
     * 
     * @type {number}
     * @memberof IncentivePlanAdminVo
     */
    'isHidden'?: number;
    /**
     * 
     * @type {string}
     * @memberof IncentivePlanAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof IncentivePlanAdminVo
     */
    'usedCount'?: number;
}
/**
 * 
 * @export
 * @interface JumpWeappAdminVo
 */
export interface JumpWeappAdminVo {
    /**
     * 
     * @type {number}
     * @memberof JumpWeappAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof JumpWeappAdminVo
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof JumpWeappAdminVo
     */
    'targetAppid': string;
    /**
     * 
     * @type {string}
     * @memberof JumpWeappAdminVo
     */
    'targetPath'?: string;
    /**
     * 
     * @type {any}
     * @memberof JumpWeappAdminVo
     */
    'nfcUrl'?: any;
    /**
     * 
     * @type {any}
     * @memberof JumpWeappAdminVo
     */
    'qrcodeUrl'?: any;
    /**
     * 
     * @type {string}
     * @memberof JumpWeappAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const MEMBERTYPEE = {
    Black: 'BLACK',
    White: 'WHITE',
    Normal: 'NORMAL'
} as const;

export type MEMBERTYPEE = typeof MEMBERTYPEE[keyof typeof MEMBERTYPEE];


/**
 * 
 * @export
 * @interface MemberAdminVo
 */
export interface MemberAdminVo {
    /**
     * 
     * @type {number}
     * @memberof MemberAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof MemberAdminVo
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof MemberAdminVo
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof MemberAdminVo
     */
    'storeId': number;
    /**
     * 
     * @type {string}
     * @memberof MemberAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {MEMBERTYPEE}
     * @memberof MemberAdminVo
     */
    'memberType'?: MEMBERTYPEE;
    /**
     * 
     * @type {boolean}
     * @memberof MemberAdminVo
     */
    'isApplay'?: boolean;
}


/**
 * 
 * @export
 * @interface MessageAdminVo
 */
export interface MessageAdminVo {
    /**
     * 
     * @type {number}
     * @memberof MessageAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof MessageAdminVo
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof MessageAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PAYSTATUSE = {
    Prep: 'PREP',
    Complete: 'COMPLETE',
    Failed: 'FAILED'
} as const;

export type PAYSTATUSE = typeof PAYSTATUSE[keyof typeof PAYSTATUSE];


/**
 * 
 * @export
 * @enum {string}
 */

export const PUBLISHSTATUSE = {
    NoPublish: 'no_publish',
    NeedUpdate: 'need_update',
    Review: 'review',
    ReviewFailure: 'review_failure',
    Success: 'success'
} as const;

export type PUBLISHSTATUSE = typeof PUBLISHSTATUSE[keyof typeof PUBLISHSTATUSE];


/**
 * 
 * @export
 * @interface PackageAdminVo
 */
export interface PackageAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PackageAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PackageAdminVo
     */
    'sequenceNumber': number;
    /**
     * 
     * @type {string}
     * @memberof PackageAdminVo
     */
    'packageAmount': string;
    /**
     * 
     * @type {number}
     * @memberof PackageAdminVo
     */
    'packageDays': number;
    /**
     * 
     * @type {number}
     * @memberof PackageAdminVo
     */
    'isHidden'?: number;
    /**
     * 
     * @type {string}
     * @memberof PackageAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PackageRecordAdminVo
 */
export interface PackageRecordAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PackageRecordAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PackageRecordAdminVo
     */
    'storeId': number;
    /**
     * 
     * @type {string}
     * @memberof PackageRecordAdminVo
     */
    'amount': string;
    /**
     * 
     * @type {number}
     * @memberof PackageRecordAdminVo
     */
    'packageDays': number;
    /**
     * 
     * @type {PAYSTATUSE}
     * @memberof PackageRecordAdminVo
     */
    'status': PAYSTATUSE;
    /**
     * 
     * @type {string}
     * @memberof PackageRecordAdminVo
     */
    'createTime'?: string;
}


/**
 * 
 * @export
 * @interface PageQueryVo
 */
export interface PageQueryVo {
    /**
     * 
     * @type {number}
     * @memberof PageQueryVo
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageQueryVo
     */
    'pageSize': number;
}
/**
 * 
 * @export
 * @interface PartialAdminVo
 */
export interface PartialAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialAdminVo
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialAdminVo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialAdminVo
     */
    'password'?: string;
    /**
     * 
     * @type {Array<any>}
     * @memberof PartialAdminVo
     */
    'menus'?: Array<any>;
    /**
     * 
     * @type {string}
     * @memberof PartialAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialAdvertisingAdminVo
 */
export interface PartialAdvertisingAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialAdvertisingAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialAdvertisingAdminVo
     */
    'sequence'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialAdvertisingAdminVo
     */
    'rowId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialAdvertisingAdminVo
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialAdvertisingAdminVo
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialAdvertisingAdminVo
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialAdvertisingAdminVo
     */
    'appid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialAdvertisingAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialAdvertisingRowAdminVo
 */
export interface PartialAdvertisingRowAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialAdvertisingRowAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialAdvertisingRowAdminVo
     */
    'position'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialAdvertisingRowAdminVo
     */
    'sequence'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialAdvertisingRowAdminVo
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialAdvertisingRowAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialAiBeanAdminVo
 */
export interface PartialAiBeanAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialAiBeanAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialAiBeanAdminVo
     */
    'phone'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialAiBeanAdminVo
     */
    'beanCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialAiBeanAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialAiBeanAdminVo
     */
    'updateTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialAiBeanRecordAdminVo
 */
export interface PartialAiBeanRecordAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialAiBeanRecordAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialAiBeanRecordAdminVo
     */
    'phone'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialAiBeanRecordAdminVo
     */
    'changeCount'?: number;
    /**
     * 
     * @type {AIBEANCHANGESOURCEE}
     * @memberof PartialAiBeanRecordAdminVo
     */
    'changeSource'?: AIBEANCHANGESOURCEE;
    /**
     * 
     * @type {any}
     * @memberof PartialAiBeanRecordAdminVo
     */
    'meta'?: any;
    /**
     * 
     * @type {number}
     * @memberof PartialAiBeanRecordAdminVo
     */
    'recordId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialAiBeanRecordAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialAiBeanRecordAdminVo
     */
    'phoneOrNameOrTrack'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialAiBeanRecordAdminVo
     */
    'userName'?: string;
}


/**
 * 
 * @export
 * @interface PartialBaseApiAdminVo
 */
export interface PartialBaseApiAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBaseApiAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseApiAdminVo
     */
    'path'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseApiAdminVo
     */
    'swaggerPath'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseApiAdminVo
     */
    'method'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseApiAdminVo
     */
    'tagName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseApiAdminVo
     */
    'summary'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PartialBaseApiAdminVo
     */
    'allowAll'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PartialBaseApiAdminVo
     */
    'enable'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof PartialBaseApiAdminVo
     */
    'roleIds'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseApiAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialBaseBalanceRecordAdminVo
 */
export interface PartialBaseBalanceRecordAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBaseBalanceRecordAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseBalanceRecordAdminVo
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseBalanceRecordAdminVo
     */
    'type'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseBalanceRecordAdminVo
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseBalanceRecordAdminVo
     */
    'balanceBefore'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseBalanceRecordAdminVo
     */
    'balanceAfter'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseBalanceRecordAdminVo
     */
    'remark'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseBalanceRecordAdminVo
     */
    'refId'?: string;
    /**
     * 
     * @type {any}
     * @memberof PartialBaseBalanceRecordAdminVo
     */
    'extra'?: any;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseBalanceRecordAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseBalanceRecordAdminVo
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseBalanceRecordAdminVo
     */
    'end'?: string;
}
/**
 * 
 * @export
 * @interface PartialBaseDictionaryAdminVo
 */
export interface PartialBaseDictionaryAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBaseDictionaryAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseDictionaryAdminVo
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseDictionaryAdminVo
     */
    'value'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseDictionaryAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialBaseLogAdminVo
 */
export interface PartialBaseLogAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBaseLogAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseLogAdminVo
     */
    'level'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseLogAdminVo
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseLogAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseLogAdminVo
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseLogAdminVo
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseLogAdminVo
     */
    'end'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseLogAdminVo
     */
    'startId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseLogAdminVo
     */
    'endId'?: number;
}
/**
 * 
 * @export
 * @interface PartialBaseMenuAdminVo
 */
export interface PartialBaseMenuAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBaseMenuAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseMenuAdminVo
     */
    'url'?: string;
    /**
     * 
     * @type {BASEMENUTYPEE}
     * @memberof PartialBaseMenuAdminVo
     */
    'type'?: BASEMENUTYPEE;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseMenuAdminVo
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseMenuAdminVo
     */
    'icon'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseMenuAdminVo
     */
    'sequence'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PartialBaseMenuAdminVo
     */
    'enable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseMenuAdminVo
     */
    'parentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseMenuAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PartialBaseMenuAdminVo
     */
    'roleIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PartialBaseMenuAdminVo
     */
    'routeIds'?: Array<number>;
}


/**
 * 
 * @export
 * @interface PartialBaseMessageAdminVo
 */
export interface PartialBaseMessageAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBaseMessageAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseMessageAdminVo
     */
    'tenantId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseMessageAdminVo
     */
    'sendUserId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseMessageAdminVo
     */
    'msgType'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseMessageAdminVo
     */
    'msgSummary'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseMessageAdminVo
     */
    'msgContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseMessageAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PartialBaseMessageAdminVo
     */
    'targetUserIds'?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PartialBaseMessageAdminVo
     */
    'targetOrgCodes'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PartialBaseOperateAdminVo
 */
export interface PartialBaseOperateAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBaseOperateAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseOperateAdminVo
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseOperateAdminVo
     */
    'name'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PartialBaseOperateAdminVo
     */
    'roleIds'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseOperateAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialBaseOrganizationAdminVo
 */
export interface PartialBaseOrganizationAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBaseOrganizationAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseOrganizationAdminVo
     */
    'tenantId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseOrganizationAdminVo
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseOrganizationAdminVo
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseOrganizationAdminVo
     */
    'parentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseOrganizationAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialBasePaymentOrderAdminVo
 */
export interface PartialBasePaymentOrderAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'platform'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'orderNo'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'subject'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'body'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'platformOrderNo'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'refundAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'expireAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'paidAt'?: string;
    /**
     * 
     * @type {any}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'extra'?: any;
    /**
     * 
     * @type {string}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'updateTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialBaseRoleAdminVo
 */
export interface PartialBaseRoleAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBaseRoleAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseRoleAdminVo
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseRoleAdminVo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseRoleAdminVo
     */
    'orgCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseRoleAdminVo
     */
    'level'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseRoleAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialBaseRouteAdminVo
 */
export interface PartialBaseRouteAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBaseRouteAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {BASEROUTETYPEE}
     * @memberof PartialBaseRouteAdminVo
     */
    'type'?: BASEROUTETYPEE;
    /**
     * 
     * @type {boolean}
     * @memberof PartialBaseRouteAdminVo
     */
    'allowAll'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseRouteAdminVo
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseRouteAdminVo
     */
    'path'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseRouteAdminVo
     */
    'componentName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PartialBaseRouteAdminVo
     */
    'isNest'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseRouteAdminVo
     */
    'redirect'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PartialBaseRouteAdminVo
     */
    'enable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseRouteAdminVo
     */
    'parentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseRouteAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PartialBaseRouteAdminVo
     */
    'roleIds'?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof PartialBaseRouteAdminVo
     */
    'isIndex'?: boolean;
}


/**
 * 
 * @export
 * @interface PartialBaseScheduleAdminVo
 */
export interface PartialBaseScheduleAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBaseScheduleAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseScheduleAdminVo
     */
    'tenantId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseScheduleAdminVo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseScheduleAdminVo
     */
    'ruleDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseScheduleAdminVo
     */
    'ruleInterval'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseScheduleAdminVo
     */
    'ruleCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseScheduleAdminVo
     */
    'ruleCurrent'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseScheduleAdminVo
     */
    'ruleNextTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseScheduleAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialBaseTenantAdminVo
 */
export interface PartialBaseTenantAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBaseTenantAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseTenantAdminVo
     */
    'name'?: string;
    /**
     * 
     * @type {any}
     * @memberof PartialBaseTenantAdminVo
     */
    'meta'?: any;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseTenantAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialBaseUserAdminVo
 */
export interface PartialBaseUserAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBaseUserAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseUserAdminVo
     */
    'tenantId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseUserAdminVo
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseUserAdminVo
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseUserAdminVo
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseUserAdminVo
     */
    'nickname'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseUserAdminVo
     */
    'avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseUserAdminVo
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseUserAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {Array<BaseUserMetaItem>}
     * @memberof PartialBaseUserAdminVo
     */
    'meta'?: Array<BaseUserMetaItem>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PartialBaseUserAdminVo
     */
    'roleIds'?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PartialBaseUserAdminVo
     */
    'orgCodes'?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PartialBaseUserAdminVo
     */
    'routeIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PartialBaseUserAdminVo
     */
    'menuIds'?: Array<number>;
}
/**
 * 
 * @export
 * @interface PartialBlackAccountAdminVo
 */
export interface PartialBlackAccountAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBlackAccountAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBlackAccountAdminVo
     */
    'phone'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialBlackAccountAdminVo
     */
    'storeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBlackAccountAdminVo
     */
    'remark'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBlackAccountAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialDeviceAdminVo
 */
export interface PartialDeviceAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialDeviceAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialDeviceAdminVo
     */
    'idHex'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialDeviceAdminVo
     */
    'serialNumber'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialDeviceAdminVo
     */
    'deviceTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialDeviceAdminVo
     */
    'remark'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialDeviceAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialDistanceAdminVo
 */
export interface PartialDistanceAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialDistanceAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialDistanceAdminVo
     */
    'phone'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialDistanceAdminVo
     */
    'storeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialDistanceAdminVo
     */
    'distance'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialDistanceAdminVo
     */
    'remark'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialDistanceAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialExpressAdminVo
 */
export interface PartialExpressAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialExpressAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialExpressAdminVo
     */
    'trackingNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialExpressAdminVo
     */
    'companyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialExpressAdminVo
     */
    'companyCode'?: string;
    /**
     * 
     * @type {EXPRESSSTATUSE}
     * @memberof PartialExpressAdminVo
     */
    'status'?: EXPRESSSTATUSE;
    /**
     * 
     * @type {Array<IExpressTrackItem>}
     * @memberof PartialExpressAdminVo
     */
    'trackInfo'?: Array<IExpressTrackItem>;
    /**
     * 
     * @type {string}
     * @memberof PartialExpressAdminVo
     */
    'updateTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialExpressAdminVo
     */
    'createTime'?: string;
}


/**
 * 
 * @export
 * @interface PartialExpressCompanyAdminVo
 */
export interface PartialExpressCompanyAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialExpressCompanyAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialExpressCompanyAdminVo
     */
    'companyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialExpressCompanyAdminVo
     */
    'companyImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialExpressCompanyAdminVo
     */
    'companyCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialExpressCompanyAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialFacilitatorAdminVo
 */
export interface PartialFacilitatorAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialFacilitatorAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialFacilitatorAdminVo
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialFacilitatorAdminVo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialFacilitatorAdminVo
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialFacilitatorAdminVo
     */
    'province'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialFacilitatorAdminVo
     */
    'city'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialFacilitatorAdminVo
     */
    'deviceCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialFacilitatorAdminVo
     */
    'relativePhone'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialFacilitatorAdminVo
     */
    'relativeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialFacilitatorAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialIncentivePlanAdminVo
 */
export interface PartialIncentivePlanAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialIncentivePlanAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialIncentivePlanAdminVo
     */
    'dailyLimit'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialIncentivePlanAdminVo
     */
    'sequenceNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialIncentivePlanAdminVo
     */
    'adCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialIncentivePlanAdminVo
     */
    'beanCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialIncentivePlanAdminVo
     */
    'isHidden'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialIncentivePlanAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialIncentivePlanAdminVo
     */
    'usedCount'?: number;
}
/**
 * 
 * @export
 * @interface PartialJumpWeappAdminVo
 */
export interface PartialJumpWeappAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialJumpWeappAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialJumpWeappAdminVo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialJumpWeappAdminVo
     */
    'targetAppid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialJumpWeappAdminVo
     */
    'targetPath'?: string;
    /**
     * 
     * @type {any}
     * @memberof PartialJumpWeappAdminVo
     */
    'nfcUrl'?: any;
    /**
     * 
     * @type {any}
     * @memberof PartialJumpWeappAdminVo
     */
    'qrcodeUrl'?: any;
    /**
     * 
     * @type {string}
     * @memberof PartialJumpWeappAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialMemberAdminVo
 */
export interface PartialMemberAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialMemberAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialMemberAdminVo
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialMemberAdminVo
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialMemberAdminVo
     */
    'storeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialMemberAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {MEMBERTYPEE}
     * @memberof PartialMemberAdminVo
     */
    'memberType'?: MEMBERTYPEE;
    /**
     * 
     * @type {boolean}
     * @memberof PartialMemberAdminVo
     */
    'isApplay'?: boolean;
}


/**
 * 
 * @export
 * @interface PartialMessageAdminVo
 */
export interface PartialMessageAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialMessageAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialMessageAdminVo
     */
    'msg'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialMessageAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialPackageAdminVo
 */
export interface PartialPackageAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialPackageAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialPackageAdminVo
     */
    'sequenceNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialPackageAdminVo
     */
    'packageAmount'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialPackageAdminVo
     */
    'packageDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialPackageAdminVo
     */
    'isHidden'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialPackageAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialPackageRecordAdminVo
 */
export interface PartialPackageRecordAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialPackageRecordAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialPackageRecordAdminVo
     */
    'storeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialPackageRecordAdminVo
     */
    'amount'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialPackageRecordAdminVo
     */
    'packageDays'?: number;
    /**
     * 
     * @type {PAYSTATUSE}
     * @memberof PartialPackageRecordAdminVo
     */
    'status'?: PAYSTATUSE;
    /**
     * 
     * @type {string}
     * @memberof PartialPackageRecordAdminVo
     */
    'createTime'?: string;
}


/**
 * 
 * @export
 * @interface PartialRechargePlanAdminVo
 */
export interface PartialRechargePlanAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialRechargePlanAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialRechargePlanAdminVo
     */
    'amount'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialRechargePlanAdminVo
     */
    'beanCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialRechargePlanAdminVo
     */
    'sequenceNumber'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialRechargePlanAdminVo
     */
    'purchaseLimit'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialRechargePlanAdminVo
     */
    'isHidden'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialRechargePlanAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialRecordAdminVo
 */
export interface PartialRecordAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialRecordAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PartialRecordAdminVo
     */
    'status'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordAdminVo
     */
    'msg'?: string;
    /**
     * 
     * @type {object}
     * @memberof PartialRecordAdminVo
     */
    'userGeo'?: object;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordAdminVo
     */
    'customType'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordAdminVo
     */
    'phone'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialRecordAdminVo
     */
    'storeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialRecordAdminVo
     */
    'distance'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordAdminVo
     */
    'deviceRemark'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordAdminVo
     */
    'storeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordAdminVo
     */
    'trackingNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordAdminVo
     */
    'companyCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordAdminVo
     */
    'companyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordAdminVo
     */
    'phoneOrNameOrTrack'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordAdminVo
     */
    'userName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialStationAddressAdminVo
 */
export interface PartialStationAddressAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialStationAddressAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialStationAddressAdminVo
     */
    'storeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialStationAddressAdminVo
     */
    'stationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialStationAddressAdminVo
     */
    'expressCompanyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialStationAddressAdminVo
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialStationAddressAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialStationAddressAdminVo
     */
    'storeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialStationAddressAdminVo
     */
    'stationAccount'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialStationAddressAdminVo
     */
    'expressCompanyName'?: string;
}
/**
 * 
 * @export
 * @interface PartialStationAdminVo
 */
export interface PartialStationAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialStationAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialStationAdminVo
     */
    'storeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialStationAdminVo
     */
    'stationTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialStationAdminVo
     */
    'account'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialStationAdminVo
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialStationAdminVo
     */
    'remark'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialStationAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialStationAdminVo
     */
    'storeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialStationAdminVo
     */
    'stationTypeName'?: string;
    /**
     * 
     * @type {Array<StationAddressAdminVo>}
     * @memberof PartialStationAdminVo
     */
    'stationAddresses'?: Array<StationAddressAdminVo>;
}
/**
 * 
 * @export
 * @interface PartialStationTypeAdminVo
 */
export interface PartialStationTypeAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialStationTypeAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialStationTypeAdminVo
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialStationTypeAdminVo
     */
    'typeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialStationTypeAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialStoreAdminVo
 */
export interface PartialStoreAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialStoreAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialStoreAdminVo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialStoreAdminVo
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialStoreAdminVo
     */
    'deviceIdHex'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialStoreAdminVo
     */
    'start'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialStoreAdminVo
     */
    'end'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialStoreAdminVo
     */
    'longtitude'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialStoreAdminVo
     */
    'latitude'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialStoreAdminVo
     */
    'distance'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialStoreAdminVo
     */
    'remark'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialStoreAdminVo
     */
    'deviceTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialStoreAdminVo
     */
    'facilitatorId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialStoreAdminVo
     */
    'facilitatorName'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialStoreAdminVo
     */
    'whiteStart'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialStoreAdminVo
     */
    'whiteEnd'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PartialStoreAdminVo
     */
    'openWhite'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PartialStoreAdminVo
     */
    'wxAppid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialStoreAdminVo
     */
    'downloadQrcodeUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialStoreAdminVo
     */
    'allCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialStoreAdminVo
     */
    'allPeople'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialStoreAdminVo
     */
    'lastdayCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialStoreAdminVo
     */
    'lastdayPeople'?: number;
    /**
     * 
     * @type {STORETYPEE}
     * @memberof PartialStoreAdminVo
     */
    'storeType'?: STORETYPEE;
    /**
     * 
     * @type {string}
     * @memberof PartialStoreAdminVo
     */
    'packageEndTime'?: string;
    /**
     * 
     * @type {any}
     * @memberof PartialStoreAdminVo
     */
    'nfcUrls'?: any;
    /**
     * 
     * @type {string}
     * @memberof PartialStoreAdminVo
     */
    'createTime'?: string;
}


/**
 * 
 * @export
 * @interface PartialStoreStatisticsAdminVo
 */
export interface PartialStoreStatisticsAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialStoreStatisticsAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialStoreStatisticsAdminVo
     */
    'storeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialStoreStatisticsAdminVo
     */
    'syncTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialStoreStatisticsAdminVo
     */
    'openPeople'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialStoreStatisticsAdminVo
     */
    'openCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialStoreStatisticsAdminVo
     */
    'storeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialStoreStatisticsAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialSubAccountAdminVo
 */
export interface PartialSubAccountAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialSubAccountAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialSubAccountAdminVo
     */
    'storeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialSubAccountAdminVo
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialSubAccountAdminVo
     */
    'remark'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialSubAccountAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialTenantAdminVo
 */
export interface PartialTenantAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialTenantAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialTenantAdminVo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialTenantAdminVo
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialTenantAdminVo
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialTenantAdminVo
     */
    'logo'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PartialTenantAdminVo
     */
    'weappTplIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PartialTenantAdminVo
     */
    'wxTplIds'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PartialTenantAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialTicketAdminVo
 */
export interface PartialTicketAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialTicketAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialTicketAdminVo
     */
    'ticketPackageId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialTicketAdminVo
     */
    'isVerified'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialTicketAdminVo
     */
    'expireTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialTicketAdminVo
     */
    'verifiedPhone'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialTicketAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialTicketAdminVo
     */
    'beanCount'?: number;
}
/**
 * 
 * @export
 * @interface PartialTicketPackageAdminVo
 */
export interface PartialTicketPackageAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialTicketPackageAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialTicketPackageAdminVo
     */
    'beanCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialTicketPackageAdminVo
     */
    'sequenceNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialTicketPackageAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialTicketPackageAdminVo
     */
    'totalTicketCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialTicketPackageAdminVo
     */
    'verifiedTicketCount'?: number;
}
/**
 * 
 * @export
 * @interface PartialUserSubscriptionAdminVo
 */
export interface PartialUserSubscriptionAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialUserSubscriptionAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialUserSubscriptionAdminVo
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialUserSubscriptionAdminVo
     */
    'trackingNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialUserSubscriptionAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialUserSubscriptionAdminVo
     */
    'updateTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialWeappAdminVo
 */
export interface PartialWeappAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialWeappAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialWeappAdminVo
     */
    'appid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialWeappAdminVo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialWeappAdminVo
     */
    'principalName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialWeappAdminVo
     */
    'remark'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PartialWeappAdminVo
     */
    'baseSetting'?: boolean;
    /**
     * 
     * @type {any}
     * @memberof PartialWeappAdminVo
     */
    'privacyInterface'?: any;
    /**
     * 
     * @type {number}
     * @memberof PartialWeappAdminVo
     */
    'templateId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialWeappAdminVo
     */
    'auditId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialWeappAdminVo
     */
    'currentVersion'?: string;
    /**
     * 
     * @type {PUBLISHSTATUSE}
     * @memberof PartialWeappAdminVo
     */
    'status'?: PUBLISHSTATUSE;
    /**
     * 
     * @type {string}
     * @memberof PartialWeappAdminVo
     */
    'modelId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialWeappAdminVo
     */
    'secret'?: string;
    /**
     * 
     * @type {any}
     * @memberof PartialWeappAdminVo
     */
    'ext'?: any;
    /**
     * 
     * @type {string}
     * @memberof PartialWeappAdminVo
     */
    'createTime'?: string;
}


/**
 * 
 * @export
 * @interface PartialWeappTplAdminVo
 */
export interface PartialWeappTplAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialWeappTplAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialWeappTplAdminVo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialWeappTplAdminVo
     */
    'currentVersion'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialWeappTplAdminVo
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialWeappTplAdminVo
     */
    'templateId'?: number;
    /**
     * 
     * @type {any}
     * @memberof PartialWeappTplAdminVo
     */
    'extjsFormItems'?: any;
    /**
     * 
     * @type {string}
     * @memberof PartialWeappTplAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialWhiteAccountAdminVo
 */
export interface PartialWhiteAccountAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialWhiteAccountAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialWhiteAccountAdminVo
     */
    'phone'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialWhiteAccountAdminVo
     */
    'storeId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PartialWhiteAccountAdminVo
     */
    'isApplay'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PartialWhiteAccountAdminVo
     */
    'remark'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialWhiteAccountAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialWxAdminVo
 */
export interface PartialWxAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialWxAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialWxAdminVo
     */
    'appid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialWxAdminVo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialWxAdminVo
     */
    'principalName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialWxAdminVo
     */
    'remark'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialWxAdminVo
     */
    'openMsgTemplateId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialWxAdminVo
     */
    'applyTemplateId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialWxAdminVo
     */
    'pickupTemplateId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialWxAdminVo
     */
    'waybillStatusTemplateId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialWxAdminVo
     */
    'scanSuccessTemplateId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialWxAdminVo
     */
    'weappAppid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialWxAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialWxTplAdminVo
 */
export interface PartialWxTplAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialWxTplAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialWxTplAdminVo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialWxTplAdminVo
     */
    'currentVersion'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialWxTplAdminVo
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialWxTplAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface RechargePlanAdminVo
 */
export interface RechargePlanAdminVo {
    /**
     * 
     * @type {number}
     * @memberof RechargePlanAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof RechargePlanAdminVo
     */
    'amount': string;
    /**
     * 
     * @type {number}
     * @memberof RechargePlanAdminVo
     */
    'beanCount': number;
    /**
     * 
     * @type {number}
     * @memberof RechargePlanAdminVo
     */
    'sequenceNumber'?: number;
    /**
     * 
     * @type {number}
     * @memberof RechargePlanAdminVo
     */
    'purchaseLimit'?: number;
    /**
     * 
     * @type {number}
     * @memberof RechargePlanAdminVo
     */
    'isHidden'?: number;
    /**
     * 
     * @type {string}
     * @memberof RechargePlanAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface RecordAdminVo
 */
export interface RecordAdminVo {
    /**
     * 
     * @type {number}
     * @memberof RecordAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RecordAdminVo
     */
    'status': boolean;
    /**
     * 
     * @type {string}
     * @memberof RecordAdminVo
     */
    'msg': string;
    /**
     * 
     * @type {object}
     * @memberof RecordAdminVo
     */
    'userGeo'?: object;
    /**
     * 
     * @type {string}
     * @memberof RecordAdminVo
     */
    'customType'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecordAdminVo
     */
    'phone'?: string;
    /**
     * 
     * @type {number}
     * @memberof RecordAdminVo
     */
    'storeId': number;
    /**
     * 
     * @type {number}
     * @memberof RecordAdminVo
     */
    'distance'?: number;
    /**
     * 
     * @type {string}
     * @memberof RecordAdminVo
     */
    'deviceRemark'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecordAdminVo
     */
    'storeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecordAdminVo
     */
    'trackingNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecordAdminVo
     */
    'companyCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecordAdminVo
     */
    'companyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecordAdminVo
     */
    'phoneOrNameOrTrack'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecordAdminVo
     */
    'userName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecordAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface ResultVo
 */
export interface ResultVo {
    /**
     * 
     * @type {boolean}
     * @memberof ResultVo
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof ResultVo
     */
    'msg'?: string;
    /**
     * 
     * @type {any}
     * @memberof ResultVo
     */
    'data'?: any;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const STORETYPEE = {
    General: 'GENERAL',
    Express: 'EXPRESS'
} as const;

export type STORETYPEE = typeof STORETYPEE[keyof typeof STORETYPEE];


/**
 * 
 * @export
 * @interface StationAddressAdminVo
 */
export interface StationAddressAdminVo {
    /**
     * 
     * @type {number}
     * @memberof StationAddressAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof StationAddressAdminVo
     */
    'storeId': number;
    /**
     * 
     * @type {number}
     * @memberof StationAddressAdminVo
     */
    'stationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof StationAddressAdminVo
     */
    'expressCompanyId': number;
    /**
     * 
     * @type {string}
     * @memberof StationAddressAdminVo
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof StationAddressAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof StationAddressAdminVo
     */
    'storeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof StationAddressAdminVo
     */
    'stationAccount'?: string;
    /**
     * 
     * @type {string}
     * @memberof StationAddressAdminVo
     */
    'expressCompanyName'?: string;
}
/**
 * 
 * @export
 * @interface StationAdminVo
 */
export interface StationAdminVo {
    /**
     * 
     * @type {number}
     * @memberof StationAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof StationAdminVo
     */
    'storeId': number;
    /**
     * 
     * @type {number}
     * @memberof StationAdminVo
     */
    'stationTypeId': number;
    /**
     * 
     * @type {string}
     * @memberof StationAdminVo
     */
    'account': string;
    /**
     * 
     * @type {string}
     * @memberof StationAdminVo
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof StationAdminVo
     */
    'remark'?: string;
    /**
     * 
     * @type {string}
     * @memberof StationAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof StationAdminVo
     */
    'storeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof StationAdminVo
     */
    'stationTypeName'?: string;
    /**
     * 
     * @type {Array<StationAddressAdminVo>}
     * @memberof StationAdminVo
     */
    'stationAddresses'?: Array<StationAddressAdminVo>;
}
/**
 * 
 * @export
 * @interface StationTypeAdminVo
 */
export interface StationTypeAdminVo {
    /**
     * 
     * @type {number}
     * @memberof StationTypeAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof StationTypeAdminVo
     */
    'imageUrl': string;
    /**
     * 
     * @type {string}
     * @memberof StationTypeAdminVo
     */
    'typeName': string;
    /**
     * 
     * @type {string}
     * @memberof StationTypeAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface StoreAdminVo
 */
export interface StoreAdminVo {
    /**
     * 
     * @type {number}
     * @memberof StoreAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof StoreAdminVo
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof StoreAdminVo
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof StoreAdminVo
     */
    'deviceIdHex': string;
    /**
     * 
     * @type {number}
     * @memberof StoreAdminVo
     */
    'start': number;
    /**
     * 
     * @type {number}
     * @memberof StoreAdminVo
     */
    'end': number;
    /**
     * 
     * @type {string}
     * @memberof StoreAdminVo
     */
    'longtitude'?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreAdminVo
     */
    'latitude'?: string;
    /**
     * 
     * @type {number}
     * @memberof StoreAdminVo
     */
    'distance'?: number;
    /**
     * 
     * @type {string}
     * @memberof StoreAdminVo
     */
    'remark'?: string;
    /**
     * 
     * @type {number}
     * @memberof StoreAdminVo
     */
    'deviceTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof StoreAdminVo
     */
    'facilitatorId'?: number;
    /**
     * 
     * @type {string}
     * @memberof StoreAdminVo
     */
    'facilitatorName'?: string;
    /**
     * 
     * @type {number}
     * @memberof StoreAdminVo
     */
    'whiteStart'?: number;
    /**
     * 
     * @type {number}
     * @memberof StoreAdminVo
     */
    'whiteEnd'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof StoreAdminVo
     */
    'openWhite'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StoreAdminVo
     */
    'wxAppid'?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreAdminVo
     */
    'downloadQrcodeUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof StoreAdminVo
     */
    'allCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof StoreAdminVo
     */
    'allPeople'?: number;
    /**
     * 
     * @type {number}
     * @memberof StoreAdminVo
     */
    'lastdayCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof StoreAdminVo
     */
    'lastdayPeople'?: number;
    /**
     * 
     * @type {STORETYPEE}
     * @memberof StoreAdminVo
     */
    'storeType'?: STORETYPEE;
    /**
     * 
     * @type {string}
     * @memberof StoreAdminVo
     */
    'packageEndTime'?: string;
    /**
     * 
     * @type {any}
     * @memberof StoreAdminVo
     */
    'nfcUrls'?: any;
    /**
     * 
     * @type {string}
     * @memberof StoreAdminVo
     */
    'createTime'?: string;
}


/**
 * 
 * @export
 * @interface StoreOwnerVo
 */
export interface StoreOwnerVo {
    /**
     * 
     * @type {number}
     * @memberof StoreOwnerVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof StoreOwnerVo
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof StoreOwnerVo
     */
    'deviceIdHex': string;
    /**
     * 
     * @type {string}
     * @memberof StoreOwnerVo
     */
    'longtitude'?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreOwnerVo
     */
    'latitude'?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreOwnerVo
     */
    'mod'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StoreOwnerVo
     */
    'status'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StoreOwnerVo
     */
    'start': number;
    /**
     * 
     * @type {number}
     * @memberof StoreOwnerVo
     */
    'end': number;
    /**
     * 
     * @type {boolean}
     * @memberof StoreOwnerVo
     */
    'isSubAccount'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StoreOwnerVo
     */
    'allCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof StoreOwnerVo
     */
    'allPeople'?: number;
    /**
     * 
     * @type {number}
     * @memberof StoreOwnerVo
     */
    'lastdayCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof StoreOwnerVo
     */
    'lastdayPeople'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof StoreOwnerVo
     */
    'openWhite'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StoreOwnerVo
     */
    'whiteStart'?: number;
    /**
     * 
     * @type {number}
     * @memberof StoreOwnerVo
     */
    'whiteEnd'?: number;
    /**
     * 
     * @type {string}
     * @memberof StoreOwnerVo
     */
    'downloadQrcodeUrl'?: string;
    /**
     * 
     * @type {STORETYPEE}
     * @memberof StoreOwnerVo
     */
    'storeType'?: STORETYPEE;
    /**
     * 
     * @type {string}
     * @memberof StoreOwnerVo
     */
    'packageEndTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreOwnerVo
     */
    'createTime'?: string;
}


/**
 * 
 * @export
 * @interface StoreStatisticsAdminVo
 */
export interface StoreStatisticsAdminVo {
    /**
     * 
     * @type {number}
     * @memberof StoreStatisticsAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof StoreStatisticsAdminVo
     */
    'storeId': number;
    /**
     * 
     * @type {string}
     * @memberof StoreStatisticsAdminVo
     */
    'syncTime': string;
    /**
     * 
     * @type {number}
     * @memberof StoreStatisticsAdminVo
     */
    'openPeople': number;
    /**
     * 
     * @type {number}
     * @memberof StoreStatisticsAdminVo
     */
    'openCount': number;
    /**
     * 
     * @type {string}
     * @memberof StoreStatisticsAdminVo
     */
    'storeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreStatisticsAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface SubAccountAdminVo
 */
export interface SubAccountAdminVo {
    /**
     * 
     * @type {number}
     * @memberof SubAccountAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubAccountAdminVo
     */
    'storeId': number;
    /**
     * 
     * @type {string}
     * @memberof SubAccountAdminVo
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof SubAccountAdminVo
     */
    'remark'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubAccountAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject1
 */
export interface SystemGenerateObject1 {
    /**
     * 
     * @type {PartialBaseApiAdminVo}
     * @memberof SystemGenerateObject1
     */
    'conditions'?: PartialBaseApiAdminVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject1
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject1
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject100
 */
export interface SystemGenerateObject100 {
    /**
     * 
     * @type {DeviceAdminVo}
     * @memberof SystemGenerateObject100
     */
    'deviceAdminVo': DeviceAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject101
 */
export interface SystemGenerateObject101 {
    /**
     * 
     * @type {DeviceAdminVo}
     * @memberof SystemGenerateObject101
     */
    'deviceAdminVo': DeviceAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject102
 */
export interface SystemGenerateObject102 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject102
     */
    'storeId': number;
    /**
     * 
     * @type {DEVICEMODE}
     * @memberof SystemGenerateObject102
     */
    'mod': DEVICEMODE;
}


/**
 * 
 * @export
 * @interface SystemGenerateObject103
 */
export interface SystemGenerateObject103 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject103
     */
    'storeId': number;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject104
 */
export interface SystemGenerateObject104 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject104
     */
    'storeId': number;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject105
 */
export interface SystemGenerateObject105 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject105
     */
    'nameOrdeviceIdHex'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject106
 */
export interface SystemGenerateObject106 {
    /**
     * 
     * @type {StoreOwnerVo}
     * @memberof SystemGenerateObject106
     */
    'storeOwnerVo': StoreOwnerVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject107
 */
export interface SystemGenerateObject107 {
    /**
     * 
     * @type {StoreOwnerVo}
     * @memberof SystemGenerateObject107
     */
    'storeOwnerVo': StoreOwnerVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject108
 */
export interface SystemGenerateObject108 {
    /**
     * 
     * @type {PartialStoreAdminVo}
     * @memberof SystemGenerateObject108
     */
    'conditions': PartialStoreAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject109
 */
export interface SystemGenerateObject109 {
    /**
     * 
     * @type {PartialStoreAdminVo}
     * @memberof SystemGenerateObject109
     */
    'conditions': PartialStoreAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject109
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject110
 */
export interface SystemGenerateObject110 {
    /**
     * 
     * @type {StoreAdminVo}
     * @memberof SystemGenerateObject110
     */
    'storeAdminVo': StoreAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject111
 */
export interface SystemGenerateObject111 {
    /**
     * 
     * @type {StoreAdminVo}
     * @memberof SystemGenerateObject111
     */
    'storeAdminVo': StoreAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject112
 */
export interface SystemGenerateObject112 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject112
     */
    'longtitude': string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject112
     */
    'latitude': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject113
 */
export interface SystemGenerateObject113 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject113
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject114
 */
export interface SystemGenerateObject114 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject114
     */
    'storeId': number;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject115
 */
export interface SystemGenerateObject115 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject115
     */
    'storeId': number;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject116
 */
export interface SystemGenerateObject116 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject116
     */
    'storeId': number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject116
     */
    'appid': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject117
 */
export interface SystemGenerateObject117 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject117
     */
    'storeId': number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject117
     */
    'appid': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject118
 */
export interface SystemGenerateObject118 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject118
     */
    'storeId': number;
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject118
     */
    'h5TplId': number;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject119
 */
export interface SystemGenerateObject119 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject119
     */
    'storeId': number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject119
     */
    'appid': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject120
 */
export interface SystemGenerateObject120 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject120
     */
    'storeId': number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject120
     */
    'appid': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject121
 */
export interface SystemGenerateObject121 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject121
     */
    'storeId': number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject121
     */
    'h5TplId': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject122
 */
export interface SystemGenerateObject122 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject122
     */
    'storeId': number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject122
     */
    'appid': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject123
 */
export interface SystemGenerateObject123 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject123
     */
    'storeId': number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject123
     */
    'qrcodeUrl': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject124
 */
export interface SystemGenerateObject124 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject124
     */
    'storeId': number;
    /**
     * 
     * @type {PartialExpressAdminVo}
     * @memberof SystemGenerateObject124
     */
    'express': PartialExpressAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject125
 */
export interface SystemGenerateObject125 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject125
     */
    'storeId': number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject125
     */
    'weappAppid': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject126
 */
export interface SystemGenerateObject126 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject126
     */
    'storeId': number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject126
     */
    'appid': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject127
 */
export interface SystemGenerateObject127 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject127
     */
    'storeId': number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject127
     */
    'appid': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject128
 */
export interface SystemGenerateObject128 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject128
     */
    'storeId': number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject128
     */
    'appid': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject129
 */
export interface SystemGenerateObject129 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject129
     */
    'storeId': number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject129
     */
    'newOwnerPhone': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject130
 */
export interface SystemGenerateObject130 {
    /**
     * 
     * @type {PartialSubAccountAdminVo}
     * @memberof SystemGenerateObject130
     */
    'conditions': PartialSubAccountAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject131
 */
export interface SystemGenerateObject131 {
    /**
     * 
     * @type {PartialSubAccountAdminVo}
     * @memberof SystemGenerateObject131
     */
    'conditions': PartialSubAccountAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject131
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject132
 */
export interface SystemGenerateObject132 {
    /**
     * 
     * @type {SubAccountAdminVo}
     * @memberof SystemGenerateObject132
     */
    'subAccountAdminVo': SubAccountAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject133
 */
export interface SystemGenerateObject133 {
    /**
     * 
     * @type {SubAccountAdminVo}
     * @memberof SystemGenerateObject133
     */
    'subAccountAdminVo': SubAccountAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject134
 */
export interface SystemGenerateObject134 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject134
     */
    'storeId': number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject134
     */
    'remarkOrPhone'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject135
 */
export interface SystemGenerateObject135 {
    /**
     * 
     * @type {SubAccountAdminVo}
     * @memberof SystemGenerateObject135
     */
    'subAccountAdminVo': SubAccountAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject136
 */
export interface SystemGenerateObject136 {
    /**
     * 
     * @type {SubAccountAdminVo}
     * @memberof SystemGenerateObject136
     */
    'subAccountAdminVo': SubAccountAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject137
 */
export interface SystemGenerateObject137 {
    /**
     * 
     * @type {PartialAdminVo}
     * @memberof SystemGenerateObject137
     */
    'conditions': PartialAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject138
 */
export interface SystemGenerateObject138 {
    /**
     * 
     * @type {PartialAdminVo}
     * @memberof SystemGenerateObject138
     */
    'conditions': PartialAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject138
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject139
 */
export interface SystemGenerateObject139 {
    /**
     * 
     * @type {AdminVo}
     * @memberof SystemGenerateObject139
     */
    'adminAdminVo': AdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject140
 */
export interface SystemGenerateObject140 {
    /**
     * 
     * @type {AdminVo}
     * @memberof SystemGenerateObject140
     */
    'adminAdminVo': AdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject141
 */
export interface SystemGenerateObject141 {
    /**
     * 
     * @type {PartialFacilitatorAdminVo}
     * @memberof SystemGenerateObject141
     */
    'conditions': PartialFacilitatorAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject142
 */
export interface SystemGenerateObject142 {
    /**
     * 
     * @type {PartialFacilitatorAdminVo}
     * @memberof SystemGenerateObject142
     */
    'conditions': PartialFacilitatorAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject142
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject143
 */
export interface SystemGenerateObject143 {
    /**
     * 
     * @type {FacilitatorAdminVo}
     * @memberof SystemGenerateObject143
     */
    'facilitatorAdminVo': FacilitatorAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject144
 */
export interface SystemGenerateObject144 {
    /**
     * 
     * @type {FacilitatorAdminVo}
     * @memberof SystemGenerateObject144
     */
    'facilitatorAdminVo': FacilitatorAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject145
 */
export interface SystemGenerateObject145 {
    /**
     * 
     * @type {PartialMessageAdminVo}
     * @memberof SystemGenerateObject145
     */
    'conditions': PartialMessageAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject146
 */
export interface SystemGenerateObject146 {
    /**
     * 
     * @type {PartialMessageAdminVo}
     * @memberof SystemGenerateObject146
     */
    'conditions': PartialMessageAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject146
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject147
 */
export interface SystemGenerateObject147 {
    /**
     * 
     * @type {MessageAdminVo}
     * @memberof SystemGenerateObject147
     */
    'messageAdminVo': MessageAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject148
 */
export interface SystemGenerateObject148 {
    /**
     * 
     * @type {MessageAdminVo}
     * @memberof SystemGenerateObject148
     */
    'messageAdminVo': MessageAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject149
 */
export interface SystemGenerateObject149 {
    /**
     * 
     * @type {PartialDistanceAdminVo}
     * @memberof SystemGenerateObject149
     */
    'conditions': PartialDistanceAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject150
 */
export interface SystemGenerateObject150 {
    /**
     * 
     * @type {PartialDistanceAdminVo}
     * @memberof SystemGenerateObject150
     */
    'conditions': PartialDistanceAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject150
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject151
 */
export interface SystemGenerateObject151 {
    /**
     * 
     * @type {DistanceAdminVo}
     * @memberof SystemGenerateObject151
     */
    'distanceAdminVo': DistanceAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject152
 */
export interface SystemGenerateObject152 {
    /**
     * 
     * @type {DistanceAdminVo}
     * @memberof SystemGenerateObject152
     */
    'distanceAdminVo': DistanceAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject153
 */
export interface SystemGenerateObject153 {
    /**
     * 
     * @type {PartialRecordAdminVo}
     * @memberof SystemGenerateObject153
     */
    'conditions': PartialRecordAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject153
     */
    'pageQuery': PageQueryVo;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject153
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject153
     */
    'end'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject154
 */
export interface SystemGenerateObject154 {
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject154
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject155
 */
export interface SystemGenerateObject155 {
    /**
     * 
     * @type {PartialRecordAdminVo}
     * @memberof SystemGenerateObject155
     */
    'conditions': PartialRecordAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject155
     */
    'pageQuery': PageQueryVo;
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject155
     */
    'storeId': number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject155
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject155
     */
    'end'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject156
 */
export interface SystemGenerateObject156 {
    /**
     * 
     * @type {RecordAdminVo}
     * @memberof SystemGenerateObject156
     */
    'recordAdminVo': RecordAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject157
 */
export interface SystemGenerateObject157 {
    /**
     * 
     * @type {RecordAdminVo}
     * @memberof SystemGenerateObject157
     */
    'recordAdminVo': RecordAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject158
 */
export interface SystemGenerateObject158 {
    /**
     * 
     * @type {PartialBlackAccountAdminVo}
     * @memberof SystemGenerateObject158
     */
    'conditions': PartialBlackAccountAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject159
 */
export interface SystemGenerateObject159 {
    /**
     * 
     * @type {PartialBlackAccountAdminVo}
     * @memberof SystemGenerateObject159
     */
    'conditions': PartialBlackAccountAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject159
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject16
 */
export interface SystemGenerateObject16 {
    /**
     * 
     * @type {Array<string>}
     * @memberof SystemGenerateObject16
     */
    'platforms': Array<string>;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject160
 */
export interface SystemGenerateObject160 {
    /**
     * 
     * @type {BlackAccountAdminVo}
     * @memberof SystemGenerateObject160
     */
    'blackAccountAdminVo': BlackAccountAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject161
 */
export interface SystemGenerateObject161 {
    /**
     * 
     * @type {BlackAccountAdminVo}
     * @memberof SystemGenerateObject161
     */
    'blackAccountAdminVo': BlackAccountAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject162
 */
export interface SystemGenerateObject162 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject162
     */
    'storeId': number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject162
     */
    'remarkOrPhone'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject163
 */
export interface SystemGenerateObject163 {
    /**
     * 
     * @type {BlackAccountAdminVo}
     * @memberof SystemGenerateObject163
     */
    'blackAccountAdminVo': BlackAccountAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject164
 */
export interface SystemGenerateObject164 {
    /**
     * 
     * @type {BlackAccountAdminVo}
     * @memberof SystemGenerateObject164
     */
    'blackAccountAdminVo': BlackAccountAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject165
 */
export interface SystemGenerateObject165 {
    /**
     * 
     * @type {PartialWhiteAccountAdminVo}
     * @memberof SystemGenerateObject165
     */
    'conditions': PartialWhiteAccountAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject166
 */
export interface SystemGenerateObject166 {
    /**
     * 
     * @type {PartialWhiteAccountAdminVo}
     * @memberof SystemGenerateObject166
     */
    'conditions': PartialWhiteAccountAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject166
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject167
 */
export interface SystemGenerateObject167 {
    /**
     * 
     * @type {WhiteAccountAdminVo}
     * @memberof SystemGenerateObject167
     */
    'whiteAccountAdminVo': WhiteAccountAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject168
 */
export interface SystemGenerateObject168 {
    /**
     * 
     * @type {WhiteAccountAdminVo}
     * @memberof SystemGenerateObject168
     */
    'whiteAccountAdminVo': WhiteAccountAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject169
 */
export interface SystemGenerateObject169 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject169
     */
    'storeId': number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject169
     */
    'remarkOrPhone'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject17
 */
export interface SystemGenerateObject17 {
    /**
     * 
     * @type {PartialBaseRoleAdminVo}
     * @memberof SystemGenerateObject17
     */
    'conditions'?: PartialBaseRoleAdminVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject17
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject17
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject170
 */
export interface SystemGenerateObject170 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject170
     */
    'storeId': number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject170
     */
    'remarkOrPhone'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject171
 */
export interface SystemGenerateObject171 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject171
     */
    'storeId': number;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject171
     */
    'pageQuery': PageQueryVo;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject171
     */
    'remarkOrPhone'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject172
 */
export interface SystemGenerateObject172 {
    /**
     * 
     * @type {WhiteAccountAdminVo}
     * @memberof SystemGenerateObject172
     */
    'whiteAccountAdminVo': WhiteAccountAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject173
 */
export interface SystemGenerateObject173 {
    /**
     * 
     * @type {WhiteAccountAdminVo}
     * @memberof SystemGenerateObject173
     */
    'whiteAccountAdminVo': WhiteAccountAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject175
 */
export interface SystemGenerateObject175 {
    /**
     * 
     * @type {PartialAdvertisingAdminVo}
     * @memberof SystemGenerateObject175
     */
    'conditions': PartialAdvertisingAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject176
 */
export interface SystemGenerateObject176 {
    /**
     * 
     * @type {AdvertisingAdminVo}
     * @memberof SystemGenerateObject176
     */
    'advertisingAdminVo': AdvertisingAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject177
 */
export interface SystemGenerateObject177 {
    /**
     * 
     * @type {AdvertisingAdminVo}
     * @memberof SystemGenerateObject177
     */
    'advertisingAdminVo': AdvertisingAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject178
 */
export interface SystemGenerateObject178 {
    /**
     * 
     * @type {PartialAdvertisingRowAdminVo}
     * @memberof SystemGenerateObject178
     */
    'conditions': PartialAdvertisingRowAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject179
 */
export interface SystemGenerateObject179 {
    /**
     * 
     * @type {AdvertisingRowAdminVo}
     * @memberof SystemGenerateObject179
     */
    'advertisingRowAdminVo': AdvertisingRowAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject18
 */
export interface SystemGenerateObject18 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject18
     */
    'userId': number;
    /**
     * 
     * @type {Array<BaseUserRoleAdminVo>}
     * @memberof SystemGenerateObject18
     */
    'userRoleVos': Array<BaseUserRoleAdminVo>;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject180
 */
export interface SystemGenerateObject180 {
    /**
     * 
     * @type {AdvertisingRowAdminVo}
     * @memberof SystemGenerateObject180
     */
    'advertisingRowAdminVo': AdvertisingRowAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject181
 */
export interface SystemGenerateObject181 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject181
     */
    'advertisingId': number;
    /**
     * 
     * @type {boolean}
     * @memberof SystemGenerateObject181
     */
    'up': boolean;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject182
 */
export interface SystemGenerateObject182 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject182
     */
    'advertisingRowId': number;
    /**
     * 
     * @type {boolean}
     * @memberof SystemGenerateObject182
     */
    'up': boolean;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject183
 */
export interface SystemGenerateObject183 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject183
     */
    'storeId': number;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject184
 */
export interface SystemGenerateObject184 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject184
     */
    'storeId': number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject184
     */
    'time': string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject184
     */
    'deviceIdx': string;
    /**
     * 
     * @type {DEVICEMODE}
     * @memberof SystemGenerateObject184
     */
    'mod': DEVICEMODE;
}


/**
 * 
 * @export
 * @interface SystemGenerateObject185
 */
export interface SystemGenerateObject185 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject185
     */
    'timerName': string;
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject185
     */
    'storeId': number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject185
     */
    'time': string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject185
     */
    'deviceIdx': string;
    /**
     * 
     * @type {DEVICEMODE}
     * @memberof SystemGenerateObject185
     */
    'mod': DEVICEMODE;
}


/**
 * 
 * @export
 * @interface SystemGenerateObject186
 */
export interface SystemGenerateObject186 {
    /**
     * 
     * @type {PartialStationTypeAdminVo}
     * @memberof SystemGenerateObject186
     */
    'conditions': PartialStationTypeAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject187
 */
export interface SystemGenerateObject187 {
    /**
     * 
     * @type {PartialStationTypeAdminVo}
     * @memberof SystemGenerateObject187
     */
    'conditions': PartialStationTypeAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject187
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject188
 */
export interface SystemGenerateObject188 {
    /**
     * 
     * @type {StationTypeAdminVo}
     * @memberof SystemGenerateObject188
     */
    'stationTypeAdminVo': StationTypeAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject189
 */
export interface SystemGenerateObject189 {
    /**
     * 
     * @type {StationTypeAdminVo}
     * @memberof SystemGenerateObject189
     */
    'stationTypeAdminVo': StationTypeAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject19
 */
export interface SystemGenerateObject19 {
    /**
     * 
     * @type {PartialBaseRoleAdminVo}
     * @memberof SystemGenerateObject19
     */
    'conditions'?: PartialBaseRoleAdminVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject19
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject19
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject190
 */
export interface SystemGenerateObject190 {
    /**
     * 
     * @type {PartialExpressCompanyAdminVo}
     * @memberof SystemGenerateObject190
     */
    'conditions': PartialExpressCompanyAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject191
 */
export interface SystemGenerateObject191 {
    /**
     * 
     * @type {PartialExpressCompanyAdminVo}
     * @memberof SystemGenerateObject191
     */
    'conditions': PartialExpressCompanyAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject191
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject192
 */
export interface SystemGenerateObject192 {
    /**
     * 
     * @type {ExpressCompanyAdminVo}
     * @memberof SystemGenerateObject192
     */
    'expressCompanyAdminVo': ExpressCompanyAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject193
 */
export interface SystemGenerateObject193 {
    /**
     * 
     * @type {ExpressCompanyAdminVo}
     * @memberof SystemGenerateObject193
     */
    'expressCompanyAdminVo': ExpressCompanyAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject194
 */
export interface SystemGenerateObject194 {
    /**
     * 
     * @type {PartialPackageAdminVo}
     * @memberof SystemGenerateObject194
     */
    'conditions': PartialPackageAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject195
 */
export interface SystemGenerateObject195 {
    /**
     * 
     * @type {PartialPackageAdminVo}
     * @memberof SystemGenerateObject195
     */
    'conditions': PartialPackageAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject195
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject196
 */
export interface SystemGenerateObject196 {
    /**
     * 
     * @type {PackageAdminVo}
     * @memberof SystemGenerateObject196
     */
    'packageAdminVo': PackageAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject197
 */
export interface SystemGenerateObject197 {
    /**
     * 
     * @type {PackageAdminVo}
     * @memberof SystemGenerateObject197
     */
    'packageAdminVo': PackageAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject198
 */
export interface SystemGenerateObject198 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject198
     */
    'packageId': number;
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject198
     */
    'storeId': number;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject199
 */
export interface SystemGenerateObject199 {
    /**
     * 
     * @type {PartialMemberAdminVo}
     * @memberof SystemGenerateObject199
     */
    'conditions': PartialMemberAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject2
 */
export interface SystemGenerateObject2 {
    /**
     * 
     * @type {PartialBaseMenuAdminVo}
     * @memberof SystemGenerateObject2
     */
    'conditions'?: PartialBaseMenuAdminVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject2
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject2
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject20
 */
export interface SystemGenerateObject20 {
    /**
     * 
     * @type {PartialBaseRoleAdminVo}
     * @memberof SystemGenerateObject20
     */
    'conditions'?: PartialBaseRoleAdminVo;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject20
     */
    'pageQuery'?: BasePageQueryVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject20
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject20
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject200
 */
export interface SystemGenerateObject200 {
    /**
     * 
     * @type {PartialMemberAdminVo}
     * @memberof SystemGenerateObject200
     */
    'conditions': PartialMemberAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject200
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject201
 */
export interface SystemGenerateObject201 {
    /**
     * 
     * @type {MemberAdminVo}
     * @memberof SystemGenerateObject201
     */
    'memberAdminVo': MemberAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject202
 */
export interface SystemGenerateObject202 {
    /**
     * 
     * @type {MemberAdminVo}
     * @memberof SystemGenerateObject202
     */
    'memberAdminVo': MemberAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject203
 */
export interface SystemGenerateObject203 {
    /**
     * 
     * @type {PartialRechargePlanAdminVo}
     * @memberof SystemGenerateObject203
     */
    'conditions': PartialRechargePlanAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject204
 */
export interface SystemGenerateObject204 {
    /**
     * 
     * @type {PartialRechargePlanAdminVo}
     * @memberof SystemGenerateObject204
     */
    'conditions': PartialRechargePlanAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject204
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject205
 */
export interface SystemGenerateObject205 {
    /**
     * 
     * @type {RechargePlanAdminVo}
     * @memberof SystemGenerateObject205
     */
    'rechargePlanAdminVo': RechargePlanAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject206
 */
export interface SystemGenerateObject206 {
    /**
     * 
     * @type {RechargePlanAdminVo}
     * @memberof SystemGenerateObject206
     */
    'rechargePlanAdminVo': RechargePlanAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject207
 */
export interface SystemGenerateObject207 {
    /**
     * 
     * @type {PartialTicketPackageAdminVo}
     * @memberof SystemGenerateObject207
     */
    'conditions': PartialTicketPackageAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject208
 */
export interface SystemGenerateObject208 {
    /**
     * 
     * @type {PartialTicketPackageAdminVo}
     * @memberof SystemGenerateObject208
     */
    'conditions': PartialTicketPackageAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject208
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject209
 */
export interface SystemGenerateObject209 {
    /**
     * 
     * @type {TicketPackageAdminVo}
     * @memberof SystemGenerateObject209
     */
    'ticketPackageAdminVo': TicketPackageAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject21
 */
export interface SystemGenerateObject21 {
    /**
     * 
     * @type {PartialBaseUserAdminVo}
     * @memberof SystemGenerateObject21
     */
    'conditions'?: PartialBaseUserAdminVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject21
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject21
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject210
 */
export interface SystemGenerateObject210 {
    /**
     * 
     * @type {TicketPackageAdminVo}
     * @memberof SystemGenerateObject210
     */
    'ticketPackageAdminVo': TicketPackageAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject211
 */
export interface SystemGenerateObject211 {
    /**
     * 
     * @type {PartialTicketAdminVo}
     * @memberof SystemGenerateObject211
     */
    'conditions': PartialTicketAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject212
 */
export interface SystemGenerateObject212 {
    /**
     * 
     * @type {PartialTicketAdminVo}
     * @memberof SystemGenerateObject212
     */
    'conditions': PartialTicketAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject212
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject213
 */
export interface SystemGenerateObject213 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject213
     */
    'ticketPackageId': number;
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject213
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject213
     */
    'expireTime': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject214
 */
export interface SystemGenerateObject214 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject214
     */
    'ticketId': number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject214
     */
    'verifiedPhone'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject215
 */
export interface SystemGenerateObject215 {
    /**
     * 
     * @type {PartialIncentivePlanAdminVo}
     * @memberof SystemGenerateObject215
     */
    'conditions': PartialIncentivePlanAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject216
 */
export interface SystemGenerateObject216 {
    /**
     * 
     * @type {PartialIncentivePlanAdminVo}
     * @memberof SystemGenerateObject216
     */
    'conditions': PartialIncentivePlanAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject216
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject217
 */
export interface SystemGenerateObject217 {
    /**
     * 
     * @type {IncentivePlanAdminVo}
     * @memberof SystemGenerateObject217
     */
    'incentivePlanAdminVo': IncentivePlanAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject218
 */
export interface SystemGenerateObject218 {
    /**
     * 
     * @type {IncentivePlanAdminVo}
     * @memberof SystemGenerateObject218
     */
    'incentivePlanAdminVo': IncentivePlanAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject219
 */
export interface SystemGenerateObject219 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject219
     */
    'incentivePlanId': number;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject22
 */
export interface SystemGenerateObject22 {
    /**
     * 
     * @type {PartialBaseUserAdminVo}
     * @memberof SystemGenerateObject22
     */
    'conditions'?: PartialBaseUserAdminVo;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject22
     */
    'pageQuery'?: BasePageQueryVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject22
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject22
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject220
 */
export interface SystemGenerateObject220 {
    /**
     * 
     * @type {PartialAiBeanAdminVo}
     * @memberof SystemGenerateObject220
     */
    'conditions': PartialAiBeanAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject221
 */
export interface SystemGenerateObject221 {
    /**
     * 
     * @type {PartialAiBeanAdminVo}
     * @memberof SystemGenerateObject221
     */
    'conditions': PartialAiBeanAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject221
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject222
 */
export interface SystemGenerateObject222 {
    /**
     * 
     * @type {AiBeanAdminVo}
     * @memberof SystemGenerateObject222
     */
    'aiBeanAdminVo': AiBeanAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject223
 */
export interface SystemGenerateObject223 {
    /**
     * 
     * @type {AiBeanAdminVo}
     * @memberof SystemGenerateObject223
     */
    'aiBeanAdminVo': AiBeanAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject224
 */
export interface SystemGenerateObject224 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject224
     */
    'phone': string;
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject224
     */
    'changeCount': number;
    /**
     * 
     * @type {AIBEANCHANGESOURCEE}
     * @memberof SystemGenerateObject224
     */
    'changeSource': AIBEANCHANGESOURCEE;
    /**
     * 
     * @type {any}
     * @memberof SystemGenerateObject224
     */
    'meta'?: any;
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject224
     */
    'recordId'?: number;
}


/**
 * 
 * @export
 * @interface SystemGenerateObject225
 */
export interface SystemGenerateObject225 {
    /**
     * 
     * @type {PartialAiBeanRecordAdminVo}
     * @memberof SystemGenerateObject225
     */
    'conditions': PartialAiBeanRecordAdminVo;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject225
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject225
     */
    'endDate'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject226
 */
export interface SystemGenerateObject226 {
    /**
     * 
     * @type {PartialAiBeanRecordAdminVo}
     * @memberof SystemGenerateObject226
     */
    'conditions': PartialAiBeanRecordAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject226
     */
    'pageQuery': PageQueryVo;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject226
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject226
     */
    'endDate'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject227
 */
export interface SystemGenerateObject227 {
    /**
     * 
     * @type {AiBeanRecordAdminVo}
     * @memberof SystemGenerateObject227
     */
    'aiBeanRecordVo': AiBeanRecordAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject228
 */
export interface SystemGenerateObject228 {
    /**
     * 
     * @type {AiBeanRecordAdminVo}
     * @memberof SystemGenerateObject228
     */
    'aiBeanRecordVo': AiBeanRecordAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject229
 */
export interface SystemGenerateObject229 {
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject229
     */
    'pageQuery': PageQueryVo;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject229
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject229
     */
    'endDate'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject23
 */
export interface SystemGenerateObject23 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject23
     */
    'oldPw': string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject23
     */
    'newPw': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject230
 */
export interface SystemGenerateObject230 {
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject230
     */
    'pageQuery': PageQueryVo;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject230
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject230
     */
    'endDate'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject231
 */
export interface SystemGenerateObject231 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject231
     */
    'storeId': number;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject231
     */
    'pageQuery': PageQueryVo;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject231
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject231
     */
    'endDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject231
     */
    'phoneOrNameOrTrack'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject232
 */
export interface SystemGenerateObject232 {
    /**
     * 
     * @type {PartialPackageRecordAdminVo}
     * @memberof SystemGenerateObject232
     */
    'conditions': PartialPackageRecordAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject233
 */
export interface SystemGenerateObject233 {
    /**
     * 
     * @type {PartialPackageRecordAdminVo}
     * @memberof SystemGenerateObject233
     */
    'conditions': PartialPackageRecordAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject234
 */
export interface SystemGenerateObject234 {
    /**
     * 
     * @type {PartialPackageRecordAdminVo}
     * @memberof SystemGenerateObject234
     */
    'conditions': PartialPackageRecordAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject234
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject235
 */
export interface SystemGenerateObject235 {
    /**
     * 
     * @type {PackageRecordAdminVo}
     * @memberof SystemGenerateObject235
     */
    'packageRecordAdminVo': PackageRecordAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject236
 */
export interface SystemGenerateObject236 {
    /**
     * 
     * @type {PackageRecordAdminVo}
     * @memberof SystemGenerateObject236
     */
    'packageRecordAdminVo': PackageRecordAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject237
 */
export interface SystemGenerateObject237 {
    /**
     * 
     * @type {PartialStationAdminVo}
     * @memberof SystemGenerateObject237
     */
    'conditions': PartialStationAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject238
 */
export interface SystemGenerateObject238 {
    /**
     * 
     * @type {PartialStationAdminVo}
     * @memberof SystemGenerateObject238
     */
    'conditions': PartialStationAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject238
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject239
 */
export interface SystemGenerateObject239 {
    /**
     * 
     * @type {StationAdminVo}
     * @memberof SystemGenerateObject239
     */
    'stationAdminVo': StationAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject24
 */
export interface SystemGenerateObject24 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject24
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject24
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject24
     */
    'newPhone'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject24
     */
    'code'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject240
 */
export interface SystemGenerateObject240 {
    /**
     * 
     * @type {StationAdminVo}
     * @memberof SystemGenerateObject240
     */
    'stationAdminVo': StationAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject241
 */
export interface SystemGenerateObject241 {
    /**
     * 
     * @type {PartialExpressAdminVo}
     * @memberof SystemGenerateObject241
     */
    'conditions': PartialExpressAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject242
 */
export interface SystemGenerateObject242 {
    /**
     * 
     * @type {PartialExpressAdminVo}
     * @memberof SystemGenerateObject242
     */
    'conditions': PartialExpressAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject242
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject243
 */
export interface SystemGenerateObject243 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject243
     */
    'trackingNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject243
     */
    'cpCode': string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject243
     */
    'tel'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SystemGenerateObject243
     */
    'needUpdate'?: boolean;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject244
 */
export interface SystemGenerateObject244 {
    /**
     * 
     * @type {ExpressAdminVo}
     * @memberof SystemGenerateObject244
     */
    'expressAdminVo': ExpressAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject245
 */
export interface SystemGenerateObject245 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject245
     */
    'id': number;
    /**
     * 
     * @type {Array<IExpressTrackItem>}
     * @memberof SystemGenerateObject245
     */
    'trackInfo': Array<IExpressTrackItem>;
    /**
     * 
     * @type {EXPRESSSTATUSE}
     * @memberof SystemGenerateObject245
     */
    'status'?: EXPRESSSTATUSE;
}


/**
 * 
 * @export
 * @interface SystemGenerateObject246
 */
export interface SystemGenerateObject246 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject246
     */
    'trackingNumber': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject247
 */
export interface SystemGenerateObject247 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject247
     */
    'storeId': number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject247
     */
    'trackingNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject247
     */
    'cpCode': string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject247
     */
    'tel'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject248
 */
export interface SystemGenerateObject248 {
    /**
     * 
     * @type {PartialUserSubscriptionAdminVo}
     * @memberof SystemGenerateObject248
     */
    'conditions': PartialUserSubscriptionAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject249
 */
export interface SystemGenerateObject249 {
    /**
     * 
     * @type {PartialUserSubscriptionAdminVo}
     * @memberof SystemGenerateObject249
     */
    'conditions': PartialUserSubscriptionAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject249
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject25
 */
export interface SystemGenerateObject25 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject25
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject25
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject25
     */
    'newEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject25
     */
    'code'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject250
 */
export interface SystemGenerateObject250 {
    /**
     * 
     * @type {UserSubscriptionAdminVo}
     * @memberof SystemGenerateObject250
     */
    'userSubscriptionAdminVo': UserSubscriptionAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject251
 */
export interface SystemGenerateObject251 {
    /**
     * 
     * @type {UserSubscriptionAdminVo}
     * @memberof SystemGenerateObject251
     */
    'userSubscriptionAdminVo': UserSubscriptionAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject252
 */
export interface SystemGenerateObject252 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject252
     */
    'trackingNumber': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject253
 */
export interface SystemGenerateObject253 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject253
     */
    'trackingNumber': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject254
 */
export interface SystemGenerateObject254 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject254
     */
    'trackingNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject254
     */
    'cpCode': string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject254
     */
    'tel'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject255
 */
export interface SystemGenerateObject255 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject255
     */
    'trackingNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject255
     */
    'cpCode': string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject255
     */
    'tel'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject256
 */
export interface SystemGenerateObject256 {
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject256
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject257
 */
export interface SystemGenerateObject257 {
    /**
     * 
     * @type {PartialStationAddressAdminVo}
     * @memberof SystemGenerateObject257
     */
    'conditions': PartialStationAddressAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject258
 */
export interface SystemGenerateObject258 {
    /**
     * 
     * @type {PartialStationAddressAdminVo}
     * @memberof SystemGenerateObject258
     */
    'conditions': PartialStationAddressAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject258
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject259
 */
export interface SystemGenerateObject259 {
    /**
     * 
     * @type {StationAddressAdminVo}
     * @memberof SystemGenerateObject259
     */
    'stationAddressAdminVo': StationAddressAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject26
 */
export interface SystemGenerateObject26 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject26
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject26
     */
    'nickname'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject26
     */
    'avatar'?: string;
    /**
     * 
     * @type {Array<BaseUserMetaItem>}
     * @memberof SystemGenerateObject26
     */
    'meta'?: Array<BaseUserMetaItem>;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject260
 */
export interface SystemGenerateObject260 {
    /**
     * 
     * @type {StationAddressAdminVo}
     * @memberof SystemGenerateObject260
     */
    'stationAddressAdminVo': StationAddressAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject261
 */
export interface SystemGenerateObject261 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject261
     */
    'storeId': number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject261
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject261
     */
    'end'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject262
 */
export interface SystemGenerateObject262 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject262
     */
    'storeId': number;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject262
     */
    'pageQuery': PageQueryVo;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject262
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject262
     */
    'end'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject263
 */
export interface SystemGenerateObject263 {
    /**
     * 
     * @type {StoreStatisticsAdminVo}
     * @memberof SystemGenerateObject263
     */
    'storeStatisticsAdminVo': StoreStatisticsAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject264
 */
export interface SystemGenerateObject264 {
    /**
     * 
     * @type {StoreStatisticsAdminVo}
     * @memberof SystemGenerateObject264
     */
    'storeStatisticsAdminVo': StoreStatisticsAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject265
 */
export interface SystemGenerateObject265 {
    /**
     * 
     * @type {PartialStoreStatisticsAdminVo}
     * @memberof SystemGenerateObject265
     */
    'conditions': PartialStoreStatisticsAdminVo;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject265
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject265
     */
    'end'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject266
 */
export interface SystemGenerateObject266 {
    /**
     * 
     * @type {PartialJumpWeappAdminVo}
     * @memberof SystemGenerateObject266
     */
    'conditions': PartialJumpWeappAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject267
 */
export interface SystemGenerateObject267 {
    /**
     * 
     * @type {PartialJumpWeappAdminVo}
     * @memberof SystemGenerateObject267
     */
    'conditions': PartialJumpWeappAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject267
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject268
 */
export interface SystemGenerateObject268 {
    /**
     * 
     * @type {JumpWeappAdminVo}
     * @memberof SystemGenerateObject268
     */
    'jumpWeappAdminVo': JumpWeappAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject269
 */
export interface SystemGenerateObject269 {
    /**
     * 
     * @type {JumpWeappAdminVo}
     * @memberof SystemGenerateObject269
     */
    'jumpWeappAdminVo': JumpWeappAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject27
 */
export interface SystemGenerateObject27 {
    /**
     * 
     * @type {PartialBaseOrganizationAdminVo}
     * @memberof SystemGenerateObject27
     */
    'conditions'?: PartialBaseOrganizationAdminVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject27
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject27
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject28
 */
export interface SystemGenerateObject28 {
    /**
     * 
     * @type {PartialBaseOrganizationAdminVo}
     * @memberof SystemGenerateObject28
     */
    'conditions'?: PartialBaseOrganizationAdminVo;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject28
     */
    'pageQuery'?: BasePageQueryVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject28
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject28
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject29
 */
export interface SystemGenerateObject29 {
    /**
     * 
     * @type {PartialBaseLogAdminVo}
     * @memberof SystemGenerateObject29
     */
    'conditions'?: PartialBaseLogAdminVo;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject29
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject3
 */
export interface SystemGenerateObject3 {
    /**
     * 
     * @type {PartialBaseMenuAdminVo}
     * @memberof SystemGenerateObject3
     */
    'conditions'?: PartialBaseMenuAdminVo;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject3
     */
    'pageQuery'?: BasePageQueryVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject3
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject3
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject30
 */
export interface SystemGenerateObject30 {
    /**
     * 
     * @type {PartialBaseLogAdminVo}
     * @memberof SystemGenerateObject30
     */
    'conditions'?: PartialBaseLogAdminVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject30
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject30
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject31
 */
export interface SystemGenerateObject31 {
    /**
     * 
     * @type {PartialBaseLogAdminVo}
     * @memberof SystemGenerateObject31
     */
    'conditions'?: PartialBaseLogAdminVo;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject31
     */
    'pageQuery'?: BasePageQueryVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject31
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject31
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject32
 */
export interface SystemGenerateObject32 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject32
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject33
 */
export interface SystemGenerateObject33 {
    /**
     * 
     * @type {PartialBaseDictionaryAdminVo}
     * @memberof SystemGenerateObject33
     */
    'conditions'?: PartialBaseDictionaryAdminVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject33
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject33
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject34
 */
export interface SystemGenerateObject34 {
    /**
     * 
     * @type {PartialBaseDictionaryAdminVo}
     * @memberof SystemGenerateObject34
     */
    'conditions'?: PartialBaseDictionaryAdminVo;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject34
     */
    'pageQuery'?: BasePageQueryVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject34
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject34
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject35
 */
export interface SystemGenerateObject35 {
    /**
     * 
     * @type {PartialBaseTenantAdminVo}
     * @memberof SystemGenerateObject35
     */
    'conditions'?: PartialBaseTenantAdminVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject35
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject35
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject36
 */
export interface SystemGenerateObject36 {
    /**
     * 
     * @type {PartialBaseTenantAdminVo}
     * @memberof SystemGenerateObject36
     */
    'conditions'?: PartialBaseTenantAdminVo;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject36
     */
    'pageQuery'?: BasePageQueryVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject36
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject36
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject37
 */
export interface SystemGenerateObject37 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject37
     */
    'userId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SystemGenerateObject37
     */
    'isRead'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject37
     */
    'msgType'?: string;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject37
     */
    'pageQuery'?: BasePageQueryVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject37
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject37
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject38
 */
export interface SystemGenerateObject38 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject38
     */
    'msgType'?: string;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject38
     */
    'pageQuery'?: BasePageQueryVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject38
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject38
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject39
 */
export interface SystemGenerateObject39 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject39
     */
    'messageId'?: number;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject4
 */
export interface SystemGenerateObject4 {
    /**
     * 
     * @type {PartialBaseOperateAdminVo}
     * @memberof SystemGenerateObject4
     */
    'conditions'?: PartialBaseOperateAdminVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject4
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject4
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject40
 */
export interface SystemGenerateObject40 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject40
     */
    'messageId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject40
     */
    'userId'?: number;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject41
 */
export interface SystemGenerateObject41 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject41
     */
    'userId'?: number;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject42
 */
export interface SystemGenerateObject42 {
    /**
     * 
     * @type {PartialBaseMessageAdminVo}
     * @memberof SystemGenerateObject42
     */
    'conditions'?: PartialBaseMessageAdminVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject42
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject42
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject43
 */
export interface SystemGenerateObject43 {
    /**
     * 
     * @type {PartialBaseMessageAdminVo}
     * @memberof SystemGenerateObject43
     */
    'conditions'?: PartialBaseMessageAdminVo;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject43
     */
    'pageQuery'?: BasePageQueryVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject43
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject43
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject44
 */
export interface SystemGenerateObject44 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject44
     */
    'messageId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject44
     */
    'tenantId'?: number;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject45
 */
export interface SystemGenerateObject45 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject45
     */
    'balanceType'?: string;
    /**
     * 
     * @type {PartialBaseBalanceRecordAdminVo}
     * @memberof SystemGenerateObject45
     */
    'conditions'?: PartialBaseBalanceRecordAdminVo;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject45
     */
    'pageQuery'?: BasePageQueryVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject45
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject45
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject46
 */
export interface SystemGenerateObject46 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject46
     */
    'userId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject46
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject46
     */
    'balanceType'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject46
     */
    'remark'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject46
     */
    'refId'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject47
 */
export interface SystemGenerateObject47 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject47
     */
    'userId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject47
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject47
     */
    'balanceType'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject47
     */
    'remark'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject47
     */
    'refId'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject48
 */
export interface SystemGenerateObject48 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject48
     */
    'userId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject48
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject48
     */
    'balanceType'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject48
     */
    'remark'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject48
     */
    'refId'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject49
 */
export interface SystemGenerateObject49 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject49
     */
    'userId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject49
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject49
     */
    'balanceType'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject49
     */
    'remark'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject49
     */
    'refId'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject5
 */
export interface SystemGenerateObject5 {
    /**
     * 
     * @type {PartialBaseOperateAdminVo}
     * @memberof SystemGenerateObject5
     */
    'conditions'?: PartialBaseOperateAdminVo;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject5
     */
    'pageQuery'?: BasePageQueryVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject5
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject5
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject50
 */
export interface SystemGenerateObject50 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject50
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject50
     */
    'platform'?: string;
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject50
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject50
     */
    'subject'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject50
     */
    'body'?: string;
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject50
     */
    'expireMinutes'?: number;
    /**
     * 
     * @type {any}
     * @memberof SystemGenerateObject50
     */
    'extra'?: any;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject51
 */
export interface SystemGenerateObject51 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject51
     */
    'orderNo'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject52
 */
export interface SystemGenerateObject52 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject52
     */
    'orderNo'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject53
 */
export interface SystemGenerateObject53 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject53
     */
    'userId'?: number;
    /**
     * 
     * @type {PartialBasePaymentOrderAdminVo}
     * @memberof SystemGenerateObject53
     */
    'conditions'?: PartialBasePaymentOrderAdminVo;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject53
     */
    'pageQuery'?: BasePageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject54
 */
export interface SystemGenerateObject54 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject54
     */
    'orderNo'?: string;
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject54
     */
    'refundAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject54
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject55
 */
export interface SystemGenerateObject55 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject55
     */
    'orderNo'?: string;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject55
     */
    'pageQuery'?: BasePageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject56
 */
export interface SystemGenerateObject56 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject56
     */
    'platform'?: string;
    /**
     * 
     * @type {any}
     * @memberof SystemGenerateObject56
     */
    'rawBody'?: any;
    /**
     * 
     * @type {any}
     * @memberof SystemGenerateObject56
     */
    'headers'?: any;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject56
     */
    'orderNoHint'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject57
 */
export interface SystemGenerateObject57 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject57
     */
    'platform'?: string;
    /**
     * 
     * @type {any}
     * @memberof SystemGenerateObject57
     */
    'rawBody'?: any;
    /**
     * 
     * @type {any}
     * @memberof SystemGenerateObject57
     */
    'headers'?: any;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject57
     */
    'refundNoHint'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject59
 */
export interface SystemGenerateObject59 {
    /**
     * 
     * @type {PartialTenantAdminVo}
     * @memberof SystemGenerateObject59
     */
    'conditions': PartialTenantAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject59
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject6
 */
export interface SystemGenerateObject6 {
    /**
     * 
     * @type {PartialBaseRouteAdminVo}
     * @memberof SystemGenerateObject6
     */
    'conditions'?: PartialBaseRouteAdminVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject6
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject6
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject60
 */
export interface SystemGenerateObject60 {
    /**
     * 
     * @type {PartialWeappAdminVo}
     * @memberof SystemGenerateObject60
     */
    'conditions': PartialWeappAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject61
 */
export interface SystemGenerateObject61 {
    /**
     * 
     * @type {PartialWeappAdminVo}
     * @memberof SystemGenerateObject61
     */
    'conditions': PartialWeappAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject61
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject62
 */
export interface SystemGenerateObject62 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject62
     */
    'redirectUri': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject63
 */
export interface SystemGenerateObject63 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject63
     */
    'authCode': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject64
 */
export interface SystemGenerateObject64 {
    /**
     * 
     * @type {WeappAdminVo}
     * @memberof SystemGenerateObject64
     */
    'weappAdminVo': WeappAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject65
 */
export interface SystemGenerateObject65 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject65
     */
    'loginCode': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject66
 */
export interface SystemGenerateObject66 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject66
     */
    'loginCode': string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject66
     */
    'phoneCode': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject67
 */
export interface SystemGenerateObject67 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject67
     */
    'appid': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject68
 */
export interface SystemGenerateObject68 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject68
     */
    'appid': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject69
 */
export interface SystemGenerateObject69 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject69
     */
    'appid': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject7
 */
export interface SystemGenerateObject7 {
    /**
     * 
     * @type {PartialBaseRouteAdminVo}
     * @memberof SystemGenerateObject7
     */
    'conditions'?: PartialBaseRouteAdminVo;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject7
     */
    'pageQuery'?: BasePageQueryVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject7
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject7
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject70
 */
export interface SystemGenerateObject70 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject70
     */
    'appid': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject71
 */
export interface SystemGenerateObject71 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject71
     */
    'appid': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject72
 */
export interface SystemGenerateObject72 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject72
     */
    'appid': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject73
 */
export interface SystemGenerateObject73 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject73
     */
    'appid': string;
    /**
     * 
     * @type {any}
     * @memberof SystemGenerateObject73
     */
    'ext': any;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject74
 */
export interface SystemGenerateObject74 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject74
     */
    'appid': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject75
 */
export interface SystemGenerateObject75 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject75
     */
    'appid': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject76
 */
export interface SystemGenerateObject76 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject76
     */
    'appid': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject77
 */
export interface SystemGenerateObject77 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject77
     */
    'appid': string;
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject77
     */
    'appVersion'?: number;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject78
 */
export interface SystemGenerateObject78 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject78
     */
    'appid': string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject78
     */
    'page': string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject78
     */
    'scene': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject79
 */
export interface SystemGenerateObject79 {
    /**
     * 
     * @type {PartialWxAdminVo}
     * @memberof SystemGenerateObject79
     */
    'conditions': PartialWxAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject8
 */
export interface SystemGenerateObject8 {
    /**
     * 
     * @type {PartialBaseScheduleAdminVo}
     * @memberof SystemGenerateObject8
     */
    'conditions'?: PartialBaseScheduleAdminVo;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject8
     */
    'pageQuery'?: BasePageQueryVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject8
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject8
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject80
 */
export interface SystemGenerateObject80 {
    /**
     * 
     * @type {PartialWxAdminVo}
     * @memberof SystemGenerateObject80
     */
    'conditions': PartialWxAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject80
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject81
 */
export interface SystemGenerateObject81 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject81
     */
    'redirectUri': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject82
 */
export interface SystemGenerateObject82 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject82
     */
    'authCode': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject83
 */
export interface SystemGenerateObject83 {
    /**
     * 
     * @type {WxAdminVo}
     * @memberof SystemGenerateObject83
     */
    'wxAdminVo': WxAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject84
 */
export interface SystemGenerateObject84 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject84
     */
    'phone': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject85
 */
export interface SystemGenerateObject85 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject85
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject85
     */
    'phoneCode': string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject85
     */
    'loginCode': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject86
 */
export interface SystemGenerateObject86 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject86
     */
    'weappOpenid': string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject86
     */
    'weappAppid': string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject86
     */
    'loginCode': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject87
 */
export interface SystemGenerateObject87 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject87
     */
    'loginCode': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject88
 */
export interface SystemGenerateObject88 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject88
     */
    'appid': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject89
 */
export interface SystemGenerateObject89 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject89
     */
    'appid': string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject89
     */
    'weappAppid': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject90
 */
export interface SystemGenerateObject90 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject90
     */
    'appid': string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject90
     */
    'weappAppid': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject91
 */
export interface SystemGenerateObject91 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject91
     */
    'openid': string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject91
     */
    'appid'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject92
 */
export interface SystemGenerateObject92 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject92
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject92
     */
    'appid'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject93
 */
export interface SystemGenerateObject93 {
    /**
     * 
     * @type {any}
     * @memberof SystemGenerateObject93
     */
    'xml': any;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject94
 */
export interface SystemGenerateObject94 {
    /**
     * 
     * @type {any}
     * @memberof SystemGenerateObject94
     */
    'xml': any;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject95
 */
export interface SystemGenerateObject95 {
    /**
     * 
     * @type {PartialWxTplAdminVo}
     * @memberof SystemGenerateObject95
     */
    'conditions': PartialWxTplAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject95
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject96
 */
export interface SystemGenerateObject96 {
    /**
     * 
     * @type {PartialWeappTplAdminVo}
     * @memberof SystemGenerateObject96
     */
    'conditions': PartialWeappTplAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject96
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject97
 */
export interface SystemGenerateObject97 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject97
     */
    'draftId': number;
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject97
     */
    'templateType': number;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject98
 */
export interface SystemGenerateObject98 {
    /**
     * 
     * @type {PartialDeviceAdminVo}
     * @memberof SystemGenerateObject98
     */
    'conditions': PartialDeviceAdminVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject99
 */
export interface SystemGenerateObject99 {
    /**
     * 
     * @type {PartialDeviceAdminVo}
     * @memberof SystemGenerateObject99
     */
    'conditions': PartialDeviceAdminVo;
    /**
     * 
     * @type {PageQueryVo}
     * @memberof SystemGenerateObject99
     */
    'pageQuery': PageQueryVo;
}
/**
 * 
 * @export
 * @interface TenantAdminVo
 */
export interface TenantAdminVo {
    /**
     * 
     * @type {number}
     * @memberof TenantAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TenantAdminVo
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TenantAdminVo
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof TenantAdminVo
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAdminVo
     */
    'logo'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof TenantAdminVo
     */
    'weappTplIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof TenantAdminVo
     */
    'wxTplIds'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof TenantAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface TicketPackageAdminVo
 */
export interface TicketPackageAdminVo {
    /**
     * 
     * @type {number}
     * @memberof TicketPackageAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TicketPackageAdminVo
     */
    'beanCount': number;
    /**
     * 
     * @type {number}
     * @memberof TicketPackageAdminVo
     */
    'sequenceNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof TicketPackageAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof TicketPackageAdminVo
     */
    'totalTicketCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TicketPackageAdminVo
     */
    'verifiedTicketCount'?: number;
}
/**
 * 
 * @export
 * @interface UserSubscriptionAdminVo
 */
export interface UserSubscriptionAdminVo {
    /**
     * 
     * @type {number}
     * @memberof UserSubscriptionAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserSubscriptionAdminVo
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof UserSubscriptionAdminVo
     */
    'trackingNumber': string;
    /**
     * 
     * @type {string}
     * @memberof UserSubscriptionAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSubscriptionAdminVo
     */
    'updateTime'?: string;
}
/**
 * 
 * @export
 * @interface WeappAdminVo
 */
export interface WeappAdminVo {
    /**
     * 
     * @type {number}
     * @memberof WeappAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof WeappAdminVo
     */
    'appid': string;
    /**
     * 
     * @type {string}
     * @memberof WeappAdminVo
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof WeappAdminVo
     */
    'principalName': string;
    /**
     * 
     * @type {string}
     * @memberof WeappAdminVo
     */
    'remark'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WeappAdminVo
     */
    'baseSetting'?: boolean;
    /**
     * 
     * @type {any}
     * @memberof WeappAdminVo
     */
    'privacyInterface'?: any;
    /**
     * 
     * @type {number}
     * @memberof WeappAdminVo
     */
    'templateId'?: number;
    /**
     * 
     * @type {number}
     * @memberof WeappAdminVo
     */
    'auditId'?: number;
    /**
     * 
     * @type {string}
     * @memberof WeappAdminVo
     */
    'currentVersion'?: string;
    /**
     * 
     * @type {PUBLISHSTATUSE}
     * @memberof WeappAdminVo
     */
    'status'?: PUBLISHSTATUSE;
    /**
     * 
     * @type {string}
     * @memberof WeappAdminVo
     */
    'modelId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WeappAdminVo
     */
    'secret'?: string;
    /**
     * 
     * @type {any}
     * @memberof WeappAdminVo
     */
    'ext'?: any;
    /**
     * 
     * @type {string}
     * @memberof WeappAdminVo
     */
    'createTime'?: string;
}


/**
 * 
 * @export
 * @interface WeappTplAdminVo
 */
export interface WeappTplAdminVo {
    /**
     * 
     * @type {number}
     * @memberof WeappTplAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof WeappTplAdminVo
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof WeappTplAdminVo
     */
    'currentVersion'?: string;
    /**
     * 
     * @type {string}
     * @memberof WeappTplAdminVo
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof WeappTplAdminVo
     */
    'templateId'?: number;
    /**
     * 
     * @type {any}
     * @memberof WeappTplAdminVo
     */
    'extjsFormItems'?: any;
    /**
     * 
     * @type {string}
     * @memberof WeappTplAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface WhiteAccountAdminVo
 */
export interface WhiteAccountAdminVo {
    /**
     * 
     * @type {number}
     * @memberof WhiteAccountAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof WhiteAccountAdminVo
     */
    'phone': string;
    /**
     * 
     * @type {number}
     * @memberof WhiteAccountAdminVo
     */
    'storeId': number;
    /**
     * 
     * @type {boolean}
     * @memberof WhiteAccountAdminVo
     */
    'isApplay'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WhiteAccountAdminVo
     */
    'remark'?: string;
    /**
     * 
     * @type {string}
     * @memberof WhiteAccountAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface WxAdminVo
 */
export interface WxAdminVo {
    /**
     * 
     * @type {number}
     * @memberof WxAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof WxAdminVo
     */
    'appid': string;
    /**
     * 
     * @type {string}
     * @memberof WxAdminVo
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof WxAdminVo
     */
    'principalName': string;
    /**
     * 
     * @type {string}
     * @memberof WxAdminVo
     */
    'remark'?: string;
    /**
     * 
     * @type {string}
     * @memberof WxAdminVo
     */
    'openMsgTemplateId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WxAdminVo
     */
    'applyTemplateId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WxAdminVo
     */
    'pickupTemplateId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WxAdminVo
     */
    'waybillStatusTemplateId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WxAdminVo
     */
    'scanSuccessTemplateId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WxAdminVo
     */
    'weappAppid'?: string;
    /**
     * 
     * @type {string}
     * @memberof WxAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface WxTplAdminVo
 */
export interface WxTplAdminVo {
    /**
     * 
     * @type {number}
     * @memberof WxTplAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof WxTplAdminVo
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof WxTplAdminVo
     */
    'currentVersion': string;
    /**
     * 
     * @type {string}
     * @memberof WxTplAdminVo
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof WxTplAdminVo
     */
    'createTime'?: string;
}

/**
 * AdminApi - axios parameter creator
 * @export
 */
export const AdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加管理员
         * @param {SystemGenerateObject139} systemGenerateObject139 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAdminadmin: async (systemGenerateObject139: SystemGenerateObject139, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject139' is not null or undefined
            assertParamExists('addAdminadmin', 'systemGenerateObject139', systemGenerateObject139)
            const localVarPath = `/admin/addAdmin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject139, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除管理员
         * @param {number} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delAdminadmin: async (adminId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminId' is not null or undefined
            assertParamExists('delAdminadmin', 'adminId', adminId)
            const localVarPath = `/admin/delAdmin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (adminId !== undefined) {
                localVarQueryParameter['adminId'] = adminId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取管理员列表
         * @param {SystemGenerateObject137} systemGenerateObject137 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdminadmin: async (systemGenerateObject137: SystemGenerateObject137, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject137' is not null or undefined
            assertParamExists('listAdminadmin', 'systemGenerateObject137', systemGenerateObject137)
            const localVarPath = `/admin/listAdmin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject137, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取管理员列表(分页)
         * @param {SystemGenerateObject138} systemGenerateObject138 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageAdminadmin: async (systemGenerateObject138: SystemGenerateObject138, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject138' is not null or undefined
            assertParamExists('pageAdminadmin', 'systemGenerateObject138', systemGenerateObject138)
            const localVarPath = `/admin/pageAdmin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject138, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新管理员
         * @param {SystemGenerateObject140} systemGenerateObject140 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdminadmin: async (systemGenerateObject140: SystemGenerateObject140, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject140' is not null or undefined
            assertParamExists('updateAdminadmin', 'systemGenerateObject140', systemGenerateObject140)
            const localVarPath = `/admin/updateAdmin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject140, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminApi - functional programming interface
 * @export
 */
export const AdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加管理员
         * @param {SystemGenerateObject139} systemGenerateObject139 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAdminadmin(systemGenerateObject139: SystemGenerateObject139, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAdminadmin(systemGenerateObject139, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除管理员
         * @param {number} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delAdminadmin(adminId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delAdminadmin(adminId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取管理员列表
         * @param {SystemGenerateObject137} systemGenerateObject137 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAdminadmin(systemGenerateObject137: SystemGenerateObject137, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAdminadmin(systemGenerateObject137, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取管理员列表(分页)
         * @param {SystemGenerateObject138} systemGenerateObject138 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageAdminadmin(systemGenerateObject138: SystemGenerateObject138, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageAdminadmin(systemGenerateObject138, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新管理员
         * @param {SystemGenerateObject140} systemGenerateObject140 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAdminadmin(systemGenerateObject140: SystemGenerateObject140, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAdminadmin(systemGenerateObject140, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminApi - factory interface
 * @export
 */
export const AdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加管理员
         * @param {SystemGenerateObject139} systemGenerateObject139 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAdminadmin(systemGenerateObject139: SystemGenerateObject139, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addAdminadmin(systemGenerateObject139, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除管理员
         * @param {number} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delAdminadmin(adminId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delAdminadmin(adminId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取管理员列表
         * @param {SystemGenerateObject137} systemGenerateObject137 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdminadmin(systemGenerateObject137: SystemGenerateObject137, options?: any): AxiosPromise<any> {
            return localVarFp.listAdminadmin(systemGenerateObject137, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取管理员列表(分页)
         * @param {SystemGenerateObject138} systemGenerateObject138 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageAdminadmin(systemGenerateObject138: SystemGenerateObject138, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageAdminadmin(systemGenerateObject138, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新管理员
         * @param {SystemGenerateObject140} systemGenerateObject140 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdminadmin(systemGenerateObject140: SystemGenerateObject140, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateAdminadmin(systemGenerateObject140, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
export class AdminApi extends BaseAPI {
    /**
     * 
     * @summary 添加管理员
     * @param {SystemGenerateObject139} systemGenerateObject139 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public addAdminadmin(systemGenerateObject139: SystemGenerateObject139, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).addAdminadmin(systemGenerateObject139, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除管理员
     * @param {number} adminId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public delAdminadmin(adminId: number, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).delAdminadmin(adminId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取管理员列表
     * @param {SystemGenerateObject137} systemGenerateObject137 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public listAdminadmin(systemGenerateObject137: SystemGenerateObject137, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).listAdminadmin(systemGenerateObject137, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取管理员列表(分页)
     * @param {SystemGenerateObject138} systemGenerateObject138 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public pageAdminadmin(systemGenerateObject138: SystemGenerateObject138, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).pageAdminadmin(systemGenerateObject138, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新管理员
     * @param {SystemGenerateObject140} systemGenerateObject140 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public updateAdminadmin(systemGenerateObject140: SystemGenerateObject140, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).updateAdminadmin(systemGenerateObject140, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdvertisingApi - axios parameter creator
 * @export
 */
export const AdvertisingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加广告行
         * @param {SystemGenerateObject179} systemGenerateObject179 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAdvertisingRowadvertising: async (systemGenerateObject179: SystemGenerateObject179, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject179' is not null or undefined
            assertParamExists('addAdvertisingRowadvertising', 'systemGenerateObject179', systemGenerateObject179)
            const localVarPath = `/advertising/addAdvertisingRow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject179, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 添加广告
         * @param {SystemGenerateObject176} systemGenerateObject176 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAdvertisingadvertising: async (systemGenerateObject176: SystemGenerateObject176, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject176' is not null or undefined
            assertParamExists('addAdvertisingadvertising', 'systemGenerateObject176', systemGenerateObject176)
            const localVarPath = `/advertising/addAdvertising`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject176, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除广告行
         * @param {number} advertisingRowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delAdvertisingRowadvertising: async (advertisingRowId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'advertisingRowId' is not null or undefined
            assertParamExists('delAdvertisingRowadvertising', 'advertisingRowId', advertisingRowId)
            const localVarPath = `/advertising/delAdvertisingRow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (advertisingRowId !== undefined) {
                localVarQueryParameter['advertisingRowId'] = advertisingRowId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除广告
         * @param {number} advertisingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delAdvertisingadvertising: async (advertisingId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'advertisingId' is not null or undefined
            assertParamExists('delAdvertisingadvertising', 'advertisingId', advertisingId)
            const localVarPath = `/advertising/delAdvertising`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (advertisingId !== undefined) {
                localVarQueryParameter['advertisingId'] = advertisingId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取广告行列表
         * @param {SystemGenerateObject178} systemGenerateObject178 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdvertisingRowadvertising: async (systemGenerateObject178: SystemGenerateObject178, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject178' is not null or undefined
            assertParamExists('listAdvertisingRowadvertising', 'systemGenerateObject178', systemGenerateObject178)
            const localVarPath = `/advertising/listAdvertisingRow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject178, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取广告列表
         * @param {SystemGenerateObject175} systemGenerateObject175 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdvertisingadvertising: async (systemGenerateObject175: SystemGenerateObject175, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject175' is not null or undefined
            assertParamExists('listAdvertisingadvertising', 'systemGenerateObject175', systemGenerateObject175)
            const localVarPath = `/advertising/listAdvertising`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject175, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 移动广告行
         * @param {SystemGenerateObject182} systemGenerateObject182 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveAdvertisingRowadvertising: async (systemGenerateObject182: SystemGenerateObject182, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject182' is not null or undefined
            assertParamExists('moveAdvertisingRowadvertising', 'systemGenerateObject182', systemGenerateObject182)
            const localVarPath = `/advertising/moveAdvertisingRow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject182, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 移动广告
         * @param {SystemGenerateObject181} systemGenerateObject181 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveAdvertisingadvertising: async (systemGenerateObject181: SystemGenerateObject181, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject181' is not null or undefined
            assertParamExists('moveAdvertisingadvertising', 'systemGenerateObject181', systemGenerateObject181)
            const localVarPath = `/advertising/moveAdvertising`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject181, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新广告行
         * @param {SystemGenerateObject180} systemGenerateObject180 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdvertisingRowadvertising: async (systemGenerateObject180: SystemGenerateObject180, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject180' is not null or undefined
            assertParamExists('updateAdvertisingRowadvertising', 'systemGenerateObject180', systemGenerateObject180)
            const localVarPath = `/advertising/updateAdvertisingRow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject180, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新广告
         * @param {SystemGenerateObject177} systemGenerateObject177 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdvertisingadvertising: async (systemGenerateObject177: SystemGenerateObject177, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject177' is not null or undefined
            assertParamExists('updateAdvertisingadvertising', 'systemGenerateObject177', systemGenerateObject177)
            const localVarPath = `/advertising/updateAdvertising`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject177, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdvertisingApi - functional programming interface
 * @export
 */
export const AdvertisingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdvertisingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加广告行
         * @param {SystemGenerateObject179} systemGenerateObject179 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAdvertisingRowadvertising(systemGenerateObject179: SystemGenerateObject179, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAdvertisingRowadvertising(systemGenerateObject179, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 添加广告
         * @param {SystemGenerateObject176} systemGenerateObject176 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAdvertisingadvertising(systemGenerateObject176: SystemGenerateObject176, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAdvertisingadvertising(systemGenerateObject176, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除广告行
         * @param {number} advertisingRowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delAdvertisingRowadvertising(advertisingRowId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delAdvertisingRowadvertising(advertisingRowId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除广告
         * @param {number} advertisingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delAdvertisingadvertising(advertisingId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delAdvertisingadvertising(advertisingId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取广告行列表
         * @param {SystemGenerateObject178} systemGenerateObject178 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAdvertisingRowadvertising(systemGenerateObject178: SystemGenerateObject178, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAdvertisingRowadvertising(systemGenerateObject178, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取广告列表
         * @param {SystemGenerateObject175} systemGenerateObject175 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAdvertisingadvertising(systemGenerateObject175: SystemGenerateObject175, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAdvertisingadvertising(systemGenerateObject175, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 移动广告行
         * @param {SystemGenerateObject182} systemGenerateObject182 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveAdvertisingRowadvertising(systemGenerateObject182: SystemGenerateObject182, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveAdvertisingRowadvertising(systemGenerateObject182, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 移动广告
         * @param {SystemGenerateObject181} systemGenerateObject181 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveAdvertisingadvertising(systemGenerateObject181: SystemGenerateObject181, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveAdvertisingadvertising(systemGenerateObject181, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新广告行
         * @param {SystemGenerateObject180} systemGenerateObject180 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAdvertisingRowadvertising(systemGenerateObject180: SystemGenerateObject180, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAdvertisingRowadvertising(systemGenerateObject180, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新广告
         * @param {SystemGenerateObject177} systemGenerateObject177 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAdvertisingadvertising(systemGenerateObject177: SystemGenerateObject177, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAdvertisingadvertising(systemGenerateObject177, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdvertisingApi - factory interface
 * @export
 */
export const AdvertisingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdvertisingApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加广告行
         * @param {SystemGenerateObject179} systemGenerateObject179 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAdvertisingRowadvertising(systemGenerateObject179: SystemGenerateObject179, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addAdvertisingRowadvertising(systemGenerateObject179, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 添加广告
         * @param {SystemGenerateObject176} systemGenerateObject176 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAdvertisingadvertising(systemGenerateObject176: SystemGenerateObject176, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addAdvertisingadvertising(systemGenerateObject176, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除广告行
         * @param {number} advertisingRowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delAdvertisingRowadvertising(advertisingRowId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delAdvertisingRowadvertising(advertisingRowId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除广告
         * @param {number} advertisingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delAdvertisingadvertising(advertisingId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delAdvertisingadvertising(advertisingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取广告行列表
         * @param {SystemGenerateObject178} systemGenerateObject178 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdvertisingRowadvertising(systemGenerateObject178: SystemGenerateObject178, options?: any): AxiosPromise<any> {
            return localVarFp.listAdvertisingRowadvertising(systemGenerateObject178, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取广告列表
         * @param {SystemGenerateObject175} systemGenerateObject175 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdvertisingadvertising(systemGenerateObject175: SystemGenerateObject175, options?: any): AxiosPromise<any> {
            return localVarFp.listAdvertisingadvertising(systemGenerateObject175, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 移动广告行
         * @param {SystemGenerateObject182} systemGenerateObject182 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveAdvertisingRowadvertising(systemGenerateObject182: SystemGenerateObject182, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.moveAdvertisingRowadvertising(systemGenerateObject182, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 移动广告
         * @param {SystemGenerateObject181} systemGenerateObject181 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveAdvertisingadvertising(systemGenerateObject181: SystemGenerateObject181, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.moveAdvertisingadvertising(systemGenerateObject181, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新广告行
         * @param {SystemGenerateObject180} systemGenerateObject180 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdvertisingRowadvertising(systemGenerateObject180: SystemGenerateObject180, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateAdvertisingRowadvertising(systemGenerateObject180, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新广告
         * @param {SystemGenerateObject177} systemGenerateObject177 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdvertisingadvertising(systemGenerateObject177: SystemGenerateObject177, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateAdvertisingadvertising(systemGenerateObject177, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdvertisingApi - object-oriented interface
 * @export
 * @class AdvertisingApi
 * @extends {BaseAPI}
 */
export class AdvertisingApi extends BaseAPI {
    /**
     * 
     * @summary 添加广告行
     * @param {SystemGenerateObject179} systemGenerateObject179 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertisingApi
     */
    public addAdvertisingRowadvertising(systemGenerateObject179: SystemGenerateObject179, options?: AxiosRequestConfig) {
        return AdvertisingApiFp(this.configuration).addAdvertisingRowadvertising(systemGenerateObject179, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 添加广告
     * @param {SystemGenerateObject176} systemGenerateObject176 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertisingApi
     */
    public addAdvertisingadvertising(systemGenerateObject176: SystemGenerateObject176, options?: AxiosRequestConfig) {
        return AdvertisingApiFp(this.configuration).addAdvertisingadvertising(systemGenerateObject176, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除广告行
     * @param {number} advertisingRowId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertisingApi
     */
    public delAdvertisingRowadvertising(advertisingRowId: number, options?: AxiosRequestConfig) {
        return AdvertisingApiFp(this.configuration).delAdvertisingRowadvertising(advertisingRowId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除广告
     * @param {number} advertisingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertisingApi
     */
    public delAdvertisingadvertising(advertisingId: number, options?: AxiosRequestConfig) {
        return AdvertisingApiFp(this.configuration).delAdvertisingadvertising(advertisingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取广告行列表
     * @param {SystemGenerateObject178} systemGenerateObject178 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertisingApi
     */
    public listAdvertisingRowadvertising(systemGenerateObject178: SystemGenerateObject178, options?: AxiosRequestConfig) {
        return AdvertisingApiFp(this.configuration).listAdvertisingRowadvertising(systemGenerateObject178, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取广告列表
     * @param {SystemGenerateObject175} systemGenerateObject175 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertisingApi
     */
    public listAdvertisingadvertising(systemGenerateObject175: SystemGenerateObject175, options?: AxiosRequestConfig) {
        return AdvertisingApiFp(this.configuration).listAdvertisingadvertising(systemGenerateObject175, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 移动广告行
     * @param {SystemGenerateObject182} systemGenerateObject182 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertisingApi
     */
    public moveAdvertisingRowadvertising(systemGenerateObject182: SystemGenerateObject182, options?: AxiosRequestConfig) {
        return AdvertisingApiFp(this.configuration).moveAdvertisingRowadvertising(systemGenerateObject182, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 移动广告
     * @param {SystemGenerateObject181} systemGenerateObject181 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertisingApi
     */
    public moveAdvertisingadvertising(systemGenerateObject181: SystemGenerateObject181, options?: AxiosRequestConfig) {
        return AdvertisingApiFp(this.configuration).moveAdvertisingadvertising(systemGenerateObject181, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新广告行
     * @param {SystemGenerateObject180} systemGenerateObject180 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertisingApi
     */
    public updateAdvertisingRowadvertising(systemGenerateObject180: SystemGenerateObject180, options?: AxiosRequestConfig) {
        return AdvertisingApiFp(this.configuration).updateAdvertisingRowadvertising(systemGenerateObject180, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新广告
     * @param {SystemGenerateObject177} systemGenerateObject177 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertisingApi
     */
    public updateAdvertisingadvertising(systemGenerateObject177: SystemGenerateObject177, options?: AxiosRequestConfig) {
        return AdvertisingApiFp(this.configuration).updateAdvertisingadvertising(systemGenerateObject177, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AiBeanRecordApi - axios parameter creator
 * @export
 */
export const AiBeanRecordApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加AI豆变更记录
         * @param {SystemGenerateObject227} systemGenerateObject227 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAiBeanRecordaiBeanRecord: async (systemGenerateObject227: SystemGenerateObject227, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject227' is not null or undefined
            assertParamExists('addAiBeanRecordaiBeanRecord', 'systemGenerateObject227', systemGenerateObject227)
            const localVarPath = `/aiBeanRecord/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject227, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除AI豆变更记录
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAiBeanRecordaiBeanRecord: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAiBeanRecordaiBeanRecord', 'id', id)
            const localVarPath = `/aiBeanRecord/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 分页获取用户自己的AI豆消费记录，需要用户登录，如需筛选时间范围，可传入开始和结束时间
         * @summary 分页获取用户自己的AI豆消费记录
         * @param {SystemGenerateObject230} systemGenerateObject230 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserConsumeRecordsaiBeanRecord: async (systemGenerateObject230: SystemGenerateObject230, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject230' is not null or undefined
            assertParamExists('getUserConsumeRecordsaiBeanRecord', 'systemGenerateObject230', systemGenerateObject230)
            const localVarPath = `/aiBeanRecord/getUserConsumeRecords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject230, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 分页获取用户自己的AI豆充值记录，需要用户登录，如需筛选时间范围，可传入开始和结束时间
         * @summary 分页获取用户自己的AI豆充值记录
         * @param {SystemGenerateObject229} systemGenerateObject229 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserRechargeRecordsaiBeanRecord: async (systemGenerateObject229: SystemGenerateObject229, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject229' is not null or undefined
            assertParamExists('getUserRechargeRecordsaiBeanRecord', 'systemGenerateObject229', systemGenerateObject229)
            const localVarPath = `/aiBeanRecord/getUserRechargeRecords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject229, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取AI豆变更记录列表
         * @param {SystemGenerateObject225} systemGenerateObject225 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAiBeanRecordaiBeanRecord: async (systemGenerateObject225: SystemGenerateObject225, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject225' is not null or undefined
            assertParamExists('listAiBeanRecordaiBeanRecord', 'systemGenerateObject225', systemGenerateObject225)
            const localVarPath = `/aiBeanRecord/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject225, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 分页查询AI豆变更记录
         * @param {SystemGenerateObject226} systemGenerateObject226 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageAiBeanRecordaiBeanRecord: async (systemGenerateObject226: SystemGenerateObject226, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject226' is not null or undefined
            assertParamExists('pageAiBeanRecordaiBeanRecord', 'systemGenerateObject226', systemGenerateObject226)
            const localVarPath = `/aiBeanRecord/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject226, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 分页查询自己店铺的AI豆门店客户查询记录，只返回changeSource为STORE_CUSTOMER_QUERY且meta.storeId等于传入storeId的记录
         * @summary 分页查询自己店铺的AI豆记录
         * @param {SystemGenerateObject231} systemGenerateObject231 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOwnerStoreAiBeanRecordaiBeanRecord: async (systemGenerateObject231: SystemGenerateObject231, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject231' is not null or undefined
            assertParamExists('pageOwnerStoreAiBeanRecordaiBeanRecord', 'systemGenerateObject231', systemGenerateObject231)
            const localVarPath = `/aiBeanRecord/pageOwnerStoreAiBeanRecord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject231, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新AI豆变更记录
         * @param {SystemGenerateObject228} systemGenerateObject228 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAiBeanRecordaiBeanRecord: async (systemGenerateObject228: SystemGenerateObject228, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject228' is not null or undefined
            assertParamExists('updateAiBeanRecordaiBeanRecord', 'systemGenerateObject228', systemGenerateObject228)
            const localVarPath = `/aiBeanRecord/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject228, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AiBeanRecordApi - functional programming interface
 * @export
 */
export const AiBeanRecordApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AiBeanRecordApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加AI豆变更记录
         * @param {SystemGenerateObject227} systemGenerateObject227 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAiBeanRecordaiBeanRecord(systemGenerateObject227: SystemGenerateObject227, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAiBeanRecordaiBeanRecord(systemGenerateObject227, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除AI豆变更记录
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAiBeanRecordaiBeanRecord(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAiBeanRecordaiBeanRecord(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 分页获取用户自己的AI豆消费记录，需要用户登录，如需筛选时间范围，可传入开始和结束时间
         * @summary 分页获取用户自己的AI豆消费记录
         * @param {SystemGenerateObject230} systemGenerateObject230 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserConsumeRecordsaiBeanRecord(systemGenerateObject230: SystemGenerateObject230, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserConsumeRecordsaiBeanRecord(systemGenerateObject230, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 分页获取用户自己的AI豆充值记录，需要用户登录，如需筛选时间范围，可传入开始和结束时间
         * @summary 分页获取用户自己的AI豆充值记录
         * @param {SystemGenerateObject229} systemGenerateObject229 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserRechargeRecordsaiBeanRecord(systemGenerateObject229: SystemGenerateObject229, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserRechargeRecordsaiBeanRecord(systemGenerateObject229, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取AI豆变更记录列表
         * @param {SystemGenerateObject225} systemGenerateObject225 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAiBeanRecordaiBeanRecord(systemGenerateObject225: SystemGenerateObject225, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAiBeanRecordaiBeanRecord(systemGenerateObject225, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 分页查询AI豆变更记录
         * @param {SystemGenerateObject226} systemGenerateObject226 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageAiBeanRecordaiBeanRecord(systemGenerateObject226: SystemGenerateObject226, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageAiBeanRecordaiBeanRecord(systemGenerateObject226, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 分页查询自己店铺的AI豆门店客户查询记录，只返回changeSource为STORE_CUSTOMER_QUERY且meta.storeId等于传入storeId的记录
         * @summary 分页查询自己店铺的AI豆记录
         * @param {SystemGenerateObject231} systemGenerateObject231 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageOwnerStoreAiBeanRecordaiBeanRecord(systemGenerateObject231: SystemGenerateObject231, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageOwnerStoreAiBeanRecordaiBeanRecord(systemGenerateObject231, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新AI豆变更记录
         * @param {SystemGenerateObject228} systemGenerateObject228 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAiBeanRecordaiBeanRecord(systemGenerateObject228: SystemGenerateObject228, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAiBeanRecordaiBeanRecord(systemGenerateObject228, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AiBeanRecordApi - factory interface
 * @export
 */
export const AiBeanRecordApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AiBeanRecordApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加AI豆变更记录
         * @param {SystemGenerateObject227} systemGenerateObject227 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAiBeanRecordaiBeanRecord(systemGenerateObject227: SystemGenerateObject227, options?: any): AxiosPromise<any> {
            return localVarFp.addAiBeanRecordaiBeanRecord(systemGenerateObject227, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除AI豆变更记录
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAiBeanRecordaiBeanRecord(id: number, options?: any): AxiosPromise<any> {
            return localVarFp.deleteAiBeanRecordaiBeanRecord(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 分页获取用户自己的AI豆消费记录，需要用户登录，如需筛选时间范围，可传入开始和结束时间
         * @summary 分页获取用户自己的AI豆消费记录
         * @param {SystemGenerateObject230} systemGenerateObject230 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserConsumeRecordsaiBeanRecord(systemGenerateObject230: SystemGenerateObject230, options?: any): AxiosPromise<any> {
            return localVarFp.getUserConsumeRecordsaiBeanRecord(systemGenerateObject230, options).then((request) => request(axios, basePath));
        },
        /**
         * 分页获取用户自己的AI豆充值记录，需要用户登录，如需筛选时间范围，可传入开始和结束时间
         * @summary 分页获取用户自己的AI豆充值记录
         * @param {SystemGenerateObject229} systemGenerateObject229 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserRechargeRecordsaiBeanRecord(systemGenerateObject229: SystemGenerateObject229, options?: any): AxiosPromise<any> {
            return localVarFp.getUserRechargeRecordsaiBeanRecord(systemGenerateObject229, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取AI豆变更记录列表
         * @param {SystemGenerateObject225} systemGenerateObject225 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAiBeanRecordaiBeanRecord(systemGenerateObject225: SystemGenerateObject225, options?: any): AxiosPromise<any> {
            return localVarFp.listAiBeanRecordaiBeanRecord(systemGenerateObject225, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 分页查询AI豆变更记录
         * @param {SystemGenerateObject226} systemGenerateObject226 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageAiBeanRecordaiBeanRecord(systemGenerateObject226: SystemGenerateObject226, options?: any): AxiosPromise<any> {
            return localVarFp.pageAiBeanRecordaiBeanRecord(systemGenerateObject226, options).then((request) => request(axios, basePath));
        },
        /**
         * 分页查询自己店铺的AI豆门店客户查询记录，只返回changeSource为STORE_CUSTOMER_QUERY且meta.storeId等于传入storeId的记录
         * @summary 分页查询自己店铺的AI豆记录
         * @param {SystemGenerateObject231} systemGenerateObject231 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOwnerStoreAiBeanRecordaiBeanRecord(systemGenerateObject231: SystemGenerateObject231, options?: any): AxiosPromise<any> {
            return localVarFp.pageOwnerStoreAiBeanRecordaiBeanRecord(systemGenerateObject231, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新AI豆变更记录
         * @param {SystemGenerateObject228} systemGenerateObject228 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAiBeanRecordaiBeanRecord(systemGenerateObject228: SystemGenerateObject228, options?: any): AxiosPromise<any> {
            return localVarFp.updateAiBeanRecordaiBeanRecord(systemGenerateObject228, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AiBeanRecordApi - object-oriented interface
 * @export
 * @class AiBeanRecordApi
 * @extends {BaseAPI}
 */
export class AiBeanRecordApi extends BaseAPI {
    /**
     * 
     * @summary 添加AI豆变更记录
     * @param {SystemGenerateObject227} systemGenerateObject227 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiBeanRecordApi
     */
    public addAiBeanRecordaiBeanRecord(systemGenerateObject227: SystemGenerateObject227, options?: AxiosRequestConfig) {
        return AiBeanRecordApiFp(this.configuration).addAiBeanRecordaiBeanRecord(systemGenerateObject227, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除AI豆变更记录
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiBeanRecordApi
     */
    public deleteAiBeanRecordaiBeanRecord(id: number, options?: AxiosRequestConfig) {
        return AiBeanRecordApiFp(this.configuration).deleteAiBeanRecordaiBeanRecord(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 分页获取用户自己的AI豆消费记录，需要用户登录，如需筛选时间范围，可传入开始和结束时间
     * @summary 分页获取用户自己的AI豆消费记录
     * @param {SystemGenerateObject230} systemGenerateObject230 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiBeanRecordApi
     */
    public getUserConsumeRecordsaiBeanRecord(systemGenerateObject230: SystemGenerateObject230, options?: AxiosRequestConfig) {
        return AiBeanRecordApiFp(this.configuration).getUserConsumeRecordsaiBeanRecord(systemGenerateObject230, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 分页获取用户自己的AI豆充值记录，需要用户登录，如需筛选时间范围，可传入开始和结束时间
     * @summary 分页获取用户自己的AI豆充值记录
     * @param {SystemGenerateObject229} systemGenerateObject229 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiBeanRecordApi
     */
    public getUserRechargeRecordsaiBeanRecord(systemGenerateObject229: SystemGenerateObject229, options?: AxiosRequestConfig) {
        return AiBeanRecordApiFp(this.configuration).getUserRechargeRecordsaiBeanRecord(systemGenerateObject229, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取AI豆变更记录列表
     * @param {SystemGenerateObject225} systemGenerateObject225 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiBeanRecordApi
     */
    public listAiBeanRecordaiBeanRecord(systemGenerateObject225: SystemGenerateObject225, options?: AxiosRequestConfig) {
        return AiBeanRecordApiFp(this.configuration).listAiBeanRecordaiBeanRecord(systemGenerateObject225, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 分页查询AI豆变更记录
     * @param {SystemGenerateObject226} systemGenerateObject226 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiBeanRecordApi
     */
    public pageAiBeanRecordaiBeanRecord(systemGenerateObject226: SystemGenerateObject226, options?: AxiosRequestConfig) {
        return AiBeanRecordApiFp(this.configuration).pageAiBeanRecordaiBeanRecord(systemGenerateObject226, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 分页查询自己店铺的AI豆门店客户查询记录，只返回changeSource为STORE_CUSTOMER_QUERY且meta.storeId等于传入storeId的记录
     * @summary 分页查询自己店铺的AI豆记录
     * @param {SystemGenerateObject231} systemGenerateObject231 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiBeanRecordApi
     */
    public pageOwnerStoreAiBeanRecordaiBeanRecord(systemGenerateObject231: SystemGenerateObject231, options?: AxiosRequestConfig) {
        return AiBeanRecordApiFp(this.configuration).pageOwnerStoreAiBeanRecordaiBeanRecord(systemGenerateObject231, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新AI豆变更记录
     * @param {SystemGenerateObject228} systemGenerateObject228 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiBeanRecordApi
     */
    public updateAiBeanRecordaiBeanRecord(systemGenerateObject228: SystemGenerateObject228, options?: AxiosRequestConfig) {
        return AiBeanRecordApiFp(this.configuration).updateAiBeanRecordaiBeanRecord(systemGenerateObject228, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AibeanApi - axios parameter creator
 * @export
 */
export const AibeanApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加AI豆记录
         * @param {SystemGenerateObject222} systemGenerateObject222 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAiBeanaibean: async (systemGenerateObject222: SystemGenerateObject222, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject222' is not null or undefined
            assertParamExists('addAiBeanaibean', 'systemGenerateObject222', systemGenerateObject222)
            const localVarPath = `/aibean/addAiBean`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject222, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 增加或减少AI豆数量
         * @param {SystemGenerateObject224} systemGenerateObject224 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAiBeanCountaibean: async (systemGenerateObject224: SystemGenerateObject224, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject224' is not null or undefined
            assertParamExists('changeAiBeanCountaibean', 'systemGenerateObject224', systemGenerateObject224)
            const localVarPath = `/aibean/changeAiBeanCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject224, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除AI豆记录
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAiBeanaibean: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAiBeanaibean', 'id', id)
            const localVarPath = `/aibean/deleteAiBean`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取当前用户的AI豆信息
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyAiBeanaibean: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/aibean/myAiBean`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取AI豆记录列表
         * @param {SystemGenerateObject220} systemGenerateObject220 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAiBeanaibean: async (systemGenerateObject220: SystemGenerateObject220, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject220' is not null or undefined
            assertParamExists('listAiBeanaibean', 'systemGenerateObject220', systemGenerateObject220)
            const localVarPath = `/aibean/listAiBean`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject220, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 分页获取AI豆记录列表
         * @param {SystemGenerateObject221} systemGenerateObject221 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageAiBeanaibean: async (systemGenerateObject221: SystemGenerateObject221, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject221' is not null or undefined
            assertParamExists('pageAiBeanaibean', 'systemGenerateObject221', systemGenerateObject221)
            const localVarPath = `/aibean/pageAiBean`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject221, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新AI豆记录
         * @param {SystemGenerateObject223} systemGenerateObject223 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAiBeanaibean: async (systemGenerateObject223: SystemGenerateObject223, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject223' is not null or undefined
            assertParamExists('updateAiBeanaibean', 'systemGenerateObject223', systemGenerateObject223)
            const localVarPath = `/aibean/updateAiBean`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject223, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AibeanApi - functional programming interface
 * @export
 */
export const AibeanApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AibeanApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加AI豆记录
         * @param {SystemGenerateObject222} systemGenerateObject222 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAiBeanaibean(systemGenerateObject222: SystemGenerateObject222, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAiBeanaibean(systemGenerateObject222, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 增加或减少AI豆数量
         * @param {SystemGenerateObject224} systemGenerateObject224 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeAiBeanCountaibean(systemGenerateObject224: SystemGenerateObject224, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeAiBeanCountaibean(systemGenerateObject224, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除AI豆记录
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAiBeanaibean(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAiBeanaibean(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取当前用户的AI豆信息
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyAiBeanaibean(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyAiBeanaibean(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取AI豆记录列表
         * @param {SystemGenerateObject220} systemGenerateObject220 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAiBeanaibean(systemGenerateObject220: SystemGenerateObject220, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAiBeanaibean(systemGenerateObject220, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 分页获取AI豆记录列表
         * @param {SystemGenerateObject221} systemGenerateObject221 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageAiBeanaibean(systemGenerateObject221: SystemGenerateObject221, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageAiBeanaibean(systemGenerateObject221, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新AI豆记录
         * @param {SystemGenerateObject223} systemGenerateObject223 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAiBeanaibean(systemGenerateObject223: SystemGenerateObject223, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAiBeanaibean(systemGenerateObject223, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AibeanApi - factory interface
 * @export
 */
export const AibeanApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AibeanApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加AI豆记录
         * @param {SystemGenerateObject222} systemGenerateObject222 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAiBeanaibean(systemGenerateObject222: SystemGenerateObject222, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addAiBeanaibean(systemGenerateObject222, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 增加或减少AI豆数量
         * @param {SystemGenerateObject224} systemGenerateObject224 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAiBeanCountaibean(systemGenerateObject224: SystemGenerateObject224, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.changeAiBeanCountaibean(systemGenerateObject224, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除AI豆记录
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAiBeanaibean(id: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.deleteAiBeanaibean(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取当前用户的AI豆信息
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyAiBeanaibean(options?: any): AxiosPromise<ResultVo> {
            return localVarFp.getMyAiBeanaibean(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取AI豆记录列表
         * @param {SystemGenerateObject220} systemGenerateObject220 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAiBeanaibean(systemGenerateObject220: SystemGenerateObject220, options?: any): AxiosPromise<any> {
            return localVarFp.listAiBeanaibean(systemGenerateObject220, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 分页获取AI豆记录列表
         * @param {SystemGenerateObject221} systemGenerateObject221 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageAiBeanaibean(systemGenerateObject221: SystemGenerateObject221, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageAiBeanaibean(systemGenerateObject221, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新AI豆记录
         * @param {SystemGenerateObject223} systemGenerateObject223 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAiBeanaibean(systemGenerateObject223: SystemGenerateObject223, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateAiBeanaibean(systemGenerateObject223, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AibeanApi - object-oriented interface
 * @export
 * @class AibeanApi
 * @extends {BaseAPI}
 */
export class AibeanApi extends BaseAPI {
    /**
     * 
     * @summary 添加AI豆记录
     * @param {SystemGenerateObject222} systemGenerateObject222 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AibeanApi
     */
    public addAiBeanaibean(systemGenerateObject222: SystemGenerateObject222, options?: AxiosRequestConfig) {
        return AibeanApiFp(this.configuration).addAiBeanaibean(systemGenerateObject222, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 增加或减少AI豆数量
     * @param {SystemGenerateObject224} systemGenerateObject224 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AibeanApi
     */
    public changeAiBeanCountaibean(systemGenerateObject224: SystemGenerateObject224, options?: AxiosRequestConfig) {
        return AibeanApiFp(this.configuration).changeAiBeanCountaibean(systemGenerateObject224, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除AI豆记录
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AibeanApi
     */
    public deleteAiBeanaibean(id: number, options?: AxiosRequestConfig) {
        return AibeanApiFp(this.configuration).deleteAiBeanaibean(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取当前用户的AI豆信息
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AibeanApi
     */
    public getMyAiBeanaibean(options?: AxiosRequestConfig) {
        return AibeanApiFp(this.configuration).getMyAiBeanaibean(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取AI豆记录列表
     * @param {SystemGenerateObject220} systemGenerateObject220 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AibeanApi
     */
    public listAiBeanaibean(systemGenerateObject220: SystemGenerateObject220, options?: AxiosRequestConfig) {
        return AibeanApiFp(this.configuration).listAiBeanaibean(systemGenerateObject220, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 分页获取AI豆记录列表
     * @param {SystemGenerateObject221} systemGenerateObject221 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AibeanApi
     */
    public pageAiBeanaibean(systemGenerateObject221: SystemGenerateObject221, options?: AxiosRequestConfig) {
        return AibeanApiFp(this.configuration).pageAiBeanaibean(systemGenerateObject221, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新AI豆记录
     * @param {SystemGenerateObject223} systemGenerateObject223 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AibeanApi
     */
    public updateAiBeanaibean(systemGenerateObject223: SystemGenerateObject223, options?: AxiosRequestConfig) {
        return AibeanApiFp(this.configuration).updateAiBeanaibean(systemGenerateObject223, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseApiApi - axios parameter creator
 * @export
 */
export const BaseApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 获取接口列表
         * @param {SystemGenerateObject1} systemGenerateObject1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApisBaseApi: async (systemGenerateObject1: SystemGenerateObject1, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject1' is not null or undefined
            assertParamExists('listApisBaseApi', 'systemGenerateObject1', systemGenerateObject1)
            const localVarPath = `/__base/api/listApis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改接口
         * @param {BaseApiAdminVo} baseApiAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiBaseApi: async (baseApiAdminVo: BaseApiAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseApiAdminVo' is not null or undefined
            assertParamExists('updateApiBaseApi', 'baseApiAdminVo', baseApiAdminVo)
            const localVarPath = `/__base/api/updateApi`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseApiAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseApiApi - functional programming interface
 * @export
 */
export const BaseApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 获取接口列表
         * @param {SystemGenerateObject1} systemGenerateObject1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listApisBaseApi(systemGenerateObject1: SystemGenerateObject1, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listApisBaseApi(systemGenerateObject1, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改接口
         * @param {BaseApiAdminVo} baseApiAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateApiBaseApi(baseApiAdminVo: BaseApiAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateApiBaseApi(baseApiAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseApiApi - factory interface
 * @export
 */
export const BaseApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseApiApiFp(configuration)
    return {
        /**
         * 
         * @summary 获取接口列表
         * @param {SystemGenerateObject1} systemGenerateObject1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApisBaseApi(systemGenerateObject1: SystemGenerateObject1, options?: any): AxiosPromise<any> {
            return localVarFp.listApisBaseApi(systemGenerateObject1, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改接口
         * @param {BaseApiAdminVo} baseApiAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiBaseApi(baseApiAdminVo: BaseApiAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateApiBaseApi(baseApiAdminVo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseApiApi - object-oriented interface
 * @export
 * @class BaseApiApi
 * @extends {BaseAPI}
 */
export class BaseApiApi extends BaseAPI {
    /**
     * 
     * @summary 获取接口列表
     * @param {SystemGenerateObject1} systemGenerateObject1 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseApiApi
     */
    public listApisBaseApi(systemGenerateObject1: SystemGenerateObject1, options?: AxiosRequestConfig) {
        return BaseApiApiFp(this.configuration).listApisBaseApi(systemGenerateObject1, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改接口
     * @param {BaseApiAdminVo} baseApiAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseApiApi
     */
    public updateApiBaseApi(baseApiAdminVo: BaseApiAdminVo, options?: AxiosRequestConfig) {
        return BaseApiApiFp(this.configuration).updateApiBaseApi(baseApiAdminVo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseBalanceApi - axios parameter creator
 * @export
 */
export const BaseBalanceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 管理员调整余额
         * @param {SystemGenerateObject49} systemGenerateObject49 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adjustBaseBalance: async (systemGenerateObject49: SystemGenerateObject49, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject49' is not null or undefined
            assertParamExists('adjustBaseBalance', 'systemGenerateObject49', systemGenerateObject49)
            const localVarPath = `/__base/balance/adjust`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject49, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 消费/扣款
         * @param {SystemGenerateObject47} systemGenerateObject47 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consumeBaseBalance: async (systemGenerateObject47: SystemGenerateObject47, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject47' is not null or undefined
            assertParamExists('consumeBaseBalance', 'systemGenerateObject47', systemGenerateObject47)
            const localVarPath = `/__base/balance/consume`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject47, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取用户余额
         * @param {number} userId 
         * @param {string} balanceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalanceBaseBalance: async (userId: number, balanceType: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getBalanceBaseBalance', 'userId', userId)
            // verify required parameter 'balanceType' is not null or undefined
            assertParamExists('getBalanceBaseBalance', 'balanceType', balanceType)
            const localVarPath = `/__base/balance/getBalance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (balanceType !== undefined) {
                localVarQueryParameter['balanceType'] = balanceType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查询余额变动记录(不分页)
         * @param {number} userId 
         * @param {string} balanceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecordsBaseBalance: async (userId: number, balanceType: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('listRecordsBaseBalance', 'userId', userId)
            // verify required parameter 'balanceType' is not null or undefined
            assertParamExists('listRecordsBaseBalance', 'balanceType', balanceType)
            const localVarPath = `/__base/balance/listRecords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (balanceType !== undefined) {
                localVarQueryParameter['balanceType'] = balanceType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 分页查询余额变动记录
         * @param {SystemGenerateObject45} systemGenerateObject45 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRecordsBaseBalance: async (systemGenerateObject45: SystemGenerateObject45, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject45' is not null or undefined
            assertParamExists('pageRecordsBaseBalance', 'systemGenerateObject45', systemGenerateObject45)
            const localVarPath = `/__base/balance/pageRecords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject45, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 充值
         * @param {SystemGenerateObject46} systemGenerateObject46 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rechargeBaseBalance: async (systemGenerateObject46: SystemGenerateObject46, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject46' is not null or undefined
            assertParamExists('rechargeBaseBalance', 'systemGenerateObject46', systemGenerateObject46)
            const localVarPath = `/__base/balance/recharge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject46, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 退款(增加余额)
         * @param {SystemGenerateObject48} systemGenerateObject48 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundBaseBalance: async (systemGenerateObject48: SystemGenerateObject48, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject48' is not null or undefined
            assertParamExists('refundBaseBalance', 'systemGenerateObject48', systemGenerateObject48)
            const localVarPath = `/__base/balance/refund`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject48, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseBalanceApi - functional programming interface
 * @export
 */
export const BaseBalanceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseBalanceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 管理员调整余额
         * @param {SystemGenerateObject49} systemGenerateObject49 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adjustBaseBalance(systemGenerateObject49: SystemGenerateObject49, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adjustBaseBalance(systemGenerateObject49, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 消费/扣款
         * @param {SystemGenerateObject47} systemGenerateObject47 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async consumeBaseBalance(systemGenerateObject47: SystemGenerateObject47, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.consumeBaseBalance(systemGenerateObject47, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取用户余额
         * @param {number} userId 
         * @param {string} balanceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBalanceBaseBalance(userId: number, balanceType: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBalanceBaseBalance(userId, balanceType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 查询余额变动记录(不分页)
         * @param {number} userId 
         * @param {string} balanceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRecordsBaseBalance(userId: number, balanceType: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRecordsBaseBalance(userId, balanceType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 分页查询余额变动记录
         * @param {SystemGenerateObject45} systemGenerateObject45 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageRecordsBaseBalance(systemGenerateObject45: SystemGenerateObject45, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageRecordsBaseBalance(systemGenerateObject45, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 充值
         * @param {SystemGenerateObject46} systemGenerateObject46 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rechargeBaseBalance(systemGenerateObject46: SystemGenerateObject46, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rechargeBaseBalance(systemGenerateObject46, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 退款(增加余额)
         * @param {SystemGenerateObject48} systemGenerateObject48 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refundBaseBalance(systemGenerateObject48: SystemGenerateObject48, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refundBaseBalance(systemGenerateObject48, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseBalanceApi - factory interface
 * @export
 */
export const BaseBalanceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseBalanceApiFp(configuration)
    return {
        /**
         * 
         * @summary 管理员调整余额
         * @param {SystemGenerateObject49} systemGenerateObject49 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adjustBaseBalance(systemGenerateObject49: SystemGenerateObject49, options?: any): AxiosPromise<any> {
            return localVarFp.adjustBaseBalance(systemGenerateObject49, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 消费/扣款
         * @param {SystemGenerateObject47} systemGenerateObject47 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consumeBaseBalance(systemGenerateObject47: SystemGenerateObject47, options?: any): AxiosPromise<any> {
            return localVarFp.consumeBaseBalance(systemGenerateObject47, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取用户余额
         * @param {number} userId 
         * @param {string} balanceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalanceBaseBalance(userId: number, balanceType: string, options?: any): AxiosPromise<any> {
            return localVarFp.getBalanceBaseBalance(userId, balanceType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查询余额变动记录(不分页)
         * @param {number} userId 
         * @param {string} balanceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecordsBaseBalance(userId: number, balanceType: string, options?: any): AxiosPromise<any> {
            return localVarFp.listRecordsBaseBalance(userId, balanceType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 分页查询余额变动记录
         * @param {SystemGenerateObject45} systemGenerateObject45 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRecordsBaseBalance(systemGenerateObject45: SystemGenerateObject45, options?: any): AxiosPromise<any> {
            return localVarFp.pageRecordsBaseBalance(systemGenerateObject45, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 充值
         * @param {SystemGenerateObject46} systemGenerateObject46 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rechargeBaseBalance(systemGenerateObject46: SystemGenerateObject46, options?: any): AxiosPromise<any> {
            return localVarFp.rechargeBaseBalance(systemGenerateObject46, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 退款(增加余额)
         * @param {SystemGenerateObject48} systemGenerateObject48 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundBaseBalance(systemGenerateObject48: SystemGenerateObject48, options?: any): AxiosPromise<any> {
            return localVarFp.refundBaseBalance(systemGenerateObject48, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseBalanceApi - object-oriented interface
 * @export
 * @class BaseBalanceApi
 * @extends {BaseAPI}
 */
export class BaseBalanceApi extends BaseAPI {
    /**
     * 
     * @summary 管理员调整余额
     * @param {SystemGenerateObject49} systemGenerateObject49 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseBalanceApi
     */
    public adjustBaseBalance(systemGenerateObject49: SystemGenerateObject49, options?: AxiosRequestConfig) {
        return BaseBalanceApiFp(this.configuration).adjustBaseBalance(systemGenerateObject49, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 消费/扣款
     * @param {SystemGenerateObject47} systemGenerateObject47 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseBalanceApi
     */
    public consumeBaseBalance(systemGenerateObject47: SystemGenerateObject47, options?: AxiosRequestConfig) {
        return BaseBalanceApiFp(this.configuration).consumeBaseBalance(systemGenerateObject47, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取用户余额
     * @param {number} userId 
     * @param {string} balanceType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseBalanceApi
     */
    public getBalanceBaseBalance(userId: number, balanceType: string, options?: AxiosRequestConfig) {
        return BaseBalanceApiFp(this.configuration).getBalanceBaseBalance(userId, balanceType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查询余额变动记录(不分页)
     * @param {number} userId 
     * @param {string} balanceType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseBalanceApi
     */
    public listRecordsBaseBalance(userId: number, balanceType: string, options?: AxiosRequestConfig) {
        return BaseBalanceApiFp(this.configuration).listRecordsBaseBalance(userId, balanceType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 分页查询余额变动记录
     * @param {SystemGenerateObject45} systemGenerateObject45 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseBalanceApi
     */
    public pageRecordsBaseBalance(systemGenerateObject45: SystemGenerateObject45, options?: AxiosRequestConfig) {
        return BaseBalanceApiFp(this.configuration).pageRecordsBaseBalance(systemGenerateObject45, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 充值
     * @param {SystemGenerateObject46} systemGenerateObject46 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseBalanceApi
     */
    public rechargeBaseBalance(systemGenerateObject46: SystemGenerateObject46, options?: AxiosRequestConfig) {
        return BaseBalanceApiFp(this.configuration).rechargeBaseBalance(systemGenerateObject46, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 退款(增加余额)
     * @param {SystemGenerateObject48} systemGenerateObject48 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseBalanceApi
     */
    public refundBaseBalance(systemGenerateObject48: SystemGenerateObject48, options?: AxiosRequestConfig) {
        return BaseBalanceApiFp(this.configuration).refundBaseBalance(systemGenerateObject48, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseConfigApi - axios parameter creator
 * @export
 */
export const BaseConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 根据key删除单个配置项
         * @summary 删除配置项
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteValueBaseConfig: async (key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('deleteValueBaseConfig', 'key', key)
            const localVarPath = `/__base/config/deleteValue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 获取系统完整配置信息
         * @summary 获取完整配置
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigBaseConfig: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/config/getConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 获取前端运行时主题配置
         * @summary 获取主题配置
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThemeConfigBaseConfig: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/config/getThemeConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 根据key获取单个配置项的值
         * @summary 获取配置项
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValueBaseConfig: async (key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getValueBaseConfig', 'key', key)
            const localVarPath = `/__base/config/getValue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 根据key设置单个配置项的值
         * @summary 设置配置项
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setValueBaseConfig: async (body: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('setValueBaseConfig', 'body', body)
            const localVarPath = `/__base/config/setValue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseConfigApi - functional programming interface
 * @export
 */
export const BaseConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * 根据key删除单个配置项
         * @summary 删除配置项
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteValueBaseConfig(key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteValueBaseConfig(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 获取系统完整配置信息
         * @summary 获取完整配置
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfigBaseConfig(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfigBaseConfig(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 获取前端运行时主题配置
         * @summary 获取主题配置
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getThemeConfigBaseConfig(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getThemeConfigBaseConfig(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 根据key获取单个配置项的值
         * @summary 获取配置项
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getValueBaseConfig(key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getValueBaseConfig(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 根据key设置单个配置项的值
         * @summary 设置配置项
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setValueBaseConfig(body: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setValueBaseConfig(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseConfigApi - factory interface
 * @export
 */
export const BaseConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseConfigApiFp(configuration)
    return {
        /**
         * 根据key删除单个配置项
         * @summary 删除配置项
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteValueBaseConfig(key: string, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.deleteValueBaseConfig(key, options).then((request) => request(axios, basePath));
        },
        /**
         * 获取系统完整配置信息
         * @summary 获取完整配置
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigBaseConfig(options?: any): AxiosPromise<any> {
            return localVarFp.getConfigBaseConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * 获取前端运行时主题配置
         * @summary 获取主题配置
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThemeConfigBaseConfig(options?: any): AxiosPromise<any> {
            return localVarFp.getThemeConfigBaseConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * 根据key获取单个配置项的值
         * @summary 获取配置项
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValueBaseConfig(key: string, options?: any): AxiosPromise<any> {
            return localVarFp.getValueBaseConfig(key, options).then((request) => request(axios, basePath));
        },
        /**
         * 根据key设置单个配置项的值
         * @summary 设置配置项
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setValueBaseConfig(body: any, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.setValueBaseConfig(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseConfigApi - object-oriented interface
 * @export
 * @class BaseConfigApi
 * @extends {BaseAPI}
 */
export class BaseConfigApi extends BaseAPI {
    /**
     * 根据key删除单个配置项
     * @summary 删除配置项
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseConfigApi
     */
    public deleteValueBaseConfig(key: string, options?: AxiosRequestConfig) {
        return BaseConfigApiFp(this.configuration).deleteValueBaseConfig(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 获取系统完整配置信息
     * @summary 获取完整配置
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseConfigApi
     */
    public getConfigBaseConfig(options?: AxiosRequestConfig) {
        return BaseConfigApiFp(this.configuration).getConfigBaseConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 获取前端运行时主题配置
     * @summary 获取主题配置
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseConfigApi
     */
    public getThemeConfigBaseConfig(options?: AxiosRequestConfig) {
        return BaseConfigApiFp(this.configuration).getThemeConfigBaseConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 根据key获取单个配置项的值
     * @summary 获取配置项
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseConfigApi
     */
    public getValueBaseConfig(key: string, options?: AxiosRequestConfig) {
        return BaseConfigApiFp(this.configuration).getValueBaseConfig(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 根据key设置单个配置项的值
     * @summary 设置配置项
     * @param {any} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseConfigApi
     */
    public setValueBaseConfig(body: any, options?: AxiosRequestConfig) {
        return BaseConfigApiFp(this.configuration).setValueBaseConfig(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseDictionaryApi - axios parameter creator
 * @export
 */
export const BaseDictionaryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加字典
         * @param {BaseDictionaryAdminVo} baseDictionaryAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDictionaryBaseDictionary: async (baseDictionaryAdminVo: BaseDictionaryAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseDictionaryAdminVo' is not null or undefined
            assertParamExists('addDictionaryBaseDictionary', 'baseDictionaryAdminVo', baseDictionaryAdminVo)
            const localVarPath = `/__base/dictionary/addDictionary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseDictionaryAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除字典
         * @param {number} dictionaryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delDictionaryBaseDictionary: async (dictionaryId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dictionaryId' is not null or undefined
            assertParamExists('delDictionaryBaseDictionary', 'dictionaryId', dictionaryId)
            const localVarPath = `/__base/dictionary/delDictionary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dictionaryId !== undefined) {
                localVarQueryParameter['dictionaryId'] = dictionaryId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取单个字典
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionaryBaseDictionary: async (key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getDictionaryBaseDictionary', 'key', key)
            const localVarPath = `/__base/dictionary/getDictionary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取字典列表
         * @param {SystemGenerateObject33} systemGenerateObject33 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDictionaryBaseDictionary: async (systemGenerateObject33: SystemGenerateObject33, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject33' is not null or undefined
            assertParamExists('listDictionaryBaseDictionary', 'systemGenerateObject33', systemGenerateObject33)
            const localVarPath = `/__base/dictionary/listDictionary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject33, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取字典列表(分页)
         * @param {SystemGenerateObject34} systemGenerateObject34 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageDictionaryBaseDictionary: async (systemGenerateObject34: SystemGenerateObject34, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject34' is not null or undefined
            assertParamExists('pageDictionaryBaseDictionary', 'systemGenerateObject34', systemGenerateObject34)
            const localVarPath = `/__base/dictionary/pageDictionary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject34, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改字典
         * @param {BaseDictionaryAdminVo} baseDictionaryAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDictionaryBaseDictionary: async (baseDictionaryAdminVo: BaseDictionaryAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseDictionaryAdminVo' is not null or undefined
            assertParamExists('updateDictionaryBaseDictionary', 'baseDictionaryAdminVo', baseDictionaryAdminVo)
            const localVarPath = `/__base/dictionary/updateDictionary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseDictionaryAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseDictionaryApi - functional programming interface
 * @export
 */
export const BaseDictionaryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseDictionaryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加字典
         * @param {BaseDictionaryAdminVo} baseDictionaryAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDictionaryBaseDictionary(baseDictionaryAdminVo: BaseDictionaryAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDictionaryBaseDictionary(baseDictionaryAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除字典
         * @param {number} dictionaryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delDictionaryBaseDictionary(dictionaryId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delDictionaryBaseDictionary(dictionaryId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取单个字典
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDictionaryBaseDictionary(key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDictionaryBaseDictionary(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取字典列表
         * @param {SystemGenerateObject33} systemGenerateObject33 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDictionaryBaseDictionary(systemGenerateObject33: SystemGenerateObject33, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDictionaryBaseDictionary(systemGenerateObject33, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取字典列表(分页)
         * @param {SystemGenerateObject34} systemGenerateObject34 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageDictionaryBaseDictionary(systemGenerateObject34: SystemGenerateObject34, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageDictionaryBaseDictionary(systemGenerateObject34, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改字典
         * @param {BaseDictionaryAdminVo} baseDictionaryAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDictionaryBaseDictionary(baseDictionaryAdminVo: BaseDictionaryAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDictionaryBaseDictionary(baseDictionaryAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseDictionaryApi - factory interface
 * @export
 */
export const BaseDictionaryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseDictionaryApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加字典
         * @param {BaseDictionaryAdminVo} baseDictionaryAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDictionaryBaseDictionary(baseDictionaryAdminVo: BaseDictionaryAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.addDictionaryBaseDictionary(baseDictionaryAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除字典
         * @param {number} dictionaryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delDictionaryBaseDictionary(dictionaryId: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.delDictionaryBaseDictionary(dictionaryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取单个字典
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionaryBaseDictionary(key: string, options?: any): AxiosPromise<any> {
            return localVarFp.getDictionaryBaseDictionary(key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取字典列表
         * @param {SystemGenerateObject33} systemGenerateObject33 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDictionaryBaseDictionary(systemGenerateObject33: SystemGenerateObject33, options?: any): AxiosPromise<any> {
            return localVarFp.listDictionaryBaseDictionary(systemGenerateObject33, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取字典列表(分页)
         * @param {SystemGenerateObject34} systemGenerateObject34 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageDictionaryBaseDictionary(systemGenerateObject34: SystemGenerateObject34, options?: any): AxiosPromise<any> {
            return localVarFp.pageDictionaryBaseDictionary(systemGenerateObject34, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改字典
         * @param {BaseDictionaryAdminVo} baseDictionaryAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDictionaryBaseDictionary(baseDictionaryAdminVo: BaseDictionaryAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateDictionaryBaseDictionary(baseDictionaryAdminVo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseDictionaryApi - object-oriented interface
 * @export
 * @class BaseDictionaryApi
 * @extends {BaseAPI}
 */
export class BaseDictionaryApi extends BaseAPI {
    /**
     * 
     * @summary 添加字典
     * @param {BaseDictionaryAdminVo} baseDictionaryAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseDictionaryApi
     */
    public addDictionaryBaseDictionary(baseDictionaryAdminVo: BaseDictionaryAdminVo, options?: AxiosRequestConfig) {
        return BaseDictionaryApiFp(this.configuration).addDictionaryBaseDictionary(baseDictionaryAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除字典
     * @param {number} dictionaryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseDictionaryApi
     */
    public delDictionaryBaseDictionary(dictionaryId: number, options?: AxiosRequestConfig) {
        return BaseDictionaryApiFp(this.configuration).delDictionaryBaseDictionary(dictionaryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取单个字典
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseDictionaryApi
     */
    public getDictionaryBaseDictionary(key: string, options?: AxiosRequestConfig) {
        return BaseDictionaryApiFp(this.configuration).getDictionaryBaseDictionary(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取字典列表
     * @param {SystemGenerateObject33} systemGenerateObject33 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseDictionaryApi
     */
    public listDictionaryBaseDictionary(systemGenerateObject33: SystemGenerateObject33, options?: AxiosRequestConfig) {
        return BaseDictionaryApiFp(this.configuration).listDictionaryBaseDictionary(systemGenerateObject33, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取字典列表(分页)
     * @param {SystemGenerateObject34} systemGenerateObject34 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseDictionaryApi
     */
    public pageDictionaryBaseDictionary(systemGenerateObject34: SystemGenerateObject34, options?: AxiosRequestConfig) {
        return BaseDictionaryApiFp(this.configuration).pageDictionaryBaseDictionary(systemGenerateObject34, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改字典
     * @param {BaseDictionaryAdminVo} baseDictionaryAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseDictionaryApi
     */
    public updateDictionaryBaseDictionary(baseDictionaryAdminVo: BaseDictionaryAdminVo, options?: AxiosRequestConfig) {
        return BaseDictionaryApiFp(this.configuration).updateDictionaryBaseDictionary(baseDictionaryAdminVo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseLogApi - axios parameter creator
 * @export
 */
export const BaseLogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 删除日志
         * @param {SystemGenerateObject32} systemGenerateObject32 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLogBaseLog: async (systemGenerateObject32: SystemGenerateObject32, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject32' is not null or undefined
            assertParamExists('deleteLogBaseLog', 'systemGenerateObject32', systemGenerateObject32)
            const localVarPath = `/__base/log/deleteLog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject32, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取日志数量
         * @param {SystemGenerateObject29} systemGenerateObject29 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountBaseLog: async (systemGenerateObject29: SystemGenerateObject29, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject29' is not null or undefined
            assertParamExists('getCountBaseLog', 'systemGenerateObject29', systemGenerateObject29)
            const localVarPath = `/__base/log/getCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject29, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取操作列表
         * @param {SystemGenerateObject30} systemGenerateObject30 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLogBaseLog: async (systemGenerateObject30: SystemGenerateObject30, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject30' is not null or undefined
            assertParamExists('listLogBaseLog', 'systemGenerateObject30', systemGenerateObject30)
            const localVarPath = `/__base/log/listLog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject30, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取操作列表(分页)
         * @param {SystemGenerateObject31} systemGenerateObject31 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageLogBaseLog: async (systemGenerateObject31: SystemGenerateObject31, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject31' is not null or undefined
            assertParamExists('pageLogBaseLog', 'systemGenerateObject31', systemGenerateObject31)
            const localVarPath = `/__base/log/pageLog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject31, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseLogApi - functional programming interface
 * @export
 */
export const BaseLogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseLogApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 删除日志
         * @param {SystemGenerateObject32} systemGenerateObject32 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLogBaseLog(systemGenerateObject32: SystemGenerateObject32, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLogBaseLog(systemGenerateObject32, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取日志数量
         * @param {SystemGenerateObject29} systemGenerateObject29 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountBaseLog(systemGenerateObject29: SystemGenerateObject29, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountBaseLog(systemGenerateObject29, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取操作列表
         * @param {SystemGenerateObject30} systemGenerateObject30 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLogBaseLog(systemGenerateObject30: SystemGenerateObject30, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLogBaseLog(systemGenerateObject30, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取操作列表(分页)
         * @param {SystemGenerateObject31} systemGenerateObject31 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageLogBaseLog(systemGenerateObject31: SystemGenerateObject31, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageLogBaseLog(systemGenerateObject31, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseLogApi - factory interface
 * @export
 */
export const BaseLogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseLogApiFp(configuration)
    return {
        /**
         * 
         * @summary 删除日志
         * @param {SystemGenerateObject32} systemGenerateObject32 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLogBaseLog(systemGenerateObject32: SystemGenerateObject32, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.deleteLogBaseLog(systemGenerateObject32, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取日志数量
         * @param {SystemGenerateObject29} systemGenerateObject29 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountBaseLog(systemGenerateObject29: SystemGenerateObject29, options?: any): AxiosPromise<any> {
            return localVarFp.getCountBaseLog(systemGenerateObject29, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取操作列表
         * @param {SystemGenerateObject30} systemGenerateObject30 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLogBaseLog(systemGenerateObject30: SystemGenerateObject30, options?: any): AxiosPromise<any> {
            return localVarFp.listLogBaseLog(systemGenerateObject30, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取操作列表(分页)
         * @param {SystemGenerateObject31} systemGenerateObject31 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageLogBaseLog(systemGenerateObject31: SystemGenerateObject31, options?: any): AxiosPromise<any> {
            return localVarFp.pageLogBaseLog(systemGenerateObject31, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseLogApi - object-oriented interface
 * @export
 * @class BaseLogApi
 * @extends {BaseAPI}
 */
export class BaseLogApi extends BaseAPI {
    /**
     * 
     * @summary 删除日志
     * @param {SystemGenerateObject32} systemGenerateObject32 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseLogApi
     */
    public deleteLogBaseLog(systemGenerateObject32: SystemGenerateObject32, options?: AxiosRequestConfig) {
        return BaseLogApiFp(this.configuration).deleteLogBaseLog(systemGenerateObject32, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取日志数量
     * @param {SystemGenerateObject29} systemGenerateObject29 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseLogApi
     */
    public getCountBaseLog(systemGenerateObject29: SystemGenerateObject29, options?: AxiosRequestConfig) {
        return BaseLogApiFp(this.configuration).getCountBaseLog(systemGenerateObject29, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取操作列表
     * @param {SystemGenerateObject30} systemGenerateObject30 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseLogApi
     */
    public listLogBaseLog(systemGenerateObject30: SystemGenerateObject30, options?: AxiosRequestConfig) {
        return BaseLogApiFp(this.configuration).listLogBaseLog(systemGenerateObject30, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取操作列表(分页)
     * @param {SystemGenerateObject31} systemGenerateObject31 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseLogApi
     */
    public pageLogBaseLog(systemGenerateObject31: SystemGenerateObject31, options?: AxiosRequestConfig) {
        return BaseLogApiFp(this.configuration).pageLogBaseLog(systemGenerateObject31, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseMenuApi - axios parameter creator
 * @export
 */
export const BaseMenuApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加菜单
         * @param {BaseMenuAdminVo} baseMenuAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMenuBaseMenu: async (baseMenuAdminVo: BaseMenuAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseMenuAdminVo' is not null or undefined
            assertParamExists('addMenuBaseMenu', 'baseMenuAdminVo', baseMenuAdminVo)
            const localVarPath = `/__base/menu/addMenu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseMenuAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除菜单
         * @param {number} menuId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delMenuBaseMenu: async (menuId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'menuId' is not null or undefined
            assertParamExists('delMenuBaseMenu', 'menuId', menuId)
            const localVarPath = `/__base/menu/delMenu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (menuId !== undefined) {
                localVarQueryParameter['menuId'] = menuId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 获取动态菜单
         * @summary 获取动态菜单
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getsBaseMenu: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/menu/gets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取菜单列表
         * @param {SystemGenerateObject2} systemGenerateObject2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMenusBaseMenu: async (systemGenerateObject2: SystemGenerateObject2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject2' is not null or undefined
            assertParamExists('listMenusBaseMenu', 'systemGenerateObject2', systemGenerateObject2)
            const localVarPath = `/__base/menu/listMenus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取菜单列表(分页)
         * @param {SystemGenerateObject3} systemGenerateObject3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageMenusBaseMenu: async (systemGenerateObject3: SystemGenerateObject3, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject3' is not null or undefined
            assertParamExists('pageMenusBaseMenu', 'systemGenerateObject3', systemGenerateObject3)
            const localVarPath = `/__base/menu/pageMenus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject3, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改菜单
         * @param {BaseMenuAdminVo} baseMenuAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMenuBaseMenu: async (baseMenuAdminVo: BaseMenuAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseMenuAdminVo' is not null or undefined
            assertParamExists('updateMenuBaseMenu', 'baseMenuAdminVo', baseMenuAdminVo)
            const localVarPath = `/__base/menu/updateMenu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseMenuAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseMenuApi - functional programming interface
 * @export
 */
export const BaseMenuApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseMenuApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加菜单
         * @param {BaseMenuAdminVo} baseMenuAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addMenuBaseMenu(baseMenuAdminVo: BaseMenuAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addMenuBaseMenu(baseMenuAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除菜单
         * @param {number} menuId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delMenuBaseMenu(menuId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delMenuBaseMenu(menuId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 获取动态菜单
         * @summary 获取动态菜单
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getsBaseMenu(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getsBaseMenu(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取菜单列表
         * @param {SystemGenerateObject2} systemGenerateObject2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMenusBaseMenu(systemGenerateObject2: SystemGenerateObject2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMenusBaseMenu(systemGenerateObject2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取菜单列表(分页)
         * @param {SystemGenerateObject3} systemGenerateObject3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageMenusBaseMenu(systemGenerateObject3: SystemGenerateObject3, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageMenusBaseMenu(systemGenerateObject3, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改菜单
         * @param {BaseMenuAdminVo} baseMenuAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMenuBaseMenu(baseMenuAdminVo: BaseMenuAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMenuBaseMenu(baseMenuAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseMenuApi - factory interface
 * @export
 */
export const BaseMenuApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseMenuApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加菜单
         * @param {BaseMenuAdminVo} baseMenuAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMenuBaseMenu(baseMenuAdminVo: BaseMenuAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.addMenuBaseMenu(baseMenuAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除菜单
         * @param {number} menuId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delMenuBaseMenu(menuId: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.delMenuBaseMenu(menuId, options).then((request) => request(axios, basePath));
        },
        /**
         * 获取动态菜单
         * @summary 获取动态菜单
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getsBaseMenu(options?: any): AxiosPromise<any> {
            return localVarFp.getsBaseMenu(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取菜单列表
         * @param {SystemGenerateObject2} systemGenerateObject2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMenusBaseMenu(systemGenerateObject2: SystemGenerateObject2, options?: any): AxiosPromise<any> {
            return localVarFp.listMenusBaseMenu(systemGenerateObject2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取菜单列表(分页)
         * @param {SystemGenerateObject3} systemGenerateObject3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageMenusBaseMenu(systemGenerateObject3: SystemGenerateObject3, options?: any): AxiosPromise<any> {
            return localVarFp.pageMenusBaseMenu(systemGenerateObject3, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改菜单
         * @param {BaseMenuAdminVo} baseMenuAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMenuBaseMenu(baseMenuAdminVo: BaseMenuAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateMenuBaseMenu(baseMenuAdminVo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseMenuApi - object-oriented interface
 * @export
 * @class BaseMenuApi
 * @extends {BaseAPI}
 */
export class BaseMenuApi extends BaseAPI {
    /**
     * 
     * @summary 添加菜单
     * @param {BaseMenuAdminVo} baseMenuAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMenuApi
     */
    public addMenuBaseMenu(baseMenuAdminVo: BaseMenuAdminVo, options?: AxiosRequestConfig) {
        return BaseMenuApiFp(this.configuration).addMenuBaseMenu(baseMenuAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除菜单
     * @param {number} menuId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMenuApi
     */
    public delMenuBaseMenu(menuId: number, options?: AxiosRequestConfig) {
        return BaseMenuApiFp(this.configuration).delMenuBaseMenu(menuId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 获取动态菜单
     * @summary 获取动态菜单
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMenuApi
     */
    public getsBaseMenu(options?: AxiosRequestConfig) {
        return BaseMenuApiFp(this.configuration).getsBaseMenu(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取菜单列表
     * @param {SystemGenerateObject2} systemGenerateObject2 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMenuApi
     */
    public listMenusBaseMenu(systemGenerateObject2: SystemGenerateObject2, options?: AxiosRequestConfig) {
        return BaseMenuApiFp(this.configuration).listMenusBaseMenu(systemGenerateObject2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取菜单列表(分页)
     * @param {SystemGenerateObject3} systemGenerateObject3 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMenuApi
     */
    public pageMenusBaseMenu(systemGenerateObject3: SystemGenerateObject3, options?: AxiosRequestConfig) {
        return BaseMenuApiFp(this.configuration).pageMenusBaseMenu(systemGenerateObject3, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改菜单
     * @param {BaseMenuAdminVo} baseMenuAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMenuApi
     */
    public updateMenuBaseMenu(baseMenuAdminVo: BaseMenuAdminVo, options?: AxiosRequestConfig) {
        return BaseMenuApiFp(this.configuration).updateMenuBaseMenu(baseMenuAdminVo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseMessageApi - axios parameter creator
 * @export
 */
export const BaseMessageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 删除消息(管理端)
         * @param {number} messageId 
         * @param {number} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delMessageBaseMessage: async (messageId: number, tenantId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('delMessageBaseMessage', 'messageId', messageId)
            const localVarPath = `/__base/message/delMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (messageId !== undefined) {
                localVarQueryParameter['messageId'] = messageId;
            }

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除我的消息
         * @param {number} messageId 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delMyMessageBaseMessage: async (messageId: number, userId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('delMyMessageBaseMessage', 'messageId', messageId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('delMyMessageBaseMessage', 'userId', userId)
            const localVarPath = `/__base/message/delMyMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (messageId !== undefined) {
                localVarQueryParameter['messageId'] = messageId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取私信功能配置
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrivateMessageFeatureBaseMessage: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/message/getPrivateMessageFeature`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取未读消息数
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadCountBaseMessage: async (userId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUnreadCountBaseMessage', 'userId', userId)
            const localVarPath = `/__base/message/getUnreadCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取消息列表(管理端)
         * @param {SystemGenerateObject42} systemGenerateObject42 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMessageBaseMessage: async (systemGenerateObject42: SystemGenerateObject42, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject42' is not null or undefined
            assertParamExists('listMessageBaseMessage', 'systemGenerateObject42', systemGenerateObject42)
            const localVarPath = `/__base/message/listMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject42, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查看消息接收情况
         * @param {SystemGenerateObject44} systemGenerateObject44 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMessageReceiversBaseMessage: async (systemGenerateObject44: SystemGenerateObject44, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject44' is not null or undefined
            assertParamExists('listMessageReceiversBaseMessage', 'systemGenerateObject44', systemGenerateObject44)
            const localVarPath = `/__base/message/listMessageReceivers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject44, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查看我发送消息的接收情况
         * @param {SystemGenerateObject39} systemGenerateObject39 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMySentReceiversBaseMessage: async (systemGenerateObject39: SystemGenerateObject39, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject39' is not null or undefined
            assertParamExists('listMySentReceiversBaseMessage', 'systemGenerateObject39', systemGenerateObject39)
            const localVarPath = `/__base/message/listMySentMessageReceivers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject39, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取消息列表(管理端分页)
         * @param {SystemGenerateObject43} systemGenerateObject43 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageMessageBaseMessage: async (systemGenerateObject43: SystemGenerateObject43, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject43' is not null or undefined
            assertParamExists('pageMessageBaseMessage', 'systemGenerateObject43', systemGenerateObject43)
            const localVarPath = `/__base/message/pageMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject43, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查询我的消息(分页)
         * @param {SystemGenerateObject37} systemGenerateObject37 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageMyMessagesBaseMessage: async (systemGenerateObject37: SystemGenerateObject37, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject37' is not null or undefined
            assertParamExists('pageMyMessagesBaseMessage', 'systemGenerateObject37', systemGenerateObject37)
            const localVarPath = `/__base/message/pageMyMessages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject37, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查询我发送的消息(分页)
         * @param {SystemGenerateObject38} systemGenerateObject38 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSentMessagesBaseMessage: async (systemGenerateObject38: SystemGenerateObject38, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject38' is not null or undefined
            assertParamExists('pageSentMessagesBaseMessage', 'systemGenerateObject38', systemGenerateObject38)
            const localVarPath = `/__base/message/pageSentMessages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject38, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 全部标记已读
         * @param {SystemGenerateObject41} systemGenerateObject41 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readAllMessagesBaseMessage: async (systemGenerateObject41: SystemGenerateObject41, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject41' is not null or undefined
            assertParamExists('readAllMessagesBaseMessage', 'systemGenerateObject41', systemGenerateObject41)
            const localVarPath = `/__base/message/readAllMessages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject41, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 标记消息已读
         * @param {SystemGenerateObject40} systemGenerateObject40 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readMessageBaseMessage: async (systemGenerateObject40: SystemGenerateObject40, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject40' is not null or undefined
            assertParamExists('readMessageBaseMessage', 'systemGenerateObject40', systemGenerateObject40)
            const localVarPath = `/__base/message/readMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject40, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 搜索私信接收用户
         * @param {BaseMessagePrivateUserSearchVo} baseMessagePrivateUserSearchVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPrivateMessageUsersBaseMessage: async (baseMessagePrivateUserSearchVo: BaseMessagePrivateUserSearchVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseMessagePrivateUserSearchVo' is not null or undefined
            assertParamExists('searchPrivateMessageUsersBaseMessage', 'baseMessagePrivateUserSearchVo', baseMessagePrivateUserSearchVo)
            const localVarPath = `/__base/message/searchPrivateMessageUsers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseMessagePrivateUserSearchVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 发送消息
         * @param {BaseMessageAdminVo} baseMessageAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessageBaseMessage: async (baseMessageAdminVo: BaseMessageAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseMessageAdminVo' is not null or undefined
            assertParamExists('sendMessageBaseMessage', 'baseMessageAdminVo', baseMessageAdminVo)
            const localVarPath = `/__base/message/sendMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseMessageAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 发送私信消息
         * @param {BaseMessagePrivateSendVo} baseMessagePrivateSendVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPrivateMessageBaseMessage: async (baseMessagePrivateSendVo: BaseMessagePrivateSendVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseMessagePrivateSendVo' is not null or undefined
            assertParamExists('sendPrivateMessageBaseMessage', 'baseMessagePrivateSendVo', baseMessagePrivateSendVo)
            const localVarPath = `/__base/message/sendPrivateMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseMessagePrivateSendVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改消息(管理端)
         * @param {BaseMessageAdminVo} baseMessageAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMessageBaseMessage: async (baseMessageAdminVo: BaseMessageAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseMessageAdminVo' is not null or undefined
            assertParamExists('updateMessageBaseMessage', 'baseMessageAdminVo', baseMessageAdminVo)
            const localVarPath = `/__base/message/updateMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseMessageAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseMessageApi - functional programming interface
 * @export
 */
export const BaseMessageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseMessageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 删除消息(管理端)
         * @param {number} messageId 
         * @param {number} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delMessageBaseMessage(messageId: number, tenantId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delMessageBaseMessage(messageId, tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除我的消息
         * @param {number} messageId 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delMyMessageBaseMessage(messageId: number, userId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delMyMessageBaseMessage(messageId, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取私信功能配置
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrivateMessageFeatureBaseMessage(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrivateMessageFeatureBaseMessage(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取未读消息数
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnreadCountBaseMessage(userId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnreadCountBaseMessage(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取消息列表(管理端)
         * @param {SystemGenerateObject42} systemGenerateObject42 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMessageBaseMessage(systemGenerateObject42: SystemGenerateObject42, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMessageBaseMessage(systemGenerateObject42, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 查看消息接收情况
         * @param {SystemGenerateObject44} systemGenerateObject44 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMessageReceiversBaseMessage(systemGenerateObject44: SystemGenerateObject44, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMessageReceiversBaseMessage(systemGenerateObject44, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 查看我发送消息的接收情况
         * @param {SystemGenerateObject39} systemGenerateObject39 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMySentReceiversBaseMessage(systemGenerateObject39: SystemGenerateObject39, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMySentReceiversBaseMessage(systemGenerateObject39, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取消息列表(管理端分页)
         * @param {SystemGenerateObject43} systemGenerateObject43 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageMessageBaseMessage(systemGenerateObject43: SystemGenerateObject43, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageMessageBaseMessage(systemGenerateObject43, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 查询我的消息(分页)
         * @param {SystemGenerateObject37} systemGenerateObject37 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageMyMessagesBaseMessage(systemGenerateObject37: SystemGenerateObject37, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageMyMessagesBaseMessage(systemGenerateObject37, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 查询我发送的消息(分页)
         * @param {SystemGenerateObject38} systemGenerateObject38 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageSentMessagesBaseMessage(systemGenerateObject38: SystemGenerateObject38, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageSentMessagesBaseMessage(systemGenerateObject38, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 全部标记已读
         * @param {SystemGenerateObject41} systemGenerateObject41 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readAllMessagesBaseMessage(systemGenerateObject41: SystemGenerateObject41, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readAllMessagesBaseMessage(systemGenerateObject41, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 标记消息已读
         * @param {SystemGenerateObject40} systemGenerateObject40 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readMessageBaseMessage(systemGenerateObject40: SystemGenerateObject40, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readMessageBaseMessage(systemGenerateObject40, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 搜索私信接收用户
         * @param {BaseMessagePrivateUserSearchVo} baseMessagePrivateUserSearchVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchPrivateMessageUsersBaseMessage(baseMessagePrivateUserSearchVo: BaseMessagePrivateUserSearchVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchPrivateMessageUsersBaseMessage(baseMessagePrivateUserSearchVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 发送消息
         * @param {BaseMessageAdminVo} baseMessageAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendMessageBaseMessage(baseMessageAdminVo: BaseMessageAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendMessageBaseMessage(baseMessageAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 发送私信消息
         * @param {BaseMessagePrivateSendVo} baseMessagePrivateSendVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendPrivateMessageBaseMessage(baseMessagePrivateSendVo: BaseMessagePrivateSendVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendPrivateMessageBaseMessage(baseMessagePrivateSendVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改消息(管理端)
         * @param {BaseMessageAdminVo} baseMessageAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMessageBaseMessage(baseMessageAdminVo: BaseMessageAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMessageBaseMessage(baseMessageAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseMessageApi - factory interface
 * @export
 */
export const BaseMessageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseMessageApiFp(configuration)
    return {
        /**
         * 
         * @summary 删除消息(管理端)
         * @param {number} messageId 
         * @param {number} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delMessageBaseMessage(messageId: number, tenantId?: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.delMessageBaseMessage(messageId, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除我的消息
         * @param {number} messageId 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delMyMessageBaseMessage(messageId: number, userId: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.delMyMessageBaseMessage(messageId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取私信功能配置
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrivateMessageFeatureBaseMessage(options?: any): AxiosPromise<any> {
            return localVarFp.getPrivateMessageFeatureBaseMessage(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取未读消息数
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadCountBaseMessage(userId: number, options?: any): AxiosPromise<any> {
            return localVarFp.getUnreadCountBaseMessage(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取消息列表(管理端)
         * @param {SystemGenerateObject42} systemGenerateObject42 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMessageBaseMessage(systemGenerateObject42: SystemGenerateObject42, options?: any): AxiosPromise<any> {
            return localVarFp.listMessageBaseMessage(systemGenerateObject42, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查看消息接收情况
         * @param {SystemGenerateObject44} systemGenerateObject44 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMessageReceiversBaseMessage(systemGenerateObject44: SystemGenerateObject44, options?: any): AxiosPromise<any> {
            return localVarFp.listMessageReceiversBaseMessage(systemGenerateObject44, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查看我发送消息的接收情况
         * @param {SystemGenerateObject39} systemGenerateObject39 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMySentReceiversBaseMessage(systemGenerateObject39: SystemGenerateObject39, options?: any): AxiosPromise<any> {
            return localVarFp.listMySentReceiversBaseMessage(systemGenerateObject39, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取消息列表(管理端分页)
         * @param {SystemGenerateObject43} systemGenerateObject43 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageMessageBaseMessage(systemGenerateObject43: SystemGenerateObject43, options?: any): AxiosPromise<any> {
            return localVarFp.pageMessageBaseMessage(systemGenerateObject43, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查询我的消息(分页)
         * @param {SystemGenerateObject37} systemGenerateObject37 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageMyMessagesBaseMessage(systemGenerateObject37: SystemGenerateObject37, options?: any): AxiosPromise<any> {
            return localVarFp.pageMyMessagesBaseMessage(systemGenerateObject37, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查询我发送的消息(分页)
         * @param {SystemGenerateObject38} systemGenerateObject38 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSentMessagesBaseMessage(systemGenerateObject38: SystemGenerateObject38, options?: any): AxiosPromise<any> {
            return localVarFp.pageSentMessagesBaseMessage(systemGenerateObject38, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 全部标记已读
         * @param {SystemGenerateObject41} systemGenerateObject41 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readAllMessagesBaseMessage(systemGenerateObject41: SystemGenerateObject41, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.readAllMessagesBaseMessage(systemGenerateObject41, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 标记消息已读
         * @param {SystemGenerateObject40} systemGenerateObject40 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readMessageBaseMessage(systemGenerateObject40: SystemGenerateObject40, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.readMessageBaseMessage(systemGenerateObject40, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 搜索私信接收用户
         * @param {BaseMessagePrivateUserSearchVo} baseMessagePrivateUserSearchVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPrivateMessageUsersBaseMessage(baseMessagePrivateUserSearchVo: BaseMessagePrivateUserSearchVo, options?: any): AxiosPromise<any> {
            return localVarFp.searchPrivateMessageUsersBaseMessage(baseMessagePrivateUserSearchVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 发送消息
         * @param {BaseMessageAdminVo} baseMessageAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessageBaseMessage(baseMessageAdminVo: BaseMessageAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.sendMessageBaseMessage(baseMessageAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 发送私信消息
         * @param {BaseMessagePrivateSendVo} baseMessagePrivateSendVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPrivateMessageBaseMessage(baseMessagePrivateSendVo: BaseMessagePrivateSendVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.sendPrivateMessageBaseMessage(baseMessagePrivateSendVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改消息(管理端)
         * @param {BaseMessageAdminVo} baseMessageAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMessageBaseMessage(baseMessageAdminVo: BaseMessageAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateMessageBaseMessage(baseMessageAdminVo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseMessageApi - object-oriented interface
 * @export
 * @class BaseMessageApi
 * @extends {BaseAPI}
 */
export class BaseMessageApi extends BaseAPI {
    /**
     * 
     * @summary 删除消息(管理端)
     * @param {number} messageId 
     * @param {number} [tenantId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public delMessageBaseMessage(messageId: number, tenantId?: number, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).delMessageBaseMessage(messageId, tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除我的消息
     * @param {number} messageId 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public delMyMessageBaseMessage(messageId: number, userId: number, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).delMyMessageBaseMessage(messageId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取私信功能配置
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public getPrivateMessageFeatureBaseMessage(options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).getPrivateMessageFeatureBaseMessage(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取未读消息数
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public getUnreadCountBaseMessage(userId: number, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).getUnreadCountBaseMessage(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取消息列表(管理端)
     * @param {SystemGenerateObject42} systemGenerateObject42 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public listMessageBaseMessage(systemGenerateObject42: SystemGenerateObject42, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).listMessageBaseMessage(systemGenerateObject42, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查看消息接收情况
     * @param {SystemGenerateObject44} systemGenerateObject44 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public listMessageReceiversBaseMessage(systemGenerateObject44: SystemGenerateObject44, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).listMessageReceiversBaseMessage(systemGenerateObject44, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查看我发送消息的接收情况
     * @param {SystemGenerateObject39} systemGenerateObject39 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public listMySentReceiversBaseMessage(systemGenerateObject39: SystemGenerateObject39, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).listMySentReceiversBaseMessage(systemGenerateObject39, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取消息列表(管理端分页)
     * @param {SystemGenerateObject43} systemGenerateObject43 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public pageMessageBaseMessage(systemGenerateObject43: SystemGenerateObject43, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).pageMessageBaseMessage(systemGenerateObject43, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查询我的消息(分页)
     * @param {SystemGenerateObject37} systemGenerateObject37 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public pageMyMessagesBaseMessage(systemGenerateObject37: SystemGenerateObject37, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).pageMyMessagesBaseMessage(systemGenerateObject37, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查询我发送的消息(分页)
     * @param {SystemGenerateObject38} systemGenerateObject38 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public pageSentMessagesBaseMessage(systemGenerateObject38: SystemGenerateObject38, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).pageSentMessagesBaseMessage(systemGenerateObject38, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 全部标记已读
     * @param {SystemGenerateObject41} systemGenerateObject41 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public readAllMessagesBaseMessage(systemGenerateObject41: SystemGenerateObject41, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).readAllMessagesBaseMessage(systemGenerateObject41, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 标记消息已读
     * @param {SystemGenerateObject40} systemGenerateObject40 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public readMessageBaseMessage(systemGenerateObject40: SystemGenerateObject40, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).readMessageBaseMessage(systemGenerateObject40, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 搜索私信接收用户
     * @param {BaseMessagePrivateUserSearchVo} baseMessagePrivateUserSearchVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public searchPrivateMessageUsersBaseMessage(baseMessagePrivateUserSearchVo: BaseMessagePrivateUserSearchVo, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).searchPrivateMessageUsersBaseMessage(baseMessagePrivateUserSearchVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 发送消息
     * @param {BaseMessageAdminVo} baseMessageAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public sendMessageBaseMessage(baseMessageAdminVo: BaseMessageAdminVo, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).sendMessageBaseMessage(baseMessageAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 发送私信消息
     * @param {BaseMessagePrivateSendVo} baseMessagePrivateSendVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public sendPrivateMessageBaseMessage(baseMessagePrivateSendVo: BaseMessagePrivateSendVo, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).sendPrivateMessageBaseMessage(baseMessagePrivateSendVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改消息(管理端)
     * @param {BaseMessageAdminVo} baseMessageAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public updateMessageBaseMessage(baseMessageAdminVo: BaseMessageAdminVo, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).updateMessageBaseMessage(baseMessageAdminVo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseOperateApi - axios parameter creator
 * @export
 */
export const BaseOperateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加操作
         * @param {BaseOperateAdminVo} baseOperateAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOperateBaseOperate: async (baseOperateAdminVo: BaseOperateAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseOperateAdminVo' is not null or undefined
            assertParamExists('addOperateBaseOperate', 'baseOperateAdminVo', baseOperateAdminVo)
            const localVarPath = `/__base/operate/addOperate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseOperateAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除操作
         * @param {number} operateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delOperateBaseOperate: async (operateId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operateId' is not null or undefined
            assertParamExists('delOperateBaseOperate', 'operateId', operateId)
            const localVarPath = `/__base/operate/delOperate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (operateId !== undefined) {
                localVarQueryParameter['operateId'] = operateId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取用户的操作列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatesBaseOperate: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/operate/getOperates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取操作列表
         * @param {SystemGenerateObject4} systemGenerateObject4 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOperateBaseOperate: async (systemGenerateObject4: SystemGenerateObject4, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject4' is not null or undefined
            assertParamExists('listOperateBaseOperate', 'systemGenerateObject4', systemGenerateObject4)
            const localVarPath = `/__base/operate/listOperate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取操作列表(分页)
         * @param {SystemGenerateObject5} systemGenerateObject5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOperateBaseOperate: async (systemGenerateObject5: SystemGenerateObject5, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject5' is not null or undefined
            assertParamExists('pageOperateBaseOperate', 'systemGenerateObject5', systemGenerateObject5)
            const localVarPath = `/__base/operate/pageOperate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject5, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改操作
         * @param {BaseOperateAdminVo} baseOperateAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOperateBaseOperate: async (baseOperateAdminVo: BaseOperateAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseOperateAdminVo' is not null or undefined
            assertParamExists('updateOperateBaseOperate', 'baseOperateAdminVo', baseOperateAdminVo)
            const localVarPath = `/__base/operate/updateOperate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseOperateAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseOperateApi - functional programming interface
 * @export
 */
export const BaseOperateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseOperateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加操作
         * @param {BaseOperateAdminVo} baseOperateAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOperateBaseOperate(baseOperateAdminVo: BaseOperateAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOperateBaseOperate(baseOperateAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除操作
         * @param {number} operateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delOperateBaseOperate(operateId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delOperateBaseOperate(operateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取用户的操作列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperatesBaseOperate(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperatesBaseOperate(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取操作列表
         * @param {SystemGenerateObject4} systemGenerateObject4 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOperateBaseOperate(systemGenerateObject4: SystemGenerateObject4, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOperateBaseOperate(systemGenerateObject4, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取操作列表(分页)
         * @param {SystemGenerateObject5} systemGenerateObject5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageOperateBaseOperate(systemGenerateObject5: SystemGenerateObject5, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageOperateBaseOperate(systemGenerateObject5, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改操作
         * @param {BaseOperateAdminVo} baseOperateAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOperateBaseOperate(baseOperateAdminVo: BaseOperateAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOperateBaseOperate(baseOperateAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseOperateApi - factory interface
 * @export
 */
export const BaseOperateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseOperateApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加操作
         * @param {BaseOperateAdminVo} baseOperateAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOperateBaseOperate(baseOperateAdminVo: BaseOperateAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.addOperateBaseOperate(baseOperateAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除操作
         * @param {number} operateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delOperateBaseOperate(operateId: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.delOperateBaseOperate(operateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取用户的操作列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatesBaseOperate(options?: any): AxiosPromise<any> {
            return localVarFp.getOperatesBaseOperate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取操作列表
         * @param {SystemGenerateObject4} systemGenerateObject4 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOperateBaseOperate(systemGenerateObject4: SystemGenerateObject4, options?: any): AxiosPromise<any> {
            return localVarFp.listOperateBaseOperate(systemGenerateObject4, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取操作列表(分页)
         * @param {SystemGenerateObject5} systemGenerateObject5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOperateBaseOperate(systemGenerateObject5: SystemGenerateObject5, options?: any): AxiosPromise<any> {
            return localVarFp.pageOperateBaseOperate(systemGenerateObject5, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改操作
         * @param {BaseOperateAdminVo} baseOperateAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOperateBaseOperate(baseOperateAdminVo: BaseOperateAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateOperateBaseOperate(baseOperateAdminVo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseOperateApi - object-oriented interface
 * @export
 * @class BaseOperateApi
 * @extends {BaseAPI}
 */
export class BaseOperateApi extends BaseAPI {
    /**
     * 
     * @summary 添加操作
     * @param {BaseOperateAdminVo} baseOperateAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOperateApi
     */
    public addOperateBaseOperate(baseOperateAdminVo: BaseOperateAdminVo, options?: AxiosRequestConfig) {
        return BaseOperateApiFp(this.configuration).addOperateBaseOperate(baseOperateAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除操作
     * @param {number} operateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOperateApi
     */
    public delOperateBaseOperate(operateId: number, options?: AxiosRequestConfig) {
        return BaseOperateApiFp(this.configuration).delOperateBaseOperate(operateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取用户的操作列表
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOperateApi
     */
    public getOperatesBaseOperate(options?: AxiosRequestConfig) {
        return BaseOperateApiFp(this.configuration).getOperatesBaseOperate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取操作列表
     * @param {SystemGenerateObject4} systemGenerateObject4 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOperateApi
     */
    public listOperateBaseOperate(systemGenerateObject4: SystemGenerateObject4, options?: AxiosRequestConfig) {
        return BaseOperateApiFp(this.configuration).listOperateBaseOperate(systemGenerateObject4, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取操作列表(分页)
     * @param {SystemGenerateObject5} systemGenerateObject5 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOperateApi
     */
    public pageOperateBaseOperate(systemGenerateObject5: SystemGenerateObject5, options?: AxiosRequestConfig) {
        return BaseOperateApiFp(this.configuration).pageOperateBaseOperate(systemGenerateObject5, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改操作
     * @param {BaseOperateAdminVo} baseOperateAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOperateApi
     */
    public updateOperateBaseOperate(baseOperateAdminVo: BaseOperateAdminVo, options?: AxiosRequestConfig) {
        return BaseOperateApiFp(this.configuration).updateOperateBaseOperate(baseOperateAdminVo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseOrganizationApi - axios parameter creator
 * @export
 */
export const BaseOrganizationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加组织
         * @param {BaseOrganizationAdminVo} baseOrganizationAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrganizationBaseOrganization: async (baseOrganizationAdminVo: BaseOrganizationAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseOrganizationAdminVo' is not null or undefined
            assertParamExists('addOrganizationBaseOrganization', 'baseOrganizationAdminVo', baseOrganizationAdminVo)
            const localVarPath = `/__base/organization/addOrganization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseOrganizationAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除组织
         * @param {number} organizationId 
         * @param {number} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delOrganizationBaseOrganization: async (organizationId: number, tenantId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('delOrganizationBaseOrganization', 'organizationId', organizationId)
            const localVarPath = `/__base/organization/delOrganization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取组织列表
         * @param {SystemGenerateObject27} systemGenerateObject27 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganizationsBaseOrganization: async (systemGenerateObject27: SystemGenerateObject27, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject27' is not null or undefined
            assertParamExists('listOrganizationsBaseOrganization', 'systemGenerateObject27', systemGenerateObject27)
            const localVarPath = `/__base/organization/listOrganizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject27, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取组织列表(分页)
         * @param {SystemGenerateObject28} systemGenerateObject28 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOrganizationsBaseOrganization: async (systemGenerateObject28: SystemGenerateObject28, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject28' is not null or undefined
            assertParamExists('pageOrganizationsBaseOrganization', 'systemGenerateObject28', systemGenerateObject28)
            const localVarPath = `/__base/organization/pageOrganizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject28, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改组织
         * @param {BaseOrganizationAdminVo} baseOrganizationAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        udpateOrganizationBaseOrganization: async (baseOrganizationAdminVo: BaseOrganizationAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseOrganizationAdminVo' is not null or undefined
            assertParamExists('udpateOrganizationBaseOrganization', 'baseOrganizationAdminVo', baseOrganizationAdminVo)
            const localVarPath = `/__base/organization/udpateOrganization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseOrganizationAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseOrganizationApi - functional programming interface
 * @export
 */
export const BaseOrganizationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseOrganizationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加组织
         * @param {BaseOrganizationAdminVo} baseOrganizationAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOrganizationBaseOrganization(baseOrganizationAdminVo: BaseOrganizationAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOrganizationBaseOrganization(baseOrganizationAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除组织
         * @param {number} organizationId 
         * @param {number} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delOrganizationBaseOrganization(organizationId: number, tenantId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delOrganizationBaseOrganization(organizationId, tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取组织列表
         * @param {SystemGenerateObject27} systemGenerateObject27 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOrganizationsBaseOrganization(systemGenerateObject27: SystemGenerateObject27, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOrganizationsBaseOrganization(systemGenerateObject27, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取组织列表(分页)
         * @param {SystemGenerateObject28} systemGenerateObject28 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageOrganizationsBaseOrganization(systemGenerateObject28: SystemGenerateObject28, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageOrganizationsBaseOrganization(systemGenerateObject28, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改组织
         * @param {BaseOrganizationAdminVo} baseOrganizationAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async udpateOrganizationBaseOrganization(baseOrganizationAdminVo: BaseOrganizationAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.udpateOrganizationBaseOrganization(baseOrganizationAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseOrganizationApi - factory interface
 * @export
 */
export const BaseOrganizationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseOrganizationApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加组织
         * @param {BaseOrganizationAdminVo} baseOrganizationAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrganizationBaseOrganization(baseOrganizationAdminVo: BaseOrganizationAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.addOrganizationBaseOrganization(baseOrganizationAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除组织
         * @param {number} organizationId 
         * @param {number} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delOrganizationBaseOrganization(organizationId: number, tenantId?: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.delOrganizationBaseOrganization(organizationId, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取组织列表
         * @param {SystemGenerateObject27} systemGenerateObject27 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganizationsBaseOrganization(systemGenerateObject27: SystemGenerateObject27, options?: any): AxiosPromise<any> {
            return localVarFp.listOrganizationsBaseOrganization(systemGenerateObject27, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取组织列表(分页)
         * @param {SystemGenerateObject28} systemGenerateObject28 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOrganizationsBaseOrganization(systemGenerateObject28: SystemGenerateObject28, options?: any): AxiosPromise<any> {
            return localVarFp.pageOrganizationsBaseOrganization(systemGenerateObject28, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改组织
         * @param {BaseOrganizationAdminVo} baseOrganizationAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        udpateOrganizationBaseOrganization(baseOrganizationAdminVo: BaseOrganizationAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.udpateOrganizationBaseOrganization(baseOrganizationAdminVo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseOrganizationApi - object-oriented interface
 * @export
 * @class BaseOrganizationApi
 * @extends {BaseAPI}
 */
export class BaseOrganizationApi extends BaseAPI {
    /**
     * 
     * @summary 添加组织
     * @param {BaseOrganizationAdminVo} baseOrganizationAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOrganizationApi
     */
    public addOrganizationBaseOrganization(baseOrganizationAdminVo: BaseOrganizationAdminVo, options?: AxiosRequestConfig) {
        return BaseOrganizationApiFp(this.configuration).addOrganizationBaseOrganization(baseOrganizationAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除组织
     * @param {number} organizationId 
     * @param {number} [tenantId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOrganizationApi
     */
    public delOrganizationBaseOrganization(organizationId: number, tenantId?: number, options?: AxiosRequestConfig) {
        return BaseOrganizationApiFp(this.configuration).delOrganizationBaseOrganization(organizationId, tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取组织列表
     * @param {SystemGenerateObject27} systemGenerateObject27 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOrganizationApi
     */
    public listOrganizationsBaseOrganization(systemGenerateObject27: SystemGenerateObject27, options?: AxiosRequestConfig) {
        return BaseOrganizationApiFp(this.configuration).listOrganizationsBaseOrganization(systemGenerateObject27, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取组织列表(分页)
     * @param {SystemGenerateObject28} systemGenerateObject28 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOrganizationApi
     */
    public pageOrganizationsBaseOrganization(systemGenerateObject28: SystemGenerateObject28, options?: AxiosRequestConfig) {
        return BaseOrganizationApiFp(this.configuration).pageOrganizationsBaseOrganization(systemGenerateObject28, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改组织
     * @param {BaseOrganizationAdminVo} baseOrganizationAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOrganizationApi
     */
    public udpateOrganizationBaseOrganization(baseOrganizationAdminVo: BaseOrganizationAdminVo, options?: AxiosRequestConfig) {
        return BaseOrganizationApiFp(this.configuration).udpateOrganizationBaseOrganization(baseOrganizationAdminVo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BasePaymentApi - axios parameter creator
 * @export
 */
export const BasePaymentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 关闭未支付订单
         * @param {SystemGenerateObject52} systemGenerateObject52 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeOrderBasePayment: async (systemGenerateObject52: SystemGenerateObject52, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject52' is not null or undefined
            assertParamExists('closeOrderBasePayment', 'systemGenerateObject52', systemGenerateObject52)
            const localVarPath = `/__base/payment/closeOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject52, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 创建支付订单
         * @param {SystemGenerateObject50} systemGenerateObject50 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderBasePayment: async (systemGenerateObject50: SystemGenerateObject50, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject50' is not null or undefined
            assertParamExists('createOrderBasePayment', 'systemGenerateObject50', systemGenerateObject50)
            const localVarPath = `/__base/payment/createOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject50, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取订单详情
         * @param {string} orderNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderBasePayment: async (orderNo: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderNo' is not null or undefined
            assertParamExists('getOrderBasePayment', 'orderNo', orderNo)
            const localVarPath = `/__base/payment/getOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orderNo !== undefined) {
                localVarQueryParameter['orderNo'] = orderNo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 处理支付回调通知
         * @param {SystemGenerateObject56} systemGenerateObject56 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleNotifyBasePayment: async (systemGenerateObject56: SystemGenerateObject56, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject56' is not null or undefined
            assertParamExists('handleNotifyBasePayment', 'systemGenerateObject56', systemGenerateObject56)
            const localVarPath = `/__base/payment/handleNotify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject56, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 处理退款回调通知
         * @param {SystemGenerateObject57} systemGenerateObject57 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleRefundNotifyBasePayment: async (systemGenerateObject57: SystemGenerateObject57, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject57' is not null or undefined
            assertParamExists('handleRefundNotifyBasePayment', 'systemGenerateObject57', systemGenerateObject57)
            const localVarPath = `/__base/payment/handleRefundNotify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject57, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 分页查询支付订单
         * @param {SystemGenerateObject53} systemGenerateObject53 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOrdersBasePayment: async (systemGenerateObject53: SystemGenerateObject53, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject53' is not null or undefined
            assertParamExists('pageOrdersBasePayment', 'systemGenerateObject53', systemGenerateObject53)
            const localVarPath = `/__base/payment/pageOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject53, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 分页查询退款记录
         * @param {SystemGenerateObject55} systemGenerateObject55 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRefundsBasePayment: async (systemGenerateObject55: SystemGenerateObject55, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject55' is not null or undefined
            assertParamExists('pageRefundsBasePayment', 'systemGenerateObject55', systemGenerateObject55)
            const localVarPath = `/__base/payment/pageRefunds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject55, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 发起退款
         * @param {SystemGenerateObject54} systemGenerateObject54 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundBasePayment: async (systemGenerateObject54: SystemGenerateObject54, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject54' is not null or undefined
            assertParamExists('refundBasePayment', 'systemGenerateObject54', systemGenerateObject54)
            const localVarPath = `/__base/payment/refund`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject54, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 主动查询并同步订单状态
         * @param {SystemGenerateObject51} systemGenerateObject51 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncOrderStatusBasePayment: async (systemGenerateObject51: SystemGenerateObject51, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject51' is not null or undefined
            assertParamExists('syncOrderStatusBasePayment', 'systemGenerateObject51', systemGenerateObject51)
            const localVarPath = `/__base/payment/syncOrderStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject51, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BasePaymentApi - functional programming interface
 * @export
 */
export const BasePaymentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BasePaymentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 关闭未支付订单
         * @param {SystemGenerateObject52} systemGenerateObject52 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async closeOrderBasePayment(systemGenerateObject52: SystemGenerateObject52, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.closeOrderBasePayment(systemGenerateObject52, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 创建支付订单
         * @param {SystemGenerateObject50} systemGenerateObject50 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrderBasePayment(systemGenerateObject50: SystemGenerateObject50, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrderBasePayment(systemGenerateObject50, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取订单详情
         * @param {string} orderNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderBasePayment(orderNo: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderBasePayment(orderNo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 处理支付回调通知
         * @param {SystemGenerateObject56} systemGenerateObject56 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleNotifyBasePayment(systemGenerateObject56: SystemGenerateObject56, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleNotifyBasePayment(systemGenerateObject56, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 处理退款回调通知
         * @param {SystemGenerateObject57} systemGenerateObject57 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleRefundNotifyBasePayment(systemGenerateObject57: SystemGenerateObject57, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleRefundNotifyBasePayment(systemGenerateObject57, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 分页查询支付订单
         * @param {SystemGenerateObject53} systemGenerateObject53 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageOrdersBasePayment(systemGenerateObject53: SystemGenerateObject53, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageOrdersBasePayment(systemGenerateObject53, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 分页查询退款记录
         * @param {SystemGenerateObject55} systemGenerateObject55 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageRefundsBasePayment(systemGenerateObject55: SystemGenerateObject55, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageRefundsBasePayment(systemGenerateObject55, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 发起退款
         * @param {SystemGenerateObject54} systemGenerateObject54 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refundBasePayment(systemGenerateObject54: SystemGenerateObject54, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refundBasePayment(systemGenerateObject54, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 主动查询并同步订单状态
         * @param {SystemGenerateObject51} systemGenerateObject51 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncOrderStatusBasePayment(systemGenerateObject51: SystemGenerateObject51, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncOrderStatusBasePayment(systemGenerateObject51, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BasePaymentApi - factory interface
 * @export
 */
export const BasePaymentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BasePaymentApiFp(configuration)
    return {
        /**
         * 
         * @summary 关闭未支付订单
         * @param {SystemGenerateObject52} systemGenerateObject52 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeOrderBasePayment(systemGenerateObject52: SystemGenerateObject52, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.closeOrderBasePayment(systemGenerateObject52, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 创建支付订单
         * @param {SystemGenerateObject50} systemGenerateObject50 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderBasePayment(systemGenerateObject50: SystemGenerateObject50, options?: any): AxiosPromise<any> {
            return localVarFp.createOrderBasePayment(systemGenerateObject50, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取订单详情
         * @param {string} orderNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderBasePayment(orderNo: string, options?: any): AxiosPromise<any> {
            return localVarFp.getOrderBasePayment(orderNo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 处理支付回调通知
         * @param {SystemGenerateObject56} systemGenerateObject56 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleNotifyBasePayment(systemGenerateObject56: SystemGenerateObject56, options?: any): AxiosPromise<any> {
            return localVarFp.handleNotifyBasePayment(systemGenerateObject56, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 处理退款回调通知
         * @param {SystemGenerateObject57} systemGenerateObject57 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleRefundNotifyBasePayment(systemGenerateObject57: SystemGenerateObject57, options?: any): AxiosPromise<any> {
            return localVarFp.handleRefundNotifyBasePayment(systemGenerateObject57, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 分页查询支付订单
         * @param {SystemGenerateObject53} systemGenerateObject53 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOrdersBasePayment(systemGenerateObject53: SystemGenerateObject53, options?: any): AxiosPromise<any> {
            return localVarFp.pageOrdersBasePayment(systemGenerateObject53, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 分页查询退款记录
         * @param {SystemGenerateObject55} systemGenerateObject55 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRefundsBasePayment(systemGenerateObject55: SystemGenerateObject55, options?: any): AxiosPromise<any> {
            return localVarFp.pageRefundsBasePayment(systemGenerateObject55, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 发起退款
         * @param {SystemGenerateObject54} systemGenerateObject54 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundBasePayment(systemGenerateObject54: SystemGenerateObject54, options?: any): AxiosPromise<any> {
            return localVarFp.refundBasePayment(systemGenerateObject54, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 主动查询并同步订单状态
         * @param {SystemGenerateObject51} systemGenerateObject51 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncOrderStatusBasePayment(systemGenerateObject51: SystemGenerateObject51, options?: any): AxiosPromise<any> {
            return localVarFp.syncOrderStatusBasePayment(systemGenerateObject51, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BasePaymentApi - object-oriented interface
 * @export
 * @class BasePaymentApi
 * @extends {BaseAPI}
 */
export class BasePaymentApi extends BaseAPI {
    /**
     * 
     * @summary 关闭未支付订单
     * @param {SystemGenerateObject52} systemGenerateObject52 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasePaymentApi
     */
    public closeOrderBasePayment(systemGenerateObject52: SystemGenerateObject52, options?: AxiosRequestConfig) {
        return BasePaymentApiFp(this.configuration).closeOrderBasePayment(systemGenerateObject52, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 创建支付订单
     * @param {SystemGenerateObject50} systemGenerateObject50 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasePaymentApi
     */
    public createOrderBasePayment(systemGenerateObject50: SystemGenerateObject50, options?: AxiosRequestConfig) {
        return BasePaymentApiFp(this.configuration).createOrderBasePayment(systemGenerateObject50, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取订单详情
     * @param {string} orderNo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasePaymentApi
     */
    public getOrderBasePayment(orderNo: string, options?: AxiosRequestConfig) {
        return BasePaymentApiFp(this.configuration).getOrderBasePayment(orderNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 处理支付回调通知
     * @param {SystemGenerateObject56} systemGenerateObject56 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasePaymentApi
     */
    public handleNotifyBasePayment(systemGenerateObject56: SystemGenerateObject56, options?: AxiosRequestConfig) {
        return BasePaymentApiFp(this.configuration).handleNotifyBasePayment(systemGenerateObject56, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 处理退款回调通知
     * @param {SystemGenerateObject57} systemGenerateObject57 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasePaymentApi
     */
    public handleRefundNotifyBasePayment(systemGenerateObject57: SystemGenerateObject57, options?: AxiosRequestConfig) {
        return BasePaymentApiFp(this.configuration).handleRefundNotifyBasePayment(systemGenerateObject57, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 分页查询支付订单
     * @param {SystemGenerateObject53} systemGenerateObject53 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasePaymentApi
     */
    public pageOrdersBasePayment(systemGenerateObject53: SystemGenerateObject53, options?: AxiosRequestConfig) {
        return BasePaymentApiFp(this.configuration).pageOrdersBasePayment(systemGenerateObject53, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 分页查询退款记录
     * @param {SystemGenerateObject55} systemGenerateObject55 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasePaymentApi
     */
    public pageRefundsBasePayment(systemGenerateObject55: SystemGenerateObject55, options?: AxiosRequestConfig) {
        return BasePaymentApiFp(this.configuration).pageRefundsBasePayment(systemGenerateObject55, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 发起退款
     * @param {SystemGenerateObject54} systemGenerateObject54 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasePaymentApi
     */
    public refundBasePayment(systemGenerateObject54: SystemGenerateObject54, options?: AxiosRequestConfig) {
        return BasePaymentApiFp(this.configuration).refundBasePayment(systemGenerateObject54, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 主动查询并同步订单状态
     * @param {SystemGenerateObject51} systemGenerateObject51 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasePaymentApi
     */
    public syncOrderStatusBasePayment(systemGenerateObject51: SystemGenerateObject51, options?: AxiosRequestConfig) {
        return BasePaymentApiFp(this.configuration).syncOrderStatusBasePayment(systemGenerateObject51, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseRouteApi - axios parameter creator
 * @export
 */
export const BaseRouteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加路由
         * @param {BaseRouteAdminVo} baseRouteAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRouteBaseRoute: async (baseRouteAdminVo: BaseRouteAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseRouteAdminVo' is not null or undefined
            assertParamExists('addRouteBaseRoute', 'baseRouteAdminVo', baseRouteAdminVo)
            const localVarPath = `/__base/route/addRoute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseRouteAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除路由
         * @param {number} routeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoteBaseRoute: async (routeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'routeId' is not null or undefined
            assertParamExists('deleteRoteBaseRoute', 'routeId', routeId)
            const localVarPath = `/__base/route/deleteRote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (routeId !== undefined) {
                localVarQueryParameter['routeId'] = routeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 获取无需授权的动态路由
         * @summary 获取无需授权的动态路由
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNoPermissionRoutesBaseRoute: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/route/getNoPermissionRoutes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 获取动态路由
         * @summary 获取动态路由
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionRoutesBaseRoute: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/route/getPermissionRoutes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取路由列表
         * @param {SystemGenerateObject6} systemGenerateObject6 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRoutesBaseRoute: async (systemGenerateObject6: SystemGenerateObject6, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject6' is not null or undefined
            assertParamExists('listRoutesBaseRoute', 'systemGenerateObject6', systemGenerateObject6)
            const localVarPath = `/__base/route/listRoutes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject6, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取路由列表(分页)
         * @param {SystemGenerateObject7} systemGenerateObject7 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRoutesBaseRoute: async (systemGenerateObject7: SystemGenerateObject7, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject7' is not null or undefined
            assertParamExists('pageRoutesBaseRoute', 'systemGenerateObject7', systemGenerateObject7)
            const localVarPath = `/__base/route/pageRoutes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject7, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改路由
         * @param {BaseRouteAdminVo} baseRouteAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRouteBaseRoute: async (baseRouteAdminVo: BaseRouteAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseRouteAdminVo' is not null or undefined
            assertParamExists('updateRouteBaseRoute', 'baseRouteAdminVo', baseRouteAdminVo)
            const localVarPath = `/__base/route/updateRoute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseRouteAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseRouteApi - functional programming interface
 * @export
 */
export const BaseRouteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseRouteApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加路由
         * @param {BaseRouteAdminVo} baseRouteAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addRouteBaseRoute(baseRouteAdminVo: BaseRouteAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addRouteBaseRoute(baseRouteAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除路由
         * @param {number} routeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRoteBaseRoute(routeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRoteBaseRoute(routeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 获取无需授权的动态路由
         * @summary 获取无需授权的动态路由
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNoPermissionRoutesBaseRoute(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNoPermissionRoutesBaseRoute(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 获取动态路由
         * @summary 获取动态路由
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPermissionRoutesBaseRoute(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPermissionRoutesBaseRoute(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取路由列表
         * @param {SystemGenerateObject6} systemGenerateObject6 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRoutesBaseRoute(systemGenerateObject6: SystemGenerateObject6, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRoutesBaseRoute(systemGenerateObject6, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取路由列表(分页)
         * @param {SystemGenerateObject7} systemGenerateObject7 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageRoutesBaseRoute(systemGenerateObject7: SystemGenerateObject7, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageRoutesBaseRoute(systemGenerateObject7, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改路由
         * @param {BaseRouteAdminVo} baseRouteAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRouteBaseRoute(baseRouteAdminVo: BaseRouteAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRouteBaseRoute(baseRouteAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseRouteApi - factory interface
 * @export
 */
export const BaseRouteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseRouteApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加路由
         * @param {BaseRouteAdminVo} baseRouteAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRouteBaseRoute(baseRouteAdminVo: BaseRouteAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.addRouteBaseRoute(baseRouteAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除路由
         * @param {number} routeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoteBaseRoute(routeId: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.deleteRoteBaseRoute(routeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 获取无需授权的动态路由
         * @summary 获取无需授权的动态路由
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNoPermissionRoutesBaseRoute(options?: any): AxiosPromise<any> {
            return localVarFp.getNoPermissionRoutesBaseRoute(options).then((request) => request(axios, basePath));
        },
        /**
         * 获取动态路由
         * @summary 获取动态路由
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionRoutesBaseRoute(options?: any): AxiosPromise<any> {
            return localVarFp.getPermissionRoutesBaseRoute(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取路由列表
         * @param {SystemGenerateObject6} systemGenerateObject6 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRoutesBaseRoute(systemGenerateObject6: SystemGenerateObject6, options?: any): AxiosPromise<any> {
            return localVarFp.listRoutesBaseRoute(systemGenerateObject6, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取路由列表(分页)
         * @param {SystemGenerateObject7} systemGenerateObject7 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRoutesBaseRoute(systemGenerateObject7: SystemGenerateObject7, options?: any): AxiosPromise<any> {
            return localVarFp.pageRoutesBaseRoute(systemGenerateObject7, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改路由
         * @param {BaseRouteAdminVo} baseRouteAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRouteBaseRoute(baseRouteAdminVo: BaseRouteAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateRouteBaseRoute(baseRouteAdminVo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseRouteApi - object-oriented interface
 * @export
 * @class BaseRouteApi
 * @extends {BaseAPI}
 */
export class BaseRouteApi extends BaseAPI {
    /**
     * 
     * @summary 添加路由
     * @param {BaseRouteAdminVo} baseRouteAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseRouteApi
     */
    public addRouteBaseRoute(baseRouteAdminVo: BaseRouteAdminVo, options?: AxiosRequestConfig) {
        return BaseRouteApiFp(this.configuration).addRouteBaseRoute(baseRouteAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除路由
     * @param {number} routeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseRouteApi
     */
    public deleteRoteBaseRoute(routeId: number, options?: AxiosRequestConfig) {
        return BaseRouteApiFp(this.configuration).deleteRoteBaseRoute(routeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 获取无需授权的动态路由
     * @summary 获取无需授权的动态路由
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseRouteApi
     */
    public getNoPermissionRoutesBaseRoute(options?: AxiosRequestConfig) {
        return BaseRouteApiFp(this.configuration).getNoPermissionRoutesBaseRoute(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 获取动态路由
     * @summary 获取动态路由
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseRouteApi
     */
    public getPermissionRoutesBaseRoute(options?: AxiosRequestConfig) {
        return BaseRouteApiFp(this.configuration).getPermissionRoutesBaseRoute(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取路由列表
     * @param {SystemGenerateObject6} systemGenerateObject6 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseRouteApi
     */
    public listRoutesBaseRoute(systemGenerateObject6: SystemGenerateObject6, options?: AxiosRequestConfig) {
        return BaseRouteApiFp(this.configuration).listRoutesBaseRoute(systemGenerateObject6, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取路由列表(分页)
     * @param {SystemGenerateObject7} systemGenerateObject7 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseRouteApi
     */
    public pageRoutesBaseRoute(systemGenerateObject7: SystemGenerateObject7, options?: AxiosRequestConfig) {
        return BaseRouteApiFp(this.configuration).pageRoutesBaseRoute(systemGenerateObject7, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改路由
     * @param {BaseRouteAdminVo} baseRouteAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseRouteApi
     */
    public updateRouteBaseRoute(baseRouteAdminVo: BaseRouteAdminVo, options?: AxiosRequestConfig) {
        return BaseRouteApiFp(this.configuration).updateRouteBaseRoute(baseRouteAdminVo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseScheduleApi - axios parameter creator
 * @export
 */
export const BaseScheduleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 删除任务
         * @param {string} scheduleName 
         * @param {number} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScheduleBaseSchedule: async (scheduleName: string, tenantId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scheduleName' is not null or undefined
            assertParamExists('deleteScheduleBaseSchedule', 'scheduleName', scheduleName)
            const localVarPath = `/__base/schedule/deleteSchedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (scheduleName !== undefined) {
                localVarQueryParameter['scheduleName'] = scheduleName;
            }

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取任务列表(分页)
         * @param {SystemGenerateObject8} systemGenerateObject8 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSchedulesBaseSchedule: async (systemGenerateObject8: SystemGenerateObject8, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject8' is not null or undefined
            assertParamExists('pageSchedulesBaseSchedule', 'systemGenerateObject8', systemGenerateObject8)
            const localVarPath = `/__base/schedule/pageSchedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject8, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseScheduleApi - functional programming interface
 * @export
 */
export const BaseScheduleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseScheduleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 删除任务
         * @param {string} scheduleName 
         * @param {number} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteScheduleBaseSchedule(scheduleName: string, tenantId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteScheduleBaseSchedule(scheduleName, tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取任务列表(分页)
         * @param {SystemGenerateObject8} systemGenerateObject8 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageSchedulesBaseSchedule(systemGenerateObject8: SystemGenerateObject8, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageSchedulesBaseSchedule(systemGenerateObject8, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseScheduleApi - factory interface
 * @export
 */
export const BaseScheduleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseScheduleApiFp(configuration)
    return {
        /**
         * 
         * @summary 删除任务
         * @param {string} scheduleName 
         * @param {number} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScheduleBaseSchedule(scheduleName: string, tenantId?: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.deleteScheduleBaseSchedule(scheduleName, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取任务列表(分页)
         * @param {SystemGenerateObject8} systemGenerateObject8 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSchedulesBaseSchedule(systemGenerateObject8: SystemGenerateObject8, options?: any): AxiosPromise<any> {
            return localVarFp.pageSchedulesBaseSchedule(systemGenerateObject8, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseScheduleApi - object-oriented interface
 * @export
 * @class BaseScheduleApi
 * @extends {BaseAPI}
 */
export class BaseScheduleApi extends BaseAPI {
    /**
     * 
     * @summary 删除任务
     * @param {string} scheduleName 
     * @param {number} [tenantId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseScheduleApi
     */
    public deleteScheduleBaseSchedule(scheduleName: string, tenantId?: number, options?: AxiosRequestConfig) {
        return BaseScheduleApiFp(this.configuration).deleteScheduleBaseSchedule(scheduleName, tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取任务列表(分页)
     * @param {SystemGenerateObject8} systemGenerateObject8 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseScheduleApi
     */
    public pageSchedulesBaseSchedule(systemGenerateObject8: SystemGenerateObject8, options?: AxiosRequestConfig) {
        return BaseScheduleApiFp(this.configuration).pageSchedulesBaseSchedule(systemGenerateObject8, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseTenantApi - axios parameter creator
 * @export
 */
export const BaseTenantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加租户
         * @param {BaseTenantAdminVo} baseTenantAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBaseTenantBaseTenant: async (baseTenantAdminVo: BaseTenantAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseTenantAdminVo' is not null or undefined
            assertParamExists('addBaseTenantBaseTenant', 'baseTenantAdminVo', baseTenantAdminVo)
            const localVarPath = `/__base/tenant/addBaseTenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseTenantAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除租户
         * @param {number} baseTenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delBaseTenantBaseTenant: async (baseTenantId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseTenantId' is not null or undefined
            assertParamExists('delBaseTenantBaseTenant', 'baseTenantId', baseTenantId)
            const localVarPath = `/__base/tenant/delBaseTenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (baseTenantId !== undefined) {
                localVarQueryParameter['baseTenantId'] = baseTenantId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取租户信息（公共）
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantPublicBaseTenant: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTenantPublicBaseTenant', 'id', id)
            const localVarPath = `/__base/tenant/getTenantPublic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取租户列表
         * @param {SystemGenerateObject35} systemGenerateObject35 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBaseTenantBaseTenant: async (systemGenerateObject35: SystemGenerateObject35, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject35' is not null or undefined
            assertParamExists('listBaseTenantBaseTenant', 'systemGenerateObject35', systemGenerateObject35)
            const localVarPath = `/__base/tenant/listBaseTenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject35, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取租户列表(分页)
         * @param {SystemGenerateObject36} systemGenerateObject36 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBaseTenantBaseTenant: async (systemGenerateObject36: SystemGenerateObject36, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject36' is not null or undefined
            assertParamExists('pageBaseTenantBaseTenant', 'systemGenerateObject36', systemGenerateObject36)
            const localVarPath = `/__base/tenant/pageBaseTenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject36, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新租户
         * @param {BaseTenantAdminVo} baseTenantAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBaseTenantBaseTenant: async (baseTenantAdminVo: BaseTenantAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseTenantAdminVo' is not null or undefined
            assertParamExists('updateBaseTenantBaseTenant', 'baseTenantAdminVo', baseTenantAdminVo)
            const localVarPath = `/__base/tenant/updateBaseTenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseTenantAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseTenantApi - functional programming interface
 * @export
 */
export const BaseTenantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseTenantApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加租户
         * @param {BaseTenantAdminVo} baseTenantAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addBaseTenantBaseTenant(baseTenantAdminVo: BaseTenantAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addBaseTenantBaseTenant(baseTenantAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除租户
         * @param {number} baseTenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delBaseTenantBaseTenant(baseTenantId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delBaseTenantBaseTenant(baseTenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取租户信息（公共）
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTenantPublicBaseTenant(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTenantPublicBaseTenant(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取租户列表
         * @param {SystemGenerateObject35} systemGenerateObject35 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBaseTenantBaseTenant(systemGenerateObject35: SystemGenerateObject35, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBaseTenantBaseTenant(systemGenerateObject35, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取租户列表(分页)
         * @param {SystemGenerateObject36} systemGenerateObject36 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageBaseTenantBaseTenant(systemGenerateObject36: SystemGenerateObject36, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageBaseTenantBaseTenant(systemGenerateObject36, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新租户
         * @param {BaseTenantAdminVo} baseTenantAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBaseTenantBaseTenant(baseTenantAdminVo: BaseTenantAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBaseTenantBaseTenant(baseTenantAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseTenantApi - factory interface
 * @export
 */
export const BaseTenantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseTenantApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加租户
         * @param {BaseTenantAdminVo} baseTenantAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBaseTenantBaseTenant(baseTenantAdminVo: BaseTenantAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.addBaseTenantBaseTenant(baseTenantAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除租户
         * @param {number} baseTenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delBaseTenantBaseTenant(baseTenantId: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.delBaseTenantBaseTenant(baseTenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取租户信息（公共）
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantPublicBaseTenant(id: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.getTenantPublicBaseTenant(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取租户列表
         * @param {SystemGenerateObject35} systemGenerateObject35 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBaseTenantBaseTenant(systemGenerateObject35: SystemGenerateObject35, options?: any): AxiosPromise<any> {
            return localVarFp.listBaseTenantBaseTenant(systemGenerateObject35, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取租户列表(分页)
         * @param {SystemGenerateObject36} systemGenerateObject36 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBaseTenantBaseTenant(systemGenerateObject36: SystemGenerateObject36, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.pageBaseTenantBaseTenant(systemGenerateObject36, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新租户
         * @param {BaseTenantAdminVo} baseTenantAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBaseTenantBaseTenant(baseTenantAdminVo: BaseTenantAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateBaseTenantBaseTenant(baseTenantAdminVo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseTenantApi - object-oriented interface
 * @export
 * @class BaseTenantApi
 * @extends {BaseAPI}
 */
export class BaseTenantApi extends BaseAPI {
    /**
     * 
     * @summary 添加租户
     * @param {BaseTenantAdminVo} baseTenantAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseTenantApi
     */
    public addBaseTenantBaseTenant(baseTenantAdminVo: BaseTenantAdminVo, options?: AxiosRequestConfig) {
        return BaseTenantApiFp(this.configuration).addBaseTenantBaseTenant(baseTenantAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除租户
     * @param {number} baseTenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseTenantApi
     */
    public delBaseTenantBaseTenant(baseTenantId: number, options?: AxiosRequestConfig) {
        return BaseTenantApiFp(this.configuration).delBaseTenantBaseTenant(baseTenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取租户信息（公共）
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseTenantApi
     */
    public getTenantPublicBaseTenant(id: number, options?: AxiosRequestConfig) {
        return BaseTenantApiFp(this.configuration).getTenantPublicBaseTenant(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取租户列表
     * @param {SystemGenerateObject35} systemGenerateObject35 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseTenantApi
     */
    public listBaseTenantBaseTenant(systemGenerateObject35: SystemGenerateObject35, options?: AxiosRequestConfig) {
        return BaseTenantApiFp(this.configuration).listBaseTenantBaseTenant(systemGenerateObject35, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取租户列表(分页)
     * @param {SystemGenerateObject36} systemGenerateObject36 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseTenantApi
     */
    public pageBaseTenantBaseTenant(systemGenerateObject36: SystemGenerateObject36, options?: AxiosRequestConfig) {
        return BaseTenantApiFp(this.configuration).pageBaseTenantBaseTenant(systemGenerateObject36, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新租户
     * @param {BaseTenantAdminVo} baseTenantAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseTenantApi
     */
    public updateBaseTenantBaseTenant(baseTenantAdminVo: BaseTenantAdminVo, options?: AxiosRequestConfig) {
        return BaseTenantApiFp(this.configuration).updateBaseTenantBaseTenant(baseTenantAdminVo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseUploadApi - axios parameter creator
 * @export
 */
export const BaseUploadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 上传文件
         * @summary 上传文件
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesBaseUpload: async (files: Array<File>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'files' is not null or undefined
            assertParamExists('filesBaseUpload', 'files', files)
            const localVarPath = `/__base/upload/file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseUploadApi - functional programming interface
 * @export
 */
export const BaseUploadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseUploadApiAxiosParamCreator(configuration)
    return {
        /**
         * 上传文件
         * @summary 上传文件
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesBaseUpload(files: Array<File>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesBaseUpload(files, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseUploadApi - factory interface
 * @export
 */
export const BaseUploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseUploadApiFp(configuration)
    return {
        /**
         * 上传文件
         * @summary 上传文件
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesBaseUpload(files: Array<File>, options?: any): AxiosPromise<any> {
            return localVarFp.filesBaseUpload(files, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseUploadApi - object-oriented interface
 * @export
 * @class BaseUploadApi
 * @extends {BaseAPI}
 */
export class BaseUploadApi extends BaseAPI {
    /**
     * 上传文件
     * @summary 上传文件
     * @param {Array<File>} files 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUploadApi
     */
    public filesBaseUpload(files: Array<File>, options?: AxiosRequestConfig) {
        return BaseUploadApiFp(this.configuration).filesBaseUpload(files, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseUserApi - axios parameter creator
 * @export
 */
export const BaseUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加角色
         * @param {BaseRoleAdminVo} baseRoleAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRoleBaseUser: async (baseRoleAdminVo: BaseRoleAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseRoleAdminVo' is not null or undefined
            assertParamExists('addRoleBaseUser', 'baseRoleAdminVo', baseRoleAdminVo)
            const localVarPath = `/__base/user/addRole`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseRoleAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 添加用户
         * @param {BaseUserAdminVo} baseUserAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserBaseUser: async (baseUserAdminVo: BaseUserAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseUserAdminVo' is not null or undefined
            assertParamExists('addUserBaseUser', 'baseUserAdminVo', baseUserAdminVo)
            const localVarPath = `/__base/user/addUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseUserAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除角色
         * @param {number} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delRoleBaseUser: async (roleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('delRoleBaseUser', 'roleId', roleId)
            const localVarPath = `/__base/user/delRole`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (roleId !== undefined) {
                localVarQueryParameter['roleId'] = roleId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除用户
         * @param {number} userId 
         * @param {number} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserBaseUser: async (userId: number, tenantId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUserBaseUser', 'userId', userId)
            const localVarPath = `/__base/user/deleteUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 邮箱查重
         * @param {string} email 
         * @param {number} [excludeUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsByEmailBaseUser: async (email: string, excludeUserId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('existsByEmailBaseUser', 'email', email)
            const localVarPath = `/__base/user/existsByEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (excludeUserId !== undefined) {
                localVarQueryParameter['excludeUserId'] = excludeUserId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 手机号查重
         * @param {string} phone 
         * @param {number} [excludeUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsByPhoneBaseUser: async (phone: string, excludeUserId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phone' is not null or undefined
            assertParamExists('existsByPhoneBaseUser', 'phone', phone)
            const localVarPath = `/__base/user/existsByPhone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (phone !== undefined) {
                localVarQueryParameter['phone'] = phone;
            }

            if (excludeUserId !== undefined) {
                localVarQueryParameter['excludeUserId'] = excludeUserId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 用户名查重
         * @param {string} username 
         * @param {number} [excludeUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsByUsernameBaseUser: async (username: string, excludeUserId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('existsByUsernameBaseUser', 'username', username)
            const localVarPath = `/__base/user/existsByUsername`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (excludeUserId !== undefined) {
                localVarQueryParameter['excludeUserId'] = excludeUserId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 获取用户信息
         * @summary 获取用户信息
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfoBaseUser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/user/getUserInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取组织机构下角色列表
         * @param {string} orgCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrgRolesBaseUser: async (orgCode: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgCode' is not null or undefined
            assertParamExists('listOrgRolesBaseUser', 'orgCode', orgCode)
            const localVarPath = `/__base/user/listOrgRoles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orgCode !== undefined) {
                localVarQueryParameter['orgCode'] = orgCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取角色列表
         * @param {SystemGenerateObject19} systemGenerateObject19 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRolesBaseUser: async (systemGenerateObject19: SystemGenerateObject19, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject19' is not null or undefined
            assertParamExists('listRolesBaseUser', 'systemGenerateObject19', systemGenerateObject19)
            const localVarPath = `/__base/user/listRoles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject19, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取系统角色列表
         * @param {SystemGenerateObject17} systemGenerateObject17 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSystemRolesBaseUser: async (systemGenerateObject17: SystemGenerateObject17, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject17' is not null or undefined
            assertParamExists('listSystemRolesBaseUser', 'systemGenerateObject17', systemGenerateObject17)
            const localVarPath = `/__base/user/listSystemRoles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject17, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取第三方绑定列表
         * @param {SystemGenerateObject16} systemGenerateObject16 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listThirdPartyBaseUser: async (systemGenerateObject16: SystemGenerateObject16, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject16' is not null or undefined
            assertParamExists('listThirdPartyBaseUser', 'systemGenerateObject16', systemGenerateObject16)
            const localVarPath = `/__base/user/listThirdParty`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject16, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查询用户的组织角色列表
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserOrgRolesBaseUser: async (userId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('listUserOrgRolesBaseUser', 'userId', userId)
            const localVarPath = `/__base/user/listUserOrgRoles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取用户列表
         * @param {SystemGenerateObject21} systemGenerateObject21 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsersBaseUser: async (systemGenerateObject21: SystemGenerateObject21, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject21' is not null or undefined
            assertParamExists('listUsersBaseUser', 'systemGenerateObject21', systemGenerateObject21)
            const localVarPath = `/__base/user/listUsers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject21, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 支持用户名、邮箱、手机号三合一登录
         * @summary 登录(用户名/邮箱/手机号)
         * @param {string} account 
         * @param {string} password 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginBaseUser: async (account: string, password: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'account' is not null or undefined
            assertParamExists('loginBaseUser', 'account', account)
            // verify required parameter 'password' is not null or undefined
            assertParamExists('loginBaseUser', 'password', password)
            const localVarPath = `/__base/user/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (account !== undefined) { 
                localVarFormParams.set('account', account as any);
            }
    
            if (password !== undefined) { 
                localVarFormParams.set('password', password as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 邮箱验证码登录
         * @param {string} email 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginByEmailCodeBaseUser: async (email: string, code: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('loginByEmailCodeBaseUser', 'email', email)
            // verify required parameter 'code' is not null or undefined
            assertParamExists('loginByEmailCodeBaseUser', 'code', code)
            const localVarPath = `/__base/user/loginByEmailCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (email !== undefined) { 
                localVarFormParams.set('email', email as any);
            }
    
            if (code !== undefined) { 
                localVarFormParams.set('code', code as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 手机号验证码登录
         * @param {string} phone 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginByPhoneCodeBaseUser: async (phone: string, code: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phone' is not null or undefined
            assertParamExists('loginByPhoneCodeBaseUser', 'phone', phone)
            // verify required parameter 'code' is not null or undefined
            assertParamExists('loginByPhoneCodeBaseUser', 'code', code)
            const localVarPath = `/__base/user/loginByPhoneCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (phone !== undefined) { 
                localVarFormParams.set('phone', phone as any);
            }
    
            if (code !== undefined) { 
                localVarFormParams.set('code', code as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 第三方平台登录
         * @param {string} platform 
         * @param {string} openId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginByThirdPartyBaseUser: async (platform: string, openId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platform' is not null or undefined
            assertParamExists('loginByThirdPartyBaseUser', 'platform', platform)
            // verify required parameter 'openId' is not null or undefined
            assertParamExists('loginByThirdPartyBaseUser', 'openId', openId)
            const localVarPath = `/__base/user/loginByThirdParty`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (platform !== undefined) { 
                localVarFormParams.set('platform', platform as any);
            }
    
            if (openId !== undefined) { 
                localVarFormParams.set('openId', openId as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 登出
         * @summary 登出
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutBaseUser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/user/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取角色列表(分页)
         * @param {SystemGenerateObject20} systemGenerateObject20 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRolesBaseUser: async (systemGenerateObject20: SystemGenerateObject20, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject20' is not null or undefined
            assertParamExists('pageRolesBaseUser', 'systemGenerateObject20', systemGenerateObject20)
            const localVarPath = `/__base/user/pageRoles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject20, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取用户列表(分页)
         * @param {SystemGenerateObject22} systemGenerateObject22 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUsersBaseUser: async (systemGenerateObject22: SystemGenerateObject22, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject22' is not null or undefined
            assertParamExists('pageUsersBaseUser', 'systemGenerateObject22', systemGenerateObject22)
            const localVarPath = `/__base/user/pageUsers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject22, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 发送邮箱验证码
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailCodeBaseUser: async (email: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('sendEmailCodeBaseUser', 'email', email)
            const localVarPath = `/__base/user/sendEmailCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (email !== undefined) { 
                localVarFormParams.set('email', email as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 发送手机验证码
         * @param {string} phone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPhoneCodeBaseUser: async (phone: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phone' is not null or undefined
            assertParamExists('sendPhoneCodeBaseUser', 'phone', phone)
            const localVarPath = `/__base/user/sendPhoneCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (phone !== undefined) { 
                localVarFormParams.set('phone', phone as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改角色
         * @param {BaseRoleAdminVo} baseRoleAdminVo 
         * @param {boolean} [force] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        udpateRoleBaseUser: async (baseRoleAdminVo: BaseRoleAdminVo, force?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseRoleAdminVo' is not null or undefined
            assertParamExists('udpateRoleBaseUser', 'baseRoleAdminVo', baseRoleAdminVo)
            const localVarPath = `/__base/user/udpateRole`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (force !== undefined) {
                localVarQueryParameter['force'] = force;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseRoleAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 解绑第三方平台
         * @param {string} platform 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unbindThirdPartyBaseUser: async (platform: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platform' is not null or undefined
            assertParamExists('unbindThirdPartyBaseUser', 'platform', platform)
            const localVarPath = `/__base/user/unbindThirdParty`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (platform !== undefined) { 
                localVarFormParams.set('platform', platform as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改邮箱(需密码+验证码)
         * @param {SystemGenerateObject25} systemGenerateObject25 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailBaseUser: async (systemGenerateObject25: SystemGenerateObject25, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject25' is not null or undefined
            assertParamExists('updateEmailBaseUser', 'systemGenerateObject25', systemGenerateObject25)
            const localVarPath = `/__base/user/updateEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject25, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改个人信息(仅头像/昵称/meta)
         * @param {SystemGenerateObject26} systemGenerateObject26 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyProfileBaseUser: async (systemGenerateObject26: SystemGenerateObject26, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject26' is not null or undefined
            assertParamExists('updateMyProfileBaseUser', 'systemGenerateObject26', systemGenerateObject26)
            const localVarPath = `/__base/user/updateMyProfile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject26, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改手机号(需密码+验证码)
         * @param {SystemGenerateObject24} systemGenerateObject24 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePhoneBaseUser: async (systemGenerateObject24: SystemGenerateObject24, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject24' is not null or undefined
            assertParamExists('updatePhoneBaseUser', 'systemGenerateObject24', systemGenerateObject24)
            const localVarPath = `/__base/user/updatePhone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject24, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改用户
         * @param {BaseUserAdminVo} baseUserAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserBaseUser: async (baseUserAdminVo: BaseUserAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseUserAdminVo' is not null or undefined
            assertParamExists('updateUserBaseUser', 'baseUserAdminVo', baseUserAdminVo)
            const localVarPath = `/__base/user/updateUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseUserAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新用户的组织角色列表
         * @param {SystemGenerateObject18} systemGenerateObject18 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserOrgRolesBaseUser: async (systemGenerateObject18: SystemGenerateObject18, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject18' is not null or undefined
            assertParamExists('updateUserOrgRolesBaseUser', 'systemGenerateObject18', systemGenerateObject18)
            const localVarPath = `/__base/user/updateUserOrgRoles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject18, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改用户密码
         * @param {SystemGenerateObject23} systemGenerateObject23 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPWBaseUser: async (systemGenerateObject23: SystemGenerateObject23, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject23' is not null or undefined
            assertParamExists('updateUserPWBaseUser', 'systemGenerateObject23', systemGenerateObject23)
            const localVarPath = `/__base/user/updateUserPW`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject23, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseUserApi - functional programming interface
 * @export
 */
export const BaseUserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseUserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加角色
         * @param {BaseRoleAdminVo} baseRoleAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addRoleBaseUser(baseRoleAdminVo: BaseRoleAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addRoleBaseUser(baseRoleAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 添加用户
         * @param {BaseUserAdminVo} baseUserAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addUserBaseUser(baseUserAdminVo: BaseUserAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addUserBaseUser(baseUserAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除角色
         * @param {number} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delRoleBaseUser(roleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delRoleBaseUser(roleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除用户
         * @param {number} userId 
         * @param {number} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserBaseUser(userId: number, tenantId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserBaseUser(userId, tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 邮箱查重
         * @param {string} email 
         * @param {number} [excludeUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async existsByEmailBaseUser(email: string, excludeUserId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.existsByEmailBaseUser(email, excludeUserId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 手机号查重
         * @param {string} phone 
         * @param {number} [excludeUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async existsByPhoneBaseUser(phone: string, excludeUserId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.existsByPhoneBaseUser(phone, excludeUserId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 用户名查重
         * @param {string} username 
         * @param {number} [excludeUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async existsByUsernameBaseUser(username: string, excludeUserId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.existsByUsernameBaseUser(username, excludeUserId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 获取用户信息
         * @summary 获取用户信息
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserInfoBaseUser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserInfoBaseUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取组织机构下角色列表
         * @param {string} orgCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOrgRolesBaseUser(orgCode: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOrgRolesBaseUser(orgCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取角色列表
         * @param {SystemGenerateObject19} systemGenerateObject19 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRolesBaseUser(systemGenerateObject19: SystemGenerateObject19, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRolesBaseUser(systemGenerateObject19, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取系统角色列表
         * @param {SystemGenerateObject17} systemGenerateObject17 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSystemRolesBaseUser(systemGenerateObject17: SystemGenerateObject17, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSystemRolesBaseUser(systemGenerateObject17, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取第三方绑定列表
         * @param {SystemGenerateObject16} systemGenerateObject16 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listThirdPartyBaseUser(systemGenerateObject16: SystemGenerateObject16, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listThirdPartyBaseUser(systemGenerateObject16, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 查询用户的组织角色列表
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUserOrgRolesBaseUser(userId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUserOrgRolesBaseUser(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取用户列表
         * @param {SystemGenerateObject21} systemGenerateObject21 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUsersBaseUser(systemGenerateObject21: SystemGenerateObject21, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUsersBaseUser(systemGenerateObject21, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 支持用户名、邮箱、手机号三合一登录
         * @summary 登录(用户名/邮箱/手机号)
         * @param {string} account 
         * @param {string} password 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginBaseUser(account: string, password: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginBaseUser(account, password, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 邮箱验证码登录
         * @param {string} email 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginByEmailCodeBaseUser(email: string, code: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginByEmailCodeBaseUser(email, code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 手机号验证码登录
         * @param {string} phone 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginByPhoneCodeBaseUser(phone: string, code: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginByPhoneCodeBaseUser(phone, code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 第三方平台登录
         * @param {string} platform 
         * @param {string} openId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginByThirdPartyBaseUser(platform: string, openId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginByThirdPartyBaseUser(platform, openId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 登出
         * @summary 登出
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logoutBaseUser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logoutBaseUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取角色列表(分页)
         * @param {SystemGenerateObject20} systemGenerateObject20 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageRolesBaseUser(systemGenerateObject20: SystemGenerateObject20, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageRolesBaseUser(systemGenerateObject20, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取用户列表(分页)
         * @param {SystemGenerateObject22} systemGenerateObject22 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageUsersBaseUser(systemGenerateObject22: SystemGenerateObject22, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageUsersBaseUser(systemGenerateObject22, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 发送邮箱验证码
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendEmailCodeBaseUser(email: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendEmailCodeBaseUser(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 发送手机验证码
         * @param {string} phone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendPhoneCodeBaseUser(phone: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendPhoneCodeBaseUser(phone, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改角色
         * @param {BaseRoleAdminVo} baseRoleAdminVo 
         * @param {boolean} [force] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async udpateRoleBaseUser(baseRoleAdminVo: BaseRoleAdminVo, force?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.udpateRoleBaseUser(baseRoleAdminVo, force, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 解绑第三方平台
         * @param {string} platform 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unbindThirdPartyBaseUser(platform: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unbindThirdPartyBaseUser(platform, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改邮箱(需密码+验证码)
         * @param {SystemGenerateObject25} systemGenerateObject25 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmailBaseUser(systemGenerateObject25: SystemGenerateObject25, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmailBaseUser(systemGenerateObject25, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改个人信息(仅头像/昵称/meta)
         * @param {SystemGenerateObject26} systemGenerateObject26 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMyProfileBaseUser(systemGenerateObject26: SystemGenerateObject26, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMyProfileBaseUser(systemGenerateObject26, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改手机号(需密码+验证码)
         * @param {SystemGenerateObject24} systemGenerateObject24 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePhoneBaseUser(systemGenerateObject24: SystemGenerateObject24, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePhoneBaseUser(systemGenerateObject24, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改用户
         * @param {BaseUserAdminVo} baseUserAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserBaseUser(baseUserAdminVo: BaseUserAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserBaseUser(baseUserAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新用户的组织角色列表
         * @param {SystemGenerateObject18} systemGenerateObject18 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserOrgRolesBaseUser(systemGenerateObject18: SystemGenerateObject18, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserOrgRolesBaseUser(systemGenerateObject18, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改用户密码
         * @param {SystemGenerateObject23} systemGenerateObject23 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserPWBaseUser(systemGenerateObject23: SystemGenerateObject23, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserPWBaseUser(systemGenerateObject23, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseUserApi - factory interface
 * @export
 */
export const BaseUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseUserApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加角色
         * @param {BaseRoleAdminVo} baseRoleAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRoleBaseUser(baseRoleAdminVo: BaseRoleAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.addRoleBaseUser(baseRoleAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 添加用户
         * @param {BaseUserAdminVo} baseUserAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserBaseUser(baseUserAdminVo: BaseUserAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.addUserBaseUser(baseUserAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除角色
         * @param {number} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delRoleBaseUser(roleId: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.delRoleBaseUser(roleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除用户
         * @param {number} userId 
         * @param {number} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserBaseUser(userId: number, tenantId?: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.deleteUserBaseUser(userId, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 邮箱查重
         * @param {string} email 
         * @param {number} [excludeUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsByEmailBaseUser(email: string, excludeUserId?: number, options?: any): AxiosPromise<any> {
            return localVarFp.existsByEmailBaseUser(email, excludeUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 手机号查重
         * @param {string} phone 
         * @param {number} [excludeUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsByPhoneBaseUser(phone: string, excludeUserId?: number, options?: any): AxiosPromise<any> {
            return localVarFp.existsByPhoneBaseUser(phone, excludeUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 用户名查重
         * @param {string} username 
         * @param {number} [excludeUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsByUsernameBaseUser(username: string, excludeUserId?: number, options?: any): AxiosPromise<any> {
            return localVarFp.existsByUsernameBaseUser(username, excludeUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 获取用户信息
         * @summary 获取用户信息
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfoBaseUser(options?: any): AxiosPromise<any> {
            return localVarFp.getUserInfoBaseUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取组织机构下角色列表
         * @param {string} orgCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrgRolesBaseUser(orgCode: string, options?: any): AxiosPromise<any> {
            return localVarFp.listOrgRolesBaseUser(orgCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取角色列表
         * @param {SystemGenerateObject19} systemGenerateObject19 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRolesBaseUser(systemGenerateObject19: SystemGenerateObject19, options?: any): AxiosPromise<any> {
            return localVarFp.listRolesBaseUser(systemGenerateObject19, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取系统角色列表
         * @param {SystemGenerateObject17} systemGenerateObject17 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSystemRolesBaseUser(systemGenerateObject17: SystemGenerateObject17, options?: any): AxiosPromise<any> {
            return localVarFp.listSystemRolesBaseUser(systemGenerateObject17, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取第三方绑定列表
         * @param {SystemGenerateObject16} systemGenerateObject16 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listThirdPartyBaseUser(systemGenerateObject16: SystemGenerateObject16, options?: any): AxiosPromise<any> {
            return localVarFp.listThirdPartyBaseUser(systemGenerateObject16, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查询用户的组织角色列表
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserOrgRolesBaseUser(userId: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.listUserOrgRolesBaseUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取用户列表
         * @param {SystemGenerateObject21} systemGenerateObject21 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsersBaseUser(systemGenerateObject21: SystemGenerateObject21, options?: any): AxiosPromise<any> {
            return localVarFp.listUsersBaseUser(systemGenerateObject21, options).then((request) => request(axios, basePath));
        },
        /**
         * 支持用户名、邮箱、手机号三合一登录
         * @summary 登录(用户名/邮箱/手机号)
         * @param {string} account 
         * @param {string} password 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginBaseUser(account: string, password: string, options?: any): AxiosPromise<any> {
            return localVarFp.loginBaseUser(account, password, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 邮箱验证码登录
         * @param {string} email 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginByEmailCodeBaseUser(email: string, code: string, options?: any): AxiosPromise<any> {
            return localVarFp.loginByEmailCodeBaseUser(email, code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 手机号验证码登录
         * @param {string} phone 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginByPhoneCodeBaseUser(phone: string, code: string, options?: any): AxiosPromise<any> {
            return localVarFp.loginByPhoneCodeBaseUser(phone, code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 第三方平台登录
         * @param {string} platform 
         * @param {string} openId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginByThirdPartyBaseUser(platform: string, openId: string, options?: any): AxiosPromise<any> {
            return localVarFp.loginByThirdPartyBaseUser(platform, openId, options).then((request) => request(axios, basePath));
        },
        /**
         * 登出
         * @summary 登出
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutBaseUser(options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.logoutBaseUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取角色列表(分页)
         * @param {SystemGenerateObject20} systemGenerateObject20 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRolesBaseUser(systemGenerateObject20: SystemGenerateObject20, options?: any): AxiosPromise<any> {
            return localVarFp.pageRolesBaseUser(systemGenerateObject20, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取用户列表(分页)
         * @param {SystemGenerateObject22} systemGenerateObject22 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUsersBaseUser(systemGenerateObject22: SystemGenerateObject22, options?: any): AxiosPromise<any> {
            return localVarFp.pageUsersBaseUser(systemGenerateObject22, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 发送邮箱验证码
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailCodeBaseUser(email: string, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.sendEmailCodeBaseUser(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 发送手机验证码
         * @param {string} phone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPhoneCodeBaseUser(phone: string, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.sendPhoneCodeBaseUser(phone, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改角色
         * @param {BaseRoleAdminVo} baseRoleAdminVo 
         * @param {boolean} [force] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        udpateRoleBaseUser(baseRoleAdminVo: BaseRoleAdminVo, force?: boolean, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.udpateRoleBaseUser(baseRoleAdminVo, force, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 解绑第三方平台
         * @param {string} platform 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unbindThirdPartyBaseUser(platform: string, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.unbindThirdPartyBaseUser(platform, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改邮箱(需密码+验证码)
         * @param {SystemGenerateObject25} systemGenerateObject25 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailBaseUser(systemGenerateObject25: SystemGenerateObject25, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateEmailBaseUser(systemGenerateObject25, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改个人信息(仅头像/昵称/meta)
         * @param {SystemGenerateObject26} systemGenerateObject26 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyProfileBaseUser(systemGenerateObject26: SystemGenerateObject26, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateMyProfileBaseUser(systemGenerateObject26, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改手机号(需密码+验证码)
         * @param {SystemGenerateObject24} systemGenerateObject24 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePhoneBaseUser(systemGenerateObject24: SystemGenerateObject24, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updatePhoneBaseUser(systemGenerateObject24, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改用户
         * @param {BaseUserAdminVo} baseUserAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserBaseUser(baseUserAdminVo: BaseUserAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateUserBaseUser(baseUserAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新用户的组织角色列表
         * @param {SystemGenerateObject18} systemGenerateObject18 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserOrgRolesBaseUser(systemGenerateObject18: SystemGenerateObject18, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateUserOrgRolesBaseUser(systemGenerateObject18, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改用户密码
         * @param {SystemGenerateObject23} systemGenerateObject23 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPWBaseUser(systemGenerateObject23: SystemGenerateObject23, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateUserPWBaseUser(systemGenerateObject23, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseUserApi - object-oriented interface
 * @export
 * @class BaseUserApi
 * @extends {BaseAPI}
 */
export class BaseUserApi extends BaseAPI {
    /**
     * 
     * @summary 添加角色
     * @param {BaseRoleAdminVo} baseRoleAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public addRoleBaseUser(baseRoleAdminVo: BaseRoleAdminVo, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).addRoleBaseUser(baseRoleAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 添加用户
     * @param {BaseUserAdminVo} baseUserAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public addUserBaseUser(baseUserAdminVo: BaseUserAdminVo, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).addUserBaseUser(baseUserAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除角色
     * @param {number} roleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public delRoleBaseUser(roleId: number, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).delRoleBaseUser(roleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除用户
     * @param {number} userId 
     * @param {number} [tenantId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public deleteUserBaseUser(userId: number, tenantId?: number, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).deleteUserBaseUser(userId, tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 邮箱查重
     * @param {string} email 
     * @param {number} [excludeUserId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public existsByEmailBaseUser(email: string, excludeUserId?: number, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).existsByEmailBaseUser(email, excludeUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 手机号查重
     * @param {string} phone 
     * @param {number} [excludeUserId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public existsByPhoneBaseUser(phone: string, excludeUserId?: number, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).existsByPhoneBaseUser(phone, excludeUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 用户名查重
     * @param {string} username 
     * @param {number} [excludeUserId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public existsByUsernameBaseUser(username: string, excludeUserId?: number, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).existsByUsernameBaseUser(username, excludeUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 获取用户信息
     * @summary 获取用户信息
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public getUserInfoBaseUser(options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).getUserInfoBaseUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取组织机构下角色列表
     * @param {string} orgCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public listOrgRolesBaseUser(orgCode: string, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).listOrgRolesBaseUser(orgCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取角色列表
     * @param {SystemGenerateObject19} systemGenerateObject19 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public listRolesBaseUser(systemGenerateObject19: SystemGenerateObject19, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).listRolesBaseUser(systemGenerateObject19, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取系统角色列表
     * @param {SystemGenerateObject17} systemGenerateObject17 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public listSystemRolesBaseUser(systemGenerateObject17: SystemGenerateObject17, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).listSystemRolesBaseUser(systemGenerateObject17, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取第三方绑定列表
     * @param {SystemGenerateObject16} systemGenerateObject16 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public listThirdPartyBaseUser(systemGenerateObject16: SystemGenerateObject16, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).listThirdPartyBaseUser(systemGenerateObject16, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查询用户的组织角色列表
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public listUserOrgRolesBaseUser(userId: number, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).listUserOrgRolesBaseUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取用户列表
     * @param {SystemGenerateObject21} systemGenerateObject21 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public listUsersBaseUser(systemGenerateObject21: SystemGenerateObject21, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).listUsersBaseUser(systemGenerateObject21, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 支持用户名、邮箱、手机号三合一登录
     * @summary 登录(用户名/邮箱/手机号)
     * @param {string} account 
     * @param {string} password 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public loginBaseUser(account: string, password: string, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).loginBaseUser(account, password, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 邮箱验证码登录
     * @param {string} email 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public loginByEmailCodeBaseUser(email: string, code: string, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).loginByEmailCodeBaseUser(email, code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 手机号验证码登录
     * @param {string} phone 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public loginByPhoneCodeBaseUser(phone: string, code: string, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).loginByPhoneCodeBaseUser(phone, code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 第三方平台登录
     * @param {string} platform 
     * @param {string} openId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public loginByThirdPartyBaseUser(platform: string, openId: string, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).loginByThirdPartyBaseUser(platform, openId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 登出
     * @summary 登出
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public logoutBaseUser(options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).logoutBaseUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取角色列表(分页)
     * @param {SystemGenerateObject20} systemGenerateObject20 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public pageRolesBaseUser(systemGenerateObject20: SystemGenerateObject20, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).pageRolesBaseUser(systemGenerateObject20, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取用户列表(分页)
     * @param {SystemGenerateObject22} systemGenerateObject22 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public pageUsersBaseUser(systemGenerateObject22: SystemGenerateObject22, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).pageUsersBaseUser(systemGenerateObject22, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 发送邮箱验证码
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public sendEmailCodeBaseUser(email: string, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).sendEmailCodeBaseUser(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 发送手机验证码
     * @param {string} phone 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public sendPhoneCodeBaseUser(phone: string, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).sendPhoneCodeBaseUser(phone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改角色
     * @param {BaseRoleAdminVo} baseRoleAdminVo 
     * @param {boolean} [force] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public udpateRoleBaseUser(baseRoleAdminVo: BaseRoleAdminVo, force?: boolean, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).udpateRoleBaseUser(baseRoleAdminVo, force, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 解绑第三方平台
     * @param {string} platform 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public unbindThirdPartyBaseUser(platform: string, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).unbindThirdPartyBaseUser(platform, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改邮箱(需密码+验证码)
     * @param {SystemGenerateObject25} systemGenerateObject25 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public updateEmailBaseUser(systemGenerateObject25: SystemGenerateObject25, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).updateEmailBaseUser(systemGenerateObject25, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改个人信息(仅头像/昵称/meta)
     * @param {SystemGenerateObject26} systemGenerateObject26 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public updateMyProfileBaseUser(systemGenerateObject26: SystemGenerateObject26, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).updateMyProfileBaseUser(systemGenerateObject26, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改手机号(需密码+验证码)
     * @param {SystemGenerateObject24} systemGenerateObject24 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public updatePhoneBaseUser(systemGenerateObject24: SystemGenerateObject24, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).updatePhoneBaseUser(systemGenerateObject24, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改用户
     * @param {BaseUserAdminVo} baseUserAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public updateUserBaseUser(baseUserAdminVo: BaseUserAdminVo, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).updateUserBaseUser(baseUserAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新用户的组织角色列表
     * @param {SystemGenerateObject18} systemGenerateObject18 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public updateUserOrgRolesBaseUser(systemGenerateObject18: SystemGenerateObject18, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).updateUserOrgRolesBaseUser(systemGenerateObject18, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改用户密码
     * @param {SystemGenerateObject23} systemGenerateObject23 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public updateUserPWBaseUser(systemGenerateObject23: SystemGenerateObject23, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).updateUserPWBaseUser(systemGenerateObject23, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseUtilApi - axios parameter creator
 * @export
 */
export const BaseUtilApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 获取id
         * @summary 获取id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdBaseUtil: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/util/getId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 获取id
         * @summary 获取ids
         * @param {number} count 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdsBaseUtil: async (count: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'count' is not null or undefined
            assertParamExists('getIdsBaseUtil', 'count', count)
            const localVarPath = `/__base/util/getIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 获取uuid
         * @summary 获取uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUUIDBaseUtil: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/util/getUUID`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseUtilApi - functional programming interface
 * @export
 */
export const BaseUtilApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseUtilApiAxiosParamCreator(configuration)
    return {
        /**
         * 获取id
         * @summary 获取id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIdBaseUtil(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIdBaseUtil(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 获取id
         * @summary 获取ids
         * @param {number} count 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIdsBaseUtil(count: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIdsBaseUtil(count, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 获取uuid
         * @summary 获取uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUUIDBaseUtil(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUUIDBaseUtil(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseUtilApi - factory interface
 * @export
 */
export const BaseUtilApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseUtilApiFp(configuration)
    return {
        /**
         * 获取id
         * @summary 获取id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdBaseUtil(options?: any): AxiosPromise<number> {
            return localVarFp.getIdBaseUtil(options).then((request) => request(axios, basePath));
        },
        /**
         * 获取id
         * @summary 获取ids
         * @param {number} count 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdsBaseUtil(count: number, options?: any): AxiosPromise<Array<number>> {
            return localVarFp.getIdsBaseUtil(count, options).then((request) => request(axios, basePath));
        },
        /**
         * 获取uuid
         * @summary 获取uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUUIDBaseUtil(options?: any): AxiosPromise<string> {
            return localVarFp.getUUIDBaseUtil(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseUtilApi - object-oriented interface
 * @export
 * @class BaseUtilApi
 * @extends {BaseAPI}
 */
export class BaseUtilApi extends BaseAPI {
    /**
     * 获取id
     * @summary 获取id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUtilApi
     */
    public getIdBaseUtil(options?: AxiosRequestConfig) {
        return BaseUtilApiFp(this.configuration).getIdBaseUtil(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 获取id
     * @summary 获取ids
     * @param {number} count 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUtilApi
     */
    public getIdsBaseUtil(count: number, options?: AxiosRequestConfig) {
        return BaseUtilApiFp(this.configuration).getIdsBaseUtil(count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 获取uuid
     * @summary 获取uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUtilApi
     */
    public getUUIDBaseUtil(options?: AxiosRequestConfig) {
        return BaseUtilApiFp(this.configuration).getUUIDBaseUtil(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BlackAccountApi - axios parameter creator
 * @export
 */
export const BlackAccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加黑名单
         * @param {SystemGenerateObject160} systemGenerateObject160 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBlackAccountblackAccount: async (systemGenerateObject160: SystemGenerateObject160, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject160' is not null or undefined
            assertParamExists('addBlackAccountblackAccount', 'systemGenerateObject160', systemGenerateObject160)
            const localVarPath = `/blackAccount/addBlackAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject160, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 添加自身管理的门店黑名单
         * @param {SystemGenerateObject163} systemGenerateObject163 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOwnerStoreBlackAccountblackAccount: async (systemGenerateObject163: SystemGenerateObject163, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject163' is not null or undefined
            assertParamExists('addOwnerStoreBlackAccountblackAccount', 'systemGenerateObject163', systemGenerateObject163)
            const localVarPath = `/blackAccount/addOwnerStoreBlackAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject163, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除黑名单
         * @param {number} blackAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delBlackAccountblackAccount: async (blackAccountId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blackAccountId' is not null or undefined
            assertParamExists('delBlackAccountblackAccount', 'blackAccountId', blackAccountId)
            const localVarPath = `/blackAccount/delBlackAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (blackAccountId !== undefined) {
                localVarQueryParameter['blackAccountId'] = blackAccountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除自身管理的门店黑名单
         * @param {number} storeId 
         * @param {number} blackAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delOwnerStoreBlackAccountblackAccount: async (storeId: number, blackAccountId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('delOwnerStoreBlackAccountblackAccount', 'storeId', storeId)
            // verify required parameter 'blackAccountId' is not null or undefined
            assertParamExists('delOwnerStoreBlackAccountblackAccount', 'blackAccountId', blackAccountId)
            const localVarPath = `/blackAccount/delOwnerStoreBlackAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (blackAccountId !== undefined) {
                localVarQueryParameter['blackAccountId'] = blackAccountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取黑名单列表
         * @param {SystemGenerateObject158} systemGenerateObject158 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBlackAccountblackAccount: async (systemGenerateObject158: SystemGenerateObject158, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject158' is not null or undefined
            assertParamExists('listBlackAccountblackAccount', 'systemGenerateObject158', systemGenerateObject158)
            const localVarPath = `/blackAccount/listBlackAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject158, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取自身管理的门店黑名单列表
         * @param {SystemGenerateObject162} systemGenerateObject162 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOwnerStoreBlackAccountblackAccount: async (systemGenerateObject162: SystemGenerateObject162, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject162' is not null or undefined
            assertParamExists('listOwnerStoreBlackAccountblackAccount', 'systemGenerateObject162', systemGenerateObject162)
            const localVarPath = `/blackAccount/listOwnerStoreBlackAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject162, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取黑名单列表(分页)
         * @param {SystemGenerateObject159} systemGenerateObject159 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBlackAccountblackAccount: async (systemGenerateObject159: SystemGenerateObject159, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject159' is not null or undefined
            assertParamExists('pageBlackAccountblackAccount', 'systemGenerateObject159', systemGenerateObject159)
            const localVarPath = `/blackAccount/pageBlackAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject159, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新黑名单
         * @param {SystemGenerateObject161} systemGenerateObject161 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBlackAccountblackAccount: async (systemGenerateObject161: SystemGenerateObject161, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject161' is not null or undefined
            assertParamExists('updateBlackAccountblackAccount', 'systemGenerateObject161', systemGenerateObject161)
            const localVarPath = `/blackAccount/updateBlackAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject161, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新自身管理的门店黑名单
         * @param {SystemGenerateObject164} systemGenerateObject164 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOwnerStoreBlackAccountblackAccount: async (systemGenerateObject164: SystemGenerateObject164, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject164' is not null or undefined
            assertParamExists('updateOwnerStoreBlackAccountblackAccount', 'systemGenerateObject164', systemGenerateObject164)
            const localVarPath = `/blackAccount/updateOwnerStoreBlackAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject164, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BlackAccountApi - functional programming interface
 * @export
 */
export const BlackAccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BlackAccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加黑名单
         * @param {SystemGenerateObject160} systemGenerateObject160 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addBlackAccountblackAccount(systemGenerateObject160: SystemGenerateObject160, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addBlackAccountblackAccount(systemGenerateObject160, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 添加自身管理的门店黑名单
         * @param {SystemGenerateObject163} systemGenerateObject163 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOwnerStoreBlackAccountblackAccount(systemGenerateObject163: SystemGenerateObject163, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOwnerStoreBlackAccountblackAccount(systemGenerateObject163, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除黑名单
         * @param {number} blackAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delBlackAccountblackAccount(blackAccountId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delBlackAccountblackAccount(blackAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除自身管理的门店黑名单
         * @param {number} storeId 
         * @param {number} blackAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delOwnerStoreBlackAccountblackAccount(storeId: number, blackAccountId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delOwnerStoreBlackAccountblackAccount(storeId, blackAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取黑名单列表
         * @param {SystemGenerateObject158} systemGenerateObject158 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBlackAccountblackAccount(systemGenerateObject158: SystemGenerateObject158, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBlackAccountblackAccount(systemGenerateObject158, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取自身管理的门店黑名单列表
         * @param {SystemGenerateObject162} systemGenerateObject162 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOwnerStoreBlackAccountblackAccount(systemGenerateObject162: SystemGenerateObject162, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOwnerStoreBlackAccountblackAccount(systemGenerateObject162, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取黑名单列表(分页)
         * @param {SystemGenerateObject159} systemGenerateObject159 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageBlackAccountblackAccount(systemGenerateObject159: SystemGenerateObject159, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageBlackAccountblackAccount(systemGenerateObject159, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新黑名单
         * @param {SystemGenerateObject161} systemGenerateObject161 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBlackAccountblackAccount(systemGenerateObject161: SystemGenerateObject161, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBlackAccountblackAccount(systemGenerateObject161, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新自身管理的门店黑名单
         * @param {SystemGenerateObject164} systemGenerateObject164 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOwnerStoreBlackAccountblackAccount(systemGenerateObject164: SystemGenerateObject164, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOwnerStoreBlackAccountblackAccount(systemGenerateObject164, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BlackAccountApi - factory interface
 * @export
 */
export const BlackAccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BlackAccountApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加黑名单
         * @param {SystemGenerateObject160} systemGenerateObject160 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBlackAccountblackAccount(systemGenerateObject160: SystemGenerateObject160, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addBlackAccountblackAccount(systemGenerateObject160, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 添加自身管理的门店黑名单
         * @param {SystemGenerateObject163} systemGenerateObject163 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOwnerStoreBlackAccountblackAccount(systemGenerateObject163: SystemGenerateObject163, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addOwnerStoreBlackAccountblackAccount(systemGenerateObject163, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除黑名单
         * @param {number} blackAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delBlackAccountblackAccount(blackAccountId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delBlackAccountblackAccount(blackAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除自身管理的门店黑名单
         * @param {number} storeId 
         * @param {number} blackAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delOwnerStoreBlackAccountblackAccount(storeId: number, blackAccountId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delOwnerStoreBlackAccountblackAccount(storeId, blackAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取黑名单列表
         * @param {SystemGenerateObject158} systemGenerateObject158 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBlackAccountblackAccount(systemGenerateObject158: SystemGenerateObject158, options?: any): AxiosPromise<any> {
            return localVarFp.listBlackAccountblackAccount(systemGenerateObject158, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取自身管理的门店黑名单列表
         * @param {SystemGenerateObject162} systemGenerateObject162 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOwnerStoreBlackAccountblackAccount(systemGenerateObject162: SystemGenerateObject162, options?: any): AxiosPromise<any> {
            return localVarFp.listOwnerStoreBlackAccountblackAccount(systemGenerateObject162, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取黑名单列表(分页)
         * @param {SystemGenerateObject159} systemGenerateObject159 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBlackAccountblackAccount(systemGenerateObject159: SystemGenerateObject159, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageBlackAccountblackAccount(systemGenerateObject159, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新黑名单
         * @param {SystemGenerateObject161} systemGenerateObject161 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBlackAccountblackAccount(systemGenerateObject161: SystemGenerateObject161, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateBlackAccountblackAccount(systemGenerateObject161, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新自身管理的门店黑名单
         * @param {SystemGenerateObject164} systemGenerateObject164 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOwnerStoreBlackAccountblackAccount(systemGenerateObject164: SystemGenerateObject164, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateOwnerStoreBlackAccountblackAccount(systemGenerateObject164, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BlackAccountApi - object-oriented interface
 * @export
 * @class BlackAccountApi
 * @extends {BaseAPI}
 */
export class BlackAccountApi extends BaseAPI {
    /**
     * 
     * @summary 添加黑名单
     * @param {SystemGenerateObject160} systemGenerateObject160 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlackAccountApi
     */
    public addBlackAccountblackAccount(systemGenerateObject160: SystemGenerateObject160, options?: AxiosRequestConfig) {
        return BlackAccountApiFp(this.configuration).addBlackAccountblackAccount(systemGenerateObject160, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 添加自身管理的门店黑名单
     * @param {SystemGenerateObject163} systemGenerateObject163 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlackAccountApi
     */
    public addOwnerStoreBlackAccountblackAccount(systemGenerateObject163: SystemGenerateObject163, options?: AxiosRequestConfig) {
        return BlackAccountApiFp(this.configuration).addOwnerStoreBlackAccountblackAccount(systemGenerateObject163, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除黑名单
     * @param {number} blackAccountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlackAccountApi
     */
    public delBlackAccountblackAccount(blackAccountId: number, options?: AxiosRequestConfig) {
        return BlackAccountApiFp(this.configuration).delBlackAccountblackAccount(blackAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除自身管理的门店黑名单
     * @param {number} storeId 
     * @param {number} blackAccountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlackAccountApi
     */
    public delOwnerStoreBlackAccountblackAccount(storeId: number, blackAccountId: number, options?: AxiosRequestConfig) {
        return BlackAccountApiFp(this.configuration).delOwnerStoreBlackAccountblackAccount(storeId, blackAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取黑名单列表
     * @param {SystemGenerateObject158} systemGenerateObject158 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlackAccountApi
     */
    public listBlackAccountblackAccount(systemGenerateObject158: SystemGenerateObject158, options?: AxiosRequestConfig) {
        return BlackAccountApiFp(this.configuration).listBlackAccountblackAccount(systemGenerateObject158, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取自身管理的门店黑名单列表
     * @param {SystemGenerateObject162} systemGenerateObject162 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlackAccountApi
     */
    public listOwnerStoreBlackAccountblackAccount(systemGenerateObject162: SystemGenerateObject162, options?: AxiosRequestConfig) {
        return BlackAccountApiFp(this.configuration).listOwnerStoreBlackAccountblackAccount(systemGenerateObject162, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取黑名单列表(分页)
     * @param {SystemGenerateObject159} systemGenerateObject159 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlackAccountApi
     */
    public pageBlackAccountblackAccount(systemGenerateObject159: SystemGenerateObject159, options?: AxiosRequestConfig) {
        return BlackAccountApiFp(this.configuration).pageBlackAccountblackAccount(systemGenerateObject159, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新黑名单
     * @param {SystemGenerateObject161} systemGenerateObject161 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlackAccountApi
     */
    public updateBlackAccountblackAccount(systemGenerateObject161: SystemGenerateObject161, options?: AxiosRequestConfig) {
        return BlackAccountApiFp(this.configuration).updateBlackAccountblackAccount(systemGenerateObject161, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新自身管理的门店黑名单
     * @param {SystemGenerateObject164} systemGenerateObject164 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlackAccountApi
     */
    public updateOwnerStoreBlackAccountblackAccount(systemGenerateObject164: SystemGenerateObject164, options?: AxiosRequestConfig) {
        return BlackAccountApiFp(this.configuration).updateOwnerStoreBlackAccountblackAccount(systemGenerateObject164, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DeviceApi - axios parameter creator
 * @export
 */
export const DeviceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加设备
         * @param {SystemGenerateObject100} systemGenerateObject100 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDeviceDevice: async (systemGenerateObject100: SystemGenerateObject100, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject100' is not null or undefined
            assertParamExists('addDeviceDevice', 'systemGenerateObject100', systemGenerateObject100)
            const localVarPath = `/device/addDevice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject100, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除设备
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeviceDevice: async (deviceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('deleteDeviceDevice', 'deviceId', deviceId)
            const localVarPath = `/device/deleteDevice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 管理员开门
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceAdminOpendoorDevice: async (deviceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('deviceAdminOpendoorDevice', 'deviceId', deviceId)
            const localVarPath = `/device/deviceAdminOpendoor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 管理员开门(Hex)
         * @param {string} deviceIdHex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceAdminOpendoorHexDevice: async (deviceIdHex: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceIdHex' is not null or undefined
            assertParamExists('deviceAdminOpendoorHexDevice', 'deviceIdHex', deviceIdHex)
            const localVarPath = `/device/deviceAdminOpendoorHex`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (deviceIdHex !== undefined) {
                localVarQueryParameter['deviceIdHex'] = deviceIdHex;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取设备模式
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceGetModDevice: async (deviceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('deviceGetModDevice', 'deviceId', deviceId)
            const localVarPath = `/device/deviceGetMod`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 请求获取设备的模式(Hwx)
         * @param {string} deviceIdHex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceGetModHexDevice: async (deviceIdHex: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceIdHex' is not null or undefined
            assertParamExists('deviceGetModHexDevice', 'deviceIdHex', deviceIdHex)
            const localVarPath = `/device/deviceGetModHex`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (deviceIdHex !== undefined) {
                localVarQueryParameter['deviceIdHex'] = deviceIdHex;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 设备恢复
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceRecoveryDevice: async (deviceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('deviceRecoveryDevice', 'deviceId', deviceId)
            const localVarPath = `/device/deviceRecovery`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 设置设备的模式
         * @param {number} deviceId 
         * @param {DEVICEMODE} mod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceSetModDevice: async (deviceId: number, mod: DEVICEMODE, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('deviceSetModDevice', 'deviceId', deviceId)
            // verify required parameter 'mod' is not null or undefined
            assertParamExists('deviceSetModDevice', 'mod', mod)
            const localVarPath = `/device/deviceSetMod`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }

            if (mod !== undefined) {
                localVarQueryParameter['mod'] = mod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取设备状态
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceStatusDevice: async (deviceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('deviceStatusDevice', 'deviceId', deviceId)
            const localVarPath = `/device/deviceStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取设备状态(Hex)
         * @param {string} deviceIdHex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceStatusHexDevice: async (deviceIdHex: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceIdHex' is not null or undefined
            assertParamExists('deviceStatusHexDevice', 'deviceIdHex', deviceIdHex)
            const localVarPath = `/device/deviceStatusHex`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (deviceIdHex !== undefined) {
                localVarQueryParameter['deviceIdHex'] = deviceIdHex;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 设备升级
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceUpgradeDevice: async (deviceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('deviceUpgradeDevice', 'deviceId', deviceId)
            const localVarPath = `/device/deviceUpgrade`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取设备版本
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceVersionDevice: async (deviceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('deviceVersionDevice', 'deviceId', deviceId)
            const localVarPath = `/device/deviceVersion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取设备列表
         * @param {SystemGenerateObject98} systemGenerateObject98 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDeviceDevice: async (systemGenerateObject98: SystemGenerateObject98, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject98' is not null or undefined
            assertParamExists('listDeviceDevice', 'systemGenerateObject98', systemGenerateObject98)
            const localVarPath = `/device/listDevice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject98, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取设备类型列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDeviceTypeDevice: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/device/listDeviceType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 直接打开设备
         * @param {string} deviceIdHex 
         * @param {number} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        opendoorByDirectGetDevice: async (deviceIdHex: string, tenantId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceIdHex' is not null or undefined
            assertParamExists('opendoorByDirectGetDevice', 'deviceIdHex', deviceIdHex)
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('opendoorByDirectGetDevice', 'tenantId', tenantId)
            const localVarPath = `/device/openDeviceByDirect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (deviceIdHex !== undefined) {
                localVarQueryParameter['deviceIdHex'] = deviceIdHex;
            }

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取设备列表(分页)
         * @param {SystemGenerateObject99} systemGenerateObject99 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageDeviceDevice: async (systemGenerateObject99: SystemGenerateObject99, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject99' is not null or undefined
            assertParamExists('pageDeviceDevice', 'systemGenerateObject99', systemGenerateObject99)
            const localVarPath = `/device/pageDevice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject99, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新设备
         * @param {SystemGenerateObject101} systemGenerateObject101 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceDevice: async (systemGenerateObject101: SystemGenerateObject101, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject101' is not null or undefined
            assertParamExists('updateDeviceDevice', 'systemGenerateObject101', systemGenerateObject101)
            const localVarPath = `/device/updateDevice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject101, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeviceApi - functional programming interface
 * @export
 */
export const DeviceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeviceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加设备
         * @param {SystemGenerateObject100} systemGenerateObject100 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDeviceDevice(systemGenerateObject100: SystemGenerateObject100, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDeviceDevice(systemGenerateObject100, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除设备
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDeviceDevice(deviceId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDeviceDevice(deviceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 管理员开门
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deviceAdminOpendoorDevice(deviceId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deviceAdminOpendoorDevice(deviceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 管理员开门(Hex)
         * @param {string} deviceIdHex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deviceAdminOpendoorHexDevice(deviceIdHex: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deviceAdminOpendoorHexDevice(deviceIdHex, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取设备模式
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deviceGetModDevice(deviceId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deviceGetModDevice(deviceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 请求获取设备的模式(Hwx)
         * @param {string} deviceIdHex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deviceGetModHexDevice(deviceIdHex: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deviceGetModHexDevice(deviceIdHex, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 设备恢复
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deviceRecoveryDevice(deviceId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deviceRecoveryDevice(deviceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 设置设备的模式
         * @param {number} deviceId 
         * @param {DEVICEMODE} mod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deviceSetModDevice(deviceId: number, mod: DEVICEMODE, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deviceSetModDevice(deviceId, mod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取设备状态
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deviceStatusDevice(deviceId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deviceStatusDevice(deviceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取设备状态(Hex)
         * @param {string} deviceIdHex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deviceStatusHexDevice(deviceIdHex: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deviceStatusHexDevice(deviceIdHex, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 设备升级
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deviceUpgradeDevice(deviceId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deviceUpgradeDevice(deviceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取设备版本
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deviceVersionDevice(deviceId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deviceVersionDevice(deviceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取设备列表
         * @param {SystemGenerateObject98} systemGenerateObject98 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDeviceDevice(systemGenerateObject98: SystemGenerateObject98, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDeviceDevice(systemGenerateObject98, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取设备类型列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDeviceTypeDevice(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDeviceTypeDevice(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 直接打开设备
         * @param {string} deviceIdHex 
         * @param {number} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async opendoorByDirectGetDevice(deviceIdHex: string, tenantId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.opendoorByDirectGetDevice(deviceIdHex, tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取设备列表(分页)
         * @param {SystemGenerateObject99} systemGenerateObject99 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageDeviceDevice(systemGenerateObject99: SystemGenerateObject99, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageDeviceDevice(systemGenerateObject99, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新设备
         * @param {SystemGenerateObject101} systemGenerateObject101 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDeviceDevice(systemGenerateObject101: SystemGenerateObject101, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDeviceDevice(systemGenerateObject101, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DeviceApi - factory interface
 * @export
 */
export const DeviceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeviceApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加设备
         * @param {SystemGenerateObject100} systemGenerateObject100 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDeviceDevice(systemGenerateObject100: SystemGenerateObject100, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addDeviceDevice(systemGenerateObject100, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除设备
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeviceDevice(deviceId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.deleteDeviceDevice(deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 管理员开门
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceAdminOpendoorDevice(deviceId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.deviceAdminOpendoorDevice(deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 管理员开门(Hex)
         * @param {string} deviceIdHex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceAdminOpendoorHexDevice(deviceIdHex: string, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.deviceAdminOpendoorHexDevice(deviceIdHex, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取设备模式
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceGetModDevice(deviceId: number, options?: any): AxiosPromise<any> {
            return localVarFp.deviceGetModDevice(deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 请求获取设备的模式(Hwx)
         * @param {string} deviceIdHex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceGetModHexDevice(deviceIdHex: string, options?: any): AxiosPromise<any> {
            return localVarFp.deviceGetModHexDevice(deviceIdHex, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 设备恢复
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceRecoveryDevice(deviceId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.deviceRecoveryDevice(deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 设置设备的模式
         * @param {number} deviceId 
         * @param {DEVICEMODE} mod 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceSetModDevice(deviceId: number, mod: DEVICEMODE, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.deviceSetModDevice(deviceId, mod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取设备状态
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceStatusDevice(deviceId: number, options?: any): AxiosPromise<any> {
            return localVarFp.deviceStatusDevice(deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取设备状态(Hex)
         * @param {string} deviceIdHex 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceStatusHexDevice(deviceIdHex: string, options?: any): AxiosPromise<any> {
            return localVarFp.deviceStatusHexDevice(deviceIdHex, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 设备升级
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceUpgradeDevice(deviceId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.deviceUpgradeDevice(deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取设备版本
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceVersionDevice(deviceId: number, options?: any): AxiosPromise<any> {
            return localVarFp.deviceVersionDevice(deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取设备列表
         * @param {SystemGenerateObject98} systemGenerateObject98 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDeviceDevice(systemGenerateObject98: SystemGenerateObject98, options?: any): AxiosPromise<any> {
            return localVarFp.listDeviceDevice(systemGenerateObject98, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取设备类型列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDeviceTypeDevice(options?: any): AxiosPromise<any> {
            return localVarFp.listDeviceTypeDevice(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 直接打开设备
         * @param {string} deviceIdHex 
         * @param {number} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        opendoorByDirectGetDevice(deviceIdHex: string, tenantId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.opendoorByDirectGetDevice(deviceIdHex, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取设备列表(分页)
         * @param {SystemGenerateObject99} systemGenerateObject99 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageDeviceDevice(systemGenerateObject99: SystemGenerateObject99, options?: any): AxiosPromise<any> {
            return localVarFp.pageDeviceDevice(systemGenerateObject99, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新设备
         * @param {SystemGenerateObject101} systemGenerateObject101 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceDevice(systemGenerateObject101: SystemGenerateObject101, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateDeviceDevice(systemGenerateObject101, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeviceApi - object-oriented interface
 * @export
 * @class DeviceApi
 * @extends {BaseAPI}
 */
export class DeviceApi extends BaseAPI {
    /**
     * 
     * @summary 添加设备
     * @param {SystemGenerateObject100} systemGenerateObject100 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public addDeviceDevice(systemGenerateObject100: SystemGenerateObject100, options?: AxiosRequestConfig) {
        return DeviceApiFp(this.configuration).addDeviceDevice(systemGenerateObject100, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除设备
     * @param {number} deviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public deleteDeviceDevice(deviceId: number, options?: AxiosRequestConfig) {
        return DeviceApiFp(this.configuration).deleteDeviceDevice(deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 管理员开门
     * @param {number} deviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public deviceAdminOpendoorDevice(deviceId: number, options?: AxiosRequestConfig) {
        return DeviceApiFp(this.configuration).deviceAdminOpendoorDevice(deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 管理员开门(Hex)
     * @param {string} deviceIdHex 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public deviceAdminOpendoorHexDevice(deviceIdHex: string, options?: AxiosRequestConfig) {
        return DeviceApiFp(this.configuration).deviceAdminOpendoorHexDevice(deviceIdHex, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取设备模式
     * @param {number} deviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public deviceGetModDevice(deviceId: number, options?: AxiosRequestConfig) {
        return DeviceApiFp(this.configuration).deviceGetModDevice(deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 请求获取设备的模式(Hwx)
     * @param {string} deviceIdHex 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public deviceGetModHexDevice(deviceIdHex: string, options?: AxiosRequestConfig) {
        return DeviceApiFp(this.configuration).deviceGetModHexDevice(deviceIdHex, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 设备恢复
     * @param {number} deviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public deviceRecoveryDevice(deviceId: number, options?: AxiosRequestConfig) {
        return DeviceApiFp(this.configuration).deviceRecoveryDevice(deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 设置设备的模式
     * @param {number} deviceId 
     * @param {DEVICEMODE} mod 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public deviceSetModDevice(deviceId: number, mod: DEVICEMODE, options?: AxiosRequestConfig) {
        return DeviceApiFp(this.configuration).deviceSetModDevice(deviceId, mod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取设备状态
     * @param {number} deviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public deviceStatusDevice(deviceId: number, options?: AxiosRequestConfig) {
        return DeviceApiFp(this.configuration).deviceStatusDevice(deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取设备状态(Hex)
     * @param {string} deviceIdHex 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public deviceStatusHexDevice(deviceIdHex: string, options?: AxiosRequestConfig) {
        return DeviceApiFp(this.configuration).deviceStatusHexDevice(deviceIdHex, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 设备升级
     * @param {number} deviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public deviceUpgradeDevice(deviceId: number, options?: AxiosRequestConfig) {
        return DeviceApiFp(this.configuration).deviceUpgradeDevice(deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取设备版本
     * @param {number} deviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public deviceVersionDevice(deviceId: number, options?: AxiosRequestConfig) {
        return DeviceApiFp(this.configuration).deviceVersionDevice(deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取设备列表
     * @param {SystemGenerateObject98} systemGenerateObject98 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public listDeviceDevice(systemGenerateObject98: SystemGenerateObject98, options?: AxiosRequestConfig) {
        return DeviceApiFp(this.configuration).listDeviceDevice(systemGenerateObject98, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取设备类型列表
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public listDeviceTypeDevice(options?: AxiosRequestConfig) {
        return DeviceApiFp(this.configuration).listDeviceTypeDevice(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 直接打开设备
     * @param {string} deviceIdHex 
     * @param {number} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public opendoorByDirectGetDevice(deviceIdHex: string, tenantId: number, options?: AxiosRequestConfig) {
        return DeviceApiFp(this.configuration).opendoorByDirectGetDevice(deviceIdHex, tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取设备列表(分页)
     * @param {SystemGenerateObject99} systemGenerateObject99 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public pageDeviceDevice(systemGenerateObject99: SystemGenerateObject99, options?: AxiosRequestConfig) {
        return DeviceApiFp(this.configuration).pageDeviceDevice(systemGenerateObject99, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新设备
     * @param {SystemGenerateObject101} systemGenerateObject101 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public updateDeviceDevice(systemGenerateObject101: SystemGenerateObject101, options?: AxiosRequestConfig) {
        return DeviceApiFp(this.configuration).updateDeviceDevice(systemGenerateObject101, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DistanceApi - axios parameter creator
 * @export
 */
export const DistanceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加距离
         * @param {SystemGenerateObject151} systemGenerateObject151 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDistancedistance: async (systemGenerateObject151: SystemGenerateObject151, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject151' is not null or undefined
            assertParamExists('addDistancedistance', 'systemGenerateObject151', systemGenerateObject151)
            const localVarPath = `/distance/addDistance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject151, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除距离
         * @param {number} distanceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delDistancedistance: async (distanceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'distanceId' is not null or undefined
            assertParamExists('delDistancedistance', 'distanceId', distanceId)
            const localVarPath = `/distance/delDistance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (distanceId !== undefined) {
                localVarQueryParameter['distanceId'] = distanceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取距离列表
         * @param {SystemGenerateObject149} systemGenerateObject149 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDistancedistance: async (systemGenerateObject149: SystemGenerateObject149, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject149' is not null or undefined
            assertParamExists('listDistancedistance', 'systemGenerateObject149', systemGenerateObject149)
            const localVarPath = `/distance/listDistance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject149, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取距离列表(分页)
         * @param {SystemGenerateObject150} systemGenerateObject150 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageDistancedistance: async (systemGenerateObject150: SystemGenerateObject150, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject150' is not null or undefined
            assertParamExists('pageDistancedistance', 'systemGenerateObject150', systemGenerateObject150)
            const localVarPath = `/distance/pageDistance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject150, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新距离
         * @param {SystemGenerateObject152} systemGenerateObject152 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDistancedistance: async (systemGenerateObject152: SystemGenerateObject152, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject152' is not null or undefined
            assertParamExists('updateDistancedistance', 'systemGenerateObject152', systemGenerateObject152)
            const localVarPath = `/distance/updateDistance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject152, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DistanceApi - functional programming interface
 * @export
 */
export const DistanceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DistanceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加距离
         * @param {SystemGenerateObject151} systemGenerateObject151 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDistancedistance(systemGenerateObject151: SystemGenerateObject151, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDistancedistance(systemGenerateObject151, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除距离
         * @param {number} distanceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delDistancedistance(distanceId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delDistancedistance(distanceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取距离列表
         * @param {SystemGenerateObject149} systemGenerateObject149 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDistancedistance(systemGenerateObject149: SystemGenerateObject149, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDistancedistance(systemGenerateObject149, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取距离列表(分页)
         * @param {SystemGenerateObject150} systemGenerateObject150 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageDistancedistance(systemGenerateObject150: SystemGenerateObject150, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageDistancedistance(systemGenerateObject150, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新距离
         * @param {SystemGenerateObject152} systemGenerateObject152 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDistancedistance(systemGenerateObject152: SystemGenerateObject152, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDistancedistance(systemGenerateObject152, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DistanceApi - factory interface
 * @export
 */
export const DistanceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DistanceApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加距离
         * @param {SystemGenerateObject151} systemGenerateObject151 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDistancedistance(systemGenerateObject151: SystemGenerateObject151, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addDistancedistance(systemGenerateObject151, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除距离
         * @param {number} distanceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delDistancedistance(distanceId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delDistancedistance(distanceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取距离列表
         * @param {SystemGenerateObject149} systemGenerateObject149 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDistancedistance(systemGenerateObject149: SystemGenerateObject149, options?: any): AxiosPromise<any> {
            return localVarFp.listDistancedistance(systemGenerateObject149, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取距离列表(分页)
         * @param {SystemGenerateObject150} systemGenerateObject150 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageDistancedistance(systemGenerateObject150: SystemGenerateObject150, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageDistancedistance(systemGenerateObject150, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新距离
         * @param {SystemGenerateObject152} systemGenerateObject152 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDistancedistance(systemGenerateObject152: SystemGenerateObject152, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateDistancedistance(systemGenerateObject152, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DistanceApi - object-oriented interface
 * @export
 * @class DistanceApi
 * @extends {BaseAPI}
 */
export class DistanceApi extends BaseAPI {
    /**
     * 
     * @summary 添加距离
     * @param {SystemGenerateObject151} systemGenerateObject151 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DistanceApi
     */
    public addDistancedistance(systemGenerateObject151: SystemGenerateObject151, options?: AxiosRequestConfig) {
        return DistanceApiFp(this.configuration).addDistancedistance(systemGenerateObject151, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除距离
     * @param {number} distanceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DistanceApi
     */
    public delDistancedistance(distanceId: number, options?: AxiosRequestConfig) {
        return DistanceApiFp(this.configuration).delDistancedistance(distanceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取距离列表
     * @param {SystemGenerateObject149} systemGenerateObject149 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DistanceApi
     */
    public listDistancedistance(systemGenerateObject149: SystemGenerateObject149, options?: AxiosRequestConfig) {
        return DistanceApiFp(this.configuration).listDistancedistance(systemGenerateObject149, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取距离列表(分页)
     * @param {SystemGenerateObject150} systemGenerateObject150 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DistanceApi
     */
    public pageDistancedistance(systemGenerateObject150: SystemGenerateObject150, options?: AxiosRequestConfig) {
        return DistanceApiFp(this.configuration).pageDistancedistance(systemGenerateObject150, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新距离
     * @param {SystemGenerateObject152} systemGenerateObject152 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DistanceApi
     */
    public updateDistancedistance(systemGenerateObject152: SystemGenerateObject152, options?: AxiosRequestConfig) {
        return DistanceApiFp(this.configuration).updateDistancedistance(systemGenerateObject152, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExpressApi - axios parameter creator
 * @export
 */
export const ExpressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加快递
         * @param {SystemGenerateObject243} systemGenerateObject243 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addExpressexpress: async (systemGenerateObject243: SystemGenerateObject243, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject243' is not null or undefined
            assertParamExists('addExpressexpress', 'systemGenerateObject243', systemGenerateObject243)
            const localVarPath = `/express/addExpress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject243, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除快递
         * @param {number} expressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delExpressexpress: async (expressId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'expressId' is not null or undefined
            assertParamExists('delExpressexpress', 'expressId', expressId)
            const localVarPath = `/express/delExpress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (expressId !== undefined) {
                localVarQueryParameter['expressId'] = expressId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取快递信息
         * @param {string} trackingNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpressexpress: async (trackingNumber: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackingNumber' is not null or undefined
            assertParamExists('getExpressexpress', 'trackingNumber', trackingNumber)
            const localVarPath = `/express/getExpress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (trackingNumber !== undefined) {
                localVarQueryParameter['trackingNumber'] = trackingNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取快递列表
         * @param {SystemGenerateObject241} systemGenerateObject241 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExpressexpress: async (systemGenerateObject241: SystemGenerateObject241, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject241' is not null or undefined
            assertParamExists('listExpressexpress', 'systemGenerateObject241', systemGenerateObject241)
            const localVarPath = `/express/listExpress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject241, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 接收订阅推送的快递更新消息
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onSubexpress: async (body: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('onSubexpress', 'body', body)
            const localVarPath = `/express/onSub`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取快递列表(分页)
         * @param {SystemGenerateObject242} systemGenerateObject242 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageExpressexpress: async (systemGenerateObject242: SystemGenerateObject242, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject242' is not null or undefined
            assertParamExists('pageExpressexpress', 'systemGenerateObject242', systemGenerateObject242)
            const localVarPath = `/express/pageExpress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject242, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查询快递单号对应的快递公司
         * @param {SystemGenerateObject246} systemGenerateObject246 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryExpressCompanyexpress: async (systemGenerateObject246: SystemGenerateObject246, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject246' is not null or undefined
            assertParamExists('queryExpressCompanyexpress', 'systemGenerateObject246', systemGenerateObject246)
            const localVarPath = `/express/queryExpressCompany`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject246, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 店铺付费查询快递信息
         * @param {SystemGenerateObject247} systemGenerateObject247 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeQueryExpressexpress: async (systemGenerateObject247: SystemGenerateObject247, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject247' is not null or undefined
            assertParamExists('storeQueryExpressexpress', 'systemGenerateObject247', systemGenerateObject247)
            const localVarPath = `/express/storeQueryExpress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject247, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新快递轨迹
         * @param {SystemGenerateObject245} systemGenerateObject245 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExpressTrackexpress: async (systemGenerateObject245: SystemGenerateObject245, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject245' is not null or undefined
            assertParamExists('updateExpressTrackexpress', 'systemGenerateObject245', systemGenerateObject245)
            const localVarPath = `/express/updateExpressTrack`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject245, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新快递信息
         * @param {SystemGenerateObject244} systemGenerateObject244 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExpressexpress: async (systemGenerateObject244: SystemGenerateObject244, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject244' is not null or undefined
            assertParamExists('updateExpressexpress', 'systemGenerateObject244', systemGenerateObject244)
            const localVarPath = `/express/updateExpress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject244, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExpressApi - functional programming interface
 * @export
 */
export const ExpressApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExpressApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加快递
         * @param {SystemGenerateObject243} systemGenerateObject243 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addExpressexpress(systemGenerateObject243: SystemGenerateObject243, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addExpressexpress(systemGenerateObject243, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除快递
         * @param {number} expressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delExpressexpress(expressId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delExpressexpress(expressId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取快递信息
         * @param {string} trackingNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExpressexpress(trackingNumber: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExpressexpress(trackingNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取快递列表
         * @param {SystemGenerateObject241} systemGenerateObject241 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listExpressexpress(systemGenerateObject241: SystemGenerateObject241, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listExpressexpress(systemGenerateObject241, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 接收订阅推送的快递更新消息
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async onSubexpress(body: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.onSubexpress(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取快递列表(分页)
         * @param {SystemGenerateObject242} systemGenerateObject242 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageExpressexpress(systemGenerateObject242: SystemGenerateObject242, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageExpressexpress(systemGenerateObject242, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 查询快递单号对应的快递公司
         * @param {SystemGenerateObject246} systemGenerateObject246 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryExpressCompanyexpress(systemGenerateObject246: SystemGenerateObject246, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryExpressCompanyexpress(systemGenerateObject246, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 店铺付费查询快递信息
         * @param {SystemGenerateObject247} systemGenerateObject247 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeQueryExpressexpress(systemGenerateObject247: SystemGenerateObject247, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeQueryExpressexpress(systemGenerateObject247, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新快递轨迹
         * @param {SystemGenerateObject245} systemGenerateObject245 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExpressTrackexpress(systemGenerateObject245: SystemGenerateObject245, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExpressTrackexpress(systemGenerateObject245, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新快递信息
         * @param {SystemGenerateObject244} systemGenerateObject244 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExpressexpress(systemGenerateObject244: SystemGenerateObject244, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExpressexpress(systemGenerateObject244, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ExpressApi - factory interface
 * @export
 */
export const ExpressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExpressApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加快递
         * @param {SystemGenerateObject243} systemGenerateObject243 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addExpressexpress(systemGenerateObject243: SystemGenerateObject243, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addExpressexpress(systemGenerateObject243, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除快递
         * @param {number} expressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delExpressexpress(expressId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delExpressexpress(expressId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取快递信息
         * @param {string} trackingNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpressexpress(trackingNumber: string, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.getExpressexpress(trackingNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取快递列表
         * @param {SystemGenerateObject241} systemGenerateObject241 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExpressexpress(systemGenerateObject241: SystemGenerateObject241, options?: any): AxiosPromise<any> {
            return localVarFp.listExpressexpress(systemGenerateObject241, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 接收订阅推送的快递更新消息
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onSubexpress(body: any, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.onSubexpress(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取快递列表(分页)
         * @param {SystemGenerateObject242} systemGenerateObject242 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageExpressexpress(systemGenerateObject242: SystemGenerateObject242, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageExpressexpress(systemGenerateObject242, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查询快递单号对应的快递公司
         * @param {SystemGenerateObject246} systemGenerateObject246 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryExpressCompanyexpress(systemGenerateObject246: SystemGenerateObject246, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.queryExpressCompanyexpress(systemGenerateObject246, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 店铺付费查询快递信息
         * @param {SystemGenerateObject247} systemGenerateObject247 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeQueryExpressexpress(systemGenerateObject247: SystemGenerateObject247, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.storeQueryExpressexpress(systemGenerateObject247, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新快递轨迹
         * @param {SystemGenerateObject245} systemGenerateObject245 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExpressTrackexpress(systemGenerateObject245: SystemGenerateObject245, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateExpressTrackexpress(systemGenerateObject245, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新快递信息
         * @param {SystemGenerateObject244} systemGenerateObject244 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExpressexpress(systemGenerateObject244: SystemGenerateObject244, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateExpressexpress(systemGenerateObject244, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExpressApi - object-oriented interface
 * @export
 * @class ExpressApi
 * @extends {BaseAPI}
 */
export class ExpressApi extends BaseAPI {
    /**
     * 
     * @summary 添加快递
     * @param {SystemGenerateObject243} systemGenerateObject243 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpressApi
     */
    public addExpressexpress(systemGenerateObject243: SystemGenerateObject243, options?: AxiosRequestConfig) {
        return ExpressApiFp(this.configuration).addExpressexpress(systemGenerateObject243, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除快递
     * @param {number} expressId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpressApi
     */
    public delExpressexpress(expressId: number, options?: AxiosRequestConfig) {
        return ExpressApiFp(this.configuration).delExpressexpress(expressId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取快递信息
     * @param {string} trackingNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpressApi
     */
    public getExpressexpress(trackingNumber: string, options?: AxiosRequestConfig) {
        return ExpressApiFp(this.configuration).getExpressexpress(trackingNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取快递列表
     * @param {SystemGenerateObject241} systemGenerateObject241 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpressApi
     */
    public listExpressexpress(systemGenerateObject241: SystemGenerateObject241, options?: AxiosRequestConfig) {
        return ExpressApiFp(this.configuration).listExpressexpress(systemGenerateObject241, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 接收订阅推送的快递更新消息
     * @param {any} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpressApi
     */
    public onSubexpress(body: any, options?: AxiosRequestConfig) {
        return ExpressApiFp(this.configuration).onSubexpress(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取快递列表(分页)
     * @param {SystemGenerateObject242} systemGenerateObject242 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpressApi
     */
    public pageExpressexpress(systemGenerateObject242: SystemGenerateObject242, options?: AxiosRequestConfig) {
        return ExpressApiFp(this.configuration).pageExpressexpress(systemGenerateObject242, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查询快递单号对应的快递公司
     * @param {SystemGenerateObject246} systemGenerateObject246 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpressApi
     */
    public queryExpressCompanyexpress(systemGenerateObject246: SystemGenerateObject246, options?: AxiosRequestConfig) {
        return ExpressApiFp(this.configuration).queryExpressCompanyexpress(systemGenerateObject246, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 店铺付费查询快递信息
     * @param {SystemGenerateObject247} systemGenerateObject247 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpressApi
     */
    public storeQueryExpressexpress(systemGenerateObject247: SystemGenerateObject247, options?: AxiosRequestConfig) {
        return ExpressApiFp(this.configuration).storeQueryExpressexpress(systemGenerateObject247, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新快递轨迹
     * @param {SystemGenerateObject245} systemGenerateObject245 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpressApi
     */
    public updateExpressTrackexpress(systemGenerateObject245: SystemGenerateObject245, options?: AxiosRequestConfig) {
        return ExpressApiFp(this.configuration).updateExpressTrackexpress(systemGenerateObject245, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新快递信息
     * @param {SystemGenerateObject244} systemGenerateObject244 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpressApi
     */
    public updateExpressexpress(systemGenerateObject244: SystemGenerateObject244, options?: AxiosRequestConfig) {
        return ExpressApiFp(this.configuration).updateExpressexpress(systemGenerateObject244, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExpressCompanyApi - axios parameter creator
 * @export
 */
export const ExpressCompanyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加快递公司
         * @param {SystemGenerateObject192} systemGenerateObject192 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addExpressCompanyexpressCompany: async (systemGenerateObject192: SystemGenerateObject192, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject192' is not null or undefined
            assertParamExists('addExpressCompanyexpressCompany', 'systemGenerateObject192', systemGenerateObject192)
            const localVarPath = `/expressCompany/addExpressCompany`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject192, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除快递公司
         * @param {number} expressCompanyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delExpressCompanyexpressCompany: async (expressCompanyId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'expressCompanyId' is not null or undefined
            assertParamExists('delExpressCompanyexpressCompany', 'expressCompanyId', expressCompanyId)
            const localVarPath = `/expressCompany/delExpressCompany`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (expressCompanyId !== undefined) {
                localVarQueryParameter['expressCompanyId'] = expressCompanyId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取快递公司列表
         * @param {SystemGenerateObject190} systemGenerateObject190 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExpressCompanyexpressCompany: async (systemGenerateObject190: SystemGenerateObject190, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject190' is not null or undefined
            assertParamExists('listExpressCompanyexpressCompany', 'systemGenerateObject190', systemGenerateObject190)
            const localVarPath = `/expressCompany/listExpressCompany`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject190, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取快递公司列表(分页)
         * @param {SystemGenerateObject191} systemGenerateObject191 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageExpressCompanyexpressCompany: async (systemGenerateObject191: SystemGenerateObject191, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject191' is not null or undefined
            assertParamExists('pageExpressCompanyexpressCompany', 'systemGenerateObject191', systemGenerateObject191)
            const localVarPath = `/expressCompany/pageExpressCompany`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject191, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新快递公司
         * @param {SystemGenerateObject193} systemGenerateObject193 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExpressCompanyexpressCompany: async (systemGenerateObject193: SystemGenerateObject193, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject193' is not null or undefined
            assertParamExists('updateExpressCompanyexpressCompany', 'systemGenerateObject193', systemGenerateObject193)
            const localVarPath = `/expressCompany/updateExpressCompany`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject193, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExpressCompanyApi - functional programming interface
 * @export
 */
export const ExpressCompanyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExpressCompanyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加快递公司
         * @param {SystemGenerateObject192} systemGenerateObject192 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addExpressCompanyexpressCompany(systemGenerateObject192: SystemGenerateObject192, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addExpressCompanyexpressCompany(systemGenerateObject192, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除快递公司
         * @param {number} expressCompanyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delExpressCompanyexpressCompany(expressCompanyId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delExpressCompanyexpressCompany(expressCompanyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取快递公司列表
         * @param {SystemGenerateObject190} systemGenerateObject190 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listExpressCompanyexpressCompany(systemGenerateObject190: SystemGenerateObject190, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listExpressCompanyexpressCompany(systemGenerateObject190, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取快递公司列表(分页)
         * @param {SystemGenerateObject191} systemGenerateObject191 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageExpressCompanyexpressCompany(systemGenerateObject191: SystemGenerateObject191, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageExpressCompanyexpressCompany(systemGenerateObject191, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新快递公司
         * @param {SystemGenerateObject193} systemGenerateObject193 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExpressCompanyexpressCompany(systemGenerateObject193: SystemGenerateObject193, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExpressCompanyexpressCompany(systemGenerateObject193, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ExpressCompanyApi - factory interface
 * @export
 */
export const ExpressCompanyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExpressCompanyApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加快递公司
         * @param {SystemGenerateObject192} systemGenerateObject192 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addExpressCompanyexpressCompany(systemGenerateObject192: SystemGenerateObject192, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addExpressCompanyexpressCompany(systemGenerateObject192, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除快递公司
         * @param {number} expressCompanyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delExpressCompanyexpressCompany(expressCompanyId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delExpressCompanyexpressCompany(expressCompanyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取快递公司列表
         * @param {SystemGenerateObject190} systemGenerateObject190 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExpressCompanyexpressCompany(systemGenerateObject190: SystemGenerateObject190, options?: any): AxiosPromise<any> {
            return localVarFp.listExpressCompanyexpressCompany(systemGenerateObject190, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取快递公司列表(分页)
         * @param {SystemGenerateObject191} systemGenerateObject191 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageExpressCompanyexpressCompany(systemGenerateObject191: SystemGenerateObject191, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageExpressCompanyexpressCompany(systemGenerateObject191, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新快递公司
         * @param {SystemGenerateObject193} systemGenerateObject193 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExpressCompanyexpressCompany(systemGenerateObject193: SystemGenerateObject193, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateExpressCompanyexpressCompany(systemGenerateObject193, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExpressCompanyApi - object-oriented interface
 * @export
 * @class ExpressCompanyApi
 * @extends {BaseAPI}
 */
export class ExpressCompanyApi extends BaseAPI {
    /**
     * 
     * @summary 添加快递公司
     * @param {SystemGenerateObject192} systemGenerateObject192 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpressCompanyApi
     */
    public addExpressCompanyexpressCompany(systemGenerateObject192: SystemGenerateObject192, options?: AxiosRequestConfig) {
        return ExpressCompanyApiFp(this.configuration).addExpressCompanyexpressCompany(systemGenerateObject192, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除快递公司
     * @param {number} expressCompanyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpressCompanyApi
     */
    public delExpressCompanyexpressCompany(expressCompanyId: number, options?: AxiosRequestConfig) {
        return ExpressCompanyApiFp(this.configuration).delExpressCompanyexpressCompany(expressCompanyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取快递公司列表
     * @param {SystemGenerateObject190} systemGenerateObject190 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpressCompanyApi
     */
    public listExpressCompanyexpressCompany(systemGenerateObject190: SystemGenerateObject190, options?: AxiosRequestConfig) {
        return ExpressCompanyApiFp(this.configuration).listExpressCompanyexpressCompany(systemGenerateObject190, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取快递公司列表(分页)
     * @param {SystemGenerateObject191} systemGenerateObject191 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpressCompanyApi
     */
    public pageExpressCompanyexpressCompany(systemGenerateObject191: SystemGenerateObject191, options?: AxiosRequestConfig) {
        return ExpressCompanyApiFp(this.configuration).pageExpressCompanyexpressCompany(systemGenerateObject191, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新快递公司
     * @param {SystemGenerateObject193} systemGenerateObject193 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpressCompanyApi
     */
    public updateExpressCompanyexpressCompany(systemGenerateObject193: SystemGenerateObject193, options?: AxiosRequestConfig) {
        return ExpressCompanyApiFp(this.configuration).updateExpressCompanyexpressCompany(systemGenerateObject193, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FacilitatorApi - axios parameter creator
 * @export
 */
export const FacilitatorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加服务商
         * @param {SystemGenerateObject143} systemGenerateObject143 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFacilitatorfacilitator: async (systemGenerateObject143: SystemGenerateObject143, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject143' is not null or undefined
            assertParamExists('addFacilitatorfacilitator', 'systemGenerateObject143', systemGenerateObject143)
            const localVarPath = `/facilitator/addFacilitator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject143, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除服务商
         * @param {number} facilitatorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delFacilitatorfacilitator: async (facilitatorId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilitatorId' is not null or undefined
            assertParamExists('delFacilitatorfacilitator', 'facilitatorId', facilitatorId)
            const localVarPath = `/facilitator/delFacilitator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (facilitatorId !== undefined) {
                localVarQueryParameter['facilitatorId'] = facilitatorId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取服务商列表
         * @param {SystemGenerateObject141} systemGenerateObject141 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilitatorfacilitator: async (systemGenerateObject141: SystemGenerateObject141, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject141' is not null or undefined
            assertParamExists('listFacilitatorfacilitator', 'systemGenerateObject141', systemGenerateObject141)
            const localVarPath = `/facilitator/listFacilitator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject141, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取服务商列表(分页)
         * @param {SystemGenerateObject142} systemGenerateObject142 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageFacilitatorfacilitator: async (systemGenerateObject142: SystemGenerateObject142, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject142' is not null or undefined
            assertParamExists('pageFacilitatorfacilitator', 'systemGenerateObject142', systemGenerateObject142)
            const localVarPath = `/facilitator/pageFacilitator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject142, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新服务商
         * @param {SystemGenerateObject144} systemGenerateObject144 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFacilitatorfacilitator: async (systemGenerateObject144: SystemGenerateObject144, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject144' is not null or undefined
            assertParamExists('updateFacilitatorfacilitator', 'systemGenerateObject144', systemGenerateObject144)
            const localVarPath = `/facilitator/updateFacilitator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject144, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FacilitatorApi - functional programming interface
 * @export
 */
export const FacilitatorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FacilitatorApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加服务商
         * @param {SystemGenerateObject143} systemGenerateObject143 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addFacilitatorfacilitator(systemGenerateObject143: SystemGenerateObject143, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addFacilitatorfacilitator(systemGenerateObject143, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除服务商
         * @param {number} facilitatorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delFacilitatorfacilitator(facilitatorId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delFacilitatorfacilitator(facilitatorId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取服务商列表
         * @param {SystemGenerateObject141} systemGenerateObject141 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFacilitatorfacilitator(systemGenerateObject141: SystemGenerateObject141, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFacilitatorfacilitator(systemGenerateObject141, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取服务商列表(分页)
         * @param {SystemGenerateObject142} systemGenerateObject142 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageFacilitatorfacilitator(systemGenerateObject142: SystemGenerateObject142, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageFacilitatorfacilitator(systemGenerateObject142, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新服务商
         * @param {SystemGenerateObject144} systemGenerateObject144 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFacilitatorfacilitator(systemGenerateObject144: SystemGenerateObject144, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFacilitatorfacilitator(systemGenerateObject144, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FacilitatorApi - factory interface
 * @export
 */
export const FacilitatorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FacilitatorApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加服务商
         * @param {SystemGenerateObject143} systemGenerateObject143 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFacilitatorfacilitator(systemGenerateObject143: SystemGenerateObject143, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addFacilitatorfacilitator(systemGenerateObject143, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除服务商
         * @param {number} facilitatorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delFacilitatorfacilitator(facilitatorId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delFacilitatorfacilitator(facilitatorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取服务商列表
         * @param {SystemGenerateObject141} systemGenerateObject141 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFacilitatorfacilitator(systemGenerateObject141: SystemGenerateObject141, options?: any): AxiosPromise<any> {
            return localVarFp.listFacilitatorfacilitator(systemGenerateObject141, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取服务商列表(分页)
         * @param {SystemGenerateObject142} systemGenerateObject142 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageFacilitatorfacilitator(systemGenerateObject142: SystemGenerateObject142, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageFacilitatorfacilitator(systemGenerateObject142, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新服务商
         * @param {SystemGenerateObject144} systemGenerateObject144 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFacilitatorfacilitator(systemGenerateObject144: SystemGenerateObject144, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateFacilitatorfacilitator(systemGenerateObject144, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FacilitatorApi - object-oriented interface
 * @export
 * @class FacilitatorApi
 * @extends {BaseAPI}
 */
export class FacilitatorApi extends BaseAPI {
    /**
     * 
     * @summary 添加服务商
     * @param {SystemGenerateObject143} systemGenerateObject143 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorApi
     */
    public addFacilitatorfacilitator(systemGenerateObject143: SystemGenerateObject143, options?: AxiosRequestConfig) {
        return FacilitatorApiFp(this.configuration).addFacilitatorfacilitator(systemGenerateObject143, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除服务商
     * @param {number} facilitatorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorApi
     */
    public delFacilitatorfacilitator(facilitatorId: number, options?: AxiosRequestConfig) {
        return FacilitatorApiFp(this.configuration).delFacilitatorfacilitator(facilitatorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取服务商列表
     * @param {SystemGenerateObject141} systemGenerateObject141 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorApi
     */
    public listFacilitatorfacilitator(systemGenerateObject141: SystemGenerateObject141, options?: AxiosRequestConfig) {
        return FacilitatorApiFp(this.configuration).listFacilitatorfacilitator(systemGenerateObject141, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取服务商列表(分页)
     * @param {SystemGenerateObject142} systemGenerateObject142 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorApi
     */
    public pageFacilitatorfacilitator(systemGenerateObject142: SystemGenerateObject142, options?: AxiosRequestConfig) {
        return FacilitatorApiFp(this.configuration).pageFacilitatorfacilitator(systemGenerateObject142, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新服务商
     * @param {SystemGenerateObject144} systemGenerateObject144 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitatorApi
     */
    public updateFacilitatorfacilitator(systemGenerateObject144: SystemGenerateObject144, options?: AxiosRequestConfig) {
        return FacilitatorApiFp(this.configuration).updateFacilitatorfacilitator(systemGenerateObject144, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HomeApi - axios parameter creator
 * @export
 */
export const HomeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加站内信
         * @param {SystemGenerateObject147} systemGenerateObject147 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMessagehome: async (systemGenerateObject147: SystemGenerateObject147, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject147' is not null or undefined
            assertParamExists('addMessagehome', 'systemGenerateObject147', systemGenerateObject147)
            const localVarPath = `/home/addMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject147, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除站内信
         * @param {number} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delMessagehome: async (messageId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('delMessagehome', 'messageId', messageId)
            const localVarPath = `/home/delMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (messageId !== undefined) {
                localVarQueryParameter['messageId'] = messageId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除用户
         * @param {{ phone: string }} deleteUserByPhoneRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delUserByPhonehome: async (deleteUserByPhoneRequest: { phone: string }, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteUserByPhoneRequest' is not null or undefined
            assertParamExists('delUserByPhonehome', 'deleteUserByPhoneRequest', deleteUserByPhoneRequest)
            const localVarPath = `/home/delUserByPhone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteUserByPhoneRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 清理用户登录信息
         * @param {{ count: number }} clearUserLoginInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearUserLoginInfohome: async (clearUserLoginInfoRequest: { count: number }, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clearUserLoginInfoRequest' is not null or undefined
            assertParamExists('clearUserLoginInfohome', 'clearUserLoginInfoRequest', clearUserLoginInfoRequest)
            const localVarPath = `/home/clearUserLoginInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clearUserLoginInfoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取首页统计
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHomeStatisticshome: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/home/getHomeStatistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取站内信列表
         * @param {SystemGenerateObject145} systemGenerateObject145 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMessagehome: async (systemGenerateObject145: SystemGenerateObject145, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject145' is not null or undefined
            assertParamExists('listMessagehome', 'systemGenerateObject145', systemGenerateObject145)
            const localVarPath = `/home/listMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject145, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取站内信列表(分页)
         * @param {SystemGenerateObject146} systemGenerateObject146 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageMessagehome: async (systemGenerateObject146: SystemGenerateObject146, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject146' is not null or undefined
            assertParamExists('pageMessagehome', 'systemGenerateObject146', systemGenerateObject146)
            const localVarPath = `/home/pageMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject146, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新站内信
         * @param {SystemGenerateObject148} systemGenerateObject148 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMessagehome: async (systemGenerateObject148: SystemGenerateObject148, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject148' is not null or undefined
            assertParamExists('updateMessagehome', 'systemGenerateObject148', systemGenerateObject148)
            const localVarPath = `/home/updateMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject148, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HomeApi - functional programming interface
 * @export
 */
export const HomeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HomeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加站内信
         * @param {SystemGenerateObject147} systemGenerateObject147 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addMessagehome(systemGenerateObject147: SystemGenerateObject147, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addMessagehome(systemGenerateObject147, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除站内信
         * @param {number} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delMessagehome(messageId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delMessagehome(messageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除用户
         * @param {{ phone: string }} deleteUserByPhoneRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delUserByPhonehome(deleteUserByPhoneRequest: { phone: string }, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delUserByPhonehome(deleteUserByPhoneRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 清理用户登录信息
         * @param {{ count: number }} clearUserLoginInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearUserLoginInfohome(clearUserLoginInfoRequest: { count: number }, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clearUserLoginInfohome(clearUserLoginInfoRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取首页统计
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHomeStatisticshome(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHomeStatisticshome(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取站内信列表
         * @param {SystemGenerateObject145} systemGenerateObject145 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMessagehome(systemGenerateObject145: SystemGenerateObject145, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMessagehome(systemGenerateObject145, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取站内信列表(分页)
         * @param {SystemGenerateObject146} systemGenerateObject146 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageMessagehome(systemGenerateObject146: SystemGenerateObject146, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageMessagehome(systemGenerateObject146, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新站内信
         * @param {SystemGenerateObject148} systemGenerateObject148 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMessagehome(systemGenerateObject148: SystemGenerateObject148, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMessagehome(systemGenerateObject148, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HomeApi - factory interface
 * @export
 */
export const HomeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HomeApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加站内信
         * @param {SystemGenerateObject147} systemGenerateObject147 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMessagehome(systemGenerateObject147: SystemGenerateObject147, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addMessagehome(systemGenerateObject147, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除站内信
         * @param {number} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delMessagehome(messageId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delMessagehome(messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除用户
         * @param {{ phone: string }} deleteUserByPhoneRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delUserByPhonehome(deleteUserByPhoneRequest: { phone: string }, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delUserByPhonehome(deleteUserByPhoneRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 清理用户登录信息
         * @param {{ count: number }} clearUserLoginInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearUserLoginInfohome(clearUserLoginInfoRequest: { count: number }, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.clearUserLoginInfohome(clearUserLoginInfoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取首页统计
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHomeStatisticshome(options?: any): AxiosPromise<ResultVo> {
            return localVarFp.getHomeStatisticshome(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取站内信列表
         * @param {SystemGenerateObject145} systemGenerateObject145 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMessagehome(systemGenerateObject145: SystemGenerateObject145, options?: any): AxiosPromise<any> {
            return localVarFp.listMessagehome(systemGenerateObject145, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取站内信列表(分页)
         * @param {SystemGenerateObject146} systemGenerateObject146 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageMessagehome(systemGenerateObject146: SystemGenerateObject146, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageMessagehome(systemGenerateObject146, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新站内信
         * @param {SystemGenerateObject148} systemGenerateObject148 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMessagehome(systemGenerateObject148: SystemGenerateObject148, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateMessagehome(systemGenerateObject148, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HomeApi - object-oriented interface
 * @export
 * @class HomeApi
 * @extends {BaseAPI}
 */
export class HomeApi extends BaseAPI {
    /**
     * 
     * @summary 添加站内信
     * @param {SystemGenerateObject147} systemGenerateObject147 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomeApi
     */
    public addMessagehome(systemGenerateObject147: SystemGenerateObject147, options?: AxiosRequestConfig) {
        return HomeApiFp(this.configuration).addMessagehome(systemGenerateObject147, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除站内信
     * @param {number} messageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomeApi
     */
    public delMessagehome(messageId: number, options?: AxiosRequestConfig) {
        return HomeApiFp(this.configuration).delMessagehome(messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除用户
     * @param {{ phone: string }} deleteUserByPhoneRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomeApi
     */
    public delUserByPhonehome(deleteUserByPhoneRequest: { phone: string }, options?: AxiosRequestConfig) {
        return HomeApiFp(this.configuration).delUserByPhonehome(deleteUserByPhoneRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 清理用户登录信息
     * @param {{ count: number }} clearUserLoginInfoRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomeApi
     */
    public clearUserLoginInfohome(clearUserLoginInfoRequest: { count: number }, options?: AxiosRequestConfig) {
        return HomeApiFp(this.configuration).clearUserLoginInfohome(clearUserLoginInfoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取首页统计
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomeApi
     */
    public getHomeStatisticshome(options?: AxiosRequestConfig) {
        return HomeApiFp(this.configuration).getHomeStatisticshome(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取站内信列表
     * @param {SystemGenerateObject145} systemGenerateObject145 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomeApi
     */
    public listMessagehome(systemGenerateObject145: SystemGenerateObject145, options?: AxiosRequestConfig) {
        return HomeApiFp(this.configuration).listMessagehome(systemGenerateObject145, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取站内信列表(分页)
     * @param {SystemGenerateObject146} systemGenerateObject146 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomeApi
     */
    public pageMessagehome(systemGenerateObject146: SystemGenerateObject146, options?: AxiosRequestConfig) {
        return HomeApiFp(this.configuration).pageMessagehome(systemGenerateObject146, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新站内信
     * @param {SystemGenerateObject148} systemGenerateObject148 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomeApi
     */
    public updateMessagehome(systemGenerateObject148: SystemGenerateObject148, options?: AxiosRequestConfig) {
        return HomeApiFp(this.configuration).updateMessagehome(systemGenerateObject148, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * IncentivePlanApi - axios parameter creator
 * @export
 */
export const IncentivePlanApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加激励套餐
         * @param {SystemGenerateObject217} systemGenerateObject217 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addIncentivePlanincentivePlan: async (systemGenerateObject217: SystemGenerateObject217, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject217' is not null or undefined
            assertParamExists('addIncentivePlanincentivePlan', 'systemGenerateObject217', systemGenerateObject217)
            const localVarPath = `/incentivePlan/addIncentivePlan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject217, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除激励套餐
         * @param {number} incentivePlanId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delIncentivePlanincentivePlan: async (incentivePlanId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'incentivePlanId' is not null or undefined
            assertParamExists('delIncentivePlanincentivePlan', 'incentivePlanId', incentivePlanId)
            const localVarPath = `/incentivePlan/delIncentivePlan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (incentivePlanId !== undefined) {
                localVarQueryParameter['incentivePlanId'] = incentivePlanId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取当前用户可用的激励套餐列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyAvailableIncentivePlansincentivePlan: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/incentivePlan/myAvailableIncentivePlans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 通过激励套餐获取AI豆
         * @param {SystemGenerateObject219} systemGenerateObject219 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        incentiveGetAiBeanincentivePlan: async (systemGenerateObject219: SystemGenerateObject219, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject219' is not null or undefined
            assertParamExists('incentiveGetAiBeanincentivePlan', 'systemGenerateObject219', systemGenerateObject219)
            const localVarPath = `/incentivePlan/incentiveGetAiBean`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject219, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取激励套餐列表
         * @param {SystemGenerateObject215} systemGenerateObject215 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listIncentivePlanincentivePlan: async (systemGenerateObject215: SystemGenerateObject215, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject215' is not null or undefined
            assertParamExists('listIncentivePlanincentivePlan', 'systemGenerateObject215', systemGenerateObject215)
            const localVarPath = `/incentivePlan/listIncentivePlan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject215, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取激励套餐列表(分页)
         * @param {SystemGenerateObject216} systemGenerateObject216 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageIncentivePlanincentivePlan: async (systemGenerateObject216: SystemGenerateObject216, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject216' is not null or undefined
            assertParamExists('pageIncentivePlanincentivePlan', 'systemGenerateObject216', systemGenerateObject216)
            const localVarPath = `/incentivePlan/pageIncentivePlan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject216, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新激励套餐
         * @param {SystemGenerateObject218} systemGenerateObject218 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIncentivePlanincentivePlan: async (systemGenerateObject218: SystemGenerateObject218, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject218' is not null or undefined
            assertParamExists('updateIncentivePlanincentivePlan', 'systemGenerateObject218', systemGenerateObject218)
            const localVarPath = `/incentivePlan/updateIncentivePlan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject218, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IncentivePlanApi - functional programming interface
 * @export
 */
export const IncentivePlanApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IncentivePlanApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加激励套餐
         * @param {SystemGenerateObject217} systemGenerateObject217 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addIncentivePlanincentivePlan(systemGenerateObject217: SystemGenerateObject217, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addIncentivePlanincentivePlan(systemGenerateObject217, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除激励套餐
         * @param {number} incentivePlanId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delIncentivePlanincentivePlan(incentivePlanId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delIncentivePlanincentivePlan(incentivePlanId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取当前用户可用的激励套餐列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyAvailableIncentivePlansincentivePlan(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyAvailableIncentivePlansincentivePlan(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 通过激励套餐获取AI豆
         * @param {SystemGenerateObject219} systemGenerateObject219 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async incentiveGetAiBeanincentivePlan(systemGenerateObject219: SystemGenerateObject219, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.incentiveGetAiBeanincentivePlan(systemGenerateObject219, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取激励套餐列表
         * @param {SystemGenerateObject215} systemGenerateObject215 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listIncentivePlanincentivePlan(systemGenerateObject215: SystemGenerateObject215, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listIncentivePlanincentivePlan(systemGenerateObject215, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取激励套餐列表(分页)
         * @param {SystemGenerateObject216} systemGenerateObject216 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageIncentivePlanincentivePlan(systemGenerateObject216: SystemGenerateObject216, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageIncentivePlanincentivePlan(systemGenerateObject216, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新激励套餐
         * @param {SystemGenerateObject218} systemGenerateObject218 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateIncentivePlanincentivePlan(systemGenerateObject218: SystemGenerateObject218, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateIncentivePlanincentivePlan(systemGenerateObject218, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IncentivePlanApi - factory interface
 * @export
 */
export const IncentivePlanApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IncentivePlanApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加激励套餐
         * @param {SystemGenerateObject217} systemGenerateObject217 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addIncentivePlanincentivePlan(systemGenerateObject217: SystemGenerateObject217, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addIncentivePlanincentivePlan(systemGenerateObject217, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除激励套餐
         * @param {number} incentivePlanId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delIncentivePlanincentivePlan(incentivePlanId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delIncentivePlanincentivePlan(incentivePlanId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取当前用户可用的激励套餐列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyAvailableIncentivePlansincentivePlan(options?: any): AxiosPromise<any> {
            return localVarFp.getMyAvailableIncentivePlansincentivePlan(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 通过激励套餐获取AI豆
         * @param {SystemGenerateObject219} systemGenerateObject219 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        incentiveGetAiBeanincentivePlan(systemGenerateObject219: SystemGenerateObject219, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.incentiveGetAiBeanincentivePlan(systemGenerateObject219, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取激励套餐列表
         * @param {SystemGenerateObject215} systemGenerateObject215 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listIncentivePlanincentivePlan(systemGenerateObject215: SystemGenerateObject215, options?: any): AxiosPromise<any> {
            return localVarFp.listIncentivePlanincentivePlan(systemGenerateObject215, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取激励套餐列表(分页)
         * @param {SystemGenerateObject216} systemGenerateObject216 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageIncentivePlanincentivePlan(systemGenerateObject216: SystemGenerateObject216, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageIncentivePlanincentivePlan(systemGenerateObject216, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新激励套餐
         * @param {SystemGenerateObject218} systemGenerateObject218 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIncentivePlanincentivePlan(systemGenerateObject218: SystemGenerateObject218, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateIncentivePlanincentivePlan(systemGenerateObject218, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IncentivePlanApi - object-oriented interface
 * @export
 * @class IncentivePlanApi
 * @extends {BaseAPI}
 */
export class IncentivePlanApi extends BaseAPI {
    /**
     * 
     * @summary 添加激励套餐
     * @param {SystemGenerateObject217} systemGenerateObject217 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncentivePlanApi
     */
    public addIncentivePlanincentivePlan(systemGenerateObject217: SystemGenerateObject217, options?: AxiosRequestConfig) {
        return IncentivePlanApiFp(this.configuration).addIncentivePlanincentivePlan(systemGenerateObject217, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除激励套餐
     * @param {number} incentivePlanId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncentivePlanApi
     */
    public delIncentivePlanincentivePlan(incentivePlanId: number, options?: AxiosRequestConfig) {
        return IncentivePlanApiFp(this.configuration).delIncentivePlanincentivePlan(incentivePlanId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取当前用户可用的激励套餐列表
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncentivePlanApi
     */
    public getMyAvailableIncentivePlansincentivePlan(options?: AxiosRequestConfig) {
        return IncentivePlanApiFp(this.configuration).getMyAvailableIncentivePlansincentivePlan(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 通过激励套餐获取AI豆
     * @param {SystemGenerateObject219} systemGenerateObject219 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncentivePlanApi
     */
    public incentiveGetAiBeanincentivePlan(systemGenerateObject219: SystemGenerateObject219, options?: AxiosRequestConfig) {
        return IncentivePlanApiFp(this.configuration).incentiveGetAiBeanincentivePlan(systemGenerateObject219, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取激励套餐列表
     * @param {SystemGenerateObject215} systemGenerateObject215 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncentivePlanApi
     */
    public listIncentivePlanincentivePlan(systemGenerateObject215: SystemGenerateObject215, options?: AxiosRequestConfig) {
        return IncentivePlanApiFp(this.configuration).listIncentivePlanincentivePlan(systemGenerateObject215, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取激励套餐列表(分页)
     * @param {SystemGenerateObject216} systemGenerateObject216 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncentivePlanApi
     */
    public pageIncentivePlanincentivePlan(systemGenerateObject216: SystemGenerateObject216, options?: AxiosRequestConfig) {
        return IncentivePlanApiFp(this.configuration).pageIncentivePlanincentivePlan(systemGenerateObject216, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新激励套餐
     * @param {SystemGenerateObject218} systemGenerateObject218 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncentivePlanApi
     */
    public updateIncentivePlanincentivePlan(systemGenerateObject218: SystemGenerateObject218, options?: AxiosRequestConfig) {
        return IncentivePlanApiFp(this.configuration).updateIncentivePlanincentivePlan(systemGenerateObject218, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * JumpWeappApi - axios parameter creator
 * @export
 */
export const JumpWeappApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加跳转小程序
         * @param {SystemGenerateObject268} systemGenerateObject268 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addJumpWeappjumpWeapp: async (systemGenerateObject268: SystemGenerateObject268, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject268' is not null or undefined
            assertParamExists('addJumpWeappjumpWeapp', 'systemGenerateObject268', systemGenerateObject268)
            const localVarPath = `/jumpWeapp/addJumpWeapp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject268, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除跳转小程序
         * @param {number} jumpWeappId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delJumpWeappjumpWeapp: async (jumpWeappId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jumpWeappId' is not null or undefined
            assertParamExists('delJumpWeappjumpWeapp', 'jumpWeappId', jumpWeappId)
            const localVarPath = `/jumpWeapp/delJumpWeapp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (jumpWeappId !== undefined) {
                localVarQueryParameter['jumpWeappId'] = jumpWeappId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取跳转小程序列表
         * @param {SystemGenerateObject266} systemGenerateObject266 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJumpWeappjumpWeapp: async (systemGenerateObject266: SystemGenerateObject266, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject266' is not null or undefined
            assertParamExists('listJumpWeappjumpWeapp', 'systemGenerateObject266', systemGenerateObject266)
            const localVarPath = `/jumpWeapp/listJumpWeapp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject266, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取跳转小程序列表(分页)
         * @param {SystemGenerateObject267} systemGenerateObject267 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageJumpWeappjumpWeapp: async (systemGenerateObject267: SystemGenerateObject267, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject267' is not null or undefined
            assertParamExists('pageJumpWeappjumpWeapp', 'systemGenerateObject267', systemGenerateObject267)
            const localVarPath = `/jumpWeapp/pageJumpWeapp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject267, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新跳转小程序
         * @param {SystemGenerateObject269} systemGenerateObject269 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJumpWeappjumpWeapp: async (systemGenerateObject269: SystemGenerateObject269, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject269' is not null or undefined
            assertParamExists('updateJumpWeappjumpWeapp', 'systemGenerateObject269', systemGenerateObject269)
            const localVarPath = `/jumpWeapp/updateJumpWeapp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject269, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JumpWeappApi - functional programming interface
 * @export
 */
export const JumpWeappApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JumpWeappApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加跳转小程序
         * @param {SystemGenerateObject268} systemGenerateObject268 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addJumpWeappjumpWeapp(systemGenerateObject268: SystemGenerateObject268, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addJumpWeappjumpWeapp(systemGenerateObject268, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除跳转小程序
         * @param {number} jumpWeappId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delJumpWeappjumpWeapp(jumpWeappId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delJumpWeappjumpWeapp(jumpWeappId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取跳转小程序列表
         * @param {SystemGenerateObject266} systemGenerateObject266 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listJumpWeappjumpWeapp(systemGenerateObject266: SystemGenerateObject266, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listJumpWeappjumpWeapp(systemGenerateObject266, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取跳转小程序列表(分页)
         * @param {SystemGenerateObject267} systemGenerateObject267 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageJumpWeappjumpWeapp(systemGenerateObject267: SystemGenerateObject267, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageJumpWeappjumpWeapp(systemGenerateObject267, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新跳转小程序
         * @param {SystemGenerateObject269} systemGenerateObject269 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateJumpWeappjumpWeapp(systemGenerateObject269: SystemGenerateObject269, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateJumpWeappjumpWeapp(systemGenerateObject269, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * JumpWeappApi - factory interface
 * @export
 */
export const JumpWeappApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JumpWeappApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加跳转小程序
         * @param {SystemGenerateObject268} systemGenerateObject268 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addJumpWeappjumpWeapp(systemGenerateObject268: SystemGenerateObject268, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addJumpWeappjumpWeapp(systemGenerateObject268, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除跳转小程序
         * @param {number} jumpWeappId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delJumpWeappjumpWeapp(jumpWeappId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delJumpWeappjumpWeapp(jumpWeappId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取跳转小程序列表
         * @param {SystemGenerateObject266} systemGenerateObject266 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJumpWeappjumpWeapp(systemGenerateObject266: SystemGenerateObject266, options?: any): AxiosPromise<any> {
            return localVarFp.listJumpWeappjumpWeapp(systemGenerateObject266, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取跳转小程序列表(分页)
         * @param {SystemGenerateObject267} systemGenerateObject267 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageJumpWeappjumpWeapp(systemGenerateObject267: SystemGenerateObject267, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageJumpWeappjumpWeapp(systemGenerateObject267, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新跳转小程序
         * @param {SystemGenerateObject269} systemGenerateObject269 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJumpWeappjumpWeapp(systemGenerateObject269: SystemGenerateObject269, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateJumpWeappjumpWeapp(systemGenerateObject269, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JumpWeappApi - object-oriented interface
 * @export
 * @class JumpWeappApi
 * @extends {BaseAPI}
 */
export class JumpWeappApi extends BaseAPI {
    /**
     * 
     * @summary 添加跳转小程序
     * @param {SystemGenerateObject268} systemGenerateObject268 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JumpWeappApi
     */
    public addJumpWeappjumpWeapp(systemGenerateObject268: SystemGenerateObject268, options?: AxiosRequestConfig) {
        return JumpWeappApiFp(this.configuration).addJumpWeappjumpWeapp(systemGenerateObject268, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除跳转小程序
     * @param {number} jumpWeappId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JumpWeappApi
     */
    public delJumpWeappjumpWeapp(jumpWeappId: number, options?: AxiosRequestConfig) {
        return JumpWeappApiFp(this.configuration).delJumpWeappjumpWeapp(jumpWeappId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取跳转小程序列表
     * @param {SystemGenerateObject266} systemGenerateObject266 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JumpWeappApi
     */
    public listJumpWeappjumpWeapp(systemGenerateObject266: SystemGenerateObject266, options?: AxiosRequestConfig) {
        return JumpWeappApiFp(this.configuration).listJumpWeappjumpWeapp(systemGenerateObject266, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取跳转小程序列表(分页)
     * @param {SystemGenerateObject267} systemGenerateObject267 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JumpWeappApi
     */
    public pageJumpWeappjumpWeapp(systemGenerateObject267: SystemGenerateObject267, options?: AxiosRequestConfig) {
        return JumpWeappApiFp(this.configuration).pageJumpWeappjumpWeapp(systemGenerateObject267, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新跳转小程序
     * @param {SystemGenerateObject269} systemGenerateObject269 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JumpWeappApi
     */
    public updateJumpWeappjumpWeapp(systemGenerateObject269: SystemGenerateObject269, options?: AxiosRequestConfig) {
        return JumpWeappApiFp(this.configuration).updateJumpWeappjumpWeapp(systemGenerateObject269, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MemberApi - axios parameter creator
 * @export
 */
export const MemberApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加会员
         * @param {SystemGenerateObject201} systemGenerateObject201 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMembermember: async (systemGenerateObject201: SystemGenerateObject201, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject201' is not null or undefined
            assertParamExists('addMembermember', 'systemGenerateObject201', systemGenerateObject201)
            const localVarPath = `/member/addMember`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject201, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除会员
         * @param {number} memberId 
         * @param {MEMBERTYPEE} [memberType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delMembermember: async (memberId: number, memberType?: MEMBERTYPEE, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('delMembermember', 'memberId', memberId)
            const localVarPath = `/member/delMember`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (memberId !== undefined) {
                localVarQueryParameter['memberId'] = memberId;
            }

            if (memberType !== undefined) {
                localVarQueryParameter['memberType'] = memberType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取会员列表
         * @param {SystemGenerateObject199} systemGenerateObject199 
         * @param {string} [nameOrPhone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMembermember: async (systemGenerateObject199: SystemGenerateObject199, nameOrPhone?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject199' is not null or undefined
            assertParamExists('listMembermember', 'systemGenerateObject199', systemGenerateObject199)
            const localVarPath = `/member/listMember`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (nameOrPhone !== undefined) {
                localVarQueryParameter['nameOrPhone'] = nameOrPhone;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject199, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取门店会员列表
         * @param {number} storeId 
         * @param {string} [nameOrPhone] 
         * @param {MEMBERTYPEE} [memberType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStoreMembermember: async (storeId: number, nameOrPhone?: string, memberType?: MEMBERTYPEE, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('listStoreMembermember', 'storeId', storeId)
            const localVarPath = `/member/listStoreMember`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (nameOrPhone !== undefined) {
                localVarQueryParameter['nameOrPhone'] = nameOrPhone;
            }

            if (memberType !== undefined) {
                localVarQueryParameter['memberType'] = memberType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取会员列表(分页)
         * @param {SystemGenerateObject200} systemGenerateObject200 
         * @param {string} [nameOrPhone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageMembermember: async (systemGenerateObject200: SystemGenerateObject200, nameOrPhone?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject200' is not null or undefined
            assertParamExists('pageMembermember', 'systemGenerateObject200', systemGenerateObject200)
            const localVarPath = `/member/pageMember`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (nameOrPhone !== undefined) {
                localVarQueryParameter['nameOrPhone'] = nameOrPhone;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject200, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新会员
         * @param {SystemGenerateObject202} systemGenerateObject202 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMembermember: async (systemGenerateObject202: SystemGenerateObject202, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject202' is not null or undefined
            assertParamExists('updateMembermember', 'systemGenerateObject202', systemGenerateObject202)
            const localVarPath = `/member/updateMember`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject202, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MemberApi - functional programming interface
 * @export
 */
export const MemberApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MemberApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加会员
         * @param {SystemGenerateObject201} systemGenerateObject201 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addMembermember(systemGenerateObject201: SystemGenerateObject201, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addMembermember(systemGenerateObject201, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除会员
         * @param {number} memberId 
         * @param {MEMBERTYPEE} [memberType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delMembermember(memberId: number, memberType?: MEMBERTYPEE, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delMembermember(memberId, memberType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取会员列表
         * @param {SystemGenerateObject199} systemGenerateObject199 
         * @param {string} [nameOrPhone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMembermember(systemGenerateObject199: SystemGenerateObject199, nameOrPhone?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMembermember(systemGenerateObject199, nameOrPhone, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取门店会员列表
         * @param {number} storeId 
         * @param {string} [nameOrPhone] 
         * @param {MEMBERTYPEE} [memberType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listStoreMembermember(storeId: number, nameOrPhone?: string, memberType?: MEMBERTYPEE, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listStoreMembermember(storeId, nameOrPhone, memberType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取会员列表(分页)
         * @param {SystemGenerateObject200} systemGenerateObject200 
         * @param {string} [nameOrPhone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageMembermember(systemGenerateObject200: SystemGenerateObject200, nameOrPhone?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageMembermember(systemGenerateObject200, nameOrPhone, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新会员
         * @param {SystemGenerateObject202} systemGenerateObject202 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMembermember(systemGenerateObject202: SystemGenerateObject202, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMembermember(systemGenerateObject202, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MemberApi - factory interface
 * @export
 */
export const MemberApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MemberApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加会员
         * @param {SystemGenerateObject201} systemGenerateObject201 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMembermember(systemGenerateObject201: SystemGenerateObject201, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addMembermember(systemGenerateObject201, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除会员
         * @param {number} memberId 
         * @param {MEMBERTYPEE} [memberType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delMembermember(memberId: number, memberType?: MEMBERTYPEE, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delMembermember(memberId, memberType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取会员列表
         * @param {SystemGenerateObject199} systemGenerateObject199 
         * @param {string} [nameOrPhone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMembermember(systemGenerateObject199: SystemGenerateObject199, nameOrPhone?: string, options?: any): AxiosPromise<any> {
            return localVarFp.listMembermember(systemGenerateObject199, nameOrPhone, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取门店会员列表
         * @param {number} storeId 
         * @param {string} [nameOrPhone] 
         * @param {MEMBERTYPEE} [memberType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStoreMembermember(storeId: number, nameOrPhone?: string, memberType?: MEMBERTYPEE, options?: any): AxiosPromise<any> {
            return localVarFp.listStoreMembermember(storeId, nameOrPhone, memberType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取会员列表(分页)
         * @param {SystemGenerateObject200} systemGenerateObject200 
         * @param {string} [nameOrPhone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageMembermember(systemGenerateObject200: SystemGenerateObject200, nameOrPhone?: string, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageMembermember(systemGenerateObject200, nameOrPhone, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新会员
         * @param {SystemGenerateObject202} systemGenerateObject202 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMembermember(systemGenerateObject202: SystemGenerateObject202, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateMembermember(systemGenerateObject202, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MemberApi - object-oriented interface
 * @export
 * @class MemberApi
 * @extends {BaseAPI}
 */
export class MemberApi extends BaseAPI {
    /**
     * 
     * @summary 添加会员
     * @param {SystemGenerateObject201} systemGenerateObject201 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public addMembermember(systemGenerateObject201: SystemGenerateObject201, options?: AxiosRequestConfig) {
        return MemberApiFp(this.configuration).addMembermember(systemGenerateObject201, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除会员
     * @param {number} memberId 
     * @param {MEMBERTYPEE} [memberType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public delMembermember(memberId: number, memberType?: MEMBERTYPEE, options?: AxiosRequestConfig) {
        return MemberApiFp(this.configuration).delMembermember(memberId, memberType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取会员列表
     * @param {SystemGenerateObject199} systemGenerateObject199 
     * @param {string} [nameOrPhone] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public listMembermember(systemGenerateObject199: SystemGenerateObject199, nameOrPhone?: string, options?: AxiosRequestConfig) {
        return MemberApiFp(this.configuration).listMembermember(systemGenerateObject199, nameOrPhone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取门店会员列表
     * @param {number} storeId 
     * @param {string} [nameOrPhone] 
     * @param {MEMBERTYPEE} [memberType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public listStoreMembermember(storeId: number, nameOrPhone?: string, memberType?: MEMBERTYPEE, options?: AxiosRequestConfig) {
        return MemberApiFp(this.configuration).listStoreMembermember(storeId, nameOrPhone, memberType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取会员列表(分页)
     * @param {SystemGenerateObject200} systemGenerateObject200 
     * @param {string} [nameOrPhone] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public pageMembermember(systemGenerateObject200: SystemGenerateObject200, nameOrPhone?: string, options?: AxiosRequestConfig) {
        return MemberApiFp(this.configuration).pageMembermember(systemGenerateObject200, nameOrPhone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新会员
     * @param {SystemGenerateObject202} systemGenerateObject202 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    public updateMembermember(systemGenerateObject202: SystemGenerateObject202, options?: AxiosRequestConfig) {
        return MemberApiFp(this.configuration).updateMembermember(systemGenerateObject202, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MessageApi - axios parameter creator
 * @export
 */
export const MessageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 微信开放平台第三方平台事件通知
         * @param {string} appid 
         * @param {SystemGenerateObject94} systemGenerateObject94 
         * @param {string} [timestamp] 
         * @param {string} [nonce] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mpmessage: async (appid: string, systemGenerateObject94: SystemGenerateObject94, timestamp?: string, nonce?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appid' is not null or undefined
            assertParamExists('mpmessage', 'appid', appid)
            // verify required parameter 'systemGenerateObject94' is not null or undefined
            assertParamExists('mpmessage', 'systemGenerateObject94', systemGenerateObject94)
            const localVarPath = `/message/mp/{appid}`
                .replace(`{${"appid"}}`, encodeURIComponent(String(appid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (timestamp !== undefined) {
                localVarQueryParameter['timestamp'] = timestamp;
            }

            if (nonce !== undefined) {
                localVarQueryParameter['nonce'] = nonce;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject94, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 微信开放平台事件通知
         * @param {SystemGenerateObject93} systemGenerateObject93 
         * @param {string} [timestamp] 
         * @param {string} [nonce] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openwxmessage: async (systemGenerateObject93: SystemGenerateObject93, timestamp?: string, nonce?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject93' is not null or undefined
            assertParamExists('openwxmessage', 'systemGenerateObject93', systemGenerateObject93)
            const localVarPath = `/message/openwx`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (timestamp !== undefined) {
                localVarQueryParameter['timestamp'] = timestamp;
            }

            if (nonce !== undefined) {
                localVarQueryParameter['nonce'] = nonce;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject93, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MessageApi - functional programming interface
 * @export
 */
export const MessageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MessageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 微信开放平台第三方平台事件通知
         * @param {string} appid 
         * @param {SystemGenerateObject94} systemGenerateObject94 
         * @param {string} [timestamp] 
         * @param {string} [nonce] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mpmessage(appid: string, systemGenerateObject94: SystemGenerateObject94, timestamp?: string, nonce?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mpmessage(appid, systemGenerateObject94, timestamp, nonce, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 微信开放平台事件通知
         * @param {SystemGenerateObject93} systemGenerateObject93 
         * @param {string} [timestamp] 
         * @param {string} [nonce] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openwxmessage(systemGenerateObject93: SystemGenerateObject93, timestamp?: string, nonce?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openwxmessage(systemGenerateObject93, timestamp, nonce, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MessageApi - factory interface
 * @export
 */
export const MessageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MessageApiFp(configuration)
    return {
        /**
         * 
         * @summary 微信开放平台第三方平台事件通知
         * @param {string} appid 
         * @param {SystemGenerateObject94} systemGenerateObject94 
         * @param {string} [timestamp] 
         * @param {string} [nonce] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mpmessage(appid: string, systemGenerateObject94: SystemGenerateObject94, timestamp?: string, nonce?: string, options?: any): AxiosPromise<string> {
            return localVarFp.mpmessage(appid, systemGenerateObject94, timestamp, nonce, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 微信开放平台事件通知
         * @param {SystemGenerateObject93} systemGenerateObject93 
         * @param {string} [timestamp] 
         * @param {string} [nonce] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openwxmessage(systemGenerateObject93: SystemGenerateObject93, timestamp?: string, nonce?: string, options?: any): AxiosPromise<string> {
            return localVarFp.openwxmessage(systemGenerateObject93, timestamp, nonce, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MessageApi - object-oriented interface
 * @export
 * @class MessageApi
 * @extends {BaseAPI}
 */
export class MessageApi extends BaseAPI {
    /**
     * 
     * @summary 微信开放平台第三方平台事件通知
     * @param {string} appid 
     * @param {SystemGenerateObject94} systemGenerateObject94 
     * @param {string} [timestamp] 
     * @param {string} [nonce] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public mpmessage(appid: string, systemGenerateObject94: SystemGenerateObject94, timestamp?: string, nonce?: string, options?: AxiosRequestConfig) {
        return MessageApiFp(this.configuration).mpmessage(appid, systemGenerateObject94, timestamp, nonce, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 微信开放平台事件通知
     * @param {SystemGenerateObject93} systemGenerateObject93 
     * @param {string} [timestamp] 
     * @param {string} [nonce] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public openwxmessage(systemGenerateObject93: SystemGenerateObject93, timestamp?: string, nonce?: string, options?: AxiosRequestConfig) {
        return MessageApiFp(this.configuration).openwxmessage(systemGenerateObject93, timestamp, nonce, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PackageApi - axios parameter creator
 * @export
 */
export const PackageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加套餐
         * @param {SystemGenerateObject196} systemGenerateObject196 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPackagepackage: async (systemGenerateObject196: SystemGenerateObject196, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject196' is not null or undefined
            assertParamExists('addPackagepackage', 'systemGenerateObject196', systemGenerateObject196)
            const localVarPath = `/package/addPackage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject196, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除套餐
         * @param {number} packageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delPackagepackage: async (packageId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'packageId' is not null or undefined
            assertParamExists('delPackagepackage', 'packageId', packageId)
            const localVarPath = `/package/delPackage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (packageId !== undefined) {
                localVarQueryParameter['packageId'] = packageId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取套餐列表
         * @param {SystemGenerateObject194} systemGenerateObject194 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPackagepackage: async (systemGenerateObject194: SystemGenerateObject194, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject194' is not null or undefined
            assertParamExists('listPackagepackage', 'systemGenerateObject194', systemGenerateObject194)
            const localVarPath = `/package/listPackage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject194, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取套餐列表(分页)
         * @param {SystemGenerateObject195} systemGenerateObject195 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePackagepackage: async (systemGenerateObject195: SystemGenerateObject195, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject195' is not null or undefined
            assertParamExists('pagePackagepackage', 'systemGenerateObject195', systemGenerateObject195)
            const localVarPath = `/package/pagePackage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject195, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 充值
         * @param {SystemGenerateObject198} systemGenerateObject198 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rechargepackage: async (systemGenerateObject198: SystemGenerateObject198, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject198' is not null or undefined
            assertParamExists('rechargepackage', 'systemGenerateObject198', systemGenerateObject198)
            const localVarPath = `/package/recharge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject198, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新套餐
         * @param {SystemGenerateObject197} systemGenerateObject197 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePackagepackage: async (systemGenerateObject197: SystemGenerateObject197, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject197' is not null or undefined
            assertParamExists('updatePackagepackage', 'systemGenerateObject197', systemGenerateObject197)
            const localVarPath = `/package/updatePackage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject197, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PackageApi - functional programming interface
 * @export
 */
export const PackageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PackageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加套餐
         * @param {SystemGenerateObject196} systemGenerateObject196 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPackagepackage(systemGenerateObject196: SystemGenerateObject196, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPackagepackage(systemGenerateObject196, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除套餐
         * @param {number} packageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delPackagepackage(packageId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delPackagepackage(packageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取套餐列表
         * @param {SystemGenerateObject194} systemGenerateObject194 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPackagepackage(systemGenerateObject194: SystemGenerateObject194, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPackagepackage(systemGenerateObject194, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取套餐列表(分页)
         * @param {SystemGenerateObject195} systemGenerateObject195 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pagePackagepackage(systemGenerateObject195: SystemGenerateObject195, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pagePackagepackage(systemGenerateObject195, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 充值
         * @param {SystemGenerateObject198} systemGenerateObject198 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rechargepackage(systemGenerateObject198: SystemGenerateObject198, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rechargepackage(systemGenerateObject198, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新套餐
         * @param {SystemGenerateObject197} systemGenerateObject197 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePackagepackage(systemGenerateObject197: SystemGenerateObject197, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePackagepackage(systemGenerateObject197, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PackageApi - factory interface
 * @export
 */
export const PackageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PackageApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加套餐
         * @param {SystemGenerateObject196} systemGenerateObject196 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPackagepackage(systemGenerateObject196: SystemGenerateObject196, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addPackagepackage(systemGenerateObject196, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除套餐
         * @param {number} packageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delPackagepackage(packageId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delPackagepackage(packageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取套餐列表
         * @param {SystemGenerateObject194} systemGenerateObject194 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPackagepackage(systemGenerateObject194: SystemGenerateObject194, options?: any): AxiosPromise<any> {
            return localVarFp.listPackagepackage(systemGenerateObject194, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取套餐列表(分页)
         * @param {SystemGenerateObject195} systemGenerateObject195 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePackagepackage(systemGenerateObject195: SystemGenerateObject195, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pagePackagepackage(systemGenerateObject195, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 充值
         * @param {SystemGenerateObject198} systemGenerateObject198 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rechargepackage(systemGenerateObject198: SystemGenerateObject198, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.rechargepackage(systemGenerateObject198, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新套餐
         * @param {SystemGenerateObject197} systemGenerateObject197 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePackagepackage(systemGenerateObject197: SystemGenerateObject197, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updatePackagepackage(systemGenerateObject197, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PackageApi - object-oriented interface
 * @export
 * @class PackageApi
 * @extends {BaseAPI}
 */
export class PackageApi extends BaseAPI {
    /**
     * 
     * @summary 添加套餐
     * @param {SystemGenerateObject196} systemGenerateObject196 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageApi
     */
    public addPackagepackage(systemGenerateObject196: SystemGenerateObject196, options?: AxiosRequestConfig) {
        return PackageApiFp(this.configuration).addPackagepackage(systemGenerateObject196, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除套餐
     * @param {number} packageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageApi
     */
    public delPackagepackage(packageId: number, options?: AxiosRequestConfig) {
        return PackageApiFp(this.configuration).delPackagepackage(packageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取套餐列表
     * @param {SystemGenerateObject194} systemGenerateObject194 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageApi
     */
    public listPackagepackage(systemGenerateObject194: SystemGenerateObject194, options?: AxiosRequestConfig) {
        return PackageApiFp(this.configuration).listPackagepackage(systemGenerateObject194, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取套餐列表(分页)
     * @param {SystemGenerateObject195} systemGenerateObject195 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageApi
     */
    public pagePackagepackage(systemGenerateObject195: SystemGenerateObject195, options?: AxiosRequestConfig) {
        return PackageApiFp(this.configuration).pagePackagepackage(systemGenerateObject195, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 充值
     * @param {SystemGenerateObject198} systemGenerateObject198 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageApi
     */
    public rechargepackage(systemGenerateObject198: SystemGenerateObject198, options?: AxiosRequestConfig) {
        return PackageApiFp(this.configuration).rechargepackage(systemGenerateObject198, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新套餐
     * @param {SystemGenerateObject197} systemGenerateObject197 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageApi
     */
    public updatePackagepackage(systemGenerateObject197: SystemGenerateObject197, options?: AxiosRequestConfig) {
        return PackageApiFp(this.configuration).updatePackagepackage(systemGenerateObject197, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PackageRecordApi - axios parameter creator
 * @export
 */
export const PackageRecordApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加包月套餐流水
         * @param {SystemGenerateObject235} systemGenerateObject235 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPackageRecordpackageRecord: async (systemGenerateObject235: SystemGenerateObject235, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject235' is not null or undefined
            assertParamExists('addPackageRecordpackageRecord', 'systemGenerateObject235', systemGenerateObject235)
            const localVarPath = `/packageRecord/addPackageRecord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject235, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除包月套餐流水
         * @param {number} packageRecordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delPackageRecordpackageRecord: async (packageRecordId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'packageRecordId' is not null or undefined
            assertParamExists('delPackageRecordpackageRecord', 'packageRecordId', packageRecordId)
            const localVarPath = `/packageRecord/delPackageRecord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (packageRecordId !== undefined) {
                localVarQueryParameter['packageRecordId'] = packageRecordId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取包月套餐流水
         * @param {SystemGenerateObject232} systemGenerateObject232 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPackageRecordpackageRecord: async (systemGenerateObject232: SystemGenerateObject232, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject232' is not null or undefined
            assertParamExists('findPackageRecordpackageRecord', 'systemGenerateObject232', systemGenerateObject232)
            const localVarPath = `/packageRecord/findPackageRecord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject232, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取包月套餐流水列表
         * @param {SystemGenerateObject233} systemGenerateObject233 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPackageRecordpackageRecord: async (systemGenerateObject233: SystemGenerateObject233, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject233' is not null or undefined
            assertParamExists('listPackageRecordpackageRecord', 'systemGenerateObject233', systemGenerateObject233)
            const localVarPath = `/packageRecord/listPackageRecord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject233, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取包月套餐流水列表(分页)
         * @param {SystemGenerateObject234} systemGenerateObject234 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePackageRecordpackageRecord: async (systemGenerateObject234: SystemGenerateObject234, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject234' is not null or undefined
            assertParamExists('pagePackageRecordpackageRecord', 'systemGenerateObject234', systemGenerateObject234)
            const localVarPath = `/packageRecord/pagePackageRecord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject234, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新包月套餐流水
         * @param {SystemGenerateObject236} systemGenerateObject236 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePackageRecordpackageRecord: async (systemGenerateObject236: SystemGenerateObject236, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject236' is not null or undefined
            assertParamExists('updatePackageRecordpackageRecord', 'systemGenerateObject236', systemGenerateObject236)
            const localVarPath = `/packageRecord/updatePackageRecord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject236, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PackageRecordApi - functional programming interface
 * @export
 */
export const PackageRecordApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PackageRecordApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加包月套餐流水
         * @param {SystemGenerateObject235} systemGenerateObject235 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPackageRecordpackageRecord(systemGenerateObject235: SystemGenerateObject235, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPackageRecordpackageRecord(systemGenerateObject235, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除包月套餐流水
         * @param {number} packageRecordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delPackageRecordpackageRecord(packageRecordId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delPackageRecordpackageRecord(packageRecordId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取包月套餐流水
         * @param {SystemGenerateObject232} systemGenerateObject232 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findPackageRecordpackageRecord(systemGenerateObject232: SystemGenerateObject232, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findPackageRecordpackageRecord(systemGenerateObject232, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取包月套餐流水列表
         * @param {SystemGenerateObject233} systemGenerateObject233 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPackageRecordpackageRecord(systemGenerateObject233: SystemGenerateObject233, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPackageRecordpackageRecord(systemGenerateObject233, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取包月套餐流水列表(分页)
         * @param {SystemGenerateObject234} systemGenerateObject234 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pagePackageRecordpackageRecord(systemGenerateObject234: SystemGenerateObject234, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pagePackageRecordpackageRecord(systemGenerateObject234, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新包月套餐流水
         * @param {SystemGenerateObject236} systemGenerateObject236 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePackageRecordpackageRecord(systemGenerateObject236: SystemGenerateObject236, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePackageRecordpackageRecord(systemGenerateObject236, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PackageRecordApi - factory interface
 * @export
 */
export const PackageRecordApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PackageRecordApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加包月套餐流水
         * @param {SystemGenerateObject235} systemGenerateObject235 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPackageRecordpackageRecord(systemGenerateObject235: SystemGenerateObject235, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addPackageRecordpackageRecord(systemGenerateObject235, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除包月套餐流水
         * @param {number} packageRecordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delPackageRecordpackageRecord(packageRecordId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delPackageRecordpackageRecord(packageRecordId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取包月套餐流水
         * @param {SystemGenerateObject232} systemGenerateObject232 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPackageRecordpackageRecord(systemGenerateObject232: SystemGenerateObject232, options?: any): AxiosPromise<any> {
            return localVarFp.findPackageRecordpackageRecord(systemGenerateObject232, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取包月套餐流水列表
         * @param {SystemGenerateObject233} systemGenerateObject233 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPackageRecordpackageRecord(systemGenerateObject233: SystemGenerateObject233, options?: any): AxiosPromise<any> {
            return localVarFp.listPackageRecordpackageRecord(systemGenerateObject233, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取包月套餐流水列表(分页)
         * @param {SystemGenerateObject234} systemGenerateObject234 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pagePackageRecordpackageRecord(systemGenerateObject234: SystemGenerateObject234, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pagePackageRecordpackageRecord(systemGenerateObject234, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新包月套餐流水
         * @param {SystemGenerateObject236} systemGenerateObject236 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePackageRecordpackageRecord(systemGenerateObject236: SystemGenerateObject236, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updatePackageRecordpackageRecord(systemGenerateObject236, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PackageRecordApi - object-oriented interface
 * @export
 * @class PackageRecordApi
 * @extends {BaseAPI}
 */
export class PackageRecordApi extends BaseAPI {
    /**
     * 
     * @summary 添加包月套餐流水
     * @param {SystemGenerateObject235} systemGenerateObject235 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageRecordApi
     */
    public addPackageRecordpackageRecord(systemGenerateObject235: SystemGenerateObject235, options?: AxiosRequestConfig) {
        return PackageRecordApiFp(this.configuration).addPackageRecordpackageRecord(systemGenerateObject235, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除包月套餐流水
     * @param {number} packageRecordId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageRecordApi
     */
    public delPackageRecordpackageRecord(packageRecordId: number, options?: AxiosRequestConfig) {
        return PackageRecordApiFp(this.configuration).delPackageRecordpackageRecord(packageRecordId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取包月套餐流水
     * @param {SystemGenerateObject232} systemGenerateObject232 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageRecordApi
     */
    public findPackageRecordpackageRecord(systemGenerateObject232: SystemGenerateObject232, options?: AxiosRequestConfig) {
        return PackageRecordApiFp(this.configuration).findPackageRecordpackageRecord(systemGenerateObject232, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取包月套餐流水列表
     * @param {SystemGenerateObject233} systemGenerateObject233 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageRecordApi
     */
    public listPackageRecordpackageRecord(systemGenerateObject233: SystemGenerateObject233, options?: AxiosRequestConfig) {
        return PackageRecordApiFp(this.configuration).listPackageRecordpackageRecord(systemGenerateObject233, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取包月套餐流水列表(分页)
     * @param {SystemGenerateObject234} systemGenerateObject234 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageRecordApi
     */
    public pagePackageRecordpackageRecord(systemGenerateObject234: SystemGenerateObject234, options?: AxiosRequestConfig) {
        return PackageRecordApiFp(this.configuration).pagePackageRecordpackageRecord(systemGenerateObject234, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新包月套餐流水
     * @param {SystemGenerateObject236} systemGenerateObject236 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageRecordApi
     */
    public updatePackageRecordpackageRecord(systemGenerateObject236: SystemGenerateObject236, options?: AxiosRequestConfig) {
        return PackageRecordApiFp(this.configuration).updatePackageRecordpackageRecord(systemGenerateObject236, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RechargePlanApi - axios parameter creator
 * @export
 */
export const RechargePlanApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加充值套餐
         * @param {SystemGenerateObject205} systemGenerateObject205 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRechargePlanrechargePlan: async (systemGenerateObject205: SystemGenerateObject205, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject205' is not null or undefined
            assertParamExists('addRechargePlanrechargePlan', 'systemGenerateObject205', systemGenerateObject205)
            const localVarPath = `/rechargePlan/addRechargePlan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject205, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除充值套餐
         * @param {number} rechargePlanId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delRechargePlanrechargePlan: async (rechargePlanId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rechargePlanId' is not null or undefined
            assertParamExists('delRechargePlanrechargePlan', 'rechargePlanId', rechargePlanId)
            const localVarPath = `/rechargePlan/delRechargePlan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (rechargePlanId !== undefined) {
                localVarQueryParameter['rechargePlanId'] = rechargePlanId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取充值套餐列表
         * @param {SystemGenerateObject203} systemGenerateObject203 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRechargePlanrechargePlan: async (systemGenerateObject203: SystemGenerateObject203, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject203' is not null or undefined
            assertParamExists('listRechargePlanrechargePlan', 'systemGenerateObject203', systemGenerateObject203)
            const localVarPath = `/rechargePlan/listRechargePlan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject203, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取充值套餐列表(分页)
         * @param {SystemGenerateObject204} systemGenerateObject204 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRechargePlanrechargePlan: async (systemGenerateObject204: SystemGenerateObject204, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject204' is not null or undefined
            assertParamExists('pageRechargePlanrechargePlan', 'systemGenerateObject204', systemGenerateObject204)
            const localVarPath = `/rechargePlan/pageRechargePlan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject204, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新充值套餐
         * @param {SystemGenerateObject206} systemGenerateObject206 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRechargePlanrechargePlan: async (systemGenerateObject206: SystemGenerateObject206, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject206' is not null or undefined
            assertParamExists('updateRechargePlanrechargePlan', 'systemGenerateObject206', systemGenerateObject206)
            const localVarPath = `/rechargePlan/updateRechargePlan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject206, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RechargePlanApi - functional programming interface
 * @export
 */
export const RechargePlanApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RechargePlanApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加充值套餐
         * @param {SystemGenerateObject205} systemGenerateObject205 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addRechargePlanrechargePlan(systemGenerateObject205: SystemGenerateObject205, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addRechargePlanrechargePlan(systemGenerateObject205, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除充值套餐
         * @param {number} rechargePlanId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delRechargePlanrechargePlan(rechargePlanId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delRechargePlanrechargePlan(rechargePlanId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取充值套餐列表
         * @param {SystemGenerateObject203} systemGenerateObject203 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRechargePlanrechargePlan(systemGenerateObject203: SystemGenerateObject203, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRechargePlanrechargePlan(systemGenerateObject203, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取充值套餐列表(分页)
         * @param {SystemGenerateObject204} systemGenerateObject204 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageRechargePlanrechargePlan(systemGenerateObject204: SystemGenerateObject204, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageRechargePlanrechargePlan(systemGenerateObject204, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新充值套餐
         * @param {SystemGenerateObject206} systemGenerateObject206 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRechargePlanrechargePlan(systemGenerateObject206: SystemGenerateObject206, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRechargePlanrechargePlan(systemGenerateObject206, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RechargePlanApi - factory interface
 * @export
 */
export const RechargePlanApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RechargePlanApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加充值套餐
         * @param {SystemGenerateObject205} systemGenerateObject205 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRechargePlanrechargePlan(systemGenerateObject205: SystemGenerateObject205, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addRechargePlanrechargePlan(systemGenerateObject205, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除充值套餐
         * @param {number} rechargePlanId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delRechargePlanrechargePlan(rechargePlanId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delRechargePlanrechargePlan(rechargePlanId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取充值套餐列表
         * @param {SystemGenerateObject203} systemGenerateObject203 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRechargePlanrechargePlan(systemGenerateObject203: SystemGenerateObject203, options?: any): AxiosPromise<any> {
            return localVarFp.listRechargePlanrechargePlan(systemGenerateObject203, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取充值套餐列表(分页)
         * @param {SystemGenerateObject204} systemGenerateObject204 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRechargePlanrechargePlan(systemGenerateObject204: SystemGenerateObject204, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageRechargePlanrechargePlan(systemGenerateObject204, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新充值套餐
         * @param {SystemGenerateObject206} systemGenerateObject206 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRechargePlanrechargePlan(systemGenerateObject206: SystemGenerateObject206, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateRechargePlanrechargePlan(systemGenerateObject206, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RechargePlanApi - object-oriented interface
 * @export
 * @class RechargePlanApi
 * @extends {BaseAPI}
 */
export class RechargePlanApi extends BaseAPI {
    /**
     * 
     * @summary 添加充值套餐
     * @param {SystemGenerateObject205} systemGenerateObject205 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RechargePlanApi
     */
    public addRechargePlanrechargePlan(systemGenerateObject205: SystemGenerateObject205, options?: AxiosRequestConfig) {
        return RechargePlanApiFp(this.configuration).addRechargePlanrechargePlan(systemGenerateObject205, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除充值套餐
     * @param {number} rechargePlanId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RechargePlanApi
     */
    public delRechargePlanrechargePlan(rechargePlanId: number, options?: AxiosRequestConfig) {
        return RechargePlanApiFp(this.configuration).delRechargePlanrechargePlan(rechargePlanId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取充值套餐列表
     * @param {SystemGenerateObject203} systemGenerateObject203 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RechargePlanApi
     */
    public listRechargePlanrechargePlan(systemGenerateObject203: SystemGenerateObject203, options?: AxiosRequestConfig) {
        return RechargePlanApiFp(this.configuration).listRechargePlanrechargePlan(systemGenerateObject203, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取充值套餐列表(分页)
     * @param {SystemGenerateObject204} systemGenerateObject204 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RechargePlanApi
     */
    public pageRechargePlanrechargePlan(systemGenerateObject204: SystemGenerateObject204, options?: AxiosRequestConfig) {
        return RechargePlanApiFp(this.configuration).pageRechargePlanrechargePlan(systemGenerateObject204, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新充值套餐
     * @param {SystemGenerateObject206} systemGenerateObject206 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RechargePlanApi
     */
    public updateRechargePlanrechargePlan(systemGenerateObject206: SystemGenerateObject206, options?: AxiosRequestConfig) {
        return RechargePlanApiFp(this.configuration).updateRechargePlanrechargePlan(systemGenerateObject206, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RecordApi - axios parameter creator
 * @export
 */
export const RecordApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加记录
         * @param {SystemGenerateObject156} systemGenerateObject156 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRecordrecord: async (systemGenerateObject156: SystemGenerateObject156, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject156' is not null or undefined
            assertParamExists('addRecordrecord', 'systemGenerateObject156', systemGenerateObject156)
            const localVarPath = `/record/addRecord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject156, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除记录
         * @param {number} recordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delRecordrecord: async (recordId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('delRecordrecord', 'recordId', recordId)
            const localVarPath = `/record/delRecord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (recordId !== undefined) {
                localVarQueryParameter['recordId'] = recordId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取记录列表(管理员后台分页)
         * @param {SystemGenerateObject153} systemGenerateObject153 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageAdminRecordrecord: async (systemGenerateObject153: SystemGenerateObject153, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject153' is not null or undefined
            assertParamExists('pageAdminRecordrecord', 'systemGenerateObject153', systemGenerateObject153)
            const localVarPath = `/record/pageAdminRecord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject153, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取记录列表(商家端分页, 默认最近7天)
         * @param {SystemGenerateObject155} systemGenerateObject155 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOwnerStoreRecordrecord: async (systemGenerateObject155: SystemGenerateObject155, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject155' is not null or undefined
            assertParamExists('pageOwnerStoreRecordrecord', 'systemGenerateObject155', systemGenerateObject155)
            const localVarPath = `/record/pageOwnerStoreRecord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject155, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取记录列表(用户端分页，只能最近7天)
         * @param {SystemGenerateObject154} systemGenerateObject154 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUserRecordrecord: async (systemGenerateObject154: SystemGenerateObject154, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject154' is not null or undefined
            assertParamExists('pageUserRecordrecord', 'systemGenerateObject154', systemGenerateObject154)
            const localVarPath = `/record/pageUserRecord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject154, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新记录
         * @param {SystemGenerateObject157} systemGenerateObject157 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRecordrecord: async (systemGenerateObject157: SystemGenerateObject157, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject157' is not null or undefined
            assertParamExists('updateRecordrecord', 'systemGenerateObject157', systemGenerateObject157)
            const localVarPath = `/record/updateRecord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject157, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RecordApi - functional programming interface
 * @export
 */
export const RecordApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RecordApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加记录
         * @param {SystemGenerateObject156} systemGenerateObject156 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addRecordrecord(systemGenerateObject156: SystemGenerateObject156, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addRecordrecord(systemGenerateObject156, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除记录
         * @param {number} recordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delRecordrecord(recordId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delRecordrecord(recordId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取记录列表(管理员后台分页)
         * @param {SystemGenerateObject153} systemGenerateObject153 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageAdminRecordrecord(systemGenerateObject153: SystemGenerateObject153, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageAdminRecordrecord(systemGenerateObject153, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取记录列表(商家端分页, 默认最近7天)
         * @param {SystemGenerateObject155} systemGenerateObject155 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageOwnerStoreRecordrecord(systemGenerateObject155: SystemGenerateObject155, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageOwnerStoreRecordrecord(systemGenerateObject155, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取记录列表(用户端分页，只能最近7天)
         * @param {SystemGenerateObject154} systemGenerateObject154 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageUserRecordrecord(systemGenerateObject154: SystemGenerateObject154, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageUserRecordrecord(systemGenerateObject154, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新记录
         * @param {SystemGenerateObject157} systemGenerateObject157 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRecordrecord(systemGenerateObject157: SystemGenerateObject157, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRecordrecord(systemGenerateObject157, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RecordApi - factory interface
 * @export
 */
export const RecordApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RecordApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加记录
         * @param {SystemGenerateObject156} systemGenerateObject156 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRecordrecord(systemGenerateObject156: SystemGenerateObject156, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addRecordrecord(systemGenerateObject156, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除记录
         * @param {number} recordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delRecordrecord(recordId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delRecordrecord(recordId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取记录列表(管理员后台分页)
         * @param {SystemGenerateObject153} systemGenerateObject153 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageAdminRecordrecord(systemGenerateObject153: SystemGenerateObject153, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageAdminRecordrecord(systemGenerateObject153, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取记录列表(商家端分页, 默认最近7天)
         * @param {SystemGenerateObject155} systemGenerateObject155 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOwnerStoreRecordrecord(systemGenerateObject155: SystemGenerateObject155, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageOwnerStoreRecordrecord(systemGenerateObject155, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取记录列表(用户端分页，只能最近7天)
         * @param {SystemGenerateObject154} systemGenerateObject154 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUserRecordrecord(systemGenerateObject154: SystemGenerateObject154, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageUserRecordrecord(systemGenerateObject154, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新记录
         * @param {SystemGenerateObject157} systemGenerateObject157 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRecordrecord(systemGenerateObject157: SystemGenerateObject157, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateRecordrecord(systemGenerateObject157, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RecordApi - object-oriented interface
 * @export
 * @class RecordApi
 * @extends {BaseAPI}
 */
export class RecordApi extends BaseAPI {
    /**
     * 
     * @summary 添加记录
     * @param {SystemGenerateObject156} systemGenerateObject156 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecordApi
     */
    public addRecordrecord(systemGenerateObject156: SystemGenerateObject156, options?: AxiosRequestConfig) {
        return RecordApiFp(this.configuration).addRecordrecord(systemGenerateObject156, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除记录
     * @param {number} recordId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecordApi
     */
    public delRecordrecord(recordId: number, options?: AxiosRequestConfig) {
        return RecordApiFp(this.configuration).delRecordrecord(recordId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取记录列表(管理员后台分页)
     * @param {SystemGenerateObject153} systemGenerateObject153 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecordApi
     */
    public pageAdminRecordrecord(systemGenerateObject153: SystemGenerateObject153, options?: AxiosRequestConfig) {
        return RecordApiFp(this.configuration).pageAdminRecordrecord(systemGenerateObject153, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取记录列表(商家端分页, 默认最近7天)
     * @param {SystemGenerateObject155} systemGenerateObject155 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecordApi
     */
    public pageOwnerStoreRecordrecord(systemGenerateObject155: SystemGenerateObject155, options?: AxiosRequestConfig) {
        return RecordApiFp(this.configuration).pageOwnerStoreRecordrecord(systemGenerateObject155, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取记录列表(用户端分页，只能最近7天)
     * @param {SystemGenerateObject154} systemGenerateObject154 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecordApi
     */
    public pageUserRecordrecord(systemGenerateObject154: SystemGenerateObject154, options?: AxiosRequestConfig) {
        return RecordApiFp(this.configuration).pageUserRecordrecord(systemGenerateObject154, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新记录
     * @param {SystemGenerateObject157} systemGenerateObject157 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecordApi
     */
    public updateRecordrecord(systemGenerateObject157: SystemGenerateObject157, options?: AxiosRequestConfig) {
        return RecordApiFp(this.configuration).updateRecordrecord(systemGenerateObject157, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StationApi - axios parameter creator
 * @export
 */
export const StationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 添加驿站，可同时添加多个关联的驿站地址
         * @summary 添加驿站
         * @param {SystemGenerateObject239} systemGenerateObject239 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStationstation: async (systemGenerateObject239: SystemGenerateObject239, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject239' is not null or undefined
            assertParamExists('addStationstation', 'systemGenerateObject239', systemGenerateObject239)
            const localVarPath = `/station/addStation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject239, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 删除驿站，同时删除关联的驿站地址
         * @summary 删除驿站
         * @param {number} stationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delStationstation: async (stationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stationId' is not null or undefined
            assertParamExists('delStationstation', 'stationId', stationId)
            const localVarPath = `/station/delStation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stationId !== undefined) {
                localVarQueryParameter['stationId'] = stationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 根据驿站ID获取驿站详情，包括关联的驿站地址
         * @summary 获取驿站详情
         * @param {number} stationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStationDetailstation: async (stationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stationId' is not null or undefined
            assertParamExists('getStationDetailstation', 'stationId', stationId)
            const localVarPath = `/station/getStationDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stationId !== undefined) {
                localVarQueryParameter['stationId'] = stationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 获取驿站列表，包括关联的驿站地址
         * @summary 获取驿站列表
         * @param {SystemGenerateObject237} systemGenerateObject237 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStationstation: async (systemGenerateObject237: SystemGenerateObject237, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject237' is not null or undefined
            assertParamExists('listStationstation', 'systemGenerateObject237', systemGenerateObject237)
            const localVarPath = `/station/listStation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject237, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 获取驿站列表(分页)，包括关联的驿站地址
         * @summary 获取驿站列表(分页)
         * @param {SystemGenerateObject238} systemGenerateObject238 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageStationstation: async (systemGenerateObject238: SystemGenerateObject238, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject238' is not null or undefined
            assertParamExists('pageStationstation', 'systemGenerateObject238', systemGenerateObject238)
            const localVarPath = `/station/pageStation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject238, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 更新驿站，可同时更新、添加或删除关联的驿站地址
         * @summary 更新驿站
         * @param {SystemGenerateObject240} systemGenerateObject240 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStationstation: async (systemGenerateObject240: SystemGenerateObject240, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject240' is not null or undefined
            assertParamExists('updateStationstation', 'systemGenerateObject240', systemGenerateObject240)
            const localVarPath = `/station/updateStation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject240, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StationApi - functional programming interface
 * @export
 */
export const StationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StationApiAxiosParamCreator(configuration)
    return {
        /**
         * 添加驿站，可同时添加多个关联的驿站地址
         * @summary 添加驿站
         * @param {SystemGenerateObject239} systemGenerateObject239 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addStationstation(systemGenerateObject239: SystemGenerateObject239, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addStationstation(systemGenerateObject239, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 删除驿站，同时删除关联的驿站地址
         * @summary 删除驿站
         * @param {number} stationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delStationstation(stationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delStationstation(stationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 根据驿站ID获取驿站详情，包括关联的驿站地址
         * @summary 获取驿站详情
         * @param {number} stationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStationDetailstation(stationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStationDetailstation(stationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 获取驿站列表，包括关联的驿站地址
         * @summary 获取驿站列表
         * @param {SystemGenerateObject237} systemGenerateObject237 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listStationstation(systemGenerateObject237: SystemGenerateObject237, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listStationstation(systemGenerateObject237, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 获取驿站列表(分页)，包括关联的驿站地址
         * @summary 获取驿站列表(分页)
         * @param {SystemGenerateObject238} systemGenerateObject238 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageStationstation(systemGenerateObject238: SystemGenerateObject238, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageStationstation(systemGenerateObject238, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 更新驿站，可同时更新、添加或删除关联的驿站地址
         * @summary 更新驿站
         * @param {SystemGenerateObject240} systemGenerateObject240 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStationstation(systemGenerateObject240: SystemGenerateObject240, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStationstation(systemGenerateObject240, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StationApi - factory interface
 * @export
 */
export const StationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StationApiFp(configuration)
    return {
        /**
         * 添加驿站，可同时添加多个关联的驿站地址
         * @summary 添加驿站
         * @param {SystemGenerateObject239} systemGenerateObject239 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStationstation(systemGenerateObject239: SystemGenerateObject239, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addStationstation(systemGenerateObject239, options).then((request) => request(axios, basePath));
        },
        /**
         * 删除驿站，同时删除关联的驿站地址
         * @summary 删除驿站
         * @param {number} stationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delStationstation(stationId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delStationstation(stationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 根据驿站ID获取驿站详情，包括关联的驿站地址
         * @summary 获取驿站详情
         * @param {number} stationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStationDetailstation(stationId: number, options?: any): AxiosPromise<any> {
            return localVarFp.getStationDetailstation(stationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 获取驿站列表，包括关联的驿站地址
         * @summary 获取驿站列表
         * @param {SystemGenerateObject237} systemGenerateObject237 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStationstation(systemGenerateObject237: SystemGenerateObject237, options?: any): AxiosPromise<any> {
            return localVarFp.listStationstation(systemGenerateObject237, options).then((request) => request(axios, basePath));
        },
        /**
         * 获取驿站列表(分页)，包括关联的驿站地址
         * @summary 获取驿站列表(分页)
         * @param {SystemGenerateObject238} systemGenerateObject238 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageStationstation(systemGenerateObject238: SystemGenerateObject238, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageStationstation(systemGenerateObject238, options).then((request) => request(axios, basePath));
        },
        /**
         * 更新驿站，可同时更新、添加或删除关联的驿站地址
         * @summary 更新驿站
         * @param {SystemGenerateObject240} systemGenerateObject240 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStationstation(systemGenerateObject240: SystemGenerateObject240, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateStationstation(systemGenerateObject240, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StationApi - object-oriented interface
 * @export
 * @class StationApi
 * @extends {BaseAPI}
 */
export class StationApi extends BaseAPI {
    /**
     * 添加驿站，可同时添加多个关联的驿站地址
     * @summary 添加驿站
     * @param {SystemGenerateObject239} systemGenerateObject239 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationApi
     */
    public addStationstation(systemGenerateObject239: SystemGenerateObject239, options?: AxiosRequestConfig) {
        return StationApiFp(this.configuration).addStationstation(systemGenerateObject239, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 删除驿站，同时删除关联的驿站地址
     * @summary 删除驿站
     * @param {number} stationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationApi
     */
    public delStationstation(stationId: number, options?: AxiosRequestConfig) {
        return StationApiFp(this.configuration).delStationstation(stationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 根据驿站ID获取驿站详情，包括关联的驿站地址
     * @summary 获取驿站详情
     * @param {number} stationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationApi
     */
    public getStationDetailstation(stationId: number, options?: AxiosRequestConfig) {
        return StationApiFp(this.configuration).getStationDetailstation(stationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 获取驿站列表，包括关联的驿站地址
     * @summary 获取驿站列表
     * @param {SystemGenerateObject237} systemGenerateObject237 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationApi
     */
    public listStationstation(systemGenerateObject237: SystemGenerateObject237, options?: AxiosRequestConfig) {
        return StationApiFp(this.configuration).listStationstation(systemGenerateObject237, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 获取驿站列表(分页)，包括关联的驿站地址
     * @summary 获取驿站列表(分页)
     * @param {SystemGenerateObject238} systemGenerateObject238 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationApi
     */
    public pageStationstation(systemGenerateObject238: SystemGenerateObject238, options?: AxiosRequestConfig) {
        return StationApiFp(this.configuration).pageStationstation(systemGenerateObject238, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 更新驿站，可同时更新、添加或删除关联的驿站地址
     * @summary 更新驿站
     * @param {SystemGenerateObject240} systemGenerateObject240 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationApi
     */
    public updateStationstation(systemGenerateObject240: SystemGenerateObject240, options?: AxiosRequestConfig) {
        return StationApiFp(this.configuration).updateStationstation(systemGenerateObject240, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StationAddressApi - axios parameter creator
 * @export
 */
export const StationAddressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加驿站地址
         * @param {SystemGenerateObject259} systemGenerateObject259 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStationAddressstationAddress: async (systemGenerateObject259: SystemGenerateObject259, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject259' is not null or undefined
            assertParamExists('addStationAddressstationAddress', 'systemGenerateObject259', systemGenerateObject259)
            const localVarPath = `/stationAddress/addStationAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject259, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除驿站地址
         * @param {number} stationAddressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delStationAddressstationAddress: async (stationAddressId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stationAddressId' is not null or undefined
            assertParamExists('delStationAddressstationAddress', 'stationAddressId', stationAddressId)
            const localVarPath = `/stationAddress/delStationAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stationAddressId !== undefined) {
                localVarQueryParameter['stationAddressId'] = stationAddressId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取驿站地址列表
         * @param {SystemGenerateObject257} systemGenerateObject257 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStationAddressstationAddress: async (systemGenerateObject257: SystemGenerateObject257, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject257' is not null or undefined
            assertParamExists('listStationAddressstationAddress', 'systemGenerateObject257', systemGenerateObject257)
            const localVarPath = `/stationAddress/listStationAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject257, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取驿站地址列表(分页)
         * @param {SystemGenerateObject258} systemGenerateObject258 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageStationAddressstationAddress: async (systemGenerateObject258: SystemGenerateObject258, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject258' is not null or undefined
            assertParamExists('pageStationAddressstationAddress', 'systemGenerateObject258', systemGenerateObject258)
            const localVarPath = `/stationAddress/pageStationAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject258, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新驿站地址
         * @param {SystemGenerateObject260} systemGenerateObject260 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStationAddressstationAddress: async (systemGenerateObject260: SystemGenerateObject260, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject260' is not null or undefined
            assertParamExists('updateStationAddressstationAddress', 'systemGenerateObject260', systemGenerateObject260)
            const localVarPath = `/stationAddress/updateStationAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject260, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StationAddressApi - functional programming interface
 * @export
 */
export const StationAddressApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StationAddressApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加驿站地址
         * @param {SystemGenerateObject259} systemGenerateObject259 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addStationAddressstationAddress(systemGenerateObject259: SystemGenerateObject259, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addStationAddressstationAddress(systemGenerateObject259, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除驿站地址
         * @param {number} stationAddressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delStationAddressstationAddress(stationAddressId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delStationAddressstationAddress(stationAddressId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取驿站地址列表
         * @param {SystemGenerateObject257} systemGenerateObject257 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listStationAddressstationAddress(systemGenerateObject257: SystemGenerateObject257, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listStationAddressstationAddress(systemGenerateObject257, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取驿站地址列表(分页)
         * @param {SystemGenerateObject258} systemGenerateObject258 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageStationAddressstationAddress(systemGenerateObject258: SystemGenerateObject258, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageStationAddressstationAddress(systemGenerateObject258, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新驿站地址
         * @param {SystemGenerateObject260} systemGenerateObject260 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStationAddressstationAddress(systemGenerateObject260: SystemGenerateObject260, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStationAddressstationAddress(systemGenerateObject260, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StationAddressApi - factory interface
 * @export
 */
export const StationAddressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StationAddressApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加驿站地址
         * @param {SystemGenerateObject259} systemGenerateObject259 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStationAddressstationAddress(systemGenerateObject259: SystemGenerateObject259, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addStationAddressstationAddress(systemGenerateObject259, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除驿站地址
         * @param {number} stationAddressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delStationAddressstationAddress(stationAddressId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delStationAddressstationAddress(stationAddressId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取驿站地址列表
         * @param {SystemGenerateObject257} systemGenerateObject257 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStationAddressstationAddress(systemGenerateObject257: SystemGenerateObject257, options?: any): AxiosPromise<any> {
            return localVarFp.listStationAddressstationAddress(systemGenerateObject257, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取驿站地址列表(分页)
         * @param {SystemGenerateObject258} systemGenerateObject258 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageStationAddressstationAddress(systemGenerateObject258: SystemGenerateObject258, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageStationAddressstationAddress(systemGenerateObject258, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新驿站地址
         * @param {SystemGenerateObject260} systemGenerateObject260 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStationAddressstationAddress(systemGenerateObject260: SystemGenerateObject260, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateStationAddressstationAddress(systemGenerateObject260, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StationAddressApi - object-oriented interface
 * @export
 * @class StationAddressApi
 * @extends {BaseAPI}
 */
export class StationAddressApi extends BaseAPI {
    /**
     * 
     * @summary 添加驿站地址
     * @param {SystemGenerateObject259} systemGenerateObject259 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationAddressApi
     */
    public addStationAddressstationAddress(systemGenerateObject259: SystemGenerateObject259, options?: AxiosRequestConfig) {
        return StationAddressApiFp(this.configuration).addStationAddressstationAddress(systemGenerateObject259, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除驿站地址
     * @param {number} stationAddressId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationAddressApi
     */
    public delStationAddressstationAddress(stationAddressId: number, options?: AxiosRequestConfig) {
        return StationAddressApiFp(this.configuration).delStationAddressstationAddress(stationAddressId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取驿站地址列表
     * @param {SystemGenerateObject257} systemGenerateObject257 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationAddressApi
     */
    public listStationAddressstationAddress(systemGenerateObject257: SystemGenerateObject257, options?: AxiosRequestConfig) {
        return StationAddressApiFp(this.configuration).listStationAddressstationAddress(systemGenerateObject257, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取驿站地址列表(分页)
     * @param {SystemGenerateObject258} systemGenerateObject258 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationAddressApi
     */
    public pageStationAddressstationAddress(systemGenerateObject258: SystemGenerateObject258, options?: AxiosRequestConfig) {
        return StationAddressApiFp(this.configuration).pageStationAddressstationAddress(systemGenerateObject258, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新驿站地址
     * @param {SystemGenerateObject260} systemGenerateObject260 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationAddressApi
     */
    public updateStationAddressstationAddress(systemGenerateObject260: SystemGenerateObject260, options?: AxiosRequestConfig) {
        return StationAddressApiFp(this.configuration).updateStationAddressstationAddress(systemGenerateObject260, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StationTypeApi - axios parameter creator
 * @export
 */
export const StationTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加驿站类型
         * @param {SystemGenerateObject188} systemGenerateObject188 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStationTypestationType: async (systemGenerateObject188: SystemGenerateObject188, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject188' is not null or undefined
            assertParamExists('addStationTypestationType', 'systemGenerateObject188', systemGenerateObject188)
            const localVarPath = `/stationType/addStationType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject188, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除驿站类型
         * @param {number} stationTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delStationTypestationType: async (stationTypeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stationTypeId' is not null or undefined
            assertParamExists('delStationTypestationType', 'stationTypeId', stationTypeId)
            const localVarPath = `/stationType/delStationType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stationTypeId !== undefined) {
                localVarQueryParameter['stationTypeId'] = stationTypeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取驿站类型列表
         * @param {SystemGenerateObject186} systemGenerateObject186 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStationTypestationType: async (systemGenerateObject186: SystemGenerateObject186, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject186' is not null or undefined
            assertParamExists('listStationTypestationType', 'systemGenerateObject186', systemGenerateObject186)
            const localVarPath = `/stationType/listStationType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject186, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取驿站类型列表(分页)
         * @param {SystemGenerateObject187} systemGenerateObject187 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageStationTypestationType: async (systemGenerateObject187: SystemGenerateObject187, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject187' is not null or undefined
            assertParamExists('pageStationTypestationType', 'systemGenerateObject187', systemGenerateObject187)
            const localVarPath = `/stationType/pageStationType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject187, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新驿站类型
         * @param {SystemGenerateObject189} systemGenerateObject189 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStationTypestationType: async (systemGenerateObject189: SystemGenerateObject189, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject189' is not null or undefined
            assertParamExists('updateStationTypestationType', 'systemGenerateObject189', systemGenerateObject189)
            const localVarPath = `/stationType/updateStationType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject189, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StationTypeApi - functional programming interface
 * @export
 */
export const StationTypeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StationTypeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加驿站类型
         * @param {SystemGenerateObject188} systemGenerateObject188 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addStationTypestationType(systemGenerateObject188: SystemGenerateObject188, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addStationTypestationType(systemGenerateObject188, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除驿站类型
         * @param {number} stationTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delStationTypestationType(stationTypeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delStationTypestationType(stationTypeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取驿站类型列表
         * @param {SystemGenerateObject186} systemGenerateObject186 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listStationTypestationType(systemGenerateObject186: SystemGenerateObject186, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listStationTypestationType(systemGenerateObject186, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取驿站类型列表(分页)
         * @param {SystemGenerateObject187} systemGenerateObject187 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageStationTypestationType(systemGenerateObject187: SystemGenerateObject187, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageStationTypestationType(systemGenerateObject187, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新驿站类型
         * @param {SystemGenerateObject189} systemGenerateObject189 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStationTypestationType(systemGenerateObject189: SystemGenerateObject189, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStationTypestationType(systemGenerateObject189, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StationTypeApi - factory interface
 * @export
 */
export const StationTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StationTypeApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加驿站类型
         * @param {SystemGenerateObject188} systemGenerateObject188 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStationTypestationType(systemGenerateObject188: SystemGenerateObject188, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addStationTypestationType(systemGenerateObject188, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除驿站类型
         * @param {number} stationTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delStationTypestationType(stationTypeId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delStationTypestationType(stationTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取驿站类型列表
         * @param {SystemGenerateObject186} systemGenerateObject186 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStationTypestationType(systemGenerateObject186: SystemGenerateObject186, options?: any): AxiosPromise<any> {
            return localVarFp.listStationTypestationType(systemGenerateObject186, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取驿站类型列表(分页)
         * @param {SystemGenerateObject187} systemGenerateObject187 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageStationTypestationType(systemGenerateObject187: SystemGenerateObject187, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageStationTypestationType(systemGenerateObject187, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新驿站类型
         * @param {SystemGenerateObject189} systemGenerateObject189 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStationTypestationType(systemGenerateObject189: SystemGenerateObject189, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateStationTypestationType(systemGenerateObject189, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StationTypeApi - object-oriented interface
 * @export
 * @class StationTypeApi
 * @extends {BaseAPI}
 */
export class StationTypeApi extends BaseAPI {
    /**
     * 
     * @summary 添加驿站类型
     * @param {SystemGenerateObject188} systemGenerateObject188 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationTypeApi
     */
    public addStationTypestationType(systemGenerateObject188: SystemGenerateObject188, options?: AxiosRequestConfig) {
        return StationTypeApiFp(this.configuration).addStationTypestationType(systemGenerateObject188, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除驿站类型
     * @param {number} stationTypeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationTypeApi
     */
    public delStationTypestationType(stationTypeId: number, options?: AxiosRequestConfig) {
        return StationTypeApiFp(this.configuration).delStationTypestationType(stationTypeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取驿站类型列表
     * @param {SystemGenerateObject186} systemGenerateObject186 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationTypeApi
     */
    public listStationTypestationType(systemGenerateObject186: SystemGenerateObject186, options?: AxiosRequestConfig) {
        return StationTypeApiFp(this.configuration).listStationTypestationType(systemGenerateObject186, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取驿站类型列表(分页)
     * @param {SystemGenerateObject187} systemGenerateObject187 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationTypeApi
     */
    public pageStationTypestationType(systemGenerateObject187: SystemGenerateObject187, options?: AxiosRequestConfig) {
        return StationTypeApiFp(this.configuration).pageStationTypestationType(systemGenerateObject187, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新驿站类型
     * @param {SystemGenerateObject189} systemGenerateObject189 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationTypeApi
     */
    public updateStationTypestationType(systemGenerateObject189: SystemGenerateObject189, options?: AxiosRequestConfig) {
        return StationTypeApiFp(this.configuration).updateStationTypestationType(systemGenerateObject189, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StoreApi - axios parameter creator
 * @export
 */
export const StoreApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加一店一码直开二维码
         * @param {SystemGenerateObject119} systemGenerateObject119 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDirectQrcodeUrlstore: async (systemGenerateObject119: SystemGenerateObject119, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject119' is not null or undefined
            assertParamExists('addDirectQrcodeUrlstore', 'systemGenerateObject119', systemGenerateObject119)
            const localVarPath = `/store/addDirectQrcodeUrl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject119, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 添加一店一码H5二维码
         * @param {SystemGenerateObject118} systemGenerateObject118 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addH5Qrcodestore: async (systemGenerateObject118: SystemGenerateObject118, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject118' is not null or undefined
            assertParamExists('addH5Qrcodestore', 'systemGenerateObject118', systemGenerateObject118)
            const localVarPath = `/store/addH5Qrcode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject118, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 添加自身管理门店
         * @param {SystemGenerateObject106} systemGenerateObject106 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOwnerStorestore: async (systemGenerateObject106: SystemGenerateObject106, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject106' is not null or undefined
            assertParamExists('addOwnerStorestore', 'systemGenerateObject106', systemGenerateObject106)
            const localVarPath = `/store/addOwnerStore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject106, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 添加门店
         * @param {SystemGenerateObject110} systemGenerateObject110 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStorestore: async (systemGenerateObject110: SystemGenerateObject110, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject110' is not null or undefined
            assertParamExists('addStorestore', 'systemGenerateObject110', systemGenerateObject110)
            const localVarPath = `/store/addStore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject110, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 添加一店一码小程序二维码
         * @param {SystemGenerateObject117} systemGenerateObject117 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWeappQrcodestore: async (systemGenerateObject117: SystemGenerateObject117, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject117' is not null or undefined
            assertParamExists('addWeappQrcodestore', 'systemGenerateObject117', systemGenerateObject117)
            const localVarPath = `/store/addWeappQrcode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject117, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 绑定一店一码公众号
         * @param {SystemGenerateObject116} systemGenerateObject116 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bindWxstore: async (systemGenerateObject116: SystemGenerateObject116, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject116' is not null or undefined
            assertParamExists('bindWxstore', 'systemGenerateObject116', systemGenerateObject116)
            const localVarPath = `/store/bindWx`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject116, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除一店一码直开二维码
         * @param {SystemGenerateObject122} systemGenerateObject122 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delDirectQrcodestore: async (systemGenerateObject122: SystemGenerateObject122, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject122' is not null or undefined
            assertParamExists('delDirectQrcodestore', 'systemGenerateObject122', systemGenerateObject122)
            const localVarPath = `/store/delDirectQrcode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject122, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除自身管理门店
         * @param {number} storeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delOwnerStorestore: async (storeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('delOwnerStorestore', 'storeId', storeId)
            const localVarPath = `/store/delOwnerStore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除门店
         * @param {number} storeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delStorestore: async (storeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('delStorestore', 'storeId', storeId)
            const localVarPath = `/store/delStore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除一店一码小程序二维码
         * @param {SystemGenerateObject120} systemGenerateObject120 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delWeappQrcodestore: async (systemGenerateObject120: SystemGenerateObject120, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject120' is not null or undefined
            assertParamExists('delWeappQrcodestore', 'systemGenerateObject120', systemGenerateObject120)
            const localVarPath = `/store/delWeappQrcode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject120, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除一店一码公众号二维码
         * @param {SystemGenerateObject121} systemGenerateObject121 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delWxQrcodestore: async (systemGenerateObject121: SystemGenerateObject121, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject121' is not null or undefined
            assertParamExists('delWxQrcodestore', 'systemGenerateObject121', systemGenerateObject121)
            const localVarPath = `/store/delWxQrcode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject121, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取一店一码直开二维码
         * @param {SystemGenerateObject127} systemGenerateObject127 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectQrcodeUrlstore: async (systemGenerateObject127: SystemGenerateObject127, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject127' is not null or undefined
            assertParamExists('getDirectQrcodeUrlstore', 'systemGenerateObject127', systemGenerateObject127)
            const localVarPath = `/store/getDirectQrcodeUrl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject127, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取一店一码NFCURL
         * @param {SystemGenerateObject128} systemGenerateObject128 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNFCUrlstore: async (systemGenerateObject128: SystemGenerateObject128, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject128' is not null or undefined
            assertParamExists('getNFCUrlstore', 'systemGenerateObject128', systemGenerateObject128)
            const localVarPath = `/store/getNFCUrl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject128, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取自身管理的门店详情
         * @param {SystemGenerateObject104} systemGenerateObject104 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnerStoreDetailstore: async (systemGenerateObject104: SystemGenerateObject104, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject104' is not null or undefined
            assertParamExists('getOwnerStoreDetailstore', 'systemGenerateObject104', systemGenerateObject104)
            const localVarPath = `/store/getOwnerStoreDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject104, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取一店一码列表
         * @param {SystemGenerateObject115} systemGenerateObject115 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQrcodesstore: async (systemGenerateObject115: SystemGenerateObject115, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject115' is not null or undefined
            assertParamExists('getQrcodesstore', 'systemGenerateObject115', systemGenerateObject115)
            const localVarPath = `/store/getQrcodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject115, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 通过门店ID获取门店的基础信息，只返回id、name和phone
         * @summary 获取门店基础信息
         * @param {number} storeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoreBasicInfostore: async (storeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getStoreBasicInfostore', 'storeId', storeId)
            const localVarPath = `/store/getStoreBasicInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取一店一码小程序二维码
         * @param {SystemGenerateObject126} systemGenerateObject126 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeappQrcodestore: async (systemGenerateObject126: SystemGenerateObject126, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject126' is not null or undefined
            assertParamExists('getWeappQrcodestore', 'systemGenerateObject126', systemGenerateObject126)
            const localVarPath = `/store/getWeappQrcode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject126, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取一店一码公众号二维码
         * @param {SystemGenerateObject125} systemGenerateObject125 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWxQrcodestore: async (systemGenerateObject125: SystemGenerateObject125, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject125' is not null or undefined
            assertParamExists('getWxQrcodestore', 'systemGenerateObject125', systemGenerateObject125)
            const localVarPath = `/store/getWxQrcode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject125, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取自身管理的门店列表
         * @param {SystemGenerateObject105} systemGenerateObject105 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOwnerStorestore: async (systemGenerateObject105: SystemGenerateObject105, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject105' is not null or undefined
            assertParamExists('listOwnerStorestore', 'systemGenerateObject105', systemGenerateObject105)
            const localVarPath = `/store/listOwnerStore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject105, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取门店列表
         * @param {SystemGenerateObject108} systemGenerateObject108 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStorestore: async (systemGenerateObject108: SystemGenerateObject108, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject108' is not null or undefined
            assertParamExists('listStorestore', 'systemGenerateObject108', systemGenerateObject108)
            const localVarPath = `/store/listStore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject108, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 扫码开门
         * @param {SystemGenerateObject113} systemGenerateObject113 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        opendoorByCodestore: async (systemGenerateObject113: SystemGenerateObject113, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject113' is not null or undefined
            assertParamExists('opendoorByCodestore', 'systemGenerateObject113', systemGenerateObject113)
            const localVarPath = `/store/opendoorByCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject113, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 直接开门
         * @param {SystemGenerateObject114} systemGenerateObject114 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        opendoorByDirectstore: async (systemGenerateObject114: SystemGenerateObject114, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject114' is not null or undefined
            assertParamExists('opendoorByDirectstore', 'systemGenerateObject114', systemGenerateObject114)
            const localVarPath = `/store/opendoorByDirect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject114, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 通过快递信息直接开门，并记录快递信息
         * @summary 通过快递信息开门
         * @param {SystemGenerateObject124} systemGenerateObject124 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        opendoorByExpressstore: async (systemGenerateObject124: SystemGenerateObject124, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject124' is not null or undefined
            assertParamExists('opendoorByExpressstore', 'systemGenerateObject124', systemGenerateObject124)
            const localVarPath = `/store/opendoorByExpress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject124, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 定位开门
         * @param {SystemGenerateObject112} systemGenerateObject112 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        opendoorByGeostore: async (systemGenerateObject112: SystemGenerateObject112, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject112' is not null or undefined
            assertParamExists('opendoorByGeostore', 'systemGenerateObject112', systemGenerateObject112)
            const localVarPath = `/store/opendoorByGeo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject112, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 打开自身管理的门店门
         * @param {SystemGenerateObject103} systemGenerateObject103 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        opendoorOwnerStorestore: async (systemGenerateObject103: SystemGenerateObject103, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject103' is not null or undefined
            assertParamExists('opendoorOwnerStorestore', 'systemGenerateObject103', systemGenerateObject103)
            const localVarPath = `/store/opendoorOwnerStore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject103, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取门店列表(分页)
         * @param {SystemGenerateObject109} systemGenerateObject109 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageStorestore: async (systemGenerateObject109: SystemGenerateObject109, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject109' is not null or undefined
            assertParamExists('pageStorestore', 'systemGenerateObject109', systemGenerateObject109)
            const localVarPath = `/store/pageStore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject109, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 设置一店一码客户端下载二维码
         * @param {SystemGenerateObject123} systemGenerateObject123 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDownloadQrcodestore: async (systemGenerateObject123: SystemGenerateObject123, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject123' is not null or undefined
            assertParamExists('setDownloadQrcodestore', 'systemGenerateObject123', systemGenerateObject123)
            const localVarPath = `/store/setDownloadQrcode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject123, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 设置自身管理的门店模式
         * @param {SystemGenerateObject102} systemGenerateObject102 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setModOwnerStorestore: async (systemGenerateObject102: SystemGenerateObject102, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject102' is not null or undefined
            assertParamExists('setModOwnerStorestore', 'systemGenerateObject102', systemGenerateObject102)
            const localVarPath = `/store/setModOwnerStore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject102, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 将店铺的店主权限转让给新用户，仅店主本人可操作
         * @summary 转让店铺店主权限
         * @param {SystemGenerateObject129} systemGenerateObject129 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferOwnerstore: async (systemGenerateObject129: SystemGenerateObject129, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject129' is not null or undefined
            assertParamExists('transferOwnerstore', 'systemGenerateObject129', systemGenerateObject129)
            const localVarPath = `/store/transferOwner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject129, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新自身管理门店
         * @param {SystemGenerateObject107} systemGenerateObject107 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOwnerStorestore: async (systemGenerateObject107: SystemGenerateObject107, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject107' is not null or undefined
            assertParamExists('updateOwnerStorestore', 'systemGenerateObject107', systemGenerateObject107)
            const localVarPath = `/store/updateOwnerStore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject107, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新门店
         * @param {SystemGenerateObject111} systemGenerateObject111 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStorestore: async (systemGenerateObject111: SystemGenerateObject111, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject111' is not null or undefined
            assertParamExists('updateStorestore', 'systemGenerateObject111', systemGenerateObject111)
            const localVarPath = `/store/updateStore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject111, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StoreApi - functional programming interface
 * @export
 */
export const StoreApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StoreApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加一店一码直开二维码
         * @param {SystemGenerateObject119} systemGenerateObject119 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDirectQrcodeUrlstore(systemGenerateObject119: SystemGenerateObject119, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDirectQrcodeUrlstore(systemGenerateObject119, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 添加一店一码H5二维码
         * @param {SystemGenerateObject118} systemGenerateObject118 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addH5Qrcodestore(systemGenerateObject118: SystemGenerateObject118, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addH5Qrcodestore(systemGenerateObject118, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 添加自身管理门店
         * @param {SystemGenerateObject106} systemGenerateObject106 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOwnerStorestore(systemGenerateObject106: SystemGenerateObject106, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOwnerStorestore(systemGenerateObject106, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 添加门店
         * @param {SystemGenerateObject110} systemGenerateObject110 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addStorestore(systemGenerateObject110: SystemGenerateObject110, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addStorestore(systemGenerateObject110, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 添加一店一码小程序二维码
         * @param {SystemGenerateObject117} systemGenerateObject117 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addWeappQrcodestore(systemGenerateObject117: SystemGenerateObject117, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addWeappQrcodestore(systemGenerateObject117, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 绑定一店一码公众号
         * @param {SystemGenerateObject116} systemGenerateObject116 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bindWxstore(systemGenerateObject116: SystemGenerateObject116, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bindWxstore(systemGenerateObject116, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除一店一码直开二维码
         * @param {SystemGenerateObject122} systemGenerateObject122 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delDirectQrcodestore(systemGenerateObject122: SystemGenerateObject122, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delDirectQrcodestore(systemGenerateObject122, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除自身管理门店
         * @param {number} storeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delOwnerStorestore(storeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delOwnerStorestore(storeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除门店
         * @param {number} storeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delStorestore(storeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delStorestore(storeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除一店一码小程序二维码
         * @param {SystemGenerateObject120} systemGenerateObject120 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delWeappQrcodestore(systemGenerateObject120: SystemGenerateObject120, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delWeappQrcodestore(systemGenerateObject120, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除一店一码公众号二维码
         * @param {SystemGenerateObject121} systemGenerateObject121 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delWxQrcodestore(systemGenerateObject121: SystemGenerateObject121, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delWxQrcodestore(systemGenerateObject121, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取一店一码直开二维码
         * @param {SystemGenerateObject127} systemGenerateObject127 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDirectQrcodeUrlstore(systemGenerateObject127: SystemGenerateObject127, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDirectQrcodeUrlstore(systemGenerateObject127, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取一店一码NFCURL
         * @param {SystemGenerateObject128} systemGenerateObject128 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNFCUrlstore(systemGenerateObject128: SystemGenerateObject128, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNFCUrlstore(systemGenerateObject128, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取自身管理的门店详情
         * @param {SystemGenerateObject104} systemGenerateObject104 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOwnerStoreDetailstore(systemGenerateObject104: SystemGenerateObject104, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOwnerStoreDetailstore(systemGenerateObject104, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取一店一码列表
         * @param {SystemGenerateObject115} systemGenerateObject115 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQrcodesstore(systemGenerateObject115: SystemGenerateObject115, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQrcodesstore(systemGenerateObject115, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 通过门店ID获取门店的基础信息，只返回id、name和phone
         * @summary 获取门店基础信息
         * @param {number} storeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStoreBasicInfostore(storeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStoreBasicInfostore(storeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取一店一码小程序二维码
         * @param {SystemGenerateObject126} systemGenerateObject126 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWeappQrcodestore(systemGenerateObject126: SystemGenerateObject126, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWeappQrcodestore(systemGenerateObject126, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取一店一码公众号二维码
         * @param {SystemGenerateObject125} systemGenerateObject125 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWxQrcodestore(systemGenerateObject125: SystemGenerateObject125, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWxQrcodestore(systemGenerateObject125, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取自身管理的门店列表
         * @param {SystemGenerateObject105} systemGenerateObject105 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOwnerStorestore(systemGenerateObject105: SystemGenerateObject105, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOwnerStorestore(systemGenerateObject105, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取门店列表
         * @param {SystemGenerateObject108} systemGenerateObject108 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listStorestore(systemGenerateObject108: SystemGenerateObject108, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listStorestore(systemGenerateObject108, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 扫码开门
         * @param {SystemGenerateObject113} systemGenerateObject113 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async opendoorByCodestore(systemGenerateObject113: SystemGenerateObject113, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.opendoorByCodestore(systemGenerateObject113, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 直接开门
         * @param {SystemGenerateObject114} systemGenerateObject114 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async opendoorByDirectstore(systemGenerateObject114: SystemGenerateObject114, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.opendoorByDirectstore(systemGenerateObject114, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 通过快递信息直接开门，并记录快递信息
         * @summary 通过快递信息开门
         * @param {SystemGenerateObject124} systemGenerateObject124 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async opendoorByExpressstore(systemGenerateObject124: SystemGenerateObject124, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.opendoorByExpressstore(systemGenerateObject124, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 定位开门
         * @param {SystemGenerateObject112} systemGenerateObject112 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async opendoorByGeostore(systemGenerateObject112: SystemGenerateObject112, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.opendoorByGeostore(systemGenerateObject112, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 打开自身管理的门店门
         * @param {SystemGenerateObject103} systemGenerateObject103 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async opendoorOwnerStorestore(systemGenerateObject103: SystemGenerateObject103, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.opendoorOwnerStorestore(systemGenerateObject103, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取门店列表(分页)
         * @param {SystemGenerateObject109} systemGenerateObject109 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageStorestore(systemGenerateObject109: SystemGenerateObject109, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageStorestore(systemGenerateObject109, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 设置一店一码客户端下载二维码
         * @param {SystemGenerateObject123} systemGenerateObject123 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setDownloadQrcodestore(systemGenerateObject123: SystemGenerateObject123, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setDownloadQrcodestore(systemGenerateObject123, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 设置自身管理的门店模式
         * @param {SystemGenerateObject102} systemGenerateObject102 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setModOwnerStorestore(systemGenerateObject102: SystemGenerateObject102, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setModOwnerStorestore(systemGenerateObject102, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 将店铺的店主权限转让给新用户，仅店主本人可操作
         * @summary 转让店铺店主权限
         * @param {SystemGenerateObject129} systemGenerateObject129 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transferOwnerstore(systemGenerateObject129: SystemGenerateObject129, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transferOwnerstore(systemGenerateObject129, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新自身管理门店
         * @param {SystemGenerateObject107} systemGenerateObject107 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOwnerStorestore(systemGenerateObject107: SystemGenerateObject107, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOwnerStorestore(systemGenerateObject107, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新门店
         * @param {SystemGenerateObject111} systemGenerateObject111 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStorestore(systemGenerateObject111: SystemGenerateObject111, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStorestore(systemGenerateObject111, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StoreApi - factory interface
 * @export
 */
export const StoreApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StoreApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加一店一码直开二维码
         * @param {SystemGenerateObject119} systemGenerateObject119 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDirectQrcodeUrlstore(systemGenerateObject119: SystemGenerateObject119, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addDirectQrcodeUrlstore(systemGenerateObject119, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 添加一店一码H5二维码
         * @param {SystemGenerateObject118} systemGenerateObject118 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addH5Qrcodestore(systemGenerateObject118: SystemGenerateObject118, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addH5Qrcodestore(systemGenerateObject118, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 添加自身管理门店
         * @param {SystemGenerateObject106} systemGenerateObject106 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOwnerStorestore(systemGenerateObject106: SystemGenerateObject106, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addOwnerStorestore(systemGenerateObject106, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 添加门店
         * @param {SystemGenerateObject110} systemGenerateObject110 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStorestore(systemGenerateObject110: SystemGenerateObject110, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addStorestore(systemGenerateObject110, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 添加一店一码小程序二维码
         * @param {SystemGenerateObject117} systemGenerateObject117 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWeappQrcodestore(systemGenerateObject117: SystemGenerateObject117, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addWeappQrcodestore(systemGenerateObject117, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 绑定一店一码公众号
         * @param {SystemGenerateObject116} systemGenerateObject116 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bindWxstore(systemGenerateObject116: SystemGenerateObject116, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.bindWxstore(systemGenerateObject116, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除一店一码直开二维码
         * @param {SystemGenerateObject122} systemGenerateObject122 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delDirectQrcodestore(systemGenerateObject122: SystemGenerateObject122, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delDirectQrcodestore(systemGenerateObject122, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除自身管理门店
         * @param {number} storeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delOwnerStorestore(storeId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delOwnerStorestore(storeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除门店
         * @param {number} storeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delStorestore(storeId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delStorestore(storeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除一店一码小程序二维码
         * @param {SystemGenerateObject120} systemGenerateObject120 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delWeappQrcodestore(systemGenerateObject120: SystemGenerateObject120, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delWeappQrcodestore(systemGenerateObject120, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除一店一码公众号二维码
         * @param {SystemGenerateObject121} systemGenerateObject121 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delWxQrcodestore(systemGenerateObject121: SystemGenerateObject121, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delWxQrcodestore(systemGenerateObject121, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取一店一码直开二维码
         * @param {SystemGenerateObject127} systemGenerateObject127 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectQrcodeUrlstore(systemGenerateObject127: SystemGenerateObject127, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.getDirectQrcodeUrlstore(systemGenerateObject127, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取一店一码NFCURL
         * @param {SystemGenerateObject128} systemGenerateObject128 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNFCUrlstore(systemGenerateObject128: SystemGenerateObject128, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.getNFCUrlstore(systemGenerateObject128, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取自身管理的门店详情
         * @param {SystemGenerateObject104} systemGenerateObject104 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnerStoreDetailstore(systemGenerateObject104: SystemGenerateObject104, options?: any): AxiosPromise<any> {
            return localVarFp.getOwnerStoreDetailstore(systemGenerateObject104, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取一店一码列表
         * @param {SystemGenerateObject115} systemGenerateObject115 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQrcodesstore(systemGenerateObject115: SystemGenerateObject115, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.getQrcodesstore(systemGenerateObject115, options).then((request) => request(axios, basePath));
        },
        /**
         * 通过门店ID获取门店的基础信息，只返回id、name和phone
         * @summary 获取门店基础信息
         * @param {number} storeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoreBasicInfostore(storeId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.getStoreBasicInfostore(storeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取一店一码小程序二维码
         * @param {SystemGenerateObject126} systemGenerateObject126 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeappQrcodestore(systemGenerateObject126: SystemGenerateObject126, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.getWeappQrcodestore(systemGenerateObject126, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取一店一码公众号二维码
         * @param {SystemGenerateObject125} systemGenerateObject125 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWxQrcodestore(systemGenerateObject125: SystemGenerateObject125, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.getWxQrcodestore(systemGenerateObject125, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取自身管理的门店列表
         * @param {SystemGenerateObject105} systemGenerateObject105 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOwnerStorestore(systemGenerateObject105: SystemGenerateObject105, options?: any): AxiosPromise<any> {
            return localVarFp.listOwnerStorestore(systemGenerateObject105, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取门店列表
         * @param {SystemGenerateObject108} systemGenerateObject108 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStorestore(systemGenerateObject108: SystemGenerateObject108, options?: any): AxiosPromise<any> {
            return localVarFp.listStorestore(systemGenerateObject108, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 扫码开门
         * @param {SystemGenerateObject113} systemGenerateObject113 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        opendoorByCodestore(systemGenerateObject113: SystemGenerateObject113, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.opendoorByCodestore(systemGenerateObject113, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 直接开门
         * @param {SystemGenerateObject114} systemGenerateObject114 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        opendoorByDirectstore(systemGenerateObject114: SystemGenerateObject114, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.opendoorByDirectstore(systemGenerateObject114, options).then((request) => request(axios, basePath));
        },
        /**
         * 通过快递信息直接开门，并记录快递信息
         * @summary 通过快递信息开门
         * @param {SystemGenerateObject124} systemGenerateObject124 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        opendoorByExpressstore(systemGenerateObject124: SystemGenerateObject124, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.opendoorByExpressstore(systemGenerateObject124, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 定位开门
         * @param {SystemGenerateObject112} systemGenerateObject112 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        opendoorByGeostore(systemGenerateObject112: SystemGenerateObject112, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.opendoorByGeostore(systemGenerateObject112, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 打开自身管理的门店门
         * @param {SystemGenerateObject103} systemGenerateObject103 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        opendoorOwnerStorestore(systemGenerateObject103: SystemGenerateObject103, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.opendoorOwnerStorestore(systemGenerateObject103, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取门店列表(分页)
         * @param {SystemGenerateObject109} systemGenerateObject109 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageStorestore(systemGenerateObject109: SystemGenerateObject109, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageStorestore(systemGenerateObject109, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 设置一店一码客户端下载二维码
         * @param {SystemGenerateObject123} systemGenerateObject123 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDownloadQrcodestore(systemGenerateObject123: SystemGenerateObject123, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.setDownloadQrcodestore(systemGenerateObject123, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 设置自身管理的门店模式
         * @param {SystemGenerateObject102} systemGenerateObject102 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setModOwnerStorestore(systemGenerateObject102: SystemGenerateObject102, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.setModOwnerStorestore(systemGenerateObject102, options).then((request) => request(axios, basePath));
        },
        /**
         * 将店铺的店主权限转让给新用户，仅店主本人可操作
         * @summary 转让店铺店主权限
         * @param {SystemGenerateObject129} systemGenerateObject129 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferOwnerstore(systemGenerateObject129: SystemGenerateObject129, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.transferOwnerstore(systemGenerateObject129, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新自身管理门店
         * @param {SystemGenerateObject107} systemGenerateObject107 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOwnerStorestore(systemGenerateObject107: SystemGenerateObject107, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateOwnerStorestore(systemGenerateObject107, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新门店
         * @param {SystemGenerateObject111} systemGenerateObject111 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStorestore(systemGenerateObject111: SystemGenerateObject111, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateStorestore(systemGenerateObject111, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StoreApi - object-oriented interface
 * @export
 * @class StoreApi
 * @extends {BaseAPI}
 */
export class StoreApi extends BaseAPI {
    /**
     * 
     * @summary 添加一店一码直开二维码
     * @param {SystemGenerateObject119} systemGenerateObject119 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public addDirectQrcodeUrlstore(systemGenerateObject119: SystemGenerateObject119, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).addDirectQrcodeUrlstore(systemGenerateObject119, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 添加一店一码H5二维码
     * @param {SystemGenerateObject118} systemGenerateObject118 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public addH5Qrcodestore(systemGenerateObject118: SystemGenerateObject118, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).addH5Qrcodestore(systemGenerateObject118, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 添加自身管理门店
     * @param {SystemGenerateObject106} systemGenerateObject106 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public addOwnerStorestore(systemGenerateObject106: SystemGenerateObject106, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).addOwnerStorestore(systemGenerateObject106, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 添加门店
     * @param {SystemGenerateObject110} systemGenerateObject110 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public addStorestore(systemGenerateObject110: SystemGenerateObject110, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).addStorestore(systemGenerateObject110, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 添加一店一码小程序二维码
     * @param {SystemGenerateObject117} systemGenerateObject117 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public addWeappQrcodestore(systemGenerateObject117: SystemGenerateObject117, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).addWeappQrcodestore(systemGenerateObject117, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 绑定一店一码公众号
     * @param {SystemGenerateObject116} systemGenerateObject116 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public bindWxstore(systemGenerateObject116: SystemGenerateObject116, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).bindWxstore(systemGenerateObject116, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除一店一码直开二维码
     * @param {SystemGenerateObject122} systemGenerateObject122 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public delDirectQrcodestore(systemGenerateObject122: SystemGenerateObject122, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).delDirectQrcodestore(systemGenerateObject122, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除自身管理门店
     * @param {number} storeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public delOwnerStorestore(storeId: number, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).delOwnerStorestore(storeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除门店
     * @param {number} storeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public delStorestore(storeId: number, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).delStorestore(storeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除一店一码小程序二维码
     * @param {SystemGenerateObject120} systemGenerateObject120 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public delWeappQrcodestore(systemGenerateObject120: SystemGenerateObject120, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).delWeappQrcodestore(systemGenerateObject120, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除一店一码公众号二维码
     * @param {SystemGenerateObject121} systemGenerateObject121 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public delWxQrcodestore(systemGenerateObject121: SystemGenerateObject121, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).delWxQrcodestore(systemGenerateObject121, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取一店一码直开二维码
     * @param {SystemGenerateObject127} systemGenerateObject127 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public getDirectQrcodeUrlstore(systemGenerateObject127: SystemGenerateObject127, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).getDirectQrcodeUrlstore(systemGenerateObject127, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取一店一码NFCURL
     * @param {SystemGenerateObject128} systemGenerateObject128 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public getNFCUrlstore(systemGenerateObject128: SystemGenerateObject128, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).getNFCUrlstore(systemGenerateObject128, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取自身管理的门店详情
     * @param {SystemGenerateObject104} systemGenerateObject104 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public getOwnerStoreDetailstore(systemGenerateObject104: SystemGenerateObject104, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).getOwnerStoreDetailstore(systemGenerateObject104, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取一店一码列表
     * @param {SystemGenerateObject115} systemGenerateObject115 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public getQrcodesstore(systemGenerateObject115: SystemGenerateObject115, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).getQrcodesstore(systemGenerateObject115, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 通过门店ID获取门店的基础信息，只返回id、name和phone
     * @summary 获取门店基础信息
     * @param {number} storeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public getStoreBasicInfostore(storeId: number, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).getStoreBasicInfostore(storeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取一店一码小程序二维码
     * @param {SystemGenerateObject126} systemGenerateObject126 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public getWeappQrcodestore(systemGenerateObject126: SystemGenerateObject126, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).getWeappQrcodestore(systemGenerateObject126, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取一店一码公众号二维码
     * @param {SystemGenerateObject125} systemGenerateObject125 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public getWxQrcodestore(systemGenerateObject125: SystemGenerateObject125, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).getWxQrcodestore(systemGenerateObject125, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取自身管理的门店列表
     * @param {SystemGenerateObject105} systemGenerateObject105 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public listOwnerStorestore(systemGenerateObject105: SystemGenerateObject105, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).listOwnerStorestore(systemGenerateObject105, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取门店列表
     * @param {SystemGenerateObject108} systemGenerateObject108 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public listStorestore(systemGenerateObject108: SystemGenerateObject108, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).listStorestore(systemGenerateObject108, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 扫码开门
     * @param {SystemGenerateObject113} systemGenerateObject113 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public opendoorByCodestore(systemGenerateObject113: SystemGenerateObject113, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).opendoorByCodestore(systemGenerateObject113, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 直接开门
     * @param {SystemGenerateObject114} systemGenerateObject114 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public opendoorByDirectstore(systemGenerateObject114: SystemGenerateObject114, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).opendoorByDirectstore(systemGenerateObject114, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 通过快递信息直接开门，并记录快递信息
     * @summary 通过快递信息开门
     * @param {SystemGenerateObject124} systemGenerateObject124 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public opendoorByExpressstore(systemGenerateObject124: SystemGenerateObject124, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).opendoorByExpressstore(systemGenerateObject124, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 定位开门
     * @param {SystemGenerateObject112} systemGenerateObject112 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public opendoorByGeostore(systemGenerateObject112: SystemGenerateObject112, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).opendoorByGeostore(systemGenerateObject112, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 打开自身管理的门店门
     * @param {SystemGenerateObject103} systemGenerateObject103 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public opendoorOwnerStorestore(systemGenerateObject103: SystemGenerateObject103, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).opendoorOwnerStorestore(systemGenerateObject103, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取门店列表(分页)
     * @param {SystemGenerateObject109} systemGenerateObject109 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public pageStorestore(systemGenerateObject109: SystemGenerateObject109, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).pageStorestore(systemGenerateObject109, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 设置一店一码客户端下载二维码
     * @param {SystemGenerateObject123} systemGenerateObject123 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public setDownloadQrcodestore(systemGenerateObject123: SystemGenerateObject123, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).setDownloadQrcodestore(systemGenerateObject123, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 设置自身管理的门店模式
     * @param {SystemGenerateObject102} systemGenerateObject102 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public setModOwnerStorestore(systemGenerateObject102: SystemGenerateObject102, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).setModOwnerStorestore(systemGenerateObject102, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 将店铺的店主权限转让给新用户，仅店主本人可操作
     * @summary 转让店铺店主权限
     * @param {SystemGenerateObject129} systemGenerateObject129 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public transferOwnerstore(systemGenerateObject129: SystemGenerateObject129, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).transferOwnerstore(systemGenerateObject129, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新自身管理门店
     * @param {SystemGenerateObject107} systemGenerateObject107 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public updateOwnerStorestore(systemGenerateObject107: SystemGenerateObject107, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).updateOwnerStorestore(systemGenerateObject107, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新门店
     * @param {SystemGenerateObject111} systemGenerateObject111 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public updateStorestore(systemGenerateObject111: SystemGenerateObject111, options?: AxiosRequestConfig) {
        return StoreApiFp(this.configuration).updateStorestore(systemGenerateObject111, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StoreStatisticsApi - axios parameter creator
 * @export
 */
export const StoreStatisticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加店铺统计
         * @param {SystemGenerateObject263} systemGenerateObject263 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStoreStatisticsstoreStatistics: async (systemGenerateObject263: SystemGenerateObject263, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject263' is not null or undefined
            assertParamExists('addStoreStatisticsstoreStatistics', 'systemGenerateObject263', systemGenerateObject263)
            const localVarPath = `/storeStatistics/addStoreStatistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject263, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除店铺统计
         * @param {number} storeStatisticsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delStoreStatisticsstoreStatistics: async (storeStatisticsId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeStatisticsId' is not null or undefined
            assertParamExists('delStoreStatisticsstoreStatistics', 'storeStatisticsId', storeStatisticsId)
            const localVarPath = `/storeStatistics/delStoreStatistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (storeStatisticsId !== undefined) {
                localVarQueryParameter['storeStatisticsId'] = storeStatisticsId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 导出店铺统计数据
         * @param {SystemGenerateObject265} systemGenerateObject265 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportStoreStatisticsstoreStatistics: async (systemGenerateObject265: SystemGenerateObject265, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject265' is not null or undefined
            assertParamExists('exportStoreStatisticsstoreStatistics', 'systemGenerateObject265', systemGenerateObject265)
            const localVarPath = `/storeStatistics/exportStoreStatistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject265, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取已同步月份
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncedMonthstoreStatistics: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storeStatistics/getSyncedMonth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取店铺统计列表
         * @param {SystemGenerateObject261} systemGenerateObject261 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStoreStatisticsstoreStatistics: async (systemGenerateObject261: SystemGenerateObject261, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject261' is not null or undefined
            assertParamExists('listStoreStatisticsstoreStatistics', 'systemGenerateObject261', systemGenerateObject261)
            const localVarPath = `/storeStatistics/listStoreStatistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject261, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取店铺统计列表(分页)
         * @param {SystemGenerateObject262} systemGenerateObject262 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageStoreStatisticsstoreStatistics: async (systemGenerateObject262: SystemGenerateObject262, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject262' is not null or undefined
            assertParamExists('pageStoreStatisticsstoreStatistics', 'systemGenerateObject262', systemGenerateObject262)
            const localVarPath = `/storeStatistics/pageStoreStatistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject262, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 同步店铺统计数据
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncStoreStatisticsstoreStatistics: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storeStatistics/syncStoreStatistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新店铺统计
         * @param {SystemGenerateObject264} systemGenerateObject264 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStoreStatisticsstoreStatistics: async (systemGenerateObject264: SystemGenerateObject264, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject264' is not null or undefined
            assertParamExists('updateStoreStatisticsstoreStatistics', 'systemGenerateObject264', systemGenerateObject264)
            const localVarPath = `/storeStatistics/updateStoreStatistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject264, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StoreStatisticsApi - functional programming interface
 * @export
 */
export const StoreStatisticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StoreStatisticsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加店铺统计
         * @param {SystemGenerateObject263} systemGenerateObject263 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addStoreStatisticsstoreStatistics(systemGenerateObject263: SystemGenerateObject263, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addStoreStatisticsstoreStatistics(systemGenerateObject263, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除店铺统计
         * @param {number} storeStatisticsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delStoreStatisticsstoreStatistics(storeStatisticsId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delStoreStatisticsstoreStatistics(storeStatisticsId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 导出店铺统计数据
         * @param {SystemGenerateObject265} systemGenerateObject265 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportStoreStatisticsstoreStatistics(systemGenerateObject265: SystemGenerateObject265, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportStoreStatisticsstoreStatistics(systemGenerateObject265, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取已同步月份
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSyncedMonthstoreStatistics(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSyncedMonthstoreStatistics(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取店铺统计列表
         * @param {SystemGenerateObject261} systemGenerateObject261 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listStoreStatisticsstoreStatistics(systemGenerateObject261: SystemGenerateObject261, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listStoreStatisticsstoreStatistics(systemGenerateObject261, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取店铺统计列表(分页)
         * @param {SystemGenerateObject262} systemGenerateObject262 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageStoreStatisticsstoreStatistics(systemGenerateObject262: SystemGenerateObject262, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageStoreStatisticsstoreStatistics(systemGenerateObject262, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 同步店铺统计数据
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncStoreStatisticsstoreStatistics(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncStoreStatisticsstoreStatistics(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新店铺统计
         * @param {SystemGenerateObject264} systemGenerateObject264 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStoreStatisticsstoreStatistics(systemGenerateObject264: SystemGenerateObject264, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStoreStatisticsstoreStatistics(systemGenerateObject264, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StoreStatisticsApi - factory interface
 * @export
 */
export const StoreStatisticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StoreStatisticsApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加店铺统计
         * @param {SystemGenerateObject263} systemGenerateObject263 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStoreStatisticsstoreStatistics(systemGenerateObject263: SystemGenerateObject263, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addStoreStatisticsstoreStatistics(systemGenerateObject263, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除店铺统计
         * @param {number} storeStatisticsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delStoreStatisticsstoreStatistics(storeStatisticsId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delStoreStatisticsstoreStatistics(storeStatisticsId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 导出店铺统计数据
         * @param {SystemGenerateObject265} systemGenerateObject265 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportStoreStatisticsstoreStatistics(systemGenerateObject265: SystemGenerateObject265, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.exportStoreStatisticsstoreStatistics(systemGenerateObject265, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取已同步月份
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncedMonthstoreStatistics(options?: any): AxiosPromise<ResultVo> {
            return localVarFp.getSyncedMonthstoreStatistics(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取店铺统计列表
         * @param {SystemGenerateObject261} systemGenerateObject261 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStoreStatisticsstoreStatistics(systemGenerateObject261: SystemGenerateObject261, options?: any): AxiosPromise<any> {
            return localVarFp.listStoreStatisticsstoreStatistics(systemGenerateObject261, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取店铺统计列表(分页)
         * @param {SystemGenerateObject262} systemGenerateObject262 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageStoreStatisticsstoreStatistics(systemGenerateObject262: SystemGenerateObject262, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageStoreStatisticsstoreStatistics(systemGenerateObject262, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 同步店铺统计数据
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncStoreStatisticsstoreStatistics(options?: any): AxiosPromise<ResultVo> {
            return localVarFp.syncStoreStatisticsstoreStatistics(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新店铺统计
         * @param {SystemGenerateObject264} systemGenerateObject264 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStoreStatisticsstoreStatistics(systemGenerateObject264: SystemGenerateObject264, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateStoreStatisticsstoreStatistics(systemGenerateObject264, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StoreStatisticsApi - object-oriented interface
 * @export
 * @class StoreStatisticsApi
 * @extends {BaseAPI}
 */
export class StoreStatisticsApi extends BaseAPI {
    /**
     * 
     * @summary 添加店铺统计
     * @param {SystemGenerateObject263} systemGenerateObject263 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreStatisticsApi
     */
    public addStoreStatisticsstoreStatistics(systemGenerateObject263: SystemGenerateObject263, options?: AxiosRequestConfig) {
        return StoreStatisticsApiFp(this.configuration).addStoreStatisticsstoreStatistics(systemGenerateObject263, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除店铺统计
     * @param {number} storeStatisticsId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreStatisticsApi
     */
    public delStoreStatisticsstoreStatistics(storeStatisticsId: number, options?: AxiosRequestConfig) {
        return StoreStatisticsApiFp(this.configuration).delStoreStatisticsstoreStatistics(storeStatisticsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 导出店铺统计数据
     * @param {SystemGenerateObject265} systemGenerateObject265 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreStatisticsApi
     */
    public exportStoreStatisticsstoreStatistics(systemGenerateObject265: SystemGenerateObject265, options?: AxiosRequestConfig) {
        return StoreStatisticsApiFp(this.configuration).exportStoreStatisticsstoreStatistics(systemGenerateObject265, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取已同步月份
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreStatisticsApi
     */
    public getSyncedMonthstoreStatistics(options?: AxiosRequestConfig) {
        return StoreStatisticsApiFp(this.configuration).getSyncedMonthstoreStatistics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取店铺统计列表
     * @param {SystemGenerateObject261} systemGenerateObject261 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreStatisticsApi
     */
    public listStoreStatisticsstoreStatistics(systemGenerateObject261: SystemGenerateObject261, options?: AxiosRequestConfig) {
        return StoreStatisticsApiFp(this.configuration).listStoreStatisticsstoreStatistics(systemGenerateObject261, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取店铺统计列表(分页)
     * @param {SystemGenerateObject262} systemGenerateObject262 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreStatisticsApi
     */
    public pageStoreStatisticsstoreStatistics(systemGenerateObject262: SystemGenerateObject262, options?: AxiosRequestConfig) {
        return StoreStatisticsApiFp(this.configuration).pageStoreStatisticsstoreStatistics(systemGenerateObject262, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 同步店铺统计数据
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreStatisticsApi
     */
    public syncStoreStatisticsstoreStatistics(options?: AxiosRequestConfig) {
        return StoreStatisticsApiFp(this.configuration).syncStoreStatisticsstoreStatistics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新店铺统计
     * @param {SystemGenerateObject264} systemGenerateObject264 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreStatisticsApi
     */
    public updateStoreStatisticsstoreStatistics(systemGenerateObject264: SystemGenerateObject264, options?: AxiosRequestConfig) {
        return StoreStatisticsApiFp(this.configuration).updateStoreStatisticsstoreStatistics(systemGenerateObject264, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SubAccountApi - axios parameter creator
 * @export
 */
export const SubAccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加自身管理的门店子账户
         * @param {SystemGenerateObject135} systemGenerateObject135 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOwnerStoreSubAccountsubAccount: async (systemGenerateObject135: SystemGenerateObject135, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject135' is not null or undefined
            assertParamExists('addOwnerStoreSubAccountsubAccount', 'systemGenerateObject135', systemGenerateObject135)
            const localVarPath = `/subAccount/addOwnerStoreSubAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject135, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 添加子账户
         * @param {SystemGenerateObject132} systemGenerateObject132 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSubAccountsubAccount: async (systemGenerateObject132: SystemGenerateObject132, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject132' is not null or undefined
            assertParamExists('addSubAccountsubAccount', 'systemGenerateObject132', systemGenerateObject132)
            const localVarPath = `/subAccount/addSubAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject132, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除自身管理的门店子账户
         * @param {number} storeId 
         * @param {number} subAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delOwnerStoreSubAccountsubAccount: async (storeId: number, subAccountId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('delOwnerStoreSubAccountsubAccount', 'storeId', storeId)
            // verify required parameter 'subAccountId' is not null or undefined
            assertParamExists('delOwnerStoreSubAccountsubAccount', 'subAccountId', subAccountId)
            const localVarPath = `/subAccount/delOwnerStoreSubAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (subAccountId !== undefined) {
                localVarQueryParameter['subAccountId'] = subAccountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除子账户
         * @param {number} subAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delSubAccountsubAccount: async (subAccountId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subAccountId' is not null or undefined
            assertParamExists('delSubAccountsubAccount', 'subAccountId', subAccountId)
            const localVarPath = `/subAccount/delSubAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (subAccountId !== undefined) {
                localVarQueryParameter['subAccountId'] = subAccountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取自身管理的门店子账户列表
         * @param {SystemGenerateObject134} systemGenerateObject134 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOwnerStoreSubAccountsubAccount: async (systemGenerateObject134: SystemGenerateObject134, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject134' is not null or undefined
            assertParamExists('listOwnerStoreSubAccountsubAccount', 'systemGenerateObject134', systemGenerateObject134)
            const localVarPath = `/subAccount/listOwnerStoreSubAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject134, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取子账户列表
         * @param {SystemGenerateObject130} systemGenerateObject130 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSubAccountsubAccount: async (systemGenerateObject130: SystemGenerateObject130, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject130' is not null or undefined
            assertParamExists('listSubAccountsubAccount', 'systemGenerateObject130', systemGenerateObject130)
            const localVarPath = `/subAccount/listSubAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject130, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取子账户列表(分页)
         * @param {SystemGenerateObject131} systemGenerateObject131 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSubAccountsubAccount: async (systemGenerateObject131: SystemGenerateObject131, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject131' is not null or undefined
            assertParamExists('pageSubAccountsubAccount', 'systemGenerateObject131', systemGenerateObject131)
            const localVarPath = `/subAccount/pageSubAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject131, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新自身管理的门店子账户
         * @param {SystemGenerateObject136} systemGenerateObject136 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOwnerStoreSubAccountsubAccount: async (systemGenerateObject136: SystemGenerateObject136, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject136' is not null or undefined
            assertParamExists('updateOwnerStoreSubAccountsubAccount', 'systemGenerateObject136', systemGenerateObject136)
            const localVarPath = `/subAccount/updateOwnerStoreSubAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject136, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新子账户
         * @param {SystemGenerateObject133} systemGenerateObject133 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubAccountsubAccount: async (systemGenerateObject133: SystemGenerateObject133, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject133' is not null or undefined
            assertParamExists('updateSubAccountsubAccount', 'systemGenerateObject133', systemGenerateObject133)
            const localVarPath = `/subAccount/updateSubAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject133, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubAccountApi - functional programming interface
 * @export
 */
export const SubAccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubAccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加自身管理的门店子账户
         * @param {SystemGenerateObject135} systemGenerateObject135 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOwnerStoreSubAccountsubAccount(systemGenerateObject135: SystemGenerateObject135, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOwnerStoreSubAccountsubAccount(systemGenerateObject135, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 添加子账户
         * @param {SystemGenerateObject132} systemGenerateObject132 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSubAccountsubAccount(systemGenerateObject132: SystemGenerateObject132, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSubAccountsubAccount(systemGenerateObject132, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除自身管理的门店子账户
         * @param {number} storeId 
         * @param {number} subAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delOwnerStoreSubAccountsubAccount(storeId: number, subAccountId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delOwnerStoreSubAccountsubAccount(storeId, subAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除子账户
         * @param {number} subAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delSubAccountsubAccount(subAccountId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delSubAccountsubAccount(subAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取自身管理的门店子账户列表
         * @param {SystemGenerateObject134} systemGenerateObject134 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOwnerStoreSubAccountsubAccount(systemGenerateObject134: SystemGenerateObject134, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOwnerStoreSubAccountsubAccount(systemGenerateObject134, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取子账户列表
         * @param {SystemGenerateObject130} systemGenerateObject130 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSubAccountsubAccount(systemGenerateObject130: SystemGenerateObject130, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSubAccountsubAccount(systemGenerateObject130, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取子账户列表(分页)
         * @param {SystemGenerateObject131} systemGenerateObject131 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageSubAccountsubAccount(systemGenerateObject131: SystemGenerateObject131, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageSubAccountsubAccount(systemGenerateObject131, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新自身管理的门店子账户
         * @param {SystemGenerateObject136} systemGenerateObject136 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOwnerStoreSubAccountsubAccount(systemGenerateObject136: SystemGenerateObject136, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOwnerStoreSubAccountsubAccount(systemGenerateObject136, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新子账户
         * @param {SystemGenerateObject133} systemGenerateObject133 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSubAccountsubAccount(systemGenerateObject133: SystemGenerateObject133, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSubAccountsubAccount(systemGenerateObject133, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SubAccountApi - factory interface
 * @export
 */
export const SubAccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubAccountApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加自身管理的门店子账户
         * @param {SystemGenerateObject135} systemGenerateObject135 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOwnerStoreSubAccountsubAccount(systemGenerateObject135: SystemGenerateObject135, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addOwnerStoreSubAccountsubAccount(systemGenerateObject135, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 添加子账户
         * @param {SystemGenerateObject132} systemGenerateObject132 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSubAccountsubAccount(systemGenerateObject132: SystemGenerateObject132, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addSubAccountsubAccount(systemGenerateObject132, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除自身管理的门店子账户
         * @param {number} storeId 
         * @param {number} subAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delOwnerStoreSubAccountsubAccount(storeId: number, subAccountId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delOwnerStoreSubAccountsubAccount(storeId, subAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除子账户
         * @param {number} subAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delSubAccountsubAccount(subAccountId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delSubAccountsubAccount(subAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取自身管理的门店子账户列表
         * @param {SystemGenerateObject134} systemGenerateObject134 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOwnerStoreSubAccountsubAccount(systemGenerateObject134: SystemGenerateObject134, options?: any): AxiosPromise<any> {
            return localVarFp.listOwnerStoreSubAccountsubAccount(systemGenerateObject134, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取子账户列表
         * @param {SystemGenerateObject130} systemGenerateObject130 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSubAccountsubAccount(systemGenerateObject130: SystemGenerateObject130, options?: any): AxiosPromise<any> {
            return localVarFp.listSubAccountsubAccount(systemGenerateObject130, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取子账户列表(分页)
         * @param {SystemGenerateObject131} systemGenerateObject131 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSubAccountsubAccount(systemGenerateObject131: SystemGenerateObject131, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageSubAccountsubAccount(systemGenerateObject131, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新自身管理的门店子账户
         * @param {SystemGenerateObject136} systemGenerateObject136 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOwnerStoreSubAccountsubAccount(systemGenerateObject136: SystemGenerateObject136, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateOwnerStoreSubAccountsubAccount(systemGenerateObject136, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新子账户
         * @param {SystemGenerateObject133} systemGenerateObject133 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubAccountsubAccount(systemGenerateObject133: SystemGenerateObject133, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateSubAccountsubAccount(systemGenerateObject133, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SubAccountApi - object-oriented interface
 * @export
 * @class SubAccountApi
 * @extends {BaseAPI}
 */
export class SubAccountApi extends BaseAPI {
    /**
     * 
     * @summary 添加自身管理的门店子账户
     * @param {SystemGenerateObject135} systemGenerateObject135 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubAccountApi
     */
    public addOwnerStoreSubAccountsubAccount(systemGenerateObject135: SystemGenerateObject135, options?: AxiosRequestConfig) {
        return SubAccountApiFp(this.configuration).addOwnerStoreSubAccountsubAccount(systemGenerateObject135, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 添加子账户
     * @param {SystemGenerateObject132} systemGenerateObject132 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubAccountApi
     */
    public addSubAccountsubAccount(systemGenerateObject132: SystemGenerateObject132, options?: AxiosRequestConfig) {
        return SubAccountApiFp(this.configuration).addSubAccountsubAccount(systemGenerateObject132, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除自身管理的门店子账户
     * @param {number} storeId 
     * @param {number} subAccountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubAccountApi
     */
    public delOwnerStoreSubAccountsubAccount(storeId: number, subAccountId: number, options?: AxiosRequestConfig) {
        return SubAccountApiFp(this.configuration).delOwnerStoreSubAccountsubAccount(storeId, subAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除子账户
     * @param {number} subAccountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubAccountApi
     */
    public delSubAccountsubAccount(subAccountId: number, options?: AxiosRequestConfig) {
        return SubAccountApiFp(this.configuration).delSubAccountsubAccount(subAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取自身管理的门店子账户列表
     * @param {SystemGenerateObject134} systemGenerateObject134 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubAccountApi
     */
    public listOwnerStoreSubAccountsubAccount(systemGenerateObject134: SystemGenerateObject134, options?: AxiosRequestConfig) {
        return SubAccountApiFp(this.configuration).listOwnerStoreSubAccountsubAccount(systemGenerateObject134, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取子账户列表
     * @param {SystemGenerateObject130} systemGenerateObject130 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubAccountApi
     */
    public listSubAccountsubAccount(systemGenerateObject130: SystemGenerateObject130, options?: AxiosRequestConfig) {
        return SubAccountApiFp(this.configuration).listSubAccountsubAccount(systemGenerateObject130, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取子账户列表(分页)
     * @param {SystemGenerateObject131} systemGenerateObject131 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubAccountApi
     */
    public pageSubAccountsubAccount(systemGenerateObject131: SystemGenerateObject131, options?: AxiosRequestConfig) {
        return SubAccountApiFp(this.configuration).pageSubAccountsubAccount(systemGenerateObject131, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新自身管理的门店子账户
     * @param {SystemGenerateObject136} systemGenerateObject136 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubAccountApi
     */
    public updateOwnerStoreSubAccountsubAccount(systemGenerateObject136: SystemGenerateObject136, options?: AxiosRequestConfig) {
        return SubAccountApiFp(this.configuration).updateOwnerStoreSubAccountsubAccount(systemGenerateObject136, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新子账户
     * @param {SystemGenerateObject133} systemGenerateObject133 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubAccountApi
     */
    public updateSubAccountsubAccount(systemGenerateObject133: SystemGenerateObject133, options?: AxiosRequestConfig) {
        return SubAccountApiFp(this.configuration).updateSubAccountsubAccount(systemGenerateObject133, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SystemApi - axios parameter creator
 * @export
 */
export const SystemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 获取swagger.json
         * @summary swagger接口文档
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _9130000000000000000system: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/swagger.json`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SystemApi - functional programming interface
 * @export
 */
export const SystemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SystemApiAxiosParamCreator(configuration)
    return {
        /**
         * 获取swagger.json
         * @summary swagger接口文档
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _9130000000000000000system(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._9130000000000000000system(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SystemApi - factory interface
 * @export
 */
export const SystemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SystemApiFp(configuration)
    return {
        /**
         * 获取swagger.json
         * @summary swagger接口文档
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _9130000000000000000system(options?: any): AxiosPromise<any> {
            return localVarFp._9130000000000000000system(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SystemApi - object-oriented interface
 * @export
 * @class SystemApi
 * @extends {BaseAPI}
 */
export class SystemApi extends BaseAPI {
    /**
     * 获取swagger.json
     * @summary swagger接口文档
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public _9130000000000000000system(options?: AxiosRequestConfig) {
        return SystemApiFp(this.configuration)._9130000000000000000system(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TenantApi - axios parameter creator
 * @export
 */
export const TenantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加租户
         * @param {TenantAdminVo} tenantAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTenanttenant: async (tenantAdminVo: TenantAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantAdminVo' is not null or undefined
            assertParamExists('addTenanttenant', 'tenantAdminVo', tenantAdminVo)
            const localVarPath = `/tenant/addTenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除租户
         * @param {number} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delTenanttenant: async (tenantId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('delTenanttenant', 'tenantId', tenantId)
            const localVarPath = `/tenant/delTenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取租户对外显示的信息
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantComInfotenant: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tenant/getTenantComInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取租户列表
         * @param {PartialTenantAdminVo} partialTenantAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTenanttenant: async (partialTenantAdminVo: PartialTenantAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partialTenantAdminVo' is not null or undefined
            assertParamExists('listTenanttenant', 'partialTenantAdminVo', partialTenantAdminVo)
            const localVarPath = `/tenant/listTenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partialTenantAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取租户列表(分页)
         * @param {SystemGenerateObject59} systemGenerateObject59 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageTenanttenant: async (systemGenerateObject59: SystemGenerateObject59, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject59' is not null or undefined
            assertParamExists('pageTenanttenant', 'systemGenerateObject59', systemGenerateObject59)
            const localVarPath = `/tenant/pageTenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject59, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新租户
         * @param {TenantAdminVo} tenantAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenanttenant: async (tenantAdminVo: TenantAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantAdminVo' is not null or undefined
            assertParamExists('updateTenanttenant', 'tenantAdminVo', tenantAdminVo)
            const localVarPath = `/tenant/updateTenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenantAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantApi - functional programming interface
 * @export
 */
export const TenantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加租户
         * @param {TenantAdminVo} tenantAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTenanttenant(tenantAdminVo: TenantAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTenanttenant(tenantAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除租户
         * @param {number} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delTenanttenant(tenantId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delTenanttenant(tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取租户对外显示的信息
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTenantComInfotenant(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTenantComInfotenant(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取租户列表
         * @param {PartialTenantAdminVo} partialTenantAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTenanttenant(partialTenantAdminVo: PartialTenantAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTenanttenant(partialTenantAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取租户列表(分页)
         * @param {SystemGenerateObject59} systemGenerateObject59 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageTenanttenant(systemGenerateObject59: SystemGenerateObject59, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageTenanttenant(systemGenerateObject59, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新租户
         * @param {TenantAdminVo} tenantAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTenanttenant(tenantAdminVo: TenantAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTenanttenant(tenantAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TenantApi - factory interface
 * @export
 */
export const TenantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加租户
         * @param {TenantAdminVo} tenantAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTenanttenant(tenantAdminVo: TenantAdminVo, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addTenanttenant(tenantAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除租户
         * @param {number} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delTenanttenant(tenantId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delTenanttenant(tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取租户对外显示的信息
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantComInfotenant(options?: any): AxiosPromise<ResultVo> {
            return localVarFp.getTenantComInfotenant(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取租户列表
         * @param {PartialTenantAdminVo} partialTenantAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTenanttenant(partialTenantAdminVo: PartialTenantAdminVo, options?: any): AxiosPromise<any> {
            return localVarFp.listTenanttenant(partialTenantAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取租户列表(分页)
         * @param {SystemGenerateObject59} systemGenerateObject59 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageTenanttenant(systemGenerateObject59: SystemGenerateObject59, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageTenanttenant(systemGenerateObject59, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新租户
         * @param {TenantAdminVo} tenantAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenanttenant(tenantAdminVo: TenantAdminVo, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateTenanttenant(tenantAdminVo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TenantApi - object-oriented interface
 * @export
 * @class TenantApi
 * @extends {BaseAPI}
 */
export class TenantApi extends BaseAPI {
    /**
     * 
     * @summary 添加租户
     * @param {TenantAdminVo} tenantAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public addTenanttenant(tenantAdminVo: TenantAdminVo, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).addTenanttenant(tenantAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除租户
     * @param {number} tenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public delTenanttenant(tenantId: number, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).delTenanttenant(tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取租户对外显示的信息
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public getTenantComInfotenant(options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).getTenantComInfotenant(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取租户列表
     * @param {PartialTenantAdminVo} partialTenantAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public listTenanttenant(partialTenantAdminVo: PartialTenantAdminVo, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).listTenanttenant(partialTenantAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取租户列表(分页)
     * @param {SystemGenerateObject59} systemGenerateObject59 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public pageTenanttenant(systemGenerateObject59: SystemGenerateObject59, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).pageTenanttenant(systemGenerateObject59, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新租户
     * @param {TenantAdminVo} tenantAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public updateTenanttenant(tenantAdminVo: TenantAdminVo, options?: AxiosRequestConfig) {
        return TenantApiFp(this.configuration).updateTenanttenant(tenantAdminVo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TicketApi - axios parameter creator
 * @export
 */
export const TicketApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 删除点券
         * @param {number} ticketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delTicketticket: async (ticketId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('delTicketticket', 'ticketId', ticketId)
            const localVarPath = `/ticket/delTicket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ticketId !== undefined) {
                localVarQueryParameter['ticketId'] = ticketId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 批量生成指定套餐的点券，参数：套餐ID、数量、有效期
         * @summary 批量生成点券
         * @param {SystemGenerateObject213} systemGenerateObject213 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTicketsticket: async (systemGenerateObject213: SystemGenerateObject213, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject213' is not null or undefined
            assertParamExists('generateTicketsticket', 'systemGenerateObject213', systemGenerateObject213)
            const localVarPath = `/ticket/generateTickets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject213, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取点券列表
         * @param {SystemGenerateObject211} systemGenerateObject211 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTicketticket: async (systemGenerateObject211: SystemGenerateObject211, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject211' is not null or undefined
            assertParamExists('listTicketticket', 'systemGenerateObject211', systemGenerateObject211)
            const localVarPath = `/ticket/listTicket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject211, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取点券列表(分页)
         * @param {SystemGenerateObject212} systemGenerateObject212 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageTicketticket: async (systemGenerateObject212: SystemGenerateObject212, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject212' is not null or undefined
            assertParamExists('pageTicketticket', 'systemGenerateObject212', systemGenerateObject212)
            const localVarPath = `/ticket/pageTicket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject212, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 核销点券，参数：点券ID、核销人手机号(可选，如未提供则使用当前登录用户手机号)
         * @summary 核销点券
         * @param {SystemGenerateObject214} systemGenerateObject214 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTicketticket: async (systemGenerateObject214: SystemGenerateObject214, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject214' is not null or undefined
            assertParamExists('verifyTicketticket', 'systemGenerateObject214', systemGenerateObject214)
            const localVarPath = `/ticket/verifyTicket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject214, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TicketApi - functional programming interface
 * @export
 */
export const TicketApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TicketApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 删除点券
         * @param {number} ticketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delTicketticket(ticketId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delTicketticket(ticketId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 批量生成指定套餐的点券，参数：套餐ID、数量、有效期
         * @summary 批量生成点券
         * @param {SystemGenerateObject213} systemGenerateObject213 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateTicketsticket(systemGenerateObject213: SystemGenerateObject213, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateTicketsticket(systemGenerateObject213, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取点券列表
         * @param {SystemGenerateObject211} systemGenerateObject211 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTicketticket(systemGenerateObject211: SystemGenerateObject211, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTicketticket(systemGenerateObject211, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取点券列表(分页)
         * @param {SystemGenerateObject212} systemGenerateObject212 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageTicketticket(systemGenerateObject212: SystemGenerateObject212, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageTicketticket(systemGenerateObject212, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 核销点券，参数：点券ID、核销人手机号(可选，如未提供则使用当前登录用户手机号)
         * @summary 核销点券
         * @param {SystemGenerateObject214} systemGenerateObject214 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyTicketticket(systemGenerateObject214: SystemGenerateObject214, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyTicketticket(systemGenerateObject214, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TicketApi - factory interface
 * @export
 */
export const TicketApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TicketApiFp(configuration)
    return {
        /**
         * 
         * @summary 删除点券
         * @param {number} ticketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delTicketticket(ticketId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delTicketticket(ticketId, options).then((request) => request(axios, basePath));
        },
        /**
         * 批量生成指定套餐的点券，参数：套餐ID、数量、有效期
         * @summary 批量生成点券
         * @param {SystemGenerateObject213} systemGenerateObject213 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTicketsticket(systemGenerateObject213: SystemGenerateObject213, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.generateTicketsticket(systemGenerateObject213, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取点券列表
         * @param {SystemGenerateObject211} systemGenerateObject211 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTicketticket(systemGenerateObject211: SystemGenerateObject211, options?: any): AxiosPromise<any> {
            return localVarFp.listTicketticket(systemGenerateObject211, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取点券列表(分页)
         * @param {SystemGenerateObject212} systemGenerateObject212 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageTicketticket(systemGenerateObject212: SystemGenerateObject212, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageTicketticket(systemGenerateObject212, options).then((request) => request(axios, basePath));
        },
        /**
         * 核销点券，参数：点券ID、核销人手机号(可选，如未提供则使用当前登录用户手机号)
         * @summary 核销点券
         * @param {SystemGenerateObject214} systemGenerateObject214 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTicketticket(systemGenerateObject214: SystemGenerateObject214, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.verifyTicketticket(systemGenerateObject214, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TicketApi - object-oriented interface
 * @export
 * @class TicketApi
 * @extends {BaseAPI}
 */
export class TicketApi extends BaseAPI {
    /**
     * 
     * @summary 删除点券
     * @param {number} ticketId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketApi
     */
    public delTicketticket(ticketId: number, options?: AxiosRequestConfig) {
        return TicketApiFp(this.configuration).delTicketticket(ticketId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 批量生成指定套餐的点券，参数：套餐ID、数量、有效期
     * @summary 批量生成点券
     * @param {SystemGenerateObject213} systemGenerateObject213 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketApi
     */
    public generateTicketsticket(systemGenerateObject213: SystemGenerateObject213, options?: AxiosRequestConfig) {
        return TicketApiFp(this.configuration).generateTicketsticket(systemGenerateObject213, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取点券列表
     * @param {SystemGenerateObject211} systemGenerateObject211 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketApi
     */
    public listTicketticket(systemGenerateObject211: SystemGenerateObject211, options?: AxiosRequestConfig) {
        return TicketApiFp(this.configuration).listTicketticket(systemGenerateObject211, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取点券列表(分页)
     * @param {SystemGenerateObject212} systemGenerateObject212 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketApi
     */
    public pageTicketticket(systemGenerateObject212: SystemGenerateObject212, options?: AxiosRequestConfig) {
        return TicketApiFp(this.configuration).pageTicketticket(systemGenerateObject212, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 核销点券，参数：点券ID、核销人手机号(可选，如未提供则使用当前登录用户手机号)
     * @summary 核销点券
     * @param {SystemGenerateObject214} systemGenerateObject214 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketApi
     */
    public verifyTicketticket(systemGenerateObject214: SystemGenerateObject214, options?: AxiosRequestConfig) {
        return TicketApiFp(this.configuration).verifyTicketticket(systemGenerateObject214, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TicketPackageApi - axios parameter creator
 * @export
 */
export const TicketPackageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加点券套餐
         * @param {SystemGenerateObject209} systemGenerateObject209 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTicketPackageticketPackage: async (systemGenerateObject209: SystemGenerateObject209, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject209' is not null or undefined
            assertParamExists('addTicketPackageticketPackage', 'systemGenerateObject209', systemGenerateObject209)
            const localVarPath = `/ticketPackage/addTicketPackage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject209, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除点券套餐
         * @param {number} ticketPackageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delTicketPackageticketPackage: async (ticketPackageId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketPackageId' is not null or undefined
            assertParamExists('delTicketPackageticketPackage', 'ticketPackageId', ticketPackageId)
            const localVarPath = `/ticketPackage/delTicketPackage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ticketPackageId !== undefined) {
                localVarQueryParameter['ticketPackageId'] = ticketPackageId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取点券套餐列表
         * @param {SystemGenerateObject207} systemGenerateObject207 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTicketPackageticketPackage: async (systemGenerateObject207: SystemGenerateObject207, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject207' is not null or undefined
            assertParamExists('listTicketPackageticketPackage', 'systemGenerateObject207', systemGenerateObject207)
            const localVarPath = `/ticketPackage/listTicketPackage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject207, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取点券套餐列表(分页)
         * @param {SystemGenerateObject208} systemGenerateObject208 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageTicketPackageticketPackage: async (systemGenerateObject208: SystemGenerateObject208, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject208' is not null or undefined
            assertParamExists('pageTicketPackageticketPackage', 'systemGenerateObject208', systemGenerateObject208)
            const localVarPath = `/ticketPackage/pageTicketPackage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject208, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新点券套餐
         * @param {SystemGenerateObject210} systemGenerateObject210 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTicketPackageticketPackage: async (systemGenerateObject210: SystemGenerateObject210, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject210' is not null or undefined
            assertParamExists('updateTicketPackageticketPackage', 'systemGenerateObject210', systemGenerateObject210)
            const localVarPath = `/ticketPackage/updateTicketPackage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject210, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TicketPackageApi - functional programming interface
 * @export
 */
export const TicketPackageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TicketPackageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加点券套餐
         * @param {SystemGenerateObject209} systemGenerateObject209 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTicketPackageticketPackage(systemGenerateObject209: SystemGenerateObject209, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTicketPackageticketPackage(systemGenerateObject209, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除点券套餐
         * @param {number} ticketPackageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delTicketPackageticketPackage(ticketPackageId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delTicketPackageticketPackage(ticketPackageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取点券套餐列表
         * @param {SystemGenerateObject207} systemGenerateObject207 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTicketPackageticketPackage(systemGenerateObject207: SystemGenerateObject207, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTicketPackageticketPackage(systemGenerateObject207, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取点券套餐列表(分页)
         * @param {SystemGenerateObject208} systemGenerateObject208 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageTicketPackageticketPackage(systemGenerateObject208: SystemGenerateObject208, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageTicketPackageticketPackage(systemGenerateObject208, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新点券套餐
         * @param {SystemGenerateObject210} systemGenerateObject210 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTicketPackageticketPackage(systemGenerateObject210: SystemGenerateObject210, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTicketPackageticketPackage(systemGenerateObject210, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TicketPackageApi - factory interface
 * @export
 */
export const TicketPackageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TicketPackageApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加点券套餐
         * @param {SystemGenerateObject209} systemGenerateObject209 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTicketPackageticketPackage(systemGenerateObject209: SystemGenerateObject209, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addTicketPackageticketPackage(systemGenerateObject209, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除点券套餐
         * @param {number} ticketPackageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delTicketPackageticketPackage(ticketPackageId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delTicketPackageticketPackage(ticketPackageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取点券套餐列表
         * @param {SystemGenerateObject207} systemGenerateObject207 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTicketPackageticketPackage(systemGenerateObject207: SystemGenerateObject207, options?: any): AxiosPromise<any> {
            return localVarFp.listTicketPackageticketPackage(systemGenerateObject207, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取点券套餐列表(分页)
         * @param {SystemGenerateObject208} systemGenerateObject208 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageTicketPackageticketPackage(systemGenerateObject208: SystemGenerateObject208, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageTicketPackageticketPackage(systemGenerateObject208, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新点券套餐
         * @param {SystemGenerateObject210} systemGenerateObject210 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTicketPackageticketPackage(systemGenerateObject210: SystemGenerateObject210, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateTicketPackageticketPackage(systemGenerateObject210, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TicketPackageApi - object-oriented interface
 * @export
 * @class TicketPackageApi
 * @extends {BaseAPI}
 */
export class TicketPackageApi extends BaseAPI {
    /**
     * 
     * @summary 添加点券套餐
     * @param {SystemGenerateObject209} systemGenerateObject209 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketPackageApi
     */
    public addTicketPackageticketPackage(systemGenerateObject209: SystemGenerateObject209, options?: AxiosRequestConfig) {
        return TicketPackageApiFp(this.configuration).addTicketPackageticketPackage(systemGenerateObject209, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除点券套餐
     * @param {number} ticketPackageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketPackageApi
     */
    public delTicketPackageticketPackage(ticketPackageId: number, options?: AxiosRequestConfig) {
        return TicketPackageApiFp(this.configuration).delTicketPackageticketPackage(ticketPackageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取点券套餐列表
     * @param {SystemGenerateObject207} systemGenerateObject207 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketPackageApi
     */
    public listTicketPackageticketPackage(systemGenerateObject207: SystemGenerateObject207, options?: AxiosRequestConfig) {
        return TicketPackageApiFp(this.configuration).listTicketPackageticketPackage(systemGenerateObject207, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取点券套餐列表(分页)
     * @param {SystemGenerateObject208} systemGenerateObject208 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketPackageApi
     */
    public pageTicketPackageticketPackage(systemGenerateObject208: SystemGenerateObject208, options?: AxiosRequestConfig) {
        return TicketPackageApiFp(this.configuration).pageTicketPackageticketPackage(systemGenerateObject208, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新点券套餐
     * @param {SystemGenerateObject210} systemGenerateObject210 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketPackageApi
     */
    public updateTicketPackageticketPackage(systemGenerateObject210: SystemGenerateObject210, options?: AxiosRequestConfig) {
        return TicketPackageApiFp(this.configuration).updateTicketPackageticketPackage(systemGenerateObject210, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TimerApi - axios parameter creator
 * @export
 */
export const TimerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加定时器
         * @param {SystemGenerateObject184} systemGenerateObject184 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTimertimer: async (systemGenerateObject184: SystemGenerateObject184, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject184' is not null or undefined
            assertParamExists('addTimertimer', 'systemGenerateObject184', systemGenerateObject184)
            const localVarPath = `/timer/addTimer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject184, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除定时器
         * @param {string} timerName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delTimertimer: async (timerName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timerName' is not null or undefined
            assertParamExists('delTimertimer', 'timerName', timerName)
            const localVarPath = `/timer/delTimer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (timerName !== undefined) {
                localVarQueryParameter['timerName'] = timerName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取定时器列表
         * @param {SystemGenerateObject183} systemGenerateObject183 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTimertimer: async (systemGenerateObject183: SystemGenerateObject183, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject183' is not null or undefined
            assertParamExists('listTimertimer', 'systemGenerateObject183', systemGenerateObject183)
            const localVarPath = `/timer/listTimer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject183, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新定时器
         * @param {SystemGenerateObject185} systemGenerateObject185 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimertimer: async (systemGenerateObject185: SystemGenerateObject185, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject185' is not null or undefined
            assertParamExists('updateTimertimer', 'systemGenerateObject185', systemGenerateObject185)
            const localVarPath = `/timer/updateTimer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject185, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TimerApi - functional programming interface
 * @export
 */
export const TimerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TimerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加定时器
         * @param {SystemGenerateObject184} systemGenerateObject184 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTimertimer(systemGenerateObject184: SystemGenerateObject184, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTimertimer(systemGenerateObject184, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除定时器
         * @param {string} timerName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delTimertimer(timerName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delTimertimer(timerName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取定时器列表
         * @param {SystemGenerateObject183} systemGenerateObject183 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTimertimer(systemGenerateObject183: SystemGenerateObject183, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTimertimer(systemGenerateObject183, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新定时器
         * @param {SystemGenerateObject185} systemGenerateObject185 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTimertimer(systemGenerateObject185: SystemGenerateObject185, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTimertimer(systemGenerateObject185, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TimerApi - factory interface
 * @export
 */
export const TimerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TimerApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加定时器
         * @param {SystemGenerateObject184} systemGenerateObject184 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTimertimer(systemGenerateObject184: SystemGenerateObject184, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addTimertimer(systemGenerateObject184, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除定时器
         * @param {string} timerName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delTimertimer(timerName: string, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delTimertimer(timerName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取定时器列表
         * @param {SystemGenerateObject183} systemGenerateObject183 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTimertimer(systemGenerateObject183: SystemGenerateObject183, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.listTimertimer(systemGenerateObject183, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新定时器
         * @param {SystemGenerateObject185} systemGenerateObject185 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimertimer(systemGenerateObject185: SystemGenerateObject185, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateTimertimer(systemGenerateObject185, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TimerApi - object-oriented interface
 * @export
 * @class TimerApi
 * @extends {BaseAPI}
 */
export class TimerApi extends BaseAPI {
    /**
     * 
     * @summary 添加定时器
     * @param {SystemGenerateObject184} systemGenerateObject184 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimerApi
     */
    public addTimertimer(systemGenerateObject184: SystemGenerateObject184, options?: AxiosRequestConfig) {
        return TimerApiFp(this.configuration).addTimertimer(systemGenerateObject184, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除定时器
     * @param {string} timerName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimerApi
     */
    public delTimertimer(timerName: string, options?: AxiosRequestConfig) {
        return TimerApiFp(this.configuration).delTimertimer(timerName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取定时器列表
     * @param {SystemGenerateObject183} systemGenerateObject183 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimerApi
     */
    public listTimertimer(systemGenerateObject183: SystemGenerateObject183, options?: AxiosRequestConfig) {
        return TimerApiFp(this.configuration).listTimertimer(systemGenerateObject183, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新定时器
     * @param {SystemGenerateObject185} systemGenerateObject185 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimerApi
     */
    public updateTimertimer(systemGenerateObject185: SystemGenerateObject185, options?: AxiosRequestConfig) {
        return TimerApiFp(this.configuration).updateTimertimer(systemGenerateObject185, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UploadApi - axios parameter creator
 * @export
 */
export const UploadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 上传图片
         * @summary 上传图片
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageUpload: async (files: Array<File>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'files' is not null or undefined
            assertParamExists('imageUpload', 'files', files)
            const localVarPath = `/upload/image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UploadApi - functional programming interface
 * @export
 */
export const UploadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UploadApiAxiosParamCreator(configuration)
    return {
        /**
         * 上传图片
         * @summary 上传图片
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async imageUpload(files: Array<File>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.imageUpload(files, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UploadApi - factory interface
 * @export
 */
export const UploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UploadApiFp(configuration)
    return {
        /**
         * 上传图片
         * @summary 上传图片
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageUpload(files: Array<File>, options?: any): AxiosPromise<any> {
            return localVarFp.imageUpload(files, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UploadApi - object-oriented interface
 * @export
 * @class UploadApi
 * @extends {BaseAPI}
 */
export class UploadApi extends BaseAPI {
    /**
     * 上传图片
     * @summary 上传图片
     * @param {Array<File>} files 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadApi
     */
    public imageUpload(files: Array<File>, options?: AxiosRequestConfig) {
        return UploadApiFp(this.configuration).imageUpload(files, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 获取用户客户端信息
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserClientVouser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/getUserClientVo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改客户的videoCount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        increaseVideoCountuser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/increaseVideoCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 获取用户客户端信息
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserClientVouser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserClientVouser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改客户的videoCount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async increaseVideoCountuser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.increaseVideoCountuser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * 
         * @summary 获取用户客户端信息
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserClientVouser(options?: any): AxiosPromise<any> {
            return localVarFp.getUserClientVouser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改客户的videoCount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        increaseVideoCountuser(options?: any): AxiosPromise<ResultVo> {
            return localVarFp.increaseVideoCountuser(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @summary 获取用户客户端信息
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUserClientVouser(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).getUserClientVouser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改客户的videoCount
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public increaseVideoCountuser(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).increaseVideoCountuser(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserSubscriptionApi - axios parameter creator
 * @export
 */
export const UserSubscriptionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加用户订阅
         * @param {SystemGenerateObject250} systemGenerateObject250 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserSubscriptionuserSubscription: async (systemGenerateObject250: SystemGenerateObject250, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject250' is not null or undefined
            assertParamExists('addUserSubscriptionuserSubscription', 'systemGenerateObject250', systemGenerateObject250)
            const localVarPath = `/userSubscription/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject250, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 检查用户是否已订阅指定快递单号
         * @param {SystemGenerateObject252} systemGenerateObject252 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkSubscriptionuserSubscription: async (systemGenerateObject252: SystemGenerateObject252, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject252' is not null or undefined
            assertParamExists('checkSubscriptionuserSubscription', 'systemGenerateObject252', systemGenerateObject252)
            const localVarPath = `/userSubscription/checkSubscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject252, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除用户订阅
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delUserSubscriptionuserSubscription: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('delUserSubscriptionuserSubscription', 'id', id)
            const localVarPath = `/userSubscription/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 免费订阅快递
         * @param {SystemGenerateObject254} systemGenerateObject254 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        freeSubscriptionuserSubscription: async (systemGenerateObject254: SystemGenerateObject254, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject254' is not null or undefined
            assertParamExists('freeSubscriptionuserSubscription', 'systemGenerateObject254', systemGenerateObject254)
            const localVarPath = `/userSubscription/freeSubscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject254, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 判断单号是否订阅
         * @param {SystemGenerateObject253} systemGenerateObject253 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isSubscribeduserSubscription: async (systemGenerateObject253: SystemGenerateObject253, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject253' is not null or undefined
            assertParamExists('isSubscribeduserSubscription', 'systemGenerateObject253', systemGenerateObject253)
            const localVarPath = `/userSubscription/isSubscribed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject253, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取用户订阅列表
         * @param {SystemGenerateObject248} systemGenerateObject248 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserSubscriptionuserSubscription: async (systemGenerateObject248: SystemGenerateObject248, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject248' is not null or undefined
            assertParamExists('listUserSubscriptionuserSubscription', 'systemGenerateObject248', systemGenerateObject248)
            const localVarPath = `/userSubscription/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject248, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取当前用户的订阅列表
         * @param {SystemGenerateObject256} systemGenerateObject256 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mySubscriptionsuserSubscription: async (systemGenerateObject256: SystemGenerateObject256, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject256' is not null or undefined
            assertParamExists('mySubscriptionsuserSubscription', 'systemGenerateObject256', systemGenerateObject256)
            const localVarPath = `/userSubscription/mySubscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject256, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取用户订阅列表(分页)
         * @param {SystemGenerateObject249} systemGenerateObject249 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUserSubscriptionuserSubscription: async (systemGenerateObject249: SystemGenerateObject249, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject249' is not null or undefined
            assertParamExists('pageUserSubscriptionuserSubscription', 'systemGenerateObject249', systemGenerateObject249)
            const localVarPath = `/userSubscription/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject249, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 自付费订阅
         * @param {SystemGenerateObject255} systemGenerateObject255 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfSubscriptionuserSubscription: async (systemGenerateObject255: SystemGenerateObject255, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject255' is not null or undefined
            assertParamExists('selfSubscriptionuserSubscription', 'systemGenerateObject255', systemGenerateObject255)
            const localVarPath = `/userSubscription/selfSubscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject255, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新用户订阅
         * @param {SystemGenerateObject251} systemGenerateObject251 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserSubscriptionuserSubscription: async (systemGenerateObject251: SystemGenerateObject251, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject251' is not null or undefined
            assertParamExists('updateUserSubscriptionuserSubscription', 'systemGenerateObject251', systemGenerateObject251)
            const localVarPath = `/userSubscription/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject251, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserSubscriptionApi - functional programming interface
 * @export
 */
export const UserSubscriptionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserSubscriptionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加用户订阅
         * @param {SystemGenerateObject250} systemGenerateObject250 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addUserSubscriptionuserSubscription(systemGenerateObject250: SystemGenerateObject250, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addUserSubscriptionuserSubscription(systemGenerateObject250, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 检查用户是否已订阅指定快递单号
         * @param {SystemGenerateObject252} systemGenerateObject252 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkSubscriptionuserSubscription(systemGenerateObject252: SystemGenerateObject252, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkSubscriptionuserSubscription(systemGenerateObject252, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除用户订阅
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delUserSubscriptionuserSubscription(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delUserSubscriptionuserSubscription(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 免费订阅快递
         * @param {SystemGenerateObject254} systemGenerateObject254 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async freeSubscriptionuserSubscription(systemGenerateObject254: SystemGenerateObject254, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.freeSubscriptionuserSubscription(systemGenerateObject254, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 判断单号是否订阅
         * @param {SystemGenerateObject253} systemGenerateObject253 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isSubscribeduserSubscription(systemGenerateObject253: SystemGenerateObject253, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isSubscribeduserSubscription(systemGenerateObject253, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取用户订阅列表
         * @param {SystemGenerateObject248} systemGenerateObject248 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUserSubscriptionuserSubscription(systemGenerateObject248: SystemGenerateObject248, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUserSubscriptionuserSubscription(systemGenerateObject248, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取当前用户的订阅列表
         * @param {SystemGenerateObject256} systemGenerateObject256 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mySubscriptionsuserSubscription(systemGenerateObject256: SystemGenerateObject256, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mySubscriptionsuserSubscription(systemGenerateObject256, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取用户订阅列表(分页)
         * @param {SystemGenerateObject249} systemGenerateObject249 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageUserSubscriptionuserSubscription(systemGenerateObject249: SystemGenerateObject249, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageUserSubscriptionuserSubscription(systemGenerateObject249, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 自付费订阅
         * @param {SystemGenerateObject255} systemGenerateObject255 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async selfSubscriptionuserSubscription(systemGenerateObject255: SystemGenerateObject255, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.selfSubscriptionuserSubscription(systemGenerateObject255, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新用户订阅
         * @param {SystemGenerateObject251} systemGenerateObject251 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserSubscriptionuserSubscription(systemGenerateObject251: SystemGenerateObject251, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserSubscriptionuserSubscription(systemGenerateObject251, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserSubscriptionApi - factory interface
 * @export
 */
export const UserSubscriptionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserSubscriptionApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加用户订阅
         * @param {SystemGenerateObject250} systemGenerateObject250 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserSubscriptionuserSubscription(systemGenerateObject250: SystemGenerateObject250, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addUserSubscriptionuserSubscription(systemGenerateObject250, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 检查用户是否已订阅指定快递单号
         * @param {SystemGenerateObject252} systemGenerateObject252 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkSubscriptionuserSubscription(systemGenerateObject252: SystemGenerateObject252, options?: any): AxiosPromise<any> {
            return localVarFp.checkSubscriptionuserSubscription(systemGenerateObject252, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除用户订阅
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delUserSubscriptionuserSubscription(id: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delUserSubscriptionuserSubscription(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 免费订阅快递
         * @param {SystemGenerateObject254} systemGenerateObject254 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        freeSubscriptionuserSubscription(systemGenerateObject254: SystemGenerateObject254, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.freeSubscriptionuserSubscription(systemGenerateObject254, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 判断单号是否订阅
         * @param {SystemGenerateObject253} systemGenerateObject253 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isSubscribeduserSubscription(systemGenerateObject253: SystemGenerateObject253, options?: any): AxiosPromise<any> {
            return localVarFp.isSubscribeduserSubscription(systemGenerateObject253, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取用户订阅列表
         * @param {SystemGenerateObject248} systemGenerateObject248 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserSubscriptionuserSubscription(systemGenerateObject248: SystemGenerateObject248, options?: any): AxiosPromise<any> {
            return localVarFp.listUserSubscriptionuserSubscription(systemGenerateObject248, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取当前用户的订阅列表
         * @param {SystemGenerateObject256} systemGenerateObject256 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mySubscriptionsuserSubscription(systemGenerateObject256: SystemGenerateObject256, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.mySubscriptionsuserSubscription(systemGenerateObject256, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取用户订阅列表(分页)
         * @param {SystemGenerateObject249} systemGenerateObject249 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUserSubscriptionuserSubscription(systemGenerateObject249: SystemGenerateObject249, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageUserSubscriptionuserSubscription(systemGenerateObject249, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 自付费订阅
         * @param {SystemGenerateObject255} systemGenerateObject255 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfSubscriptionuserSubscription(systemGenerateObject255: SystemGenerateObject255, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.selfSubscriptionuserSubscription(systemGenerateObject255, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新用户订阅
         * @param {SystemGenerateObject251} systemGenerateObject251 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserSubscriptionuserSubscription(systemGenerateObject251: SystemGenerateObject251, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateUserSubscriptionuserSubscription(systemGenerateObject251, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserSubscriptionApi - object-oriented interface
 * @export
 * @class UserSubscriptionApi
 * @extends {BaseAPI}
 */
export class UserSubscriptionApi extends BaseAPI {
    /**
     * 
     * @summary 添加用户订阅
     * @param {SystemGenerateObject250} systemGenerateObject250 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSubscriptionApi
     */
    public addUserSubscriptionuserSubscription(systemGenerateObject250: SystemGenerateObject250, options?: AxiosRequestConfig) {
        return UserSubscriptionApiFp(this.configuration).addUserSubscriptionuserSubscription(systemGenerateObject250, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 检查用户是否已订阅指定快递单号
     * @param {SystemGenerateObject252} systemGenerateObject252 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSubscriptionApi
     */
    public checkSubscriptionuserSubscription(systemGenerateObject252: SystemGenerateObject252, options?: AxiosRequestConfig) {
        return UserSubscriptionApiFp(this.configuration).checkSubscriptionuserSubscription(systemGenerateObject252, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除用户订阅
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSubscriptionApi
     */
    public delUserSubscriptionuserSubscription(id: number, options?: AxiosRequestConfig) {
        return UserSubscriptionApiFp(this.configuration).delUserSubscriptionuserSubscription(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 免费订阅快递
     * @param {SystemGenerateObject254} systemGenerateObject254 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSubscriptionApi
     */
    public freeSubscriptionuserSubscription(systemGenerateObject254: SystemGenerateObject254, options?: AxiosRequestConfig) {
        return UserSubscriptionApiFp(this.configuration).freeSubscriptionuserSubscription(systemGenerateObject254, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 判断单号是否订阅
     * @param {SystemGenerateObject253} systemGenerateObject253 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSubscriptionApi
     */
    public isSubscribeduserSubscription(systemGenerateObject253: SystemGenerateObject253, options?: AxiosRequestConfig) {
        return UserSubscriptionApiFp(this.configuration).isSubscribeduserSubscription(systemGenerateObject253, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取用户订阅列表
     * @param {SystemGenerateObject248} systemGenerateObject248 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSubscriptionApi
     */
    public listUserSubscriptionuserSubscription(systemGenerateObject248: SystemGenerateObject248, options?: AxiosRequestConfig) {
        return UserSubscriptionApiFp(this.configuration).listUserSubscriptionuserSubscription(systemGenerateObject248, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取当前用户的订阅列表
     * @param {SystemGenerateObject256} systemGenerateObject256 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSubscriptionApi
     */
    public mySubscriptionsuserSubscription(systemGenerateObject256: SystemGenerateObject256, options?: AxiosRequestConfig) {
        return UserSubscriptionApiFp(this.configuration).mySubscriptionsuserSubscription(systemGenerateObject256, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取用户订阅列表(分页)
     * @param {SystemGenerateObject249} systemGenerateObject249 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSubscriptionApi
     */
    public pageUserSubscriptionuserSubscription(systemGenerateObject249: SystemGenerateObject249, options?: AxiosRequestConfig) {
        return UserSubscriptionApiFp(this.configuration).pageUserSubscriptionuserSubscription(systemGenerateObject249, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 自付费订阅
     * @param {SystemGenerateObject255} systemGenerateObject255 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSubscriptionApi
     */
    public selfSubscriptionuserSubscription(systemGenerateObject255: SystemGenerateObject255, options?: AxiosRequestConfig) {
        return UserSubscriptionApiFp(this.configuration).selfSubscriptionuserSubscription(systemGenerateObject255, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新用户订阅
     * @param {SystemGenerateObject251} systemGenerateObject251 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSubscriptionApi
     */
    public updateUserSubscriptionuserSubscription(systemGenerateObject251: SystemGenerateObject251, options?: AxiosRequestConfig) {
        return UserSubscriptionApiFp(this.configuration).updateUserSubscriptionuserSubscription(systemGenerateObject251, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WeappApi - axios parameter creator
 * @export
 */
export const WeappApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加微信小程序(获取授权信息)
         * @param {SystemGenerateObject63} systemGenerateObject63 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWeappweapp: async (systemGenerateObject63: SystemGenerateObject63, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject63' is not null or undefined
            assertParamExists('addWeappweapp', 'systemGenerateObject63', systemGenerateObject63)
            const localVarPath = `/weapp/addWeapp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject63, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 检查配置基础配置（服务器域名、业务域名、类目）
         * @param {SystemGenerateObject67} systemGenerateObject67 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkBaseSettingweapp: async (systemGenerateObject67: SystemGenerateObject67, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject67' is not null or undefined
            assertParamExists('checkBaseSettingweapp', 'systemGenerateObject67', systemGenerateObject67)
            const localVarPath = `/weapp/checkBaseSetting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject67, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 检查接口配置（定位）
         * @param {SystemGenerateObject68} systemGenerateObject68 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPrivacyInterfaceweapp: async (systemGenerateObject68: SystemGenerateObject68, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject68' is not null or undefined
            assertParamExists('checkPrivacyInterfaceweapp', 'systemGenerateObject68', systemGenerateObject68)
            const localVarPath = `/weapp/checkPrivacyInterface`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject68, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 检查发布状态
         * @param {SystemGenerateObject69} systemGenerateObject69 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkStatusweapp: async (systemGenerateObject69: SystemGenerateObject69, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject69' is not null or undefined
            assertParamExists('checkStatusweapp', 'systemGenerateObject69', systemGenerateObject69)
            const localVarPath = `/weapp/checkStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject69, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除微信小程序
         * @param {string} appid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delWeappweapp: async (appid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appid' is not null or undefined
            assertParamExists('delWeappweapp', 'appid', appid)
            const localVarPath = `/weapp/delWeapp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (appid !== undefined) {
                localVarQueryParameter['appid'] = appid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取微信小程序二维码
         * @param {SystemGenerateObject78} systemGenerateObject78 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQrcodeweapp: async (systemGenerateObject78: SystemGenerateObject78, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject78' is not null or undefined
            assertParamExists('getQrcodeweapp', 'systemGenerateObject78', systemGenerateObject78)
            const localVarPath = `/weapp/getQrcode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject78, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取可回退的小程序版本列表
         * @param {SystemGenerateObject76} systemGenerateObject76 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRevertVersionListweapp: async (systemGenerateObject76: SystemGenerateObject76, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject76' is not null or undefined
            assertParamExists('getRevertVersionListweapp', 'systemGenerateObject76', systemGenerateObject76)
            const localVarPath = `/weapp/getRevertVersionList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject76, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取小程序版本信息（体验版和线上版）
         * @param {SystemGenerateObject75} systemGenerateObject75 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersionInfoweapp: async (systemGenerateObject75: SystemGenerateObject75, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject75' is not null or undefined
            assertParamExists('getVersionInfoweapp', 'systemGenerateObject75', systemGenerateObject75)
            const localVarPath = `/weapp/getVersionInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject75, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取微信小程序授权连接
         * @param {SystemGenerateObject62} systemGenerateObject62 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeappAuthUrlweapp: async (systemGenerateObject62: SystemGenerateObject62, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject62' is not null or undefined
            assertParamExists('getWeappAuthUrlweapp', 'systemGenerateObject62', systemGenerateObject62)
            const localVarPath = `/weapp/getWeappAuthUrl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject62, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取微信小程序列表
         * @param {SystemGenerateObject60} systemGenerateObject60 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWeappweapp: async (systemGenerateObject60: SystemGenerateObject60, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject60' is not null or undefined
            assertParamExists('listWeappweapp', 'systemGenerateObject60', systemGenerateObject60)
            const localVarPath = `/weapp/listWeapp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject60, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 登录微信小程序
         * @param {SystemGenerateObject65} systemGenerateObject65 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginweapp: async (systemGenerateObject65: SystemGenerateObject65, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject65' is not null or undefined
            assertParamExists('loginweapp', 'systemGenerateObject65', systemGenerateObject65)
            const localVarPath = `/weapp/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject65, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取微信小程序列表(分页)
         * @param {SystemGenerateObject61} systemGenerateObject61 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageWeappweapp: async (systemGenerateObject61: SystemGenerateObject61, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject61' is not null or undefined
            assertParamExists('pageWeappweapp', 'systemGenerateObject61', systemGenerateObject61)
            const localVarPath = `/weapp/pageWeapp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject61, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配置发布小程序
         * @param {SystemGenerateObject73} systemGenerateObject73 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishWeappweapp: async (systemGenerateObject73: SystemGenerateObject73, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject73' is not null or undefined
            assertParamExists('publishWeappweapp', 'systemGenerateObject73', systemGenerateObject73)
            const localVarPath = `/weapp/publishWeapp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject73, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 授权微信小程序
         * @param {SystemGenerateObject66} systemGenerateObject66 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerweapp: async (systemGenerateObject66: SystemGenerateObject66, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject66' is not null or undefined
            assertParamExists('registerweapp', 'systemGenerateObject66', systemGenerateObject66)
            const localVarPath = `/weapp/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject66, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 回退小程序版本
         * @param {SystemGenerateObject77} systemGenerateObject77 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revertCodeReleaseweapp: async (systemGenerateObject77: SystemGenerateObject77, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject77' is not null or undefined
            assertParamExists('revertCodeReleaseweapp', 'systemGenerateObject77', systemGenerateObject77)
            const localVarPath = `/weapp/revertCodeRelease`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject77, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配置所有
         * @param {SystemGenerateObject72} systemGenerateObject72 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAllweapp: async (systemGenerateObject72: SystemGenerateObject72, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject72' is not null or undefined
            assertParamExists('setAllweapp', 'systemGenerateObject72', systemGenerateObject72)
            const localVarPath = `/weapp/setAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject72, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配置基础配置（服务器域名、业务域名、类目）
         * @param {SystemGenerateObject70} systemGenerateObject70 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setBaseSettingweapp: async (systemGenerateObject70: SystemGenerateObject70, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject70' is not null or undefined
            assertParamExists('setBaseSettingweapp', 'systemGenerateObject70', systemGenerateObject70)
            const localVarPath = `/weapp/setBaseSetting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject70, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配置接口配置（定位）
         * @param {SystemGenerateObject71} systemGenerateObject71 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPrivacyInterfaceweapp: async (systemGenerateObject71: SystemGenerateObject71, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject71' is not null or undefined
            assertParamExists('setPrivacyInterfaceweapp', 'systemGenerateObject71', systemGenerateObject71)
            const localVarPath = `/weapp/setPrivacyInterface`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject71, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 撤回代码审核
         * @param {SystemGenerateObject74} systemGenerateObject74 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoAuditweapp: async (systemGenerateObject74: SystemGenerateObject74, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject74' is not null or undefined
            assertParamExists('undoAuditweapp', 'systemGenerateObject74', systemGenerateObject74)
            const localVarPath = `/weapp/undoAudit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject74, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新微信小程序
         * @param {SystemGenerateObject64} systemGenerateObject64 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWeappweapp: async (systemGenerateObject64: SystemGenerateObject64, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject64' is not null or undefined
            assertParamExists('updateWeappweapp', 'systemGenerateObject64', systemGenerateObject64)
            const localVarPath = `/weapp/updateWeapp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject64, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 微信小程序验证token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        veryfyTokenweapp: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/weapp/veryfyToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WeappApi - functional programming interface
 * @export
 */
export const WeappApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WeappApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加微信小程序(获取授权信息)
         * @param {SystemGenerateObject63} systemGenerateObject63 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addWeappweapp(systemGenerateObject63: SystemGenerateObject63, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addWeappweapp(systemGenerateObject63, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 检查配置基础配置（服务器域名、业务域名、类目）
         * @param {SystemGenerateObject67} systemGenerateObject67 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkBaseSettingweapp(systemGenerateObject67: SystemGenerateObject67, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkBaseSettingweapp(systemGenerateObject67, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 检查接口配置（定位）
         * @param {SystemGenerateObject68} systemGenerateObject68 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkPrivacyInterfaceweapp(systemGenerateObject68: SystemGenerateObject68, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkPrivacyInterfaceweapp(systemGenerateObject68, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 检查发布状态
         * @param {SystemGenerateObject69} systemGenerateObject69 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkStatusweapp(systemGenerateObject69: SystemGenerateObject69, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkStatusweapp(systemGenerateObject69, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除微信小程序
         * @param {string} appid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delWeappweapp(appid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delWeappweapp(appid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取微信小程序二维码
         * @param {SystemGenerateObject78} systemGenerateObject78 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQrcodeweapp(systemGenerateObject78: SystemGenerateObject78, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQrcodeweapp(systemGenerateObject78, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取可回退的小程序版本列表
         * @param {SystemGenerateObject76} systemGenerateObject76 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRevertVersionListweapp(systemGenerateObject76: SystemGenerateObject76, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRevertVersionListweapp(systemGenerateObject76, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取小程序版本信息（体验版和线上版）
         * @param {SystemGenerateObject75} systemGenerateObject75 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVersionInfoweapp(systemGenerateObject75: SystemGenerateObject75, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVersionInfoweapp(systemGenerateObject75, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取微信小程序授权连接
         * @param {SystemGenerateObject62} systemGenerateObject62 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWeappAuthUrlweapp(systemGenerateObject62: SystemGenerateObject62, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWeappAuthUrlweapp(systemGenerateObject62, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取微信小程序列表
         * @param {SystemGenerateObject60} systemGenerateObject60 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWeappweapp(systemGenerateObject60: SystemGenerateObject60, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWeappweapp(systemGenerateObject60, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 登录微信小程序
         * @param {SystemGenerateObject65} systemGenerateObject65 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginweapp(systemGenerateObject65: SystemGenerateObject65, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginweapp(systemGenerateObject65, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取微信小程序列表(分页)
         * @param {SystemGenerateObject61} systemGenerateObject61 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageWeappweapp(systemGenerateObject61: SystemGenerateObject61, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageWeappweapp(systemGenerateObject61, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 配置发布小程序
         * @param {SystemGenerateObject73} systemGenerateObject73 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishWeappweapp(systemGenerateObject73: SystemGenerateObject73, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publishWeappweapp(systemGenerateObject73, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 授权微信小程序
         * @param {SystemGenerateObject66} systemGenerateObject66 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerweapp(systemGenerateObject66: SystemGenerateObject66, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerweapp(systemGenerateObject66, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 回退小程序版本
         * @param {SystemGenerateObject77} systemGenerateObject77 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revertCodeReleaseweapp(systemGenerateObject77: SystemGenerateObject77, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revertCodeReleaseweapp(systemGenerateObject77, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 配置所有
         * @param {SystemGenerateObject72} systemGenerateObject72 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAllweapp(systemGenerateObject72: SystemGenerateObject72, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAllweapp(systemGenerateObject72, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 配置基础配置（服务器域名、业务域名、类目）
         * @param {SystemGenerateObject70} systemGenerateObject70 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setBaseSettingweapp(systemGenerateObject70: SystemGenerateObject70, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setBaseSettingweapp(systemGenerateObject70, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 配置接口配置（定位）
         * @param {SystemGenerateObject71} systemGenerateObject71 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPrivacyInterfaceweapp(systemGenerateObject71: SystemGenerateObject71, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPrivacyInterfaceweapp(systemGenerateObject71, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 撤回代码审核
         * @param {SystemGenerateObject74} systemGenerateObject74 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async undoAuditweapp(systemGenerateObject74: SystemGenerateObject74, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.undoAuditweapp(systemGenerateObject74, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新微信小程序
         * @param {SystemGenerateObject64} systemGenerateObject64 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWeappweapp(systemGenerateObject64: SystemGenerateObject64, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWeappweapp(systemGenerateObject64, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 微信小程序验证token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async veryfyTokenweapp(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.veryfyTokenweapp(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WeappApi - factory interface
 * @export
 */
export const WeappApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WeappApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加微信小程序(获取授权信息)
         * @param {SystemGenerateObject63} systemGenerateObject63 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWeappweapp(systemGenerateObject63: SystemGenerateObject63, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addWeappweapp(systemGenerateObject63, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 检查配置基础配置（服务器域名、业务域名、类目）
         * @param {SystemGenerateObject67} systemGenerateObject67 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkBaseSettingweapp(systemGenerateObject67: SystemGenerateObject67, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.checkBaseSettingweapp(systemGenerateObject67, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 检查接口配置（定位）
         * @param {SystemGenerateObject68} systemGenerateObject68 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPrivacyInterfaceweapp(systemGenerateObject68: SystemGenerateObject68, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.checkPrivacyInterfaceweapp(systemGenerateObject68, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 检查发布状态
         * @param {SystemGenerateObject69} systemGenerateObject69 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkStatusweapp(systemGenerateObject69: SystemGenerateObject69, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.checkStatusweapp(systemGenerateObject69, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除微信小程序
         * @param {string} appid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delWeappweapp(appid: string, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delWeappweapp(appid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取微信小程序二维码
         * @param {SystemGenerateObject78} systemGenerateObject78 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQrcodeweapp(systemGenerateObject78: SystemGenerateObject78, options?: any): AxiosPromise<any> {
            return localVarFp.getQrcodeweapp(systemGenerateObject78, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取可回退的小程序版本列表
         * @param {SystemGenerateObject76} systemGenerateObject76 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRevertVersionListweapp(systemGenerateObject76: SystemGenerateObject76, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.getRevertVersionListweapp(systemGenerateObject76, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取小程序版本信息（体验版和线上版）
         * @param {SystemGenerateObject75} systemGenerateObject75 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersionInfoweapp(systemGenerateObject75: SystemGenerateObject75, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.getVersionInfoweapp(systemGenerateObject75, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取微信小程序授权连接
         * @param {SystemGenerateObject62} systemGenerateObject62 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeappAuthUrlweapp(systemGenerateObject62: SystemGenerateObject62, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.getWeappAuthUrlweapp(systemGenerateObject62, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取微信小程序列表
         * @param {SystemGenerateObject60} systemGenerateObject60 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWeappweapp(systemGenerateObject60: SystemGenerateObject60, options?: any): AxiosPromise<any> {
            return localVarFp.listWeappweapp(systemGenerateObject60, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 登录微信小程序
         * @param {SystemGenerateObject65} systemGenerateObject65 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginweapp(systemGenerateObject65: SystemGenerateObject65, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.loginweapp(systemGenerateObject65, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取微信小程序列表(分页)
         * @param {SystemGenerateObject61} systemGenerateObject61 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageWeappweapp(systemGenerateObject61: SystemGenerateObject61, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageWeappweapp(systemGenerateObject61, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配置发布小程序
         * @param {SystemGenerateObject73} systemGenerateObject73 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishWeappweapp(systemGenerateObject73: SystemGenerateObject73, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.publishWeappweapp(systemGenerateObject73, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 授权微信小程序
         * @param {SystemGenerateObject66} systemGenerateObject66 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerweapp(systemGenerateObject66: SystemGenerateObject66, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.registerweapp(systemGenerateObject66, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 回退小程序版本
         * @param {SystemGenerateObject77} systemGenerateObject77 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revertCodeReleaseweapp(systemGenerateObject77: SystemGenerateObject77, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.revertCodeReleaseweapp(systemGenerateObject77, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配置所有
         * @param {SystemGenerateObject72} systemGenerateObject72 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAllweapp(systemGenerateObject72: SystemGenerateObject72, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.setAllweapp(systemGenerateObject72, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配置基础配置（服务器域名、业务域名、类目）
         * @param {SystemGenerateObject70} systemGenerateObject70 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setBaseSettingweapp(systemGenerateObject70: SystemGenerateObject70, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.setBaseSettingweapp(systemGenerateObject70, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配置接口配置（定位）
         * @param {SystemGenerateObject71} systemGenerateObject71 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPrivacyInterfaceweapp(systemGenerateObject71: SystemGenerateObject71, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.setPrivacyInterfaceweapp(systemGenerateObject71, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 撤回代码审核
         * @param {SystemGenerateObject74} systemGenerateObject74 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoAuditweapp(systemGenerateObject74: SystemGenerateObject74, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.undoAuditweapp(systemGenerateObject74, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新微信小程序
         * @param {SystemGenerateObject64} systemGenerateObject64 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWeappweapp(systemGenerateObject64: SystemGenerateObject64, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateWeappweapp(systemGenerateObject64, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 微信小程序验证token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        veryfyTokenweapp(options?: any): AxiosPromise<ResultVo> {
            return localVarFp.veryfyTokenweapp(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WeappApi - object-oriented interface
 * @export
 * @class WeappApi
 * @extends {BaseAPI}
 */
export class WeappApi extends BaseAPI {
    /**
     * 
     * @summary 添加微信小程序(获取授权信息)
     * @param {SystemGenerateObject63} systemGenerateObject63 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappApi
     */
    public addWeappweapp(systemGenerateObject63: SystemGenerateObject63, options?: AxiosRequestConfig) {
        return WeappApiFp(this.configuration).addWeappweapp(systemGenerateObject63, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 检查配置基础配置（服务器域名、业务域名、类目）
     * @param {SystemGenerateObject67} systemGenerateObject67 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappApi
     */
    public checkBaseSettingweapp(systemGenerateObject67: SystemGenerateObject67, options?: AxiosRequestConfig) {
        return WeappApiFp(this.configuration).checkBaseSettingweapp(systemGenerateObject67, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 检查接口配置（定位）
     * @param {SystemGenerateObject68} systemGenerateObject68 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappApi
     */
    public checkPrivacyInterfaceweapp(systemGenerateObject68: SystemGenerateObject68, options?: AxiosRequestConfig) {
        return WeappApiFp(this.configuration).checkPrivacyInterfaceweapp(systemGenerateObject68, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 检查发布状态
     * @param {SystemGenerateObject69} systemGenerateObject69 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappApi
     */
    public checkStatusweapp(systemGenerateObject69: SystemGenerateObject69, options?: AxiosRequestConfig) {
        return WeappApiFp(this.configuration).checkStatusweapp(systemGenerateObject69, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除微信小程序
     * @param {string} appid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappApi
     */
    public delWeappweapp(appid: string, options?: AxiosRequestConfig) {
        return WeappApiFp(this.configuration).delWeappweapp(appid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取微信小程序二维码
     * @param {SystemGenerateObject78} systemGenerateObject78 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappApi
     */
    public getQrcodeweapp(systemGenerateObject78: SystemGenerateObject78, options?: AxiosRequestConfig) {
        return WeappApiFp(this.configuration).getQrcodeweapp(systemGenerateObject78, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取可回退的小程序版本列表
     * @param {SystemGenerateObject76} systemGenerateObject76 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappApi
     */
    public getRevertVersionListweapp(systemGenerateObject76: SystemGenerateObject76, options?: AxiosRequestConfig) {
        return WeappApiFp(this.configuration).getRevertVersionListweapp(systemGenerateObject76, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取小程序版本信息（体验版和线上版）
     * @param {SystemGenerateObject75} systemGenerateObject75 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappApi
     */
    public getVersionInfoweapp(systemGenerateObject75: SystemGenerateObject75, options?: AxiosRequestConfig) {
        return WeappApiFp(this.configuration).getVersionInfoweapp(systemGenerateObject75, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取微信小程序授权连接
     * @param {SystemGenerateObject62} systemGenerateObject62 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappApi
     */
    public getWeappAuthUrlweapp(systemGenerateObject62: SystemGenerateObject62, options?: AxiosRequestConfig) {
        return WeappApiFp(this.configuration).getWeappAuthUrlweapp(systemGenerateObject62, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取微信小程序列表
     * @param {SystemGenerateObject60} systemGenerateObject60 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappApi
     */
    public listWeappweapp(systemGenerateObject60: SystemGenerateObject60, options?: AxiosRequestConfig) {
        return WeappApiFp(this.configuration).listWeappweapp(systemGenerateObject60, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 登录微信小程序
     * @param {SystemGenerateObject65} systemGenerateObject65 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappApi
     */
    public loginweapp(systemGenerateObject65: SystemGenerateObject65, options?: AxiosRequestConfig) {
        return WeappApiFp(this.configuration).loginweapp(systemGenerateObject65, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取微信小程序列表(分页)
     * @param {SystemGenerateObject61} systemGenerateObject61 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappApi
     */
    public pageWeappweapp(systemGenerateObject61: SystemGenerateObject61, options?: AxiosRequestConfig) {
        return WeappApiFp(this.configuration).pageWeappweapp(systemGenerateObject61, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配置发布小程序
     * @param {SystemGenerateObject73} systemGenerateObject73 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappApi
     */
    public publishWeappweapp(systemGenerateObject73: SystemGenerateObject73, options?: AxiosRequestConfig) {
        return WeappApiFp(this.configuration).publishWeappweapp(systemGenerateObject73, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 授权微信小程序
     * @param {SystemGenerateObject66} systemGenerateObject66 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappApi
     */
    public registerweapp(systemGenerateObject66: SystemGenerateObject66, options?: AxiosRequestConfig) {
        return WeappApiFp(this.configuration).registerweapp(systemGenerateObject66, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 回退小程序版本
     * @param {SystemGenerateObject77} systemGenerateObject77 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappApi
     */
    public revertCodeReleaseweapp(systemGenerateObject77: SystemGenerateObject77, options?: AxiosRequestConfig) {
        return WeappApiFp(this.configuration).revertCodeReleaseweapp(systemGenerateObject77, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配置所有
     * @param {SystemGenerateObject72} systemGenerateObject72 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappApi
     */
    public setAllweapp(systemGenerateObject72: SystemGenerateObject72, options?: AxiosRequestConfig) {
        return WeappApiFp(this.configuration).setAllweapp(systemGenerateObject72, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配置基础配置（服务器域名、业务域名、类目）
     * @param {SystemGenerateObject70} systemGenerateObject70 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappApi
     */
    public setBaseSettingweapp(systemGenerateObject70: SystemGenerateObject70, options?: AxiosRequestConfig) {
        return WeappApiFp(this.configuration).setBaseSettingweapp(systemGenerateObject70, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配置接口配置（定位）
     * @param {SystemGenerateObject71} systemGenerateObject71 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappApi
     */
    public setPrivacyInterfaceweapp(systemGenerateObject71: SystemGenerateObject71, options?: AxiosRequestConfig) {
        return WeappApiFp(this.configuration).setPrivacyInterfaceweapp(systemGenerateObject71, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 撤回代码审核
     * @param {SystemGenerateObject74} systemGenerateObject74 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappApi
     */
    public undoAuditweapp(systemGenerateObject74: SystemGenerateObject74, options?: AxiosRequestConfig) {
        return WeappApiFp(this.configuration).undoAuditweapp(systemGenerateObject74, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新微信小程序
     * @param {SystemGenerateObject64} systemGenerateObject64 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappApi
     */
    public updateWeappweapp(systemGenerateObject64: SystemGenerateObject64, options?: AxiosRequestConfig) {
        return WeappApiFp(this.configuration).updateWeappweapp(systemGenerateObject64, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 微信小程序验证token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappApi
     */
    public veryfyTokenweapp(options?: AxiosRequestConfig) {
        return WeappApiFp(this.configuration).veryfyTokenweapp(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WeappTplApi - axios parameter creator
 * @export
 */
export const WeappTplApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加草稿到开放平台模板
         * @param {SystemGenerateObject97} systemGenerateObject97 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTplweappTpl: async (systemGenerateObject97: SystemGenerateObject97, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject97' is not null or undefined
            assertParamExists('addTplweappTpl', 'systemGenerateObject97', systemGenerateObject97)
            const localVarPath = `/weappTpl/addTpl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject97, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 添加微信小程序模板
         * @param {WeappTplAdminVo} weappTplAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWeappTplweappTpl: async (weappTplAdminVo: WeappTplAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weappTplAdminVo' is not null or undefined
            assertParamExists('addWeappTplweappTpl', 'weappTplAdminVo', weappTplAdminVo)
            const localVarPath = `/weappTpl/addWeappTpl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(weappTplAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除开放平台模板
         * @param {number} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delTplweappTpl: async (templateId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('delTplweappTpl', 'templateId', templateId)
            const localVarPath = `/weappTpl/delTpl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (templateId !== undefined) {
                localVarQueryParameter['templateId'] = templateId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除微信小程序模板
         * @param {number} weappTplId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delWeappTplweappTpl: async (weappTplId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weappTplId' is not null or undefined
            assertParamExists('delWeappTplweappTpl', 'weappTplId', weappTplId)
            const localVarPath = `/weappTpl/delWeappTpl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (weappTplId !== undefined) {
                localVarQueryParameter['weappTplId'] = weappTplId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取开放平台模板草稿列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTplDraftListweappTpl: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/weappTpl/getTplDraftList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取开放平台模板列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTplListweappTpl: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/weappTpl/getTplList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取租户授权的微信小程序模板列表
         * @param {PartialWeappTplAdminVo} partialWeappTplAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWeappTplByTenantweappTpl: async (partialWeappTplAdminVo: PartialWeappTplAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partialWeappTplAdminVo' is not null or undefined
            assertParamExists('listWeappTplByTenantweappTpl', 'partialWeappTplAdminVo', partialWeappTplAdminVo)
            const localVarPath = `/weappTpl/listWeappTplByTenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partialWeappTplAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取微信小程序模板列表
         * @param {PartialWeappTplAdminVo} partialWeappTplAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWeappTplweappTpl: async (partialWeappTplAdminVo: PartialWeappTplAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partialWeappTplAdminVo' is not null or undefined
            assertParamExists('listWeappTplweappTpl', 'partialWeappTplAdminVo', partialWeappTplAdminVo)
            const localVarPath = `/weappTpl/listWeappTpl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partialWeappTplAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取微信小程序模板列表(分页)
         * @param {SystemGenerateObject96} systemGenerateObject96 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageWeappTplweappTpl: async (systemGenerateObject96: SystemGenerateObject96, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject96' is not null or undefined
            assertParamExists('pageWeappTplweappTpl', 'systemGenerateObject96', systemGenerateObject96)
            const localVarPath = `/weappTpl/pageWeappTpl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject96, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新微信小程序模板
         * @param {WeappTplAdminVo} weappTplAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWeappTplweappTpl: async (weappTplAdminVo: WeappTplAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weappTplAdminVo' is not null or undefined
            assertParamExists('updateWeappTplweappTpl', 'weappTplAdminVo', weappTplAdminVo)
            const localVarPath = `/weappTpl/updateWeappTpl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(weappTplAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WeappTplApi - functional programming interface
 * @export
 */
export const WeappTplApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WeappTplApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加草稿到开放平台模板
         * @param {SystemGenerateObject97} systemGenerateObject97 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTplweappTpl(systemGenerateObject97: SystemGenerateObject97, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTplweappTpl(systemGenerateObject97, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 添加微信小程序模板
         * @param {WeappTplAdminVo} weappTplAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addWeappTplweappTpl(weappTplAdminVo: WeappTplAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addWeappTplweappTpl(weappTplAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除开放平台模板
         * @param {number} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delTplweappTpl(templateId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delTplweappTpl(templateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除微信小程序模板
         * @param {number} weappTplId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delWeappTplweappTpl(weappTplId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delWeappTplweappTpl(weappTplId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取开放平台模板草稿列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTplDraftListweappTpl(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTplDraftListweappTpl(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取开放平台模板列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTplListweappTpl(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTplListweappTpl(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取租户授权的微信小程序模板列表
         * @param {PartialWeappTplAdminVo} partialWeappTplAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWeappTplByTenantweappTpl(partialWeappTplAdminVo: PartialWeappTplAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWeappTplByTenantweappTpl(partialWeappTplAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取微信小程序模板列表
         * @param {PartialWeappTplAdminVo} partialWeappTplAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWeappTplweappTpl(partialWeappTplAdminVo: PartialWeappTplAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWeappTplweappTpl(partialWeappTplAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取微信小程序模板列表(分页)
         * @param {SystemGenerateObject96} systemGenerateObject96 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageWeappTplweappTpl(systemGenerateObject96: SystemGenerateObject96, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageWeappTplweappTpl(systemGenerateObject96, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新微信小程序模板
         * @param {WeappTplAdminVo} weappTplAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWeappTplweappTpl(weappTplAdminVo: WeappTplAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWeappTplweappTpl(weappTplAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WeappTplApi - factory interface
 * @export
 */
export const WeappTplApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WeappTplApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加草稿到开放平台模板
         * @param {SystemGenerateObject97} systemGenerateObject97 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTplweappTpl(systemGenerateObject97: SystemGenerateObject97, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addTplweappTpl(systemGenerateObject97, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 添加微信小程序模板
         * @param {WeappTplAdminVo} weappTplAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWeappTplweappTpl(weappTplAdminVo: WeappTplAdminVo, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addWeappTplweappTpl(weappTplAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除开放平台模板
         * @param {number} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delTplweappTpl(templateId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delTplweappTpl(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除微信小程序模板
         * @param {number} weappTplId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delWeappTplweappTpl(weappTplId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delWeappTplweappTpl(weappTplId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取开放平台模板草稿列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTplDraftListweappTpl(options?: any): AxiosPromise<ResultVo> {
            return localVarFp.getTplDraftListweappTpl(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取开放平台模板列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTplListweappTpl(options?: any): AxiosPromise<ResultVo> {
            return localVarFp.getTplListweappTpl(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取租户授权的微信小程序模板列表
         * @param {PartialWeappTplAdminVo} partialWeappTplAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWeappTplByTenantweappTpl(partialWeappTplAdminVo: PartialWeappTplAdminVo, options?: any): AxiosPromise<any> {
            return localVarFp.listWeappTplByTenantweappTpl(partialWeappTplAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取微信小程序模板列表
         * @param {PartialWeappTplAdminVo} partialWeappTplAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWeappTplweappTpl(partialWeappTplAdminVo: PartialWeappTplAdminVo, options?: any): AxiosPromise<any> {
            return localVarFp.listWeappTplweappTpl(partialWeappTplAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取微信小程序模板列表(分页)
         * @param {SystemGenerateObject96} systemGenerateObject96 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageWeappTplweappTpl(systemGenerateObject96: SystemGenerateObject96, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageWeappTplweappTpl(systemGenerateObject96, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新微信小程序模板
         * @param {WeappTplAdminVo} weappTplAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWeappTplweappTpl(weappTplAdminVo: WeappTplAdminVo, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateWeappTplweappTpl(weappTplAdminVo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WeappTplApi - object-oriented interface
 * @export
 * @class WeappTplApi
 * @extends {BaseAPI}
 */
export class WeappTplApi extends BaseAPI {
    /**
     * 
     * @summary 添加草稿到开放平台模板
     * @param {SystemGenerateObject97} systemGenerateObject97 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappTplApi
     */
    public addTplweappTpl(systemGenerateObject97: SystemGenerateObject97, options?: AxiosRequestConfig) {
        return WeappTplApiFp(this.configuration).addTplweappTpl(systemGenerateObject97, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 添加微信小程序模板
     * @param {WeappTplAdminVo} weappTplAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappTplApi
     */
    public addWeappTplweappTpl(weappTplAdminVo: WeappTplAdminVo, options?: AxiosRequestConfig) {
        return WeappTplApiFp(this.configuration).addWeappTplweappTpl(weappTplAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除开放平台模板
     * @param {number} templateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappTplApi
     */
    public delTplweappTpl(templateId: number, options?: AxiosRequestConfig) {
        return WeappTplApiFp(this.configuration).delTplweappTpl(templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除微信小程序模板
     * @param {number} weappTplId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappTplApi
     */
    public delWeappTplweappTpl(weappTplId: number, options?: AxiosRequestConfig) {
        return WeappTplApiFp(this.configuration).delWeappTplweappTpl(weappTplId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取开放平台模板草稿列表
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappTplApi
     */
    public getTplDraftListweappTpl(options?: AxiosRequestConfig) {
        return WeappTplApiFp(this.configuration).getTplDraftListweappTpl(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取开放平台模板列表
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappTplApi
     */
    public getTplListweappTpl(options?: AxiosRequestConfig) {
        return WeappTplApiFp(this.configuration).getTplListweappTpl(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取租户授权的微信小程序模板列表
     * @param {PartialWeappTplAdminVo} partialWeappTplAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappTplApi
     */
    public listWeappTplByTenantweappTpl(partialWeappTplAdminVo: PartialWeappTplAdminVo, options?: AxiosRequestConfig) {
        return WeappTplApiFp(this.configuration).listWeappTplByTenantweappTpl(partialWeappTplAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取微信小程序模板列表
     * @param {PartialWeappTplAdminVo} partialWeappTplAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappTplApi
     */
    public listWeappTplweappTpl(partialWeappTplAdminVo: PartialWeappTplAdminVo, options?: AxiosRequestConfig) {
        return WeappTplApiFp(this.configuration).listWeappTplweappTpl(partialWeappTplAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取微信小程序模板列表(分页)
     * @param {SystemGenerateObject96} systemGenerateObject96 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappTplApi
     */
    public pageWeappTplweappTpl(systemGenerateObject96: SystemGenerateObject96, options?: AxiosRequestConfig) {
        return WeappTplApiFp(this.configuration).pageWeappTplweappTpl(systemGenerateObject96, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新微信小程序模板
     * @param {WeappTplAdminVo} weappTplAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeappTplApi
     */
    public updateWeappTplweappTpl(weappTplAdminVo: WeappTplAdminVo, options?: AxiosRequestConfig) {
        return WeappTplApiFp(this.configuration).updateWeappTplweappTpl(weappTplAdminVo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WhiteAccountApi - axios parameter creator
 * @export
 */
export const WhiteAccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 同意自身管理的门店白名单申请
         * @param {number} storeId 
         * @param {number} whiteAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessApplywhiteAccount: async (storeId: number, whiteAccountId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('accessApplywhiteAccount', 'storeId', storeId)
            // verify required parameter 'whiteAccountId' is not null or undefined
            assertParamExists('accessApplywhiteAccount', 'whiteAccountId', whiteAccountId)
            const localVarPath = `/whiteAccount/accessApply`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (whiteAccountId !== undefined) {
                localVarQueryParameter['whiteAccountId'] = whiteAccountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 添加自身管理的门店白名单
         * @param {SystemGenerateObject172} systemGenerateObject172 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOwnerStoreWhiteAccountwhiteAccount: async (systemGenerateObject172: SystemGenerateObject172, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject172' is not null or undefined
            assertParamExists('addOwnerStoreWhiteAccountwhiteAccount', 'systemGenerateObject172', systemGenerateObject172)
            const localVarPath = `/whiteAccount/addOwnerStoreWhiteAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject172, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 添加白名单
         * @param {SystemGenerateObject167} systemGenerateObject167 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWhiteAccountwhiteAccount: async (systemGenerateObject167: SystemGenerateObject167, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject167' is not null or undefined
            assertParamExists('addWhiteAccountwhiteAccount', 'systemGenerateObject167', systemGenerateObject167)
            const localVarPath = `/whiteAccount/addWhiteAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject167, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 门店白名单申请
         * @param {number} storeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applywhiteAccount: async (storeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('applywhiteAccount', 'storeId', storeId)
            const localVarPath = `/whiteAccount/apply`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除自身管理的门店白名单
         * @param {number} storeId 
         * @param {number} whiteAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delOwnerStoreWhiteAccountwhiteAccount: async (storeId: number, whiteAccountId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('delOwnerStoreWhiteAccountwhiteAccount', 'storeId', storeId)
            // verify required parameter 'whiteAccountId' is not null or undefined
            assertParamExists('delOwnerStoreWhiteAccountwhiteAccount', 'whiteAccountId', whiteAccountId)
            const localVarPath = `/whiteAccount/delOwnerStoreWhiteAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (whiteAccountId !== undefined) {
                localVarQueryParameter['whiteAccountId'] = whiteAccountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除白名单
         * @param {number} whiteAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delWhiteAccountwhiteAccount: async (whiteAccountId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'whiteAccountId' is not null or undefined
            assertParamExists('delWhiteAccountwhiteAccount', 'whiteAccountId', whiteAccountId)
            const localVarPath = `/whiteAccount/delWhiteAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (whiteAccountId !== undefined) {
                localVarQueryParameter['whiteAccountId'] = whiteAccountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取自身管理的门店白名单申请列表
         * @param {SystemGenerateObject170} systemGenerateObject170 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOwnerStoreApplyWhiteAccountwhiteAccount: async (systemGenerateObject170: SystemGenerateObject170, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject170' is not null or undefined
            assertParamExists('listOwnerStoreApplyWhiteAccountwhiteAccount', 'systemGenerateObject170', systemGenerateObject170)
            const localVarPath = `/whiteAccount/listOwnerStoreApplyWhiteAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject170, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取自身管理的门店白名单列表
         * @param {SystemGenerateObject169} systemGenerateObject169 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOwnerStoreWhiteAccountwhiteAccount: async (systemGenerateObject169: SystemGenerateObject169, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject169' is not null or undefined
            assertParamExists('listOwnerStoreWhiteAccountwhiteAccount', 'systemGenerateObject169', systemGenerateObject169)
            const localVarPath = `/whiteAccount/listOwnerStoreWhiteAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject169, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取白名单列表
         * @param {SystemGenerateObject165} systemGenerateObject165 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWhiteAccountwhiteAccount: async (systemGenerateObject165: SystemGenerateObject165, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject165' is not null or undefined
            assertParamExists('listWhiteAccountwhiteAccount', 'systemGenerateObject165', systemGenerateObject165)
            const localVarPath = `/whiteAccount/listWhiteAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject165, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取自身管理的门店白名单列表(分页)
         * @param {SystemGenerateObject171} systemGenerateObject171 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOwnerStoreWhiteAccountwhiteAccount: async (systemGenerateObject171: SystemGenerateObject171, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject171' is not null or undefined
            assertParamExists('pageOwnerStoreWhiteAccountwhiteAccount', 'systemGenerateObject171', systemGenerateObject171)
            const localVarPath = `/whiteAccount/pageOwnerStoreWhiteAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject171, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取白名单列表(分页)
         * @param {SystemGenerateObject166} systemGenerateObject166 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageWhiteAccountwhiteAccount: async (systemGenerateObject166: SystemGenerateObject166, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject166' is not null or undefined
            assertParamExists('pageWhiteAccountwhiteAccount', 'systemGenerateObject166', systemGenerateObject166)
            const localVarPath = `/whiteAccount/pageWhiteAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject166, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新自身管理的门店白名单
         * @param {SystemGenerateObject173} systemGenerateObject173 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOwnerStoreWhiteAccountwhiteAccount: async (systemGenerateObject173: SystemGenerateObject173, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject173' is not null or undefined
            assertParamExists('updateOwnerStoreWhiteAccountwhiteAccount', 'systemGenerateObject173', systemGenerateObject173)
            const localVarPath = `/whiteAccount/updateOwnerStoreWhiteAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject173, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新白名单
         * @param {SystemGenerateObject168} systemGenerateObject168 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWhiteAccountwhiteAccount: async (systemGenerateObject168: SystemGenerateObject168, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject168' is not null or undefined
            assertParamExists('updateWhiteAccountwhiteAccount', 'systemGenerateObject168', systemGenerateObject168)
            const localVarPath = `/whiteAccount/updateWhiteAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject168, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WhiteAccountApi - functional programming interface
 * @export
 */
export const WhiteAccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WhiteAccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 同意自身管理的门店白名单申请
         * @param {number} storeId 
         * @param {number} whiteAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accessApplywhiteAccount(storeId: number, whiteAccountId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accessApplywhiteAccount(storeId, whiteAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 添加自身管理的门店白名单
         * @param {SystemGenerateObject172} systemGenerateObject172 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOwnerStoreWhiteAccountwhiteAccount(systemGenerateObject172: SystemGenerateObject172, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOwnerStoreWhiteAccountwhiteAccount(systemGenerateObject172, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 添加白名单
         * @param {SystemGenerateObject167} systemGenerateObject167 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addWhiteAccountwhiteAccount(systemGenerateObject167: SystemGenerateObject167, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addWhiteAccountwhiteAccount(systemGenerateObject167, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 门店白名单申请
         * @param {number} storeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applywhiteAccount(storeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applywhiteAccount(storeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除自身管理的门店白名单
         * @param {number} storeId 
         * @param {number} whiteAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delOwnerStoreWhiteAccountwhiteAccount(storeId: number, whiteAccountId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delOwnerStoreWhiteAccountwhiteAccount(storeId, whiteAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除白名单
         * @param {number} whiteAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delWhiteAccountwhiteAccount(whiteAccountId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delWhiteAccountwhiteAccount(whiteAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取自身管理的门店白名单申请列表
         * @param {SystemGenerateObject170} systemGenerateObject170 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOwnerStoreApplyWhiteAccountwhiteAccount(systemGenerateObject170: SystemGenerateObject170, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOwnerStoreApplyWhiteAccountwhiteAccount(systemGenerateObject170, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取自身管理的门店白名单列表
         * @param {SystemGenerateObject169} systemGenerateObject169 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOwnerStoreWhiteAccountwhiteAccount(systemGenerateObject169: SystemGenerateObject169, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOwnerStoreWhiteAccountwhiteAccount(systemGenerateObject169, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取白名单列表
         * @param {SystemGenerateObject165} systemGenerateObject165 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWhiteAccountwhiteAccount(systemGenerateObject165: SystemGenerateObject165, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWhiteAccountwhiteAccount(systemGenerateObject165, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取自身管理的门店白名单列表(分页)
         * @param {SystemGenerateObject171} systemGenerateObject171 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageOwnerStoreWhiteAccountwhiteAccount(systemGenerateObject171: SystemGenerateObject171, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageOwnerStoreWhiteAccountwhiteAccount(systemGenerateObject171, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取白名单列表(分页)
         * @param {SystemGenerateObject166} systemGenerateObject166 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageWhiteAccountwhiteAccount(systemGenerateObject166: SystemGenerateObject166, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageWhiteAccountwhiteAccount(systemGenerateObject166, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新自身管理的门店白名单
         * @param {SystemGenerateObject173} systemGenerateObject173 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOwnerStoreWhiteAccountwhiteAccount(systemGenerateObject173: SystemGenerateObject173, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOwnerStoreWhiteAccountwhiteAccount(systemGenerateObject173, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新白名单
         * @param {SystemGenerateObject168} systemGenerateObject168 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWhiteAccountwhiteAccount(systemGenerateObject168: SystemGenerateObject168, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWhiteAccountwhiteAccount(systemGenerateObject168, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WhiteAccountApi - factory interface
 * @export
 */
export const WhiteAccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WhiteAccountApiFp(configuration)
    return {
        /**
         * 
         * @summary 同意自身管理的门店白名单申请
         * @param {number} storeId 
         * @param {number} whiteAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessApplywhiteAccount(storeId: number, whiteAccountId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.accessApplywhiteAccount(storeId, whiteAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 添加自身管理的门店白名单
         * @param {SystemGenerateObject172} systemGenerateObject172 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOwnerStoreWhiteAccountwhiteAccount(systemGenerateObject172: SystemGenerateObject172, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addOwnerStoreWhiteAccountwhiteAccount(systemGenerateObject172, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 添加白名单
         * @param {SystemGenerateObject167} systemGenerateObject167 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWhiteAccountwhiteAccount(systemGenerateObject167: SystemGenerateObject167, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addWhiteAccountwhiteAccount(systemGenerateObject167, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 门店白名单申请
         * @param {number} storeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applywhiteAccount(storeId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.applywhiteAccount(storeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除自身管理的门店白名单
         * @param {number} storeId 
         * @param {number} whiteAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delOwnerStoreWhiteAccountwhiteAccount(storeId: number, whiteAccountId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delOwnerStoreWhiteAccountwhiteAccount(storeId, whiteAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除白名单
         * @param {number} whiteAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delWhiteAccountwhiteAccount(whiteAccountId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delWhiteAccountwhiteAccount(whiteAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取自身管理的门店白名单申请列表
         * @param {SystemGenerateObject170} systemGenerateObject170 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOwnerStoreApplyWhiteAccountwhiteAccount(systemGenerateObject170: SystemGenerateObject170, options?: any): AxiosPromise<any> {
            return localVarFp.listOwnerStoreApplyWhiteAccountwhiteAccount(systemGenerateObject170, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取自身管理的门店白名单列表
         * @param {SystemGenerateObject169} systemGenerateObject169 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOwnerStoreWhiteAccountwhiteAccount(systemGenerateObject169: SystemGenerateObject169, options?: any): AxiosPromise<any> {
            return localVarFp.listOwnerStoreWhiteAccountwhiteAccount(systemGenerateObject169, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取白名单列表
         * @param {SystemGenerateObject165} systemGenerateObject165 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWhiteAccountwhiteAccount(systemGenerateObject165: SystemGenerateObject165, options?: any): AxiosPromise<any> {
            return localVarFp.listWhiteAccountwhiteAccount(systemGenerateObject165, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取自身管理的门店白名单列表(分页)
         * @param {SystemGenerateObject171} systemGenerateObject171 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOwnerStoreWhiteAccountwhiteAccount(systemGenerateObject171: SystemGenerateObject171, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageOwnerStoreWhiteAccountwhiteAccount(systemGenerateObject171, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取白名单列表(分页)
         * @param {SystemGenerateObject166} systemGenerateObject166 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageWhiteAccountwhiteAccount(systemGenerateObject166: SystemGenerateObject166, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageWhiteAccountwhiteAccount(systemGenerateObject166, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新自身管理的门店白名单
         * @param {SystemGenerateObject173} systemGenerateObject173 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOwnerStoreWhiteAccountwhiteAccount(systemGenerateObject173: SystemGenerateObject173, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateOwnerStoreWhiteAccountwhiteAccount(systemGenerateObject173, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新白名单
         * @param {SystemGenerateObject168} systemGenerateObject168 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWhiteAccountwhiteAccount(systemGenerateObject168: SystemGenerateObject168, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateWhiteAccountwhiteAccount(systemGenerateObject168, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WhiteAccountApi - object-oriented interface
 * @export
 * @class WhiteAccountApi
 * @extends {BaseAPI}
 */
export class WhiteAccountApi extends BaseAPI {
    /**
     * 
     * @summary 同意自身管理的门店白名单申请
     * @param {number} storeId 
     * @param {number} whiteAccountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhiteAccountApi
     */
    public accessApplywhiteAccount(storeId: number, whiteAccountId: number, options?: AxiosRequestConfig) {
        return WhiteAccountApiFp(this.configuration).accessApplywhiteAccount(storeId, whiteAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 添加自身管理的门店白名单
     * @param {SystemGenerateObject172} systemGenerateObject172 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhiteAccountApi
     */
    public addOwnerStoreWhiteAccountwhiteAccount(systemGenerateObject172: SystemGenerateObject172, options?: AxiosRequestConfig) {
        return WhiteAccountApiFp(this.configuration).addOwnerStoreWhiteAccountwhiteAccount(systemGenerateObject172, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 添加白名单
     * @param {SystemGenerateObject167} systemGenerateObject167 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhiteAccountApi
     */
    public addWhiteAccountwhiteAccount(systemGenerateObject167: SystemGenerateObject167, options?: AxiosRequestConfig) {
        return WhiteAccountApiFp(this.configuration).addWhiteAccountwhiteAccount(systemGenerateObject167, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 门店白名单申请
     * @param {number} storeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhiteAccountApi
     */
    public applywhiteAccount(storeId: number, options?: AxiosRequestConfig) {
        return WhiteAccountApiFp(this.configuration).applywhiteAccount(storeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除自身管理的门店白名单
     * @param {number} storeId 
     * @param {number} whiteAccountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhiteAccountApi
     */
    public delOwnerStoreWhiteAccountwhiteAccount(storeId: number, whiteAccountId: number, options?: AxiosRequestConfig) {
        return WhiteAccountApiFp(this.configuration).delOwnerStoreWhiteAccountwhiteAccount(storeId, whiteAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除白名单
     * @param {number} whiteAccountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhiteAccountApi
     */
    public delWhiteAccountwhiteAccount(whiteAccountId: number, options?: AxiosRequestConfig) {
        return WhiteAccountApiFp(this.configuration).delWhiteAccountwhiteAccount(whiteAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取自身管理的门店白名单申请列表
     * @param {SystemGenerateObject170} systemGenerateObject170 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhiteAccountApi
     */
    public listOwnerStoreApplyWhiteAccountwhiteAccount(systemGenerateObject170: SystemGenerateObject170, options?: AxiosRequestConfig) {
        return WhiteAccountApiFp(this.configuration).listOwnerStoreApplyWhiteAccountwhiteAccount(systemGenerateObject170, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取自身管理的门店白名单列表
     * @param {SystemGenerateObject169} systemGenerateObject169 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhiteAccountApi
     */
    public listOwnerStoreWhiteAccountwhiteAccount(systemGenerateObject169: SystemGenerateObject169, options?: AxiosRequestConfig) {
        return WhiteAccountApiFp(this.configuration).listOwnerStoreWhiteAccountwhiteAccount(systemGenerateObject169, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取白名单列表
     * @param {SystemGenerateObject165} systemGenerateObject165 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhiteAccountApi
     */
    public listWhiteAccountwhiteAccount(systemGenerateObject165: SystemGenerateObject165, options?: AxiosRequestConfig) {
        return WhiteAccountApiFp(this.configuration).listWhiteAccountwhiteAccount(systemGenerateObject165, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取自身管理的门店白名单列表(分页)
     * @param {SystemGenerateObject171} systemGenerateObject171 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhiteAccountApi
     */
    public pageOwnerStoreWhiteAccountwhiteAccount(systemGenerateObject171: SystemGenerateObject171, options?: AxiosRequestConfig) {
        return WhiteAccountApiFp(this.configuration).pageOwnerStoreWhiteAccountwhiteAccount(systemGenerateObject171, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取白名单列表(分页)
     * @param {SystemGenerateObject166} systemGenerateObject166 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhiteAccountApi
     */
    public pageWhiteAccountwhiteAccount(systemGenerateObject166: SystemGenerateObject166, options?: AxiosRequestConfig) {
        return WhiteAccountApiFp(this.configuration).pageWhiteAccountwhiteAccount(systemGenerateObject166, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新自身管理的门店白名单
     * @param {SystemGenerateObject173} systemGenerateObject173 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhiteAccountApi
     */
    public updateOwnerStoreWhiteAccountwhiteAccount(systemGenerateObject173: SystemGenerateObject173, options?: AxiosRequestConfig) {
        return WhiteAccountApiFp(this.configuration).updateOwnerStoreWhiteAccountwhiteAccount(systemGenerateObject173, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新白名单
     * @param {SystemGenerateObject168} systemGenerateObject168 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhiteAccountApi
     */
    public updateWhiteAccountwhiteAccount(systemGenerateObject168: SystemGenerateObject168, options?: AxiosRequestConfig) {
        return WhiteAccountApiFp(this.configuration).updateWhiteAccountwhiteAccount(systemGenerateObject168, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WxApi - axios parameter creator
 * @export
 */
export const WxApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加微信公众号(获取授权信息)
         * @param {SystemGenerateObject82} systemGenerateObject82 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWxwx: async (systemGenerateObject82: SystemGenerateObject82, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject82' is not null or undefined
            assertParamExists('addWxwx', 'systemGenerateObject82', systemGenerateObject82)
            const localVarPath = `/wx/addWx`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject82, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 取消公众号关联的小程序
         * @param {SystemGenerateObject90} systemGenerateObject90 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRelativeWeappwx: async (systemGenerateObject90: SystemGenerateObject90, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject90' is not null or undefined
            assertParamExists('cancelRelativeWeappwx', 'systemGenerateObject90', systemGenerateObject90)
            const localVarPath = `/wx/cancelRelativeWeapp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject90, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除微信公众号
         * @param {string} appid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delWxwx: async (appid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appid' is not null or undefined
            assertParamExists('delWxwx', 'appid', appid)
            const localVarPath = `/wx/delWx`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (appid !== undefined) {
                localVarQueryParameter['appid'] = appid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取公众号关联的小程序列表
         * @param {SystemGenerateObject88} systemGenerateObject88 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelativeWeappwx: async (systemGenerateObject88: SystemGenerateObject88, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject88' is not null or undefined
            assertParamExists('getRelativeWeappwx', 'systemGenerateObject88', systemGenerateObject88)
            const localVarPath = `/wx/getRelativeWeapp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject88, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取微信公众号授权连接
         * @param {SystemGenerateObject81} systemGenerateObject81 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWxAuthUrlwx: async (systemGenerateObject81: SystemGenerateObject81, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject81' is not null or undefined
            assertParamExists('getWxAuthUrlwx', 'systemGenerateObject81', systemGenerateObject81)
            const localVarPath = `/wx/getWxAuthUrl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject81, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取开放平台appid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWxOpenAppidwx: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/wx/getWxOpenAppid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 是否关注公众号通过openid
         * @param {SystemGenerateObject91} systemGenerateObject91 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isSubscribeByOpenidwx: async (systemGenerateObject91: SystemGenerateObject91, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject91' is not null or undefined
            assertParamExists('isSubscribeByOpenidwx', 'systemGenerateObject91', systemGenerateObject91)
            const localVarPath = `/wx/isSubscribeByOpenid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject91, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 是否关注公众号
         * @param {SystemGenerateObject92} systemGenerateObject92 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isSubscribewx: async (systemGenerateObject92: SystemGenerateObject92, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject92' is not null or undefined
            assertParamExists('isSubscribewx', 'systemGenerateObject92', systemGenerateObject92)
            const localVarPath = `/wx/isSubscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject92, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取微信公众号列表
         * @param {SystemGenerateObject79} systemGenerateObject79 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWxwx: async (systemGenerateObject79: SystemGenerateObject79, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject79' is not null or undefined
            assertParamExists('listWxwx', 'systemGenerateObject79', systemGenerateObject79)
            const localVarPath = `/wx/listWx`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject79, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 公众号登录
         * @param {SystemGenerateObject87} systemGenerateObject87 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginwx: async (systemGenerateObject87: SystemGenerateObject87, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject87' is not null or undefined
            assertParamExists('loginwx', 'systemGenerateObject87', systemGenerateObject87)
            const localVarPath = `/wx/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject87, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取微信公众号列表(分页)
         * @param {SystemGenerateObject80} systemGenerateObject80 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageWxwx: async (systemGenerateObject80: SystemGenerateObject80, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject80' is not null or undefined
            assertParamExists('pageWxwx', 'systemGenerateObject80', systemGenerateObject80)
            const localVarPath = `/wx/pageWx`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject80, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 公众号通过小程序openid注册
         * @param {SystemGenerateObject86} systemGenerateObject86 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerByOpenidwx: async (systemGenerateObject86: SystemGenerateObject86, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject86' is not null or undefined
            assertParamExists('registerByOpenidwx', 'systemGenerateObject86', systemGenerateObject86)
            const localVarPath = `/wx/registerByOpenid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject86, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 公众号注册
         * @param {SystemGenerateObject85} systemGenerateObject85 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerwx: async (systemGenerateObject85: SystemGenerateObject85, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject85' is not null or undefined
            assertParamExists('registerwx', 'systemGenerateObject85', systemGenerateObject85)
            const localVarPath = `/wx/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject85, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 公众号关联的小程序
         * @param {SystemGenerateObject89} systemGenerateObject89 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        relativeWeappwx: async (systemGenerateObject89: SystemGenerateObject89, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject89' is not null or undefined
            assertParamExists('relativeWeappwx', 'systemGenerateObject89', systemGenerateObject89)
            const localVarPath = `/wx/relativeWeapp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject89, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 发送验证码
         * @param {SystemGenerateObject84} systemGenerateObject84 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendCodewx: async (systemGenerateObject84: SystemGenerateObject84, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject84' is not null or undefined
            assertParamExists('sendCodewx', 'systemGenerateObject84', systemGenerateObject84)
            const localVarPath = `/wx/sendCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject84, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新微信公众号
         * @param {SystemGenerateObject83} systemGenerateObject83 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWxwx: async (systemGenerateObject83: SystemGenerateObject83, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject83' is not null or undefined
            assertParamExists('updateWxwx', 'systemGenerateObject83', systemGenerateObject83)
            const localVarPath = `/wx/updateWx`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject83, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WxApi - functional programming interface
 * @export
 */
export const WxApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WxApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加微信公众号(获取授权信息)
         * @param {SystemGenerateObject82} systemGenerateObject82 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addWxwx(systemGenerateObject82: SystemGenerateObject82, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addWxwx(systemGenerateObject82, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 取消公众号关联的小程序
         * @param {SystemGenerateObject90} systemGenerateObject90 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelRelativeWeappwx(systemGenerateObject90: SystemGenerateObject90, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelRelativeWeappwx(systemGenerateObject90, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除微信公众号
         * @param {string} appid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delWxwx(appid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delWxwx(appid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取公众号关联的小程序列表
         * @param {SystemGenerateObject88} systemGenerateObject88 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelativeWeappwx(systemGenerateObject88: SystemGenerateObject88, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelativeWeappwx(systemGenerateObject88, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取微信公众号授权连接
         * @param {SystemGenerateObject81} systemGenerateObject81 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWxAuthUrlwx(systemGenerateObject81: SystemGenerateObject81, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWxAuthUrlwx(systemGenerateObject81, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取开放平台appid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWxOpenAppidwx(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWxOpenAppidwx(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 是否关注公众号通过openid
         * @param {SystemGenerateObject91} systemGenerateObject91 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isSubscribeByOpenidwx(systemGenerateObject91: SystemGenerateObject91, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isSubscribeByOpenidwx(systemGenerateObject91, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 是否关注公众号
         * @param {SystemGenerateObject92} systemGenerateObject92 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isSubscribewx(systemGenerateObject92: SystemGenerateObject92, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isSubscribewx(systemGenerateObject92, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取微信公众号列表
         * @param {SystemGenerateObject79} systemGenerateObject79 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWxwx(systemGenerateObject79: SystemGenerateObject79, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWxwx(systemGenerateObject79, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 公众号登录
         * @param {SystemGenerateObject87} systemGenerateObject87 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginwx(systemGenerateObject87: SystemGenerateObject87, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginwx(systemGenerateObject87, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取微信公众号列表(分页)
         * @param {SystemGenerateObject80} systemGenerateObject80 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageWxwx(systemGenerateObject80: SystemGenerateObject80, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageWxwx(systemGenerateObject80, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 公众号通过小程序openid注册
         * @param {SystemGenerateObject86} systemGenerateObject86 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerByOpenidwx(systemGenerateObject86: SystemGenerateObject86, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerByOpenidwx(systemGenerateObject86, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 公众号注册
         * @param {SystemGenerateObject85} systemGenerateObject85 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerwx(systemGenerateObject85: SystemGenerateObject85, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerwx(systemGenerateObject85, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 公众号关联的小程序
         * @param {SystemGenerateObject89} systemGenerateObject89 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async relativeWeappwx(systemGenerateObject89: SystemGenerateObject89, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.relativeWeappwx(systemGenerateObject89, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 发送验证码
         * @param {SystemGenerateObject84} systemGenerateObject84 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendCodewx(systemGenerateObject84: SystemGenerateObject84, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendCodewx(systemGenerateObject84, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新微信公众号
         * @param {SystemGenerateObject83} systemGenerateObject83 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWxwx(systemGenerateObject83: SystemGenerateObject83, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWxwx(systemGenerateObject83, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WxApi - factory interface
 * @export
 */
export const WxApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WxApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加微信公众号(获取授权信息)
         * @param {SystemGenerateObject82} systemGenerateObject82 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWxwx(systemGenerateObject82: SystemGenerateObject82, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addWxwx(systemGenerateObject82, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 取消公众号关联的小程序
         * @param {SystemGenerateObject90} systemGenerateObject90 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRelativeWeappwx(systemGenerateObject90: SystemGenerateObject90, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.cancelRelativeWeappwx(systemGenerateObject90, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除微信公众号
         * @param {string} appid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delWxwx(appid: string, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delWxwx(appid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取公众号关联的小程序列表
         * @param {SystemGenerateObject88} systemGenerateObject88 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelativeWeappwx(systemGenerateObject88: SystemGenerateObject88, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.getRelativeWeappwx(systemGenerateObject88, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取微信公众号授权连接
         * @param {SystemGenerateObject81} systemGenerateObject81 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWxAuthUrlwx(systemGenerateObject81: SystemGenerateObject81, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.getWxAuthUrlwx(systemGenerateObject81, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取开放平台appid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWxOpenAppidwx(options?: any): AxiosPromise<ResultVo> {
            return localVarFp.getWxOpenAppidwx(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 是否关注公众号通过openid
         * @param {SystemGenerateObject91} systemGenerateObject91 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isSubscribeByOpenidwx(systemGenerateObject91: SystemGenerateObject91, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.isSubscribeByOpenidwx(systemGenerateObject91, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 是否关注公众号
         * @param {SystemGenerateObject92} systemGenerateObject92 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isSubscribewx(systemGenerateObject92: SystemGenerateObject92, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.isSubscribewx(systemGenerateObject92, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取微信公众号列表
         * @param {SystemGenerateObject79} systemGenerateObject79 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWxwx(systemGenerateObject79: SystemGenerateObject79, options?: any): AxiosPromise<any> {
            return localVarFp.listWxwx(systemGenerateObject79, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 公众号登录
         * @param {SystemGenerateObject87} systemGenerateObject87 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginwx(systemGenerateObject87: SystemGenerateObject87, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.loginwx(systemGenerateObject87, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取微信公众号列表(分页)
         * @param {SystemGenerateObject80} systemGenerateObject80 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageWxwx(systemGenerateObject80: SystemGenerateObject80, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageWxwx(systemGenerateObject80, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 公众号通过小程序openid注册
         * @param {SystemGenerateObject86} systemGenerateObject86 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerByOpenidwx(systemGenerateObject86: SystemGenerateObject86, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.registerByOpenidwx(systemGenerateObject86, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 公众号注册
         * @param {SystemGenerateObject85} systemGenerateObject85 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerwx(systemGenerateObject85: SystemGenerateObject85, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.registerwx(systemGenerateObject85, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 公众号关联的小程序
         * @param {SystemGenerateObject89} systemGenerateObject89 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        relativeWeappwx(systemGenerateObject89: SystemGenerateObject89, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.relativeWeappwx(systemGenerateObject89, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 发送验证码
         * @param {SystemGenerateObject84} systemGenerateObject84 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendCodewx(systemGenerateObject84: SystemGenerateObject84, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.sendCodewx(systemGenerateObject84, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新微信公众号
         * @param {SystemGenerateObject83} systemGenerateObject83 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWxwx(systemGenerateObject83: SystemGenerateObject83, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateWxwx(systemGenerateObject83, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WxApi - object-oriented interface
 * @export
 * @class WxApi
 * @extends {BaseAPI}
 */
export class WxApi extends BaseAPI {
    /**
     * 
     * @summary 添加微信公众号(获取授权信息)
     * @param {SystemGenerateObject82} systemGenerateObject82 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WxApi
     */
    public addWxwx(systemGenerateObject82: SystemGenerateObject82, options?: AxiosRequestConfig) {
        return WxApiFp(this.configuration).addWxwx(systemGenerateObject82, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 取消公众号关联的小程序
     * @param {SystemGenerateObject90} systemGenerateObject90 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WxApi
     */
    public cancelRelativeWeappwx(systemGenerateObject90: SystemGenerateObject90, options?: AxiosRequestConfig) {
        return WxApiFp(this.configuration).cancelRelativeWeappwx(systemGenerateObject90, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除微信公众号
     * @param {string} appid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WxApi
     */
    public delWxwx(appid: string, options?: AxiosRequestConfig) {
        return WxApiFp(this.configuration).delWxwx(appid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取公众号关联的小程序列表
     * @param {SystemGenerateObject88} systemGenerateObject88 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WxApi
     */
    public getRelativeWeappwx(systemGenerateObject88: SystemGenerateObject88, options?: AxiosRequestConfig) {
        return WxApiFp(this.configuration).getRelativeWeappwx(systemGenerateObject88, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取微信公众号授权连接
     * @param {SystemGenerateObject81} systemGenerateObject81 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WxApi
     */
    public getWxAuthUrlwx(systemGenerateObject81: SystemGenerateObject81, options?: AxiosRequestConfig) {
        return WxApiFp(this.configuration).getWxAuthUrlwx(systemGenerateObject81, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取开放平台appid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WxApi
     */
    public getWxOpenAppidwx(options?: AxiosRequestConfig) {
        return WxApiFp(this.configuration).getWxOpenAppidwx(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 是否关注公众号通过openid
     * @param {SystemGenerateObject91} systemGenerateObject91 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WxApi
     */
    public isSubscribeByOpenidwx(systemGenerateObject91: SystemGenerateObject91, options?: AxiosRequestConfig) {
        return WxApiFp(this.configuration).isSubscribeByOpenidwx(systemGenerateObject91, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 是否关注公众号
     * @param {SystemGenerateObject92} systemGenerateObject92 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WxApi
     */
    public isSubscribewx(systemGenerateObject92: SystemGenerateObject92, options?: AxiosRequestConfig) {
        return WxApiFp(this.configuration).isSubscribewx(systemGenerateObject92, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取微信公众号列表
     * @param {SystemGenerateObject79} systemGenerateObject79 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WxApi
     */
    public listWxwx(systemGenerateObject79: SystemGenerateObject79, options?: AxiosRequestConfig) {
        return WxApiFp(this.configuration).listWxwx(systemGenerateObject79, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 公众号登录
     * @param {SystemGenerateObject87} systemGenerateObject87 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WxApi
     */
    public loginwx(systemGenerateObject87: SystemGenerateObject87, options?: AxiosRequestConfig) {
        return WxApiFp(this.configuration).loginwx(systemGenerateObject87, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取微信公众号列表(分页)
     * @param {SystemGenerateObject80} systemGenerateObject80 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WxApi
     */
    public pageWxwx(systemGenerateObject80: SystemGenerateObject80, options?: AxiosRequestConfig) {
        return WxApiFp(this.configuration).pageWxwx(systemGenerateObject80, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 公众号通过小程序openid注册
     * @param {SystemGenerateObject86} systemGenerateObject86 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WxApi
     */
    public registerByOpenidwx(systemGenerateObject86: SystemGenerateObject86, options?: AxiosRequestConfig) {
        return WxApiFp(this.configuration).registerByOpenidwx(systemGenerateObject86, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 公众号注册
     * @param {SystemGenerateObject85} systemGenerateObject85 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WxApi
     */
    public registerwx(systemGenerateObject85: SystemGenerateObject85, options?: AxiosRequestConfig) {
        return WxApiFp(this.configuration).registerwx(systemGenerateObject85, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 公众号关联的小程序
     * @param {SystemGenerateObject89} systemGenerateObject89 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WxApi
     */
    public relativeWeappwx(systemGenerateObject89: SystemGenerateObject89, options?: AxiosRequestConfig) {
        return WxApiFp(this.configuration).relativeWeappwx(systemGenerateObject89, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 发送验证码
     * @param {SystemGenerateObject84} systemGenerateObject84 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WxApi
     */
    public sendCodewx(systemGenerateObject84: SystemGenerateObject84, options?: AxiosRequestConfig) {
        return WxApiFp(this.configuration).sendCodewx(systemGenerateObject84, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新微信公众号
     * @param {SystemGenerateObject83} systemGenerateObject83 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WxApi
     */
    public updateWxwx(systemGenerateObject83: SystemGenerateObject83, options?: AxiosRequestConfig) {
        return WxApiFp(this.configuration).updateWxwx(systemGenerateObject83, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WxTplApi - axios parameter creator
 * @export
 */
export const WxTplApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加微信h5模板
         * @param {WxTplAdminVo} wxTplAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWxTplwxTpl: async (wxTplAdminVo: WxTplAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'wxTplAdminVo' is not null or undefined
            assertParamExists('addWxTplwxTpl', 'wxTplAdminVo', wxTplAdminVo)
            const localVarPath = `/wxTpl/addWxTpl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(wxTplAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除微信h5模板
         * @param {number} wxTplId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delWxTplwxTpl: async (wxTplId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'wxTplId' is not null or undefined
            assertParamExists('delWxTplwxTpl', 'wxTplId', wxTplId)
            const localVarPath = `/wxTpl/delWxTpl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (wxTplId !== undefined) {
                localVarQueryParameter['wxTplId'] = wxTplId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取租户授权的h5模板列表
         * @param {PartialWxTplAdminVo} partialWxTplAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWxTplByTenantwxTpl: async (partialWxTplAdminVo: PartialWxTplAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partialWxTplAdminVo' is not null or undefined
            assertParamExists('listWxTplByTenantwxTpl', 'partialWxTplAdminVo', partialWxTplAdminVo)
            const localVarPath = `/wxTpl/listWxTplByTenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partialWxTplAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取微信h5模板列表
         * @param {PartialWxTplAdminVo} partialWxTplAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWxTplwxTpl: async (partialWxTplAdminVo: PartialWxTplAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partialWxTplAdminVo' is not null or undefined
            assertParamExists('listWxTplwxTpl', 'partialWxTplAdminVo', partialWxTplAdminVo)
            const localVarPath = `/wxTpl/listWxTpl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partialWxTplAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取微信h5模板列表(分页)
         * @param {SystemGenerateObject95} systemGenerateObject95 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageWxTplwxTpl: async (systemGenerateObject95: SystemGenerateObject95, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject95' is not null or undefined
            assertParamExists('pageWxTplwxTpl', 'systemGenerateObject95', systemGenerateObject95)
            const localVarPath = `/wxTpl/pageWxTpl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject95, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新微信h5模板
         * @param {WxTplAdminVo} wxTplAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWxTplwxTpl: async (wxTplAdminVo: WxTplAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'wxTplAdminVo' is not null or undefined
            assertParamExists('updateWxTplwxTpl', 'wxTplAdminVo', wxTplAdminVo)
            const localVarPath = `/wxTpl/updateWxTpl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(wxTplAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WxTplApi - functional programming interface
 * @export
 */
export const WxTplApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WxTplApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加微信h5模板
         * @param {WxTplAdminVo} wxTplAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addWxTplwxTpl(wxTplAdminVo: WxTplAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addWxTplwxTpl(wxTplAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除微信h5模板
         * @param {number} wxTplId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delWxTplwxTpl(wxTplId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delWxTplwxTpl(wxTplId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取租户授权的h5模板列表
         * @param {PartialWxTplAdminVo} partialWxTplAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWxTplByTenantwxTpl(partialWxTplAdminVo: PartialWxTplAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWxTplByTenantwxTpl(partialWxTplAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取微信h5模板列表
         * @param {PartialWxTplAdminVo} partialWxTplAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWxTplwxTpl(partialWxTplAdminVo: PartialWxTplAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWxTplwxTpl(partialWxTplAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取微信h5模板列表(分页)
         * @param {SystemGenerateObject95} systemGenerateObject95 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageWxTplwxTpl(systemGenerateObject95: SystemGenerateObject95, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageWxTplwxTpl(systemGenerateObject95, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新微信h5模板
         * @param {WxTplAdminVo} wxTplAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWxTplwxTpl(wxTplAdminVo: WxTplAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWxTplwxTpl(wxTplAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WxTplApi - factory interface
 * @export
 */
export const WxTplApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WxTplApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加微信h5模板
         * @param {WxTplAdminVo} wxTplAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWxTplwxTpl(wxTplAdminVo: WxTplAdminVo, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.addWxTplwxTpl(wxTplAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除微信h5模板
         * @param {number} wxTplId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delWxTplwxTpl(wxTplId: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.delWxTplwxTpl(wxTplId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取租户授权的h5模板列表
         * @param {PartialWxTplAdminVo} partialWxTplAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWxTplByTenantwxTpl(partialWxTplAdminVo: PartialWxTplAdminVo, options?: any): AxiosPromise<any> {
            return localVarFp.listWxTplByTenantwxTpl(partialWxTplAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取微信h5模板列表
         * @param {PartialWxTplAdminVo} partialWxTplAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWxTplwxTpl(partialWxTplAdminVo: PartialWxTplAdminVo, options?: any): AxiosPromise<any> {
            return localVarFp.listWxTplwxTpl(partialWxTplAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取微信h5模板列表(分页)
         * @param {SystemGenerateObject95} systemGenerateObject95 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageWxTplwxTpl(systemGenerateObject95: SystemGenerateObject95, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.pageWxTplwxTpl(systemGenerateObject95, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新微信h5模板
         * @param {WxTplAdminVo} wxTplAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWxTplwxTpl(wxTplAdminVo: WxTplAdminVo, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.updateWxTplwxTpl(wxTplAdminVo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WxTplApi - object-oriented interface
 * @export
 * @class WxTplApi
 * @extends {BaseAPI}
 */
export class WxTplApi extends BaseAPI {
    /**
     * 
     * @summary 添加微信h5模板
     * @param {WxTplAdminVo} wxTplAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WxTplApi
     */
    public addWxTplwxTpl(wxTplAdminVo: WxTplAdminVo, options?: AxiosRequestConfig) {
        return WxTplApiFp(this.configuration).addWxTplwxTpl(wxTplAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除微信h5模板
     * @param {number} wxTplId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WxTplApi
     */
    public delWxTplwxTpl(wxTplId: number, options?: AxiosRequestConfig) {
        return WxTplApiFp(this.configuration).delWxTplwxTpl(wxTplId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取租户授权的h5模板列表
     * @param {PartialWxTplAdminVo} partialWxTplAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WxTplApi
     */
    public listWxTplByTenantwxTpl(partialWxTplAdminVo: PartialWxTplAdminVo, options?: AxiosRequestConfig) {
        return WxTplApiFp(this.configuration).listWxTplByTenantwxTpl(partialWxTplAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取微信h5模板列表
     * @param {PartialWxTplAdminVo} partialWxTplAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WxTplApi
     */
    public listWxTplwxTpl(partialWxTplAdminVo: PartialWxTplAdminVo, options?: AxiosRequestConfig) {
        return WxTplApiFp(this.configuration).listWxTplwxTpl(partialWxTplAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取微信h5模板列表(分页)
     * @param {SystemGenerateObject95} systemGenerateObject95 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WxTplApi
     */
    public pageWxTplwxTpl(systemGenerateObject95: SystemGenerateObject95, options?: AxiosRequestConfig) {
        return WxTplApiFp(this.configuration).pageWxTplwxTpl(systemGenerateObject95, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新微信h5模板
     * @param {WxTplAdminVo} wxTplAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WxTplApi
     */
    public updateWxTplwxTpl(wxTplAdminVo: WxTplAdminVo, options?: AxiosRequestConfig) {
        return WxTplApiFp(this.configuration).updateWxTplwxTpl(wxTplAdminVo, options).then((request) => request(this.axios, this.basePath));
    }
}



